import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={571}
      height={422.101}
      viewBox="0 0 571 422.101"
      {...props}
    >
      <defs>
        <linearGradient
          id="prefix__a"
          x1={0.5}
          y1={1}
          x2={0.5}
          y2={-0.001}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.1} stopColor="#fafafa" />
          <stop offset={0.22} stopColor="#eaeaea" />
          <stop offset={0.36} stopColor="#d1d1d1" />
          <stop offset={0.51} stopColor="#adadad" />
          <stop offset={0.66} stopColor="#7f7f7f" />
          <stop offset={0.82} stopColor="#474747" />
          <stop offset={0.98} stopColor="#060606" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="prefix__d"
          x1={0.499}
          y1={1}
          x2={0.499}
          y2={-0.001}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__e"
          x1={0.499}
          y1={1}
          x2={0.499}
          y2={-0.001}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__f"
          x1={-0.953}
          y1={1}
          x2={-0.953}
          y2={-0.001}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__h"
          x1={0.502}
          y1={1}
          x2={0.502}
          y2={-0.001}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__i"
          x1={0.502}
          y1={1}
          x2={0.502}
          y2={0}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__j"
          x1={0.501}
          y1={1}
          x2={0.501}
          y2={0}
          xlinkHref="#prefix__a"
        />
        <clipPath id="prefix__b">
          <path
            data-name="Path 9649"
            d="M551.2 294.817a6.955 6.955 0 01.164 3.423 9.324 9.324 0 01-3.622.076c0-2.82.047-3.064.047-3.064a2.739 2.739 0 011.836-.663 6.031 6.031 0 011.575.228z"
            transform="translate(-547.74 -294.589)"
            fill="#fff"
            opacity={0.5}
          />
        </clipPath>
        <clipPath id="prefix__c">
          <path
            data-name="Path 9656"
            d="M577.813 294.454a6.954 6.954 0 00-.164 3.423 14.5 14.5 0 004.5.076c0-2.82-.68-3.377-.68-3.377a5.7 5.7 0 00-2.246-.616c-1.085-.009-1.41.494-1.41.494z"
            transform="translate(-577.509 -293.96)"
            fill="#fff"
            opacity={0.5}
          />
        </clipPath>
        <clipPath id="prefix__g">
          <path
            data-name="Path 9876"
            d="M338.534 189.318l9.742 11.135 14.191 13.022 23.988-8.092-2.111-16.6-19.758-27.014-15.854-3.238-15.272 16.111 3.01 12.557z"
            transform="translate(-333.46 -158.53)"
            fill="none"
          />
        </clipPath>
        <radialGradient
          id="prefix__k"
          cx={0.5}
          cy={0.5}
          r={0.5}
          gradientTransform="rotate(45 .5 .5)"
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.09} stopColor="#f1f1f1" />
          <stop offset={0.27} stopColor="#ccc" />
          <stop offset={0.5} stopColor="#909090" />
          <stop offset={0.79} stopColor="#3e3e3e" />
          <stop offset={1} />
        </radialGradient>
      </defs>
      <g data-name="Group 675">
        <path
          data-name="Path 10569"
          d="M557.808 100.926c-14.4-29.226-46.011-51.2-76.781-44.462-18.424 4.037-36.726 17.583-54.4 10.784-12.734-4.9-19.92-18.8-30.624-27.52-16.472-13.422-39.855-13.265-59.931-7.25S297.619 49.55 277.79 56.387a147.57 147.57 0 01-104.549-3.5c-14.5-6.1-28.063-14.517-42.82-19.885s-31.491-7.452-45.737-.74-24.458 24.274-19.516 39.773c.987 3.091 2.534 6.121 2.334 9.391-.325 5.213-5.142 9.032-10.012 10.19s-9.948.4-14.941.532C20.136 92.74.107 114.126.002 137.564c-.088 19.441 11.377 36.524 21.181 53.042s18.61 36.337 12.774 54.8c-3.46 10.943-11.585 19.5-16.907 29.6-13.8 26.171-6.422 60.821 12.843 82.9s48.109 32.875 76.586 35.446 57.029-2.257 85.244-7.028 56.789-9.517 85.249-6.784c0 0 73.9 10.315 130.7 2.616 11.891-1.613 63.871 1.552 68.9-9.831 4.242-9.613.434-20.878 1.307-31.425 1.259-15.2 12.165-27.646 24.056-36.484s25.383-15.412 36.1-25.764c20.96-20.255 28.071-51.605 31.2-81.268 3.426-32.677 2.981-67.231-11.427-96.458z"
          fill="rgba(160,212,104,0.21)"
        />
        <g data-name="Asset 1">
          <g transform="translate(80.128)" data-name="Layer 2">
            <path
              data-name="Path 9556"
              d="M260.702 395.622c0 1.081-11.245 1.95-25.115 1.95s-25.115-.87-25.115-1.95 11.245-1.946 25.115-1.946 25.115.869 25.115 1.946z"
              fill="#1c1f23"
              opacity={0.1}
            />
            <path
              data-name="Path 9557"
              d="M245.326 395.623c0 .591-7.176 1.068-15.981 1.068s-15.981-.477-15.981-1.068 7.155-1.064 15.981-1.064 15.981.477 15.981 1.064z"
              fill="#1c1f23"
              opacity={0.1}
            />
            <path
              data-name="Path 9558"
              d="M77.135 395.622c0 1.081-11.245 1.95-25.115 1.95s-25.115-.87-25.115-1.95 11.245-1.946 25.115-1.946 25.115.869 25.115 1.946z"
              fill="#1c1f23"
              opacity={0.1}
            />
            <path
              data-name="Path 9559"
              d="M61.757 395.623c0 .591-7.155 1.068-15.981 1.068s-15.98-.482-15.98-1.068 7.176-1.064 15.981-1.064 15.98.477 15.98 1.064z"
              fill="#1c1f23"
              opacity={0.1}
            />
            <path
              data-name="Path 9560"
              d="M141.801 395.622c0 1.081-13.731 1.95-30.666 1.95s-30.661-.87-30.661-1.95 13.731-1.946 30.661-1.946 30.666.869 30.666 1.946z"
              fill="#1c1f23"
              opacity={0.1}
            />
            <path
              data-name="Path 9561"
              d="M136.192 395.623c0 .591-12.144 1.068-27.128 1.068s-27.124-.477-27.124-1.068 12.144-1.064 27.124-1.064 27.128.477 27.128 1.064z"
              fill="#1c1f23"
              opacity={0.1}
            />
            <path
              data-name="Path 9562"
              d="M335.317 395.622c0 1.081-11.24 1.95-25.115 1.95s-25.115-.87-25.115-1.95 11.245-1.946 25.115-1.946 25.115.869 25.115 1.946z"
              fill="#1c1f23"
              opacity={0.1}
            />
            <path
              data-name="Path 9563"
              d="M319.953 395.623c0 .591-7.176 1.068-15.981 1.068s-15.985-.477-15.985-1.068 7.176-1.064 15.985-1.064 15.981.477 15.981 1.064z"
              fill="#1c1f23"
              opacity={0.1}
            />
            <path
              data-name="Path 9564"
              d="M280.9 395.622c0 1.081-4.242 1.95-9.476 1.95s-9.48-.87-9.48-1.95 4.246-1.946 9.48-1.946 9.476.869 9.476 1.946z"
              fill="#1c1f23"
              opacity={0.1}
            />
            <path
              data-name="Path 9565"
              d="M275.095 395.623c0 .591-2.7 1.068-6.028 1.068s-6.032-.477-6.032-1.068 2.7-1.064 6.032-1.064 6.028.477 6.028 1.064z"
              fill="#1c1f23"
              opacity={0.1}
            />
            <path
              data-name="Path 9566"
              d="M410.742 395.622c0 1.081-4.242 1.95-9.476 1.95s-9.476-.87-9.476-1.95 4.221-1.946 9.476-1.946 9.476.869 9.476 1.946z"
              fill="#1c1f23"
              opacity={0.1}
            />
            <path
              data-name="Path 9567"
              d="M404.943 395.623c0 .591-2.7 1.068-6.032 1.068s-6.032-.477-6.032-1.068 2.7-1.064 6.032-1.064 6.032.477 6.032 1.064z"
              fill="#1c1f23"
              opacity={0.1}
            />
            <path
              data-name="Path 9568"
              d="M272.529 230.766a.845.845 0 01-.068-1.688c1.03-.084 4.221-2.495 1.975-29.969a263.657 263.657 0 00-3.8-28.922c-2.2-10.945-3.845-12.076-4.006-12.161a.846.846 0 01-.1-1.688c.87-.072 2.912-.241 5.605 12.752a258.783 258.783 0 013.991 29.884c2.263 27.745-.7 31.569-3.524 31.8z"
              fill="#535363"
            />
            <path
              data-name="Path 9569"
              d="M268.267 231.083a.844.844 0 010-1.688c1.034 0 4.411-2.144 4.411-29.737a261.882 261.882 0 00-1.439-29.125c-1.3-11.089-2.853-12.346-3.005-12.448a.844.844 0 11.038-1.688c.874 0 2.921 0 4.554 13.165a260.619 260.619 0 011.541 30.1c-.001 27.85-3.26 31.421-6.1 31.421z"
              fill="#60606f"
            />
            <path
              data-name="Path 9570"
              d="M274.787 230.628a.845.845 0 11-.068-1.688c.515-.042 1.773-.713 2.4-6.032.6-5.065.456-13.127-.422-23.946a261.993 261.993 0 00-3.8-28.922c-2.2-10.945-3.845-12.076-4.006-12.161a.846.846 0 11-.1-1.688c.865-.072 2.908-.236 5.605 12.756a258.865 258.865 0 013.985 29.876c.891 10.932 1.034 19.1.422 24.283-.371 3.119-1.182 7.294-3.947 7.518z"
              fill="#535363"
            />
            <path
              data-name="Path 9571"
              d="M276.37 230.365a.845.845 0 01-.068-1.688c1.034-.084 4.221-2.495 1.98-29.969a263.4 263.4 0 00-3.8-28.922c-2.2-10.949-3.849-12.081-4.006-12.165a.844.844 0 01-.1-1.684c.87-.072 2.912-.236 5.605 12.756a258.537 258.537 0 013.989 29.876c2.262 27.745-.7 31.569-3.525 31.8z"
              fill="#60606f"
            />
            <path
              data-name="Path 9572"
              d="M272.112 230.678a.844.844 0 110-1.688c1.034 0 4.407-2.14 4.407-29.72a261.907 261.907 0 00-1.439-29.125c-1.3-11.089-2.853-12.351-3.005-12.448a.844.844 0 01.038-1.688c.874 0 2.921 0 4.55 13.165a258.586 258.586 0 011.545 30.1c-.001 27.835-3.26 31.404-6.096 31.404z"
              fill="#60606f"
            />
            <path
              data-name="Path 9573"
              d="M278.625 230.226a.845.845 0 11-.068-1.688c1.03-.084 4.221-2.495 1.975-29.969a263.624 263.624 0 00-3.8-28.922c-2.2-10.945-3.845-12.076-4.006-12.161a.846.846 0 11-.1-1.688c.87-.076 2.912-.232 5.605 12.752a257.851 257.851 0 013.989 29.881c2.262 27.745-.7 31.569-3.525 31.8z"
              fill="#535363"
            />
            <path
              data-name="Path 9574"
              d="M303.398 195.779h26.221v1.861a2.955 2.955 0 01-2.955 2.955h-20.332a2.955 2.955 0 01-2.955-2.955v-1.861z"
              fill="#97a6b3"
            />
            <path
              data-name="Path 9575"
              d="M329.619 197.645v-1.866h-1.541l-1.228 4.791a2.955 2.955 0 002.769-2.925z"
              opacity={0.15}
            />
            <path
              data-name="Path 9576"
              d="M306.606 195.779l-1.731 4.407a2.877 2.877 0 001.456.392h3.09l1.883-4.8z"
              opacity={0.15}
            />
            <path
              data-name="Path 9577"
              d="M319.826 200.578l1.882-4.8h4.7l-1.883 4.8z"
              opacity={0.15}
            />
            <path
              data-name="Path 9578"
              d="M312.274 200.578l1.883-4.8h4.7l-1.883 4.8z"
              opacity={0.15}
            />
            <rect
              data-name="Rectangle 1299"
              width={4.698}
              height={1.287}
              rx={0.644}
              transform="translate(306.606 195.137)"
              fill="#97a6b3"
            />
            <rect
              data-name="Rectangle 1300"
              width={4.698}
              height={1.287}
              rx={0.644}
              transform="translate(314.157 195.137)"
              fill="#97a6b3"
            />
            <rect
              data-name="Rectangle 1301"
              width={4.698}
              height={1.287}
              rx={0.644}
              transform="translate(321.708 195.137)"
              fill="#97a6b3"
            />
            <path
              data-name="Path 9579"
              d="M313.098 141.463h41.328v1.86a2.955 2.955 0 01-2.955 2.955h-35.456a2.955 2.955 0 01-2.955-2.955v-1.86z"
              fill="#97a6b3"
            />
            <path
              data-name="Path 9580"
              d="M316.306 141.463l-1.73 4.407a2.92 2.92 0 001.456.388h3.077l1.883-4.8z"
              opacity={0.15}
            />
            <path
              data-name="Path 9581"
              d="M344.633 146.258l1.882-4.795h4.7l-1.887 4.795z"
              opacity={0.15}
            />
            <path
              data-name="Path 9582"
              d="M337.077 146.258l1.886-4.795h4.7l-1.883 4.795z"
              opacity={0.15}
            />
            <path
              data-name="Path 9583"
              d="M329.526 146.258l1.883-4.795h4.7l-1.882 4.795z"
              opacity={0.15}
            />
            <path
              data-name="Path 9584"
              d="M321.974 146.258l1.883-4.795h4.7l-1.883 4.795z"
              opacity={0.15}
            />
            <rect
              data-name="Rectangle 1302"
              width={4.698}
              height={1.287}
              rx={0.644}
              transform="translate(316.306 140.817)"
              fill="#97a6b3"
            />
            <rect
              data-name="Rectangle 1303"
              width={4.698}
              height={1.287}
              rx={0.644}
              transform="translate(323.857 140.817)"
              fill="#97a6b3"
            />
            <rect
              data-name="Rectangle 1304"
              width={4.698}
              height={1.287}
              rx={0.644}
              transform="translate(331.408 140.817)"
              fill="#97a6b3"
            />
            <rect
              data-name="Rectangle 1305"
              width={4.698}
              height={1.287}
              rx={0.644}
              transform="translate(338.964 140.817)"
              fill="#97a6b3"
            />
            <rect
              data-name="Rectangle 1306"
              width={4.698}
              height={1.287}
              rx={0.644}
              transform="translate(346.515 140.817)"
              fill="#97a6b3"
            />
            <path
              data-name="Path 9585"
              d="M402.917 395.623h-8.864l-65.139-254.16h8.864z"
              fill="#97a6b3"
            />
            <circle
              data-name="Ellipse 437"
              cx={1.701}
              cy={1.701}
              r={1.701}
              transform="translate(376.81 315.719)"
              fill="#535363"
            />
            <path
              data-name="Path 9586"
              d="M337.778 141.463l1.553 6.057-3.871 19.484-6.546-25.541z"
              opacity={0.15}
            />
            <path
              data-name="Path 9587"
              d="M228.285 252.994c-1.161-4.327-3.765-6.331-7.112-4.9s-8.32 6.437-8.32 6.437c-1.114.988-.886 2.7-.127 5.829a9.121 9.121 0 01-.139 5.6l1.123.844s5.2-3.943 9.341-7.315c3.255-2.666 5.728-4.591 5.234-6.495z"
              fill="#594a42"
            />
            <path
              data-name="Path 9588"
              d="M228.283 252.994l-.063-.042a1.674 1.674 0 01-.173-.127 5.563 5.563 0 01-.544-.515l-.321-.346c-.093-.131-.219-.258-.329-.422a11.268 11.268 0 00-.709-.95 4.582 4.582 0 00-.422-.464c-.08-.068-.152-.152-.232-.22l-.249-.2a4.018 4.018 0 00-1.072-.591 3.376 3.376 0 00-1.233-.177 4.906 4.906 0 00-1.452.321l-.447.182-.371.177c-.245.106-.519.27-.785.4-.532.283-1.051.6-1.553.9s-.992.616-1.452.916l-1.3.844c-.4.27-.777.507-1.106.726l-.844.574-.776.544s.912-.916 2.359-2.195c.359-.321.76-.658 1.182-1.013s.882-.718 1.363-1.085.988-.73 1.52-1.077a13.542 13.542 0 011.688-.941 5.58 5.58 0 011.84-.532 4.085 4.085 0 011.828.224 4.643 4.643 0 011.456.937 6.95 6.95 0 01.971 1.211 8.28 8.28 0 01.612 1.165c.173.355.266.688.371.95.156.518.243.826.243.826z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 9589"
              d="M213.718 266.768c1.195-3.66-1.266-10.7.7-11.616s4.5-1.612 7.408 2.322c0 0 .76 2.111 1.233 1.98-4.134 3.384-9.341 7.314-9.341 7.314z"
              fill="#1c1f23"
              opacity={0.15}
            />
            <path
              data-name="Path 9590"
              d="M225.571 284.652s-3.732.95-5.981-.317a213.385 213.385 0 01-4.255-25.773c2.849.658 9.193-2.111 9.193-2.111z"
              fill="#594a42"
            />
            <path
              data-name="Path 9591"
              d="M300.24 375.742l.114-.114a8.305 8.305 0 00.422-3.2s-1.224-.979-5.956-.211c-3.714.6-5.107 2.511-5.107 2.511l1.958 3.052.844 6.682 9.738-1.262z"
              fill="#aa3d4b"
            />
            <path
              data-name="Path 9592"
              d="M299.805 372.555c-3.668-.393-8.362.739-9.231 2.005 1.883 1.507 8 1.334 9.231-2.005z"
              opacity={0.3}
            />
            <path
              data-name="Path 9593"
              d="M308.134 392.638c-4.567-10.451-6.078-12.026-9.286-12.73s-5.96.194-6.382 3.3.46 7.045.257 9.43 16.394 2.284 15.411 0z"
              fill="#aa3d4b"
            />
            <path
              data-name="Path 9594"
              d="M214.909 208.066c4.027-8.222 11.886-13.575 15.685-18.007s4.154-26.8-7.843-26.8-19.417 23.325-24 28.614-6.922 15.284-2.879 21.05 14.043 5.345 19.037-4.857z"
              fill="#aa3d4b"
            />
            <path
              data-name="Path 9595"
              d="M222.751 163.256l-.422.025a7.066 7.066 0 00-1.22.139 5.828 5.828 0 00-.844.194l-.477.144a3.022 3.022 0 00-.507.177 12.441 12.441 0 00-2.2 1.131l-.583.38-.574.422a13.2 13.2 0 00-1.165.975 13.625 13.625 0 00-1.173 1.152c-.384.422-.764.8-1.119 1.266-.751.844-1.448 1.8-2.149 2.769s-1.359 1.988-1.988 3.022c-2.533 4.132-4.673 8.5-6.391 11.709-.844 1.6-1.6 2.921-2.191 3.8-.3.422-.536.785-.718 1l-.274.338a2.973 2.973 0 00.5-.156 5.683 5.683 0 001.245-.684 7.989 7.989 0 001.511-1.4c.5-.587.967-1.309 1.494-2.068s1.081-1.6 1.625-2.486 1.1-1.836 1.646-2.82l.806-1.507.794-1.553c.553-1.03 1.089-2.11 1.646-3.128s1.165-2.047 1.743-3.048a28.891 28.891 0 011.845-2.811c.3-.46.633-.87.95-1.292s.646-.8.979-1.165.646-.734.988-1.043l.494-.477.5-.422a12.738 12.738 0 011.937-1.353 9.789 9.789 0 011.688-.76 7.45 7.45 0 011.182-.342z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 9596"
              d="M200.498 190.304c7.463 0 13.085 13.013 14.423 17.762s-.7 6.931-2.744 9.219-8.375 9.164-16.3 5.162-11.819-11.726-11.506-15.736 6.069-16.407 16.127-16.407z"
              fill="#aa3d4b"
            />
            <path
              data-name="Path 9597"
              d="M201.15 191.604c5.973 2.33 9.67 14.212 10.109 19.066s-1.5 4.715-2.748 6.614-6.488 7.6-11.418 5.2-10.759-8.725-10.654-14.212 4.06-20.817 14.711-16.668z"
              fill="#1c1f23"
              opacity={0.2}
            />
            <path
              data-name="Path 9598"
              d="M186.083 178.734c2.33 5.947-2.414 23.528 1.148 30.391s9.063 11.819 10.865 12.03 2.11 1.055 5.065-1.372 5.838-7.387 4.643-15.829a17.69 17.69 0 00-7.028-12.135s-3.562-11.08-4.061-13.347-12.08-3.424-10.632.262z"
              fill="#fcbd92"
            />
            <path
              data-name="Path 9599"
              d="M203.17 219.78c-2.955 2.427-3.267 1.583-5.065 1.372-.844-.1-2.5-1.241-4.394-3.136 5.183 2.533 7.657.874 6.222.675a6.481 6.481 0 01-4.432-2.25c1.688 1.194 7.036 2.929 8.657-7.484a21.908 21.908 0 00-4.964-17.386s-.249 1.828-3.309 2.144a8.765 8.765 0 01-9.151-8.02c.1-2.879 0-5.352-.642-6.965-1.448-3.689 10.156-2.533 10.65-.266s4.06 13.347 4.06 13.347a17.673 17.673 0 017.028 12.135c1.19 8.443-1.692 13.411-4.66 15.834z"
              opacity={0.05}
            />
            <path
              data-name="Path 9600"
              d="M186.084 178.734l.169.5a11.272 11.272 0 01.312 1.46 21.69 21.69 0 01.177 2.322c.025.895 0 1.912-.03 3.014-.093 2.212-.308 4.782-.515 7.539a83.8 83.8 0 00-.321 8.649 23.887 23.887 0 00.485 4.369 10.93 10.93 0 00.646 2.051l.224.481.253.464c.169.308.329.616.506.916a40.88 40.88 0 002.17 3.339 32.78 32.78 0 002.237 2.782 29.693 29.693 0 002.11 2.157 16.511 16.511 0 001.794 1.477 7.223 7.223 0 00.726.464 4.139 4.139 0 00.566.283 3.133 3.133 0 00.506.148l-.114-.11a2.919 2.919 0 01-.283-.312c-.114-.152-.245-.3-.388-.519-.072-.11-.152-.207-.232-.321s-.169-.245-.258-.376c-.371-.507-.8-1.135-1.325-1.811s-1.151-1.406-1.77-2.256-1.237-1.815-1.9-2.82-1.3-2.11-1.9-3.2a11.858 11.858 0 01-1.46-3.313 19.1 19.1 0 01-.363-1.908c-.055-.333-.089-.675-.135-1.013l-.1-1.038c-.118-1.4-.131-2.828-.165-4.251s0-2.845 0-4.221v-4c0-1.271-.059-2.49-.11-3.613s-.169-2.157-.287-3.069a19.351 19.351 0 00-.46-2.343 10.071 10.071 0 00-.519-1.448z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 9601"
              d="M194.065 175.649c-.844-1.878-3.638-2.921-4.4-3.512a7.122 7.122 0 01-1.409-2.512 6.891 6.891 0 00-.641-3.651c-.886-1.6-2.111-2.343-2.689-2.111s-2.469.886-2.507 1.76 1.266 2.845 1.152 3.98 1.064 2.748 1.165 4.124-.317 5.019 3.985 6.066 6.435-1.764 5.344-4.144z"
              fill="#fcbd92"
            />
            <path
              data-name="Path 9602"
              d="M184.732 173.707c-.1-1.376-1.266-2.988-1.165-4.124s-1.19-3.1-1.152-3.98c0-.422.422-.772.937-1.064-.6 1.186.646 3.55 2.047 4.462 1.266.823 2.478.566 2.866-.553a6.948 6.948 0 010 1.178 7.593 7.593 0 001.325 2.435 2.781 2.781 0 00-1.334.368c-1.866 1.021-1.368 4.343.76 4.643 1.908.262 3.081-2.376 3.28-3.352a5.185 5.185 0 011.786 1.938c1.089 2.381-1.051 5.167-5.348 4.124s-3.896-4.695-4.002-6.075z"
              opacity={0.05}
            />
            <path
              data-name="Path 9603"
              d="M163.653 176.438c-.051-2.921.62-3.141 1.815-3.761a4.8 4.8 0 014.732.578 10.177 10.177 0 003.537 2.111c1.946.743 2.786 1.33 4.732 1.507s2.828 3.714 2.111 4.2-2.17.308-3.938-.4-3.313-.443-5.129-1.638-2.655-1.148-3.005-1.591-1.857-.266-3.052-.4-1.794-.256-1.803-.606z"
              fill="#fcbd92"
            />
            <path
              data-name="Path 9604"
              d="M163.653 176.438v-.879c.747 1.173 4.559.494 5.065.933s.469.6 2.3 1.114 2.478-1.372 1.557-2.714c.3.144.675.3 1.157.485 1.946.755 2.786 1.33 4.732 1.507s2.828 3.714 2.11 4.2-2.17.308-3.938-.4-3.314-.443-5.129-1.638-2.655-1.148-3.005-1.591-1.857-.266-3.052-.4-1.789-.267-1.797-.617z"
              opacity={0.05}
            />
            <path
              data-name="Path 9605"
              d="M173.69 169.005a2.811 2.811 0 00-1.946 1.722c-.084.422 1.46 2.435 1.372 3.1a3.6 3.6 0 00.574 2.035c.4.84 1.46 1.017 3.1 3.313s2.077 2.921 3.406 3.1 5.395-.692 6.365-.92.574-3.018-1.195-3.9a6.558 6.558 0 00-3.963-.342 26.65 26.65 0 00-2.419-2.474c-.354-2.212-.219-2.638-1.5-4.01s-2.215-2.097-3.794-1.624z"
              fill="#fcbd92"
            />
            <path
              data-name="Path 9606"
              d="M180.196 182.271a2.532 2.532 0 01-1.5-.671 2.235 2.235 0 002.824-2.533 9.43 9.43 0 00-.629-2.533c.3.333.511.57.511.57a6.522 6.522 0 013.964.342c1.769.886 2.17 3.668 1.195 3.9s-5.057 1.103-6.365.925z"
              opacity={0.05}
            />
            <path
              data-name="Path 9607"
              d="M173.906 173.905c.844.422 2.474-.287 2.474-.287l-1.237-3.225a6.78 6.78 0 01-2.955.549 100.861 100.861 0 011.718 2.963z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 9608"
              d="M180.871 172.64c.4-1.9-.266-3.8.422-4.221a7.065 7.065 0 012.132-.734 3.3 3.3 0 012.744 2.478 6.4 6.4 0 01.106 4.466c-.059.169 0 .093 0 .11a7.313 7.313 0 003.871 2.482l.034-.025c1.549-1.266 4.289-1.992 5.909-.751s1.461 4.466.443 4.466-1.815.574-3.318 1.946-3.406.8-5.264-.219a31.735 31.735 0 00-4.377-1.769c-.929-.4-.515-1.832-1.49-3.246s-1.6-2.03-1.545-2.786-.107-1.737.333-2.197z"
              fill="#fcbd92"
            />
            <path
              data-name="Path 9609"
              d="M181.288 172.601a5.318 5.318 0 002.482.148l.228-3.887a14.059 14.059 0 00-2.6 0c-.127 1.409-.11 3.739-.11 3.739z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 9610"
              d="M190.186 177.185a1.333 1.333 0 00.422.072 2.432 2.432 0 00.35 0c.11-.021.224-.068.363-.1s.283-.072.422-.118.3-.084.46-.144.317-.118.481-.173l.5-.173c.169-.051.342-.1.515-.135a3.7 3.7 0 01.506-.1 3.99 3.99 0 01.49-.046 3.907 3.907 0 01.447 0h.207a.45.45 0 01.186.025 1.575 1.575 0 01.3.063l.279.072-.228-.152a1.838 1.838 0 00-.279-.148 1.82 1.82 0 00-.376-.152 2.808 2.808 0 00-.469-.122 4.142 4.142 0 00-.536-.063 4.374 4.374 0 00-.574 0 5.791 5.791 0 00-.591.072 6.588 6.588 0 00-2.051.747 5.448 5.448 0 00-.6.393z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 9611"
              d="M183.42 167.675a2.416 2.416 0 01.95.422 3.163 3.163 0 01.713.709 4.861 4.861 0 01.274.422 3.935 3.935 0 01.219.443c.055.152.118.3.16.464s.084.325.127.5a9.845 9.845 0 01.156.988 5.411 5.411 0 01.03.975 5.114 5.114 0 01-.144.945 4.715 4.715 0 01-.131.464 9.128 9.128 0 01-.169.447l-.127.308.2.3c.11.16.211.325.329.477a4.013 4.013 0 00.38.422 3.586 3.586 0 00.422.376c.156.11.287.241.422.338a4.051 4.051 0 00.46.287c.16.084.312.177.473.253a4.958 4.958 0 00.485.215c.165.059.329.127.494.182a8.635 8.635 0 001 .274c.342.068.68.131 1.017.177.169.025.346.03.515.042s.346 0 .519 0a4.444 4.444 0 00.519-.084 2.675 2.675 0 00.515-.182 14.5 14.5 0 01-1.95-.291c-.321-.072-.637-.156-.954-.249s-.625-.2-.933-.321a8.654 8.654 0 01-1.748-.9c-.143-.089-.266-.2-.4-.3s-.245-.215-.371-.321a4.534 4.534 0 01-.338-.359 3.851 3.851 0 01-.3-.393 6.421 6.421 0 00.371-2.089 7.088 7.088 0 00-.346-2.11 6.422 6.422 0 00-.393-.988 4.525 4.525 0 00-.279-.456 3.464 3.464 0 00-.333-.422 3.327 3.327 0 00-.844-.658 2.314 2.314 0 00-.99-.307z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 9612"
              d="M203.558 188.73c5.432-.422 8.324 4.318 9.075 7.176 0 0-.443-6.331-3.98-8.311s-5.095 1.135-5.095 1.135z"
              fill="#1c1f23"
              opacity={0.2}
            />
            <path
              data-name="Path 9613"
              d="M200.498 190.304l.266.089a6.271 6.271 0 01.73.283 7.8 7.8 0 011.009.536 9.927 9.927 0 011.161.865 12.217 12.217 0 011.19 1.195 15.983 15.983 0 011.165 1.482c.393.519.756 1.1 1.119 1.688s.726 1.2 1.051 1.832.646 1.266.963 1.9c.156.312.312.625.469.929l.473.907c.325.587.65 1.152.979 1.688s.654 1.03.954 1.494a11.748 11.748 0 00.844 1.266 4.835 4.835 0 00.9.907 6.666 6.666 0 00.806.532c.1.059.2.1.262.131l.1.042a33.135 33.135 0 00-1.266-3.554 43.047 43.047 0 00-3.824-7.344 26.872 26.872 0 00-1.313-1.824 21.021 21.021 0 00-1.431-1.642 15.026 15.026 0 00-1.5-1.376c-.258-.194-.5-.393-.764-.553l-.371-.249-.376-.215a8.8 8.8 0 00-1.406-.629 6.9 6.9 0 00-1.156-.283 4.722 4.722 0 00-.76-.076z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 9614"
              d="M198.755 181.925c.257 2.815-6.361 7.67-13.326 4.782a15.039 15.039 0 000-4.149s-3.512 1.549-5.762.916-2.393-1.6-6.12-2.14c-3.377-1.309-4.643-2.165-6.331-2.617s-4.643-.249-4.926-1.617.11-6.3 4.782-6.3a12.326 12.326 0 014.365 1.473s-1.055-1.549-.844-2.448 1.634-2.11 4.272-2.216 4.554 2.587 4.757 4.065c.363-1.266-.27-3.225.258-3.8a4.619 4.619 0 011.41-.945 2.767 2.767 0 01-.384-1.98c.287-.924 3.246-2.372 4.276-2.4s2.841 1.321 3.542 2.9a7.3 7.3 0 01.73 3.563 2.6 2.6 0 001.794 2.609c1.266.477 3.457 1.823 3.723 2.9 1.448-.025 3.6 2.347 3.128 4.723a7.09 7.09 0 00.656 2.681z"
              fill="#f15a29"
              opacity={0.5}
            />
            <path
              data-name="Path 9615"
              d="M265.7 249.849c-.275-3.44-10.092-4.124-22.076-3.09s-21.16 3.377-21.325 6.83l-.177-3.717c-.274-3.444 9.388-5.8 21.426-6.842s21.9-.359 22.177 3.086z"
              fill="#58402c"
            />
            <g data-name="Group 476">
              <path
                data-name="Path 9616"
                d="M264.781 246c-.224-2.841-9.649-3.288-21.177-2.3s-20.8 3.056-20.569 5.909l-.912.275c-.274-3.444 9.388-5.8 21.426-6.842s21.9-.359 22.177 3.085z"
                fill="#fff"
                opacity={0.3}
              />
            </g>
            <path
              data-name="Path 9617"
              d="M230.391 395.623c0-21.413.384-52.568-2.288-73.023h11.067s4 8.666 4 17.8-8.742 32.67-8.742 55.244z"
              fill="#4a3c40"
            />
            <path
              data-name="Path 9618"
              d="M246.929 268.131v-18.923h-22.371s-5.753 16.715 3.546 73.374h11.063s-1.49-54.451 7.762-54.451z"
              fill="#4a3c40"
            />
            <path
              data-name="Path 9619"
              d="M236.746 269.157s3.588-.211 4.571.49-4.077 4.786-4.571 5.909 2.368-.49 2.664.494.257 17.787.257 17.787c.844-13.085 2.8-25.706 7.248-25.706-4.891-1.017-10.169 1.026-10.169 1.026z"
              fill="#1c1f23"
              opacity={0.3}
            />
            <path
              data-name="Path 9620"
              d="M246.929 268.131l-5.065-18.923h22.371s9.89 13.815 15.778 70.491l-10.759 2.9s-13.098-54.468-22.325-54.468z"
              fill="#4a3c40"
            />
            <path
              data-name="Path 9621"
              d="M265.615 251.715a19.373 19.373 0 00-1.38-2.507h-39.707s-2.355 6.884-1.587 26.795a19.2 19.2 0 015.437-11.084c4.854-4.63 8.957-3.005 18.294-5.01 7.935-1.701 16.36-4.209 18.943-8.194z"
              opacity={0.15}
            />
            <path
              data-name="Path 9622"
              d="M235.587 258.3c-8.594 3.3-12.874 12.009-12.7 16.225a3.124 3.124 0 01-1.807-1.743 34.037 34.037 0 01-.316-4.934c.105-1.819 2.735-7.653 8.678-10.527s6.145.979 6.145.979z"
              fill="#594a42"
            />
            <path
              data-name="Path 9623"
              d="M221.084 272.782s-.139-.979-.253-2.457a20.046 20.046 0 01-.059-2.533 5.91 5.91 0 01.338-1.384 12.953 12.953 0 01.578-1.351 14.517 14.517 0 01.713-1.287c.253-.422.523-.81.8-1.186a13.429 13.429 0 01.844-1.047c.291-.325.544-.62.81-.878s.5-.506.726-.7.422-.38.587-.511l.528-.422a1.2 1.2 0 01-.1.156 4.726 4.726 0 01-.312.422c-.144.165-.3.376-.5.591s-.422.456-.675.726-.49.578-.751.9l-.795 1.045c-.266.363-.532.747-.781 1.148s-.49.819-.722 1.241a11.269 11.269 0 00-.6 1.3 6.657 6.657 0 00-.228.654 4.052 4.052 0 00-.135.646 12.08 12.08 0 00-.076 1.292v1.186c0 .739.025 1.359.047 1.79s.016.659.016.659z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 9624"
              d="M235.587 258.3c-6.429 2.292-16.095 10.7-14.166 15.1a3.32 3.32 0 001.469 1.127c-.177-4.218 4.104-12.93 12.697-16.227z"
              fill="#1c1f23"
              opacity={0.3}
            />
            <path
              data-name="Path 9625"
              d="M229.121 257.481c-.321.169-.637.342-.945.528 1.076.342 3.094 1.064 4.643 1.617a19.663 19.663 0 012.781-1.334 42.645 42.645 0 01-6.479-.811z"
              fill="#1c1f23"
              opacity={0.3}
            />
            <path
              data-name="Path 9626"
              d="M279.316 157.545c-21 0-50.58 2.419-57.11 5.065-9.924 4-11.143 27.576-6.121 35.507 5.644 10.3 8.442 23.878 8.442 51.1-.962 2.2-1.912 4.221 3.8 5.791s19.1 1.347 26.96-1.038 9.236-3.457 8.948-4.765c-5.669-25.4 9.438-42.5 15.082-52.792 11.379-14.521 9.843-38.868-.001-38.868z"
              fill="#aa3d4b"
            />
            <path
              data-name="Path 9627"
              d="M213.267 186.91l.089.177c.063.118.156.291.253.519.215.456.477 1.106.806 1.929l.5 1.346c.089.241.177.49.27.751s.194.523.287.8a24.392 24.392 0 001.452 3.478c.156.291.329.57.511.844l.139.2.072.1v.025l.089.152.038.063.312.515a31.24 31.24 0 011.266 2.237l.633 1.237c.19.422.384.844.578 1.266a27.566 27.566 0 011.051 2.668l.253.692.228.7c.148.469.308.941.447 1.418.27.962.494 1.946.743 2.929s.422 1.988.625 2.988.317 2.018.473 3.031.249 2.022.376 3.031.194 2.009.27 3.005.122 1.984.182 2.955.093 1.938.122 2.883c.046 1.9.025 3.723 0 5.454s-.076 3.377-.106 4.867c0 .755-.068 1.477-.11 2.161l-.122 1.95c-.072 1.22-.169 2.284-.232 3.161s-.148 1.562-.19 2.03l-.072.722v-2.752c0-.874 0-1.933-.034-3.153s-.059-2.592-.1-4.09-.1-3.124-.2-4.837-.19-3.525-.35-5.394c-.068-.933-.144-1.883-.249-2.841s-.181-1.933-.308-2.908-.253-1.958-.38-2.955l-.469-2.955q-.279-1.475-.561-2.955c-.19-.988-.422-1.937-.663-2.9s-.494-1.9-.772-2.824c-.143-.46-.287-.916-.422-1.372l-.215-.68a48.089 48.089 0 00-.236-.663c-.317-.882-.616-1.752-.975-2.579l-.504-1.236-.549-1.182c-.35-.785-.743-1.524-1.119-2.241a13.92 13.92 0 00-.574-1.043 8.289 8.289 0 01-.515-1.021 20.447 20.447 0 01-1.266-3.887c-.27-1.19-.422-2.241-.54-3.107s-.165-1.553-.2-2.022z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 9628"
              d="M264.237 249.208c-4.474-20.041 3.989-34.912 10.527-45.35-7.37 5.871-18.712-6.332-18.484-18.847 0 0 6.26-25.82 18.007-27.437-1.84.03-3.723.076-5.631.135s-12.587 1.722-18.412 27.635c-10.253.557-19.214.557-24.862.587-1.106-12.95 5.871-23.828 10.856-25.947-1.688.2-3.309.422-4.791.625-.084.03-14.858 3.377-11.468 38.977.743 7.847-1.321 3.938-1.321 3.938 3.921 9.738 5.871 22.954 5.871 45.667-.962 2.2-1.912 4.221 3.8 5.791s19.1 1.347 26.96-1.038 9.234-3.428 8.948-4.736z"
              fill="#fbb040"
              opacity={0.5}
            />
            <path
              data-name="Path 9629"
              d="M286.894 177.881l-10.776-2.089a16.844 16.844 0 00-.608 11.135c1.347 4.1-4.985 14.508-10.05 19.923s-7.492 17.378-7.492 26.221-1.688 13.824-10.764 16.665-22.042 1.524-22.515-.528c-.051-.1-.106-.19-.16-.279v.279c-.962 2.2-1.912 4.221 3.8 5.791s19.1 1.347 26.96-1.038 9.235-3.444 8.948-4.753c-5.669-25.4 9.438-42.5 15.082-52.792a39.327 39.327 0 007.575-18.535z"
              opacity={0.1}
            />
            <path
              data-name="Path 9630"
              d="M260.69 249.516c.232-2.359-.92-6.053-5.04-11.084s-4.614-7.454-4.58-9 5.348-4.115 8.442.245 4.985 18.062 4.55 19.125-3.372.714-3.372.714z"
              opacity={0.1}
            />
            <path
              data-name="Path 9631"
              d="M231.067 160.677c.532 1.6 2.765 4.917 12.2 5.154 6.083.156 20.978-1.688 29.2-8.21a374.592 374.592 0 00-41.4 3.056z"
              opacity={0.15}
            />
            <path
              data-name="Path 9632"
              d="M260.558 160.082c.127 1.688-8.408 5-15.137 5.513s-9.1-1.958-9.231-3.664 6.754-2.288 13.461-2.8 10.782-.754 10.907.951z"
              fill="#fcbd92"
            />
            <path
              data-name="Path 9633"
              d="M263.712 134.16c-1.578 3.208-2.98 9.286-4.124 15.766-1.621 9.2-.612 9.843-1.026 10.633s-8.256 3.453-15.854 3.453c-3.406 0-4.221-2.647-3.947-4.158s2.039-11.979 1.173-17.137 7.6-8.911 12.41-9.62 13.635-3.512 11.368 1.063z"
              fill="#fcbd92"
            />
            <path
              data-name="Path 9634"
              d="M251.475 158.022a91.016 91.016 0 008.961-12.574 52.786 52.786 0 013.276-11.287c2.262-4.593-6.581-1.773-11.4-1.064s-13.275 4.462-12.41 9.62-.908 15.618-1.174 17.137.54 4.158 3.947 4.158c.473 0 .946 0 1.418-.03a22.642 22.642 0 007.382-5.96z"
              opacity={0.15}
            />
            <path
              data-name="Path 9635"
              d="M258.414 136.824c7.112-3.048 7.243-5 9.185-9.865s3.111-11.886-.228-17.728a19.111 19.111 0 00-16.006-9.151c-5.846 0-16.1 3.377-18.429 6.044s-5.179 31.987 7.277 31.987 15.639-.19 18.201-1.287z"
              fill="#fcbd92"
            />
            <path
              data-name="Path 9636"
              d="M263.686 129.809c2.49-.574 3.2-2.161 3.774-5.821s-.958-4.221-2.313-4.643-2.917 1.439-2.917 1.439l.815 8.936a.667.667 0 00.641.089z"
              fill="#fcbd92"
            />
            <path
              data-name="Path 9637"
              d="M263.205 122.831c.452-1.566 2.06-2.06 2.832-1.4s.477 2.457-.35 3.634c.228-.95.422-2.144-.333-2.313s-1.638-.03-1.76.35.916.751.667 1.655-.95 1.266-.6 2.191a1.086 1.086 0 01-.126-1.46c.3-.616.494-.916.105-1.444s-.553-.79-.435-1.213z"
              opacity={0.15}
            />
            <path
              data-name="Path 9638"
              d="M263.687 129.808l.177-.076c.114-.051.283-.127.477-.236a2.361 2.361 0 00.321-.186 2.528 2.528 0 00.346-.249 3.57 3.57 0 00.346-.329 4.015 4.015 0 00.312-.422 5.618 5.618 0 00.789-2.347c.084-.46.139-.954.2-1.456 0-.245.046-.494.072-.743a6.9 6.9 0 00.038-.751 5.415 5.415 0 00-.122-1.313 1.6 1.6 0 00-.084-.274 1.216 1.216 0 00-.11-.236 1.581 1.581 0 00-.257-.388 2.887 2.887 0 00-.844-.557l-.279-.114-.076-.03h.034l-.152-.047-.076-.025h-.021a.056.056 0 01-.034 0h-.173a2.9 2.9 0 00-.806.232c-.262.11-.511.207-.73.291a6.914 6.914 0 01-.751.241 5.626 5.626 0 01.511-.511 5.225 5.225 0 01.65-.507 3.1 3.1 0 01.975-.422 1.629 1.629 0 01.608 0 3.918 3.918 0 01.629.182 3.184 3.184 0 011.211.713 2.656 2.656 0 01.671 1.338 5.652 5.652 0 01.076 1.557 15.531 15.531 0 01-.207 1.549c-.093.506-.19 1.009-.312 1.486a5.932 5.932 0 01-1.11 2.423 3.13 3.13 0 01-.81.7 3 3 0 01-.393.211 2.575 2.575 0 01-.35.143 3.68 3.68 0 01-.511.156z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 9639"
              d="M262.884 127.689s-.452-10.721-3.027-14.925c-3.8-6.2-15.795-11.713-26.921-6.631-4.318 4.031-4.449 15.2-4.449 15.2s.971 4.314.3 6.564-.87 2.955.257 9.143 2.533 10.814 4.436 11.751a12.374 12.374 0 004.141 1.017 1.553 1.553 0 00.245.021h.1c3.685 0 4.934 0 7.028-.815a41.745 41.745 0 004.17-1.414c4.035-1.549 7.935-2.955 11.16-5.77s5.79-7.049 2.56-14.141z"
              fill="#fcbd92"
            />
            <path
              data-name="Path 9640"
              d="M247.14 148.331c1.891-1.266 1.5-5.01.38-6.754s-1.6-2.891-4.25-2.533c-.6-1.739 4.284-3.461 5.8-2.651s1.726 7.176 1.688 8.442a6.161 6.161 0 01-.561 2.322z"
              opacity={0.15}
            />
            <path
              data-name="Path 9641"
              d="M244.996 149.001s.486-.169 1.313-.506c.422-.165.912-.371 1.482-.625l1.9-.844c1.4-.621 3.039-1.33 4.711-2.2a23.57 23.57 0 004.88-3.149l.532-.477.549-.532c.156-.177.321-.342.481-.511l.46-.536a11.505 11.505 0 001.431-2.288 9.209 9.209 0 00.734-2.389 11.466 11.466 0 00.126-2.284 9.886 9.886 0 00-.1-1.034c-.034-.329-.106-.642-.152-.937s-.1-.574-.148-.844-.08-.5-.114-.722c-.089-.422-.131-.794-.165-1.038a.912.912 0 00-.025-.287v-.1l.536 1.3c.131.422.338.929.49 1.532.068.3.16.62.228.962s.122.7.169 1.085a10.755 10.755 0 01-.025 2.465 10.166 10.166 0 01-.253 1.325 11.18 11.18 0 01-.49 1.321 10.88 10.88 0 01-1.57 2.48 15.44 15.44 0 01-2.182 2.111 24.409 24.409 0 01-5.124 3.081c-1.739.8-3.411 1.431-4.842 1.98s-2.621.992-3.474 1.266-1.358.395-1.358.395z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 9642"
              d="M250.58 134.65c-1.8-2.161-4.719-.971-8.526-.236a20.534 20.534 0 01-9.649-.422c-2.744-.979-4.221.393-3.546 5.53s.929 6.437 3.465 8.151c-.988-1.937-.067-3.157-.625-5.107s-.211-3.613 1.385-3.579c4.875 1.494 10.531-.1 12.8-.3 2.372-.211 4.787 4.736 4.31 8.514 3.349-1.349 4.497-7.592.386-12.551z"
              fill="#4a3c40"
            />
            <path
              data-name="Path 9643"
              d="M233.084 138.982a28.191 28.191 0 01-1.169-.4c-2.993-.878-2.731 5.145.422 9.092-.988-1.937-.067-3.157-.625-5.107s-.223-3.616 1.372-3.585z"
              opacity={0.15}
            />
            <path
              data-name="Path 9644"
              d="M242.552 141.973a3.191 3.191 0 01-1.912 1.494 12.255 12.255 0 01-6.192 0c-1.266-.456-1.435-2.533-.477-2.858s8.6-.582 8.885.169a1.589 1.589 0 01-.304 1.195z"
              fill="#1c1f23"
              opacity={0.2}
            />
            <path
              data-name="Path 9645"
              d="M242.556 141.201a3.469 3.469 0 01-2.11 1.49 14.805 14.805 0 01-6.842 0c-1.406-.456-1.579-2.533-.523-2.858s9.493-.583 9.81.169c.137.312-.061.768-.335 1.199z"
              fill="#fcbd92"
            />
            <path
              data-name="Path 9646"
              d="M234.662 124.574a6.955 6.955 0 01.164 3.423 9.324 9.324 0 01-3.622.076c0-2.82.047-3.064.047-3.064a2.739 2.739 0 011.836-.663 6.031 6.031 0 011.575.228z"
              fill="#fff"
              opacity={0.5}
            />
            <g
              data-name="Group 477"
              transform="translate(231.202 124.346)"
              clipPath="url(#prefix__b)"
            >
              <path
                data-name="Path 9647"
                d="M.078 1.812c-.177 1.667.844 1.959 1.79 1.84 1.123-.139 1.617-.3 1.722-1.84C3.683.394 2.796.077 1.834.212.785.364.178.87.078 1.812z"
                fill="#fff"
                opacity={0.5}
              />
              <path
                data-name="Path 9648"
                d="M1.347 1.963A1.266 1.266 0 102.613.697a1.266 1.266 0 00-1.266 1.266z"
                fill="#4e474b"
              />
            </g>
            <path
              data-name="Path 9650"
              d="M233.105 125.2a.511.511 0 10.511-.511.511.511 0 00-.511.511z"
              fill="#fff"
              opacity={0.5}
            />
            <path
              data-name="Path 9651"
              d="M235.111 127.403c-.059.3.089.941-1.642 1.081a3.875 3.875 0 01-2.461-.393h.177s3.082.393 3.926-.688z"
              opacity={0.3}
            />
            <path
              data-name="Path 9652"
              d="M234.659 124.575a1.689 1.689 0 00-.988-.886 3.141 3.141 0 00-2.423 1.321 4.157 4.157 0 013.411-.435z"
              fill="#4e474b"
            />
            <path
              data-name="Path 9653"
              d="M244.071 124.575a6.954 6.954 0 00-.164 3.423 14.5 14.5 0 004.5.076c0-2.82-.68-3.377-.68-3.377a5.7 5.7 0 00-2.246-.616c-1.085-.009-1.41.494-1.41.494z"
              fill="#fff"
              opacity={0.5}
            />
            <g
              data-name="Group 478"
              transform="translate(243.767 124.081)"
              clipPath="url(#prefix__c)"
            >
              <path
                data-name="Path 9654"
                d="M4.234 2.06c.2 1.663-.954 1.959-2.064 1.836C.87 3.761.304 3.596.186 2.06.076.642 1.098.325 2.208.46c1.211.148 1.908.654 2.026 1.6z"
                fill="#fff"
                opacity={0.5}
              />
              <path
                data-name="Path 9655"
                d="M3.926 2.203A1.266 1.266 0 112.66.937a1.266 1.266 0 011.266 1.266z"
                fill="#4e474b"
              />
            </g>
            <path
              data-name="Path 9657"
              d="M247.731 124.689c-1.545-1.211-4.825-.844-4.825-.844l1.165.73s.903-.638 3.66.114z"
              fill="#4e474b"
            />
            <path
              data-name="Path 9658"
              d="M247.237 125.2a.511.511 0 11-.511-.511.511.511 0 01.511.511z"
              fill="#fff"
              opacity={0.5}
            />
            <path
              data-name="Path 9659"
              d="M243.784 126.162s-.291 1.266-.329 1.718a1.642 1.642 0 01-.562-.477s-.105.941 1.942 1.081a19.762 19.762 0 004.428-.338l-.844-.072s-3.93.266-4.263-.144a4.374 4.374 0 01-.372-1.768z"
              opacity={0.3}
            />
            <path
              data-name="Path 9660"
              d="M241.323 118.775c.329 1.828 6.133 1.076 8.725 3.8 1.266-.4.844-2.44.844-2.44s-3.47-3.309-6.454-3.309c-2.22 0-2.845-.7-2.845-.7a3.372 3.372 0 00-.27 2.649z"
              fill="#4a3c40"
            />
            <path
              data-name="Path 9661"
              d="M233.954 116.137c.35 2-.321 2.988-1.165 3.305s-3.617.789-4.136 2.11c-.734-.3-.844-1.532-.359-2.414a4.411 4.411 0 013.157-2.17 13.1 13.1 0 002.503-.831z"
              fill="#4a3c40"
            />
            <path
              data-name="Path 9662"
              d="M233.802 120.185c2.343 2.955 1.178 4.221.7 7.29s-1.988 4.943-1.57 6.969 3.014 1.431 5.572.574c2.229-.747 4.09-.03 4.449-1.372a2.49 2.49 0 00-1.469-2.9 25.029 25.029 0 01-1.081-6.754 4.591 4.591 0 00-2.461-4.369c-1.612-.705-4.14.562-4.14.562z"
              fill="#fcbd92"
            />
            <path
              data-name="Path 9663"
              d="M233.802 120.185l.228.131a3.8 3.8 0 01.612.422 4.912 4.912 0 01.844.844 4.005 4.005 0 01.743 1.49 4.545 4.545 0 01.164.967 9.439 9.439 0 010 .983c-.025.646-.122 1.237-.19 1.819-.03.287-.068.574-.122.844l-.059.266a.981.981 0 01-.063.236c-.021.08-.127.35-.19.523a13.535 13.535 0 01-1.038 1.916 9.622 9.622 0 00-.844 1.764 3.8 3.8 0 00-.257 1.6l.025.181v.122c-.029-.131 0-.034 0-.059v.055c.042.135.093.329.123.333s0 .051.042.08a.783.783 0 01.076.1 1.288 1.288 0 00.182.16 1.988 1.988 0 001.076.258 4.645 4.645 0 001.136-.169c.35-.089.671-.181.941-.266l.658-.2a2.218 2.218 0 01.257-.068l-.182.156a4.8 4.8 0 01-.532.422 5.273 5.273 0 01-.916.507 4.338 4.338 0 01-1.313.329 2.478 2.478 0 01-1.541-.338 1.955 1.955 0 01-.8-1.532 5.161 5.161 0 01.245-1.9c.186-.625.422-1.266.642-1.874a19.149 19.149 0 00.561-1.9c.152-.637.224-1.266.359-1.887s.283-1.19.393-1.752a5.529 5.529 0 00.114-1.6 4.037 4.037 0 00-.355-1.3 6.078 6.078 0 00-.506-.916c-.152-.249-.3-.422-.388-.553z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 9664"
              d="M236.275 135.65a4.463 4.463 0 01.422-.236c.135-.068.3-.144.5-.228s.422-.181.654-.262c.49-.16 1.059-.333 1.663-.523s1.241-.346 1.807-.553a3.5 3.5 0 00.692-.346c.08-.055.118-.105.114-.114s-.038.114 0-.089a1.366 1.366 0 00.029-.262v-.291a3.428 3.428 0 00-.1-.583 4.838 4.838 0 00-.2-.5c-.068-.152-.11-.3-.16-.422a2.076 2.076 0 00-.135-.338.869.869 0 00-.084-.144.9.9 0 01.422.169 2.709 2.709 0 011.076 2.566 1.009 1.009 0 01-.544.756 3.889 3.889 0 01-.92.372 18.542 18.542 0 01-1.929.384c-.62.1-1.2.186-1.688.274a11.084 11.084 0 00-1.619.37z"
              fill="#1c1f23"
              opacity={0.2}
            />
            <path
              data-name="Path 9665"
              d="M234.013 381.668c3.761 0 4.643.925 4.643.925l-1.477 2.326.266 7.72h-10.6l1.688-8.636-1.144-1.908a33.62 33.62 0 016.624-.427z"
              fill="#aa3d4b"
            />
            <path
              data-name="Path 9666"
              d="M238.673 392.638s-1.144-5.854-9.341-5.854c-3.495 0-9.476 2.448-9.476 2.448l-2.423-.579-1.545 1.055-.739 2.929z"
              fill="#aa3d4b"
            />
            <path
              data-name="Path 9667"
              d="M226.917 387.066a31.286 31.286 0 00-3.233.844 8.418 8.418 0 015.116 4.753h4.221c-.823-3.659-4.221-5.086-6.104-5.597z"
              opacity={0.15}
            />
            <path
              data-name="Path 9668"
              d="M238.673 392.638l.392 2.984h-24.452l.54-2.984z"
              fill="#783d4b"
            />
            <path
              data-name="Path 9669"
              d="M227.382 382.094l1.144 1.908c7.6-1.076 8.67.916 8.67.916l1.477-2.326s-.9-.924-4.643-.924a33.872 33.872 0 00-6.648.426z"
              opacity={0.15}
            />
            <path
              data-name="Path 9670"
              d="M218.226 390.253l5.2 1.076a2.068 2.068 0 00-1.325-1.49c6.277-2.111 9.683-2.685 13.837-1.173a10.74 10.74 0 00-6.606-1.887c-3.5 0-9.476 2.448-9.476 2.448l-2.423-.574-1.545 1.055-.739 2.929h1.718l.388-1.857z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 9671"
              d="M257.951 110.747c.038-.089.068-.177.106-.27a22.934 22.934 0 00-25.119-4.343c-4.17 3.888-4.436 14.411-4.449 15.141 5.651 2.793 24.067 2.865 29.462-10.528z"
              opacity={0.15}
            />
            <path
              data-name="Path 9672"
              d="M269.482 108.628c-1.87-7.323-11.156-11.967-21.975-12.549-5.323.844-14.976 4.749-17.044 8.97a25.654 25.654 0 00-2.005 6.154c-4.111.933-6.251 2.748-6.251 6.652a21.275 21.275 0 006.635-.992l.131-.9s1.292-1.887 7.273-2.3c2.815 1.047 2.6 1.785 4.187 2s6.817-1.22 14.592-.422c5.036 1.385 11.819 2.706 14.2 5.8.684.875 2.115-5.098.257-12.413z"
              fill="#aa3d4b"
            />
            <path
              data-name="Path 9673"
              d="M269.22 121.025a.222.222 0 00.122 0c.047-.03.034-.1.051-.219a9.529 9.529 0 00-.08-1.207c-.025-.266-.05-.553-.089-.87s-.063-.654-.08-1.013c-.055-.722-.067-1.532-.173-2.419s-.258-1.836-.422-2.832-.422-2.039-.7-3.1l-.051-.2v-.1c.059.215 0 .051.025.1v-.08l-.135-.422c-.093-.279-.182-.561-.275-.844-.1-.207-.194-.422-.287-.629l-.139-.325-.2-.338-.4-.688c-.152-.224-.329-.422-.481-.654a11.978 11.978 0 00-1.059-1.266 7.275 7.275 0 00-.6-.591c-.211-.19-.422-.393-.629-.578l-.675-.528a8.384 8.384 0 00-.688-.519c-.477-.317-.929-.671-1.435-.941s-.971-.587-1.482-.823-.979-.523-1.486-.73-.975-.456-1.469-.625-.958-.376-1.427-.54l-1.359-.447c-.882-.262-1.688-.519-2.427-.7s-1.376-.342-1.912-.422-.958-.2-1.266-.258l-.422-.1 1.689.131c.544.038 1.2.144 1.954.232.376.038.772.127 1.19.194s.844.139 1.321.253l1.418.329c.49.122.988.279 1.5.422s1.03.346 1.562.528 1.06.422 1.6.637 1.068.5 1.608.768 1.051.6 1.583.9a8.076 8.076 0 01.768.511l.756.536c.249.19.477.4.718.6a8.87 8.87 0 01.7.62 13.847 13.847 0 011.266 1.376c.19.245.392.481.574.73s.325.523.49.785l.241.388.194.422.388.844.279.844a7.456 7.456 0 01.245.844 29.372 29.372 0 01.844 6.331 19.2 19.2 0 01-.372 4.5 3.643 3.643 0 01-.422 1.182c-.084.118-.2.181-.274.135a.446.446 0 01-.17-.134z"
              fill="#ffe6d2"
              opacity={0.15}
            />
            <path
              data-name="Path 9674"
              d="M236.334 110.312a46.637 46.637 0 0118.923 3.588c.477-2.9 1.46-9.755.582-12.384-1.127-3.377-8.332-5.437-8.332-5.437-5.323.844-14.976 4.749-17.044 8.97a25.653 25.653 0 00-2 6.154 49.95 49.95 0 017.876-.891z"
              fill="#ffe6d2"
              opacity={0.15}
            />
            <path
              data-name="Path 9675"
              d="M224.557 113.912a5.542 5.542 0 00-1.549 3.926 20.873 20.873 0 005.821-.975l.131-.9s1.292-1.887 7.273-2.3c-5.264-2.072-9.987-1.439-11.676.249z"
              opacity={0.15}
            />
            <path
              data-name="Path 9676"
              d="M255.46 114.06a.578.578 0 00-.2-.16 46.636 46.636 0 00-18.923-3.588c-4.643.253-8.181.667-10.553 1.76 4.478-1.8 10.975.54 13.317 1.688s2.187.772 7.6.148a28.235 28.235 0 018.759.152z"
              fill="#ffe6d2"
              opacity={0.3}
            />
            <path
              data-name="Path 9677"
              d="M242.494 98.455c2.532 0 3.769 2.385 2.731 5.323s-3.938 5.323-6.484 5.323-3.769-2.385-2.731-5.323 3.938-5.323 6.484-5.323z"
              fill="#fbb040"
              opacity={0.5}
            />
            <path
              data-name="Path 9678"
              d="M271.339 124.005c2.111-.57 3.039-3.972 1.912-4.9.916 1.959-2.393 4.449-4.031 1.921-2.026-2.617-7.176-3.964-11.785-5.158-.148.844-.025 1.752.62 1.971a3.579 3.579 0 000 3.276s.106-1.659 1.266-2.009c-.262 1.237 1 3.2 2.908 1.688 0 0 1.562-1.853 2.917-1.439s2.887.992 2.313 4.643a11.561 11.561 0 01-1.152 4.039 16.03 16.03 0 01-.654 2.452c-.528 1.583.924 1.743 1.933 2a4.015 4.015 0 01-.536-2.347 2.613 2.613 0 001.954.186 2.014 2.014 0 01-1.743-1.714 2.11 2.11 0 002.22-.654c.768.321 1.976-.844 1.857-1.794 0 0 2.018.422 3.5-2.089-1.165.443-1.27.81-3.499-.072z"
              fill="#4a3c40"
            />
            <path
              data-name="Path 9679"
              d="M279.317 157.545c9.375 0 16.656 7.125 16.656 7.125s29.019 4.854 29.019 21.844c0 5.909-7.07 12.769-17.2 9.708s-22.16-11.819-37.356-8.653c-4.643-10.869-4.187-30.024 8.881-30.024z"
              fill="#aa3d4b"
            />
            <path
              data-name="Path 9680"
              d="M291.482 165.252c-.7.916-8.442 1.617-9.708 3.094s-4.993 2.566-4.993 2.566l5.487-.734s3.736-3.064 12.591-3.449c3.55-.152 1.114-2.06 1.114-2.06a28.828 28.828 0 00-6.07-4.272c1.857 1.618 2.284 3.939 1.579 4.855z"
              fill="#fff"
              opacity={0.1}
            />
            <path
              data-name="Path 9681"
              d="M279.317 157.545l1.156.051.578.03.574.076 1.144.16 1.131.245a11.483 11.483 0 011.119.3c.367.118.743.2 1.106.346l1.085.422c.359.139.7.308 1.059.46s.7.321 1.047.494.692.342 1.026.54.675.371 1 .578.658.4.979.616c.642.422 1.266.87 1.887 1.342a22.82 22.82 0 011.764 1.49c1.608.291 3.2.667 4.77 1.089s3.136.9 4.677 1.435c.768.27 1.532.557 2.292.844s1.516.612 2.258.95c.371.16.743.333 1.11.515s.739.346 1.1.54l1.081.566 1.064.6c.7.422 1.4.844 2.064 1.317s1.321.954 1.963 1.456l.924.8c.308.27.587.566.882.844s.562.591.844.895l.422.456c.131.156.249.325.376.485a18.232 18.232 0 011.363 2.026l.557 1.089c.169.371.3.756.456 1.135a9.306 9.306 0 01.359 1.165l.165.591.1.6a16.167 16.167 0 01.224 2.431l-.2-1.207a11.162 11.162 0 00-.3-1.178l-.156-.578-.219-.557a9.629 9.629 0 00-.46-1.093c-.186-.35-.346-.709-.54-1.047l-.659-1a19.581 19.581 0 00-1.46-1.815c-.131-.144-.253-.291-.393-.422l-.422-.422q-.4-.413-.844-.785c-.3-.245-.587-.506-.895-.743l-.933-.7c-.646-.422-1.266-.878-1.963-1.266-.334-.2-.667-.4-1.017-.578s-.675-.384-1.03-.561l-1.047-.523-1.072-.49c-.354-.169-.722-.312-1.085-.464s-.726-.3-1.093-.422c-.73-.3-1.473-.566-2.212-.844s-1.5-.5-2.254-.734-1.515-.447-2.279-.646-1.528-.422-2.3-.608-1.536-.363-2.3-.523-1.562-.342-2.267-.464l-.667-.114-.519-.485c-.194-.182-.473-.447-.73-.671s-.536-.46-.819-.684a39.076 39.076 0 00-1.688-1.317c-.291-.215-.587-.422-.882-.629s-.6-.393-.9-.6-.608-.388-.916-.578-.616-.38-.937-.54-.633-.35-.958-.506l-.983-.452c-.329-.161-.667-.27-1-.422s-.667-.3-1-.422-.679-.283-1.021-.447-.675-.262-1.021-.422l-.528-.245c-.19-.068-.376-.152-.566-.228a9.565 9.565 0 01-1.171-.547z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 9682"
              d="M298.716 194.466c-3.727-2.579-3.183-15.006 4.909-20.349s15.352-3.01 18.028-.122c4.221 2.11 4.255 4.149 5.871 9.565s-2.613 12.017-5.829 13.587-12.494 4.562-22.979-2.681z"
              fill="#aa3d4b"
            />
            <path
              data-name="Path 9683"
              d="M300.751 194.065c-3.178-2.17-2.714-12.642 4.179-17.146s13.085-2.533 15.36-.106c3.592 1.781 3.626 3.5 5 8.062s-2.224 10.13-4.968 11.447-10.644 3.85-19.571-2.257z"
              opacity={0.15}
            />
            <path
              data-name="Path 9684"
              d="M298.717 194.466s-.131-.1-.367-.308a4.641 4.641 0 01-.815-1.076 10.3 10.3 0 01-1.034-4.689 18.243 18.243 0 011.233-6.694 16.708 16.708 0 011.764-3.428 15.412 15.412 0 012.613-2.993c.249-.224.515-.422.772-.637a6.725 6.725 0 01.844-.574c.574-.334 1.123-.709 1.688-1a17.639 17.639 0 011.764-.844l.895-.354.9-.283a15.529 15.529 0 011.794-.422c.3-.051.591-.08.882-.118a6.921 6.921 0 01.87-.084l.844-.034c.279 0 .553.021.844.03a14.862 14.862 0 011.553.161 13.039 13.039 0 012.626.743c.19.08.376.148.544.232l.49.249a7.694 7.694 0 01.844.494 6.363 6.363 0 01.633.456 3.519 3.519 0 01.422.38l.346.333-.38-.3a3.183 3.183 0 00-.464-.333 6.7 6.7 0 00-.658-.4 8.124 8.124 0 00-.844-.422l-.494-.207c-.173-.068-.363-.118-.549-.182a13.815 13.815 0 00-2.592-.528 13.266 13.266 0 00-1.5-.068h-.785l-.81.08a7.241 7.241 0 00-.844.127c-.274.055-.553.1-.844.165a16.937 16.937 0 00-1.688.515l-.844.3-.844.371a16.4 16.4 0 00-1.621.844 9.514 9.514 0 00-.819.511l-.844.545-.705.536c-.228.207-.464.4-.688.612a15.771 15.771 0 00-3.161 4.4c-.262.532-.519 1.064-.726 1.608s-.393 1.085-.557 1.621-.308 1.072-.422 1.6a18.943 18.943 0 00-.422 2.993 14.982 14.982 0 00.1 2.533 13.562 13.562 0 00.346 1.912 7.335 7.335 0 00.447 1.2z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 9685"
              d="M293.753 190.591c.886.346 1.76.7 2.621 1.068-3.567-7.323 1.5-16.682 3.752-19.839-5.102 2.74-9.577 13.258-6.373 18.771z"
              opacity={0.15}
            />
            <path
              data-name="Path 9686"
              d="M316.128 176.067c6.049.92 11.528 10.886 7.083 17.526s-15.2 12.663-20.683 12.663-4.947-8.29-4.947-8.29.139-12.8 6.12-18.783c2.744-2.745 7.273-3.906 12.427-3.116z"
              fill="#fcbd92"
            />
            <path
              data-name="Path 9687"
              d="M316.534 191.87c-4.854-9.577-13.381-5.77-13.381-5.77a10.379 10.379 0 018.049-.6c4.133 1.58 5.332 6.37 5.332 6.37z"
              opacity={0.15}
            />
            <path
              data-name="Path 9688"
              d="M319.417 189.612c-4.972-10.291-13.71-6.2-13.71-6.2a10.2 10.2 0 018.252-.654c4.234 1.7 5.458 6.854 5.458 6.854z"
              opacity={0.15}
            />
            <path
              data-name="Path 9689"
              d="M321.809 187.676c-5.276-11.464-14.064-7.281-14.064-7.281s4.373-2.566 8.505-.984 5.559 8.265 5.559 8.265z"
              opacity={0.15}
            />
            <path
              data-name="Path 9690"
              d="M319.952 177.865c6.488 6.893 1.157 12.608-3.643 16.563s-10.025 9.307-15.618 8.058a32.577 32.577 0 01-2.786-.768c.49 2.191 1.688 4.529 4.614 4.529 5.487 0 16.251-6.015 20.683-12.663 3.475-5.167.908-12.359-3.25-15.719z"
              opacity={0.05}
            />
            <path
              data-name="Path 9691"
              d="M296.792 191.039l-.076-.072c-.051-.046-.127-.114-.211-.2s-.186-.207-.3-.342a2.5 2.5 0 01-.317-.477q-.152-.3-.317-.684a6.019 6.019 0 01-.228-.815 5.479 5.479 0 01-.122-.941c0-.329-.051-.684-.042-1.047a14.923 14.923 0 01.131-2.36c.068-.422.139-.844.241-1.266s.224-.844.371-1.3a9.97 9.97 0 01.519-1.3 13.937 13.937 0 01.671-1.266 14.51 14.51 0 011.689-2.41c.333-.367.641-.751 1.009-1.085a10.029 10.029 0 011.1-.971 16.522 16.522 0 012.359-1.549 21.69 21.69 0 012.334-1.039 17.327 17.327 0 012.187-.646 15.053 15.053 0 011.891-.291c.566-.046 1.055-.072 1.46-.068s.718.034.933.051l.325.034-.321.025a7.241 7.241 0 00-.9.11 16.886 16.886 0 00-3.149.8 20.335 20.335 0 00-4.107 2.039 15.873 15.873 0 00-2.052 1.578 10.927 10.927 0 00-.937.941 11.8 11.8 0 00-.844 1.03 16.538 16.538 0 00-1.439 2.254 18.472 18.472 0 00-1.047 2.368c-.148.393-.253.794-.376 1.178s-.194.777-.287 1.152a18.038 18.038 0 00-.333 2.144c-.047.333-.051.658-.063.962a8.68 8.68 0 000 .87 7.267 7.267 0 00.025.764c.025.232.042.452.063.65a8.5 8.5 0 00.139.9z"
              opacity={0.15}
            />
            <path
              data-name="Path 9692"
              d="M297.581 197.965s0-.865.139-2.368c.072-.751.16-1.663.325-2.7s.371-2.208.654-3.47a32.136 32.136 0 011.22-3.993c.245-.7.574-1.389.9-2.11.16-.359.376-.688.561-1.038.1-.173.2-.346.3-.523s.224-.329.338-.5c.236-.329.452-.675.709-1l.823-.929a10.018 10.018 0 011.946-1.591 13.006 13.006 0 014.812-1.735 16.466 16.466 0 012.575-.211 19.1 19.1 0 012.558.143 8.086 8.086 0 014.521 1.912 13.2 13.2 0 012.989 3.55 16.045 16.045 0 01.937 1.946 14.84 14.84 0 01.6 1.925 12.327 12.327 0 01.3 3.5 9.653 9.653 0 01-.536 2.659 9.507 9.507 0 01-.73 1.591l-.325.528.287-.549c.093-.177.177-.422.3-.68a6.893 6.893 0 00.312-.945 9.285 9.285 0 00.371-2.626 12.487 12.487 0 00-.485-3.377 14.4 14.4 0 00-.65-1.769 14.9 14.9 0 00-.979-1.815 12.37 12.37 0 00-2.955-3.2 8.491 8.491 0 00-1.908-1.11c-.169-.072-.342-.118-.515-.182l-.477-.131-.308-.055-.156-.025h-.11l-.6-.063a18.667 18.667 0 00-2.427-.068 15.1 15.1 0 00-2.393.27 11.984 11.984 0 00-2.271.646 10.832 10.832 0 00-2.043 1.013 8.717 8.717 0 00-.87.642l-.2.16-.228.22-.228.215-.055.055c.068-.068 0 0 .025 0l-.021.025-.093.105c-.241.287-.494.561-.739.844s-.422.608-.654.9a21.971 21.971 0 00-2.043 3.854 38.1 38.1 0 00-1.33 3.8c-.338 1.211-.6 2.343-.844 3.351-.051.253-.118.5-.177.73l-.16.684c-.114.422-.215.844-.308 1.207a27.83 27.83 0 01-.684 2.288z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 9693"
              d="M223.034 249.6c.228 2.841 9.755 4.339 21.282 3.343s20.683-4.1 20.464-6.943l.945.118-.03 3.309c.274 3.44-9.219 7.678-21.206 8.712s-22.371-1.266-22.194-4.972l-.173-3.292z"
              fill="#594a42"
            />
            <g data-name="Group 479">
              <path
                data-name="Path 9694"
                d="M265.725 246.118c.274 3.44-9.265 7.07-21.308 8.109s-22.021-.912-22.3-4.352l.912-.274c.228 2.841 9.755 4.339 21.282 3.343s20.683-4.1 20.464-6.943z"
                fill="#fff"
                opacity={0.3}
              />
            </g>
            <path
              data-name="Path 9695"
              d="M234.853 256.459a.962.962 0 11-.954-1.085 1.026 1.026 0 01.954 1.085z"
              fill="#1c1f23"
              opacity={0.2}
            />
            <path
              data-name="Path 9696"
              d="M234.853 256.177a.954.954 0 11-.954-.95.954.954 0 01.954.95z"
              fill="#a65b42"
            />
            <ellipse
              data-name="Ellipse 438"
              cx={0.494}
              cy={0.371}
              rx={0.494}
              ry={0.371}
              transform="translate(233.316 255.35)"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 9697"
              d="M250.243 255.743a.958.958 0 11-.954-1.085 1.026 1.026 0 01.954 1.085z"
              fill="#1c1f23"
              opacity={0.2}
            />
            <path
              data-name="Path 9698"
              d="M250.243 255.456a.954.954 0 11-.954-.954.954.954 0 01.954.954z"
              fill="#a65b42"
            />
            <path
              data-name="Path 9699"
              d="M249.696 254.999c0 .207-.224.372-.494.372s-.494-.165-.494-.372.219-.367.494-.367.494.165.494.367z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 9700"
              d="M274.763 203.874c-.258.2-.5.422-.777.608a7.141 7.141 0 01-.87.5l-.46.215-.481.156a7.046 7.046 0 01-.992.224 7.523 7.523 0 01-2.043 0l-.511-.076-.5-.122a9.122 9.122 0 01-.983-.3c-.325-.114-.629-.266-.95-.4a7.709 7.709 0 01-.9-.485 8.573 8.573 0 01-.844-.553c-.262-.194-.561-.4-.844-.612a19.437 19.437 0 01-1.532-1.355 24.172 24.172 0 01-1.38-1.5l-.637-.8-.6-.844a25.529 25.529 0 01-1.093-1.726 18.94 18.94 0 01-.946-1.815 26.548 26.548 0 01-.785-1.9l-.342-.971-.3-.984c-.173-.663-.346-1.33-.464-2.009-.072-.338-.127-.68-.169-1.021s-.106-.684-.127-1.03c-.076-.688-.1-1.385-.114-2.081v-.118l.038-.152c.165-.734.338-1.427.523-2.132s.38-1.4.583-2.111a92.8 92.8 0 011.359-4.132c.249-.684.5-1.363.764-2.039s.561-1.347.844-2.009.6-1.33.92-1.988.65-1.309 1.013-1.946.73-1.266 1.11-1.9c.19-.312.4-.616.6-.929s.422-.616.625-.912c.422-.608.891-1.186 1.347-1.764a19.109 19.109 0 011.5-1.659c.253-.274.532-.528.811-.781a10.2 10.2 0 01.865-.722 11.865 11.865 0 011.908-1.228c.346-.156.684-.325 1.043-.456s.722-.232 1.085-.325a8.412 8.412 0 011.119-.156 9.734 9.734 0 011.11 0l-1.051.211c-.342.105-.675.224-1.017.338a10.491 10.491 0 00-1.9.983 14.017 14.017 0 00-1.688 1.292 9.825 9.825 0 00-.785.73c-.253.249-.511.5-.743.772-.49.519-.933 1.08-1.376 1.638s-.844 1.152-1.237 1.752-.764 1.207-1.135 1.819-.709 1.241-1.034 1.874a66.484 66.484 0 00-3.461 7.91c-.5 1.338-.958 2.689-1.393 4.052s-.844 2.735-1.178 4.12a19.282 19.282 0 00.068 1.975 8.627 8.627 0 00.1.984c.038.329.08.654.144.975a17.194 17.194 0 00.422 1.933l.262.954.308.937a23.2 23.2 0 00.718 1.84 9.607 9.607 0 00.422.9c.16.3.283.591.447.878.3.582.646 1.148 1 1.688l.553.819.591.794c.422.515.844 1.017 1.266 1.5a18.152 18.152 0 001.431 1.359c.245.219.515.422.772.616s.54.376.811.566.566.338.844.5a6.426 6.426 0 00.895.422 9.017 9.017 0 00.929.333l.473.144.485.093a6.965 6.965 0 001.963.1 6.213 6.213 0 00.971-.169l.477-.131.46-.182a6.63 6.63 0 00.882-.443c.253-.16.51-.374.781-.536z"
              opacity={0.15}
            />
            <path
              data-name="Path 9701"
              d="M225.402 185.944a6.032 6.032 0 01-.608-1.241 6.808 6.808 0 01-.376-1.452c-.072-.583-.1-1.245-.139-1.975a20.668 20.668 0 01.046-2.317 22.132 22.132 0 01.329-2.571 24.067 24.067 0 01.692-2.68c.152-.447.3-.9.452-1.355s.367-.882.549-1.325.367-.882.591-1.3.422-.844.642-1.266c.494-.806.929-1.617 1.46-2.343.27-.359.5-.73.785-1.059l.806-.971c.258-.312.553-.591.811-.874l.392-.422a5.079 5.079 0 01.422-.367q.4-.359.773-.671l.76-.532.342-.24c.114-.072.232-.131.342-.194l.6-.329a2.49 2.49 0 01.507-.215l.38-.139.317-.114-.3.156a8.871 8.871 0 00-.819.452l-.544.384c-.1.072-.207.143-.308.224l-.308.266-.675.591-.684.718c-.118.127-.245.249-.363.388l-.346.422c-.232.291-.49.578-.718.9l-.747 1.013c-.245.338-.448.718-.675 1.081-.473.726-.844 1.541-1.266 2.339-.359.844-.776 1.659-1.076 2.532-.156.422-.333.844-.473 1.3l-.422 1.308a12.869 12.869 0 00-.342 1.3c-.1.43-.2.844-.3 1.266-.144.844-.291 1.688-.422 2.461a21.74 21.74 0 00-.2 2.224c-.046.688-.034 1.325-.051 1.887s.038 1.051.046 1.456z"
              opacity={0.15}
            />
            <path
              data-name="Path 9702"
              d="M289.696 374.728c4.006 2.68 10.109.73 11.063-2.3a8.3 8.3 0 01-.422 3.2 8.131 8.131 0 01-3.854 2.153 10.552 10.552 0 01-4.812 0z"
              opacity={0.15}
            />
            <path
              data-name="Path 9703"
              d="M297.341 374.23c-6.053-14.567-5.6-35.355-8.049-41.248s-9.286-13.3-9.286-13.3l-10.759 2.9c8.159 13.208 18.078 38.833 23.819 52.653 2.321.223 4.398-.701 4.275-1.005z"
              fill="#4a3c40"
            />
            <path
              data-name="Path 9704"
              d="M280.803 345.768c2.2 5.015 4.335 10.13 6.331 14.921l4.466-13.6c-.722-6.332-1.241-11.587-2.288-14.111a32.638 32.638 0 00-3.191-5.626z"
              fill="#1c1f23"
              opacity={0.3}
            />
            <path
              data-name="Path 9705"
              d="M305.419 386.784c-2.913-4.732-7.488-6-9.506-4.782a8.586 8.586 0 00-3.563 4.25c.063 1.363.215 2.744.308 3.989.633-1.621 2.153-4.82 4.479-5.445 2.765-.743 7.741 2.465 8.894 3.246-.211-.448-.43-.866-.612-1.258z"
              opacity={0.15}
            />
            <path
              data-name="Path 9706"
              d="M308.134 392.638l-.08-.021a1.31 1.31 0 01-.211-.055 3.629 3.629 0 01-.658-.274 2.953 2.953 0 01-.734-.557 10.4 10.4 0 01-.654-.844 15.6 15.6 0 01-1.406-2.19c-.207-.422-.422-.844-.6-1.309s-.38-.908-.557-1.372l-.582-1.342-.287-.646-.3-.608a10.543 10.543 0 00-.608-1.093 6.027 6.027 0 00-.658-.891 4.017 4.017 0 00-.346-.359 2.164 2.164 0 00-.354-.308 8.181 8.181 0 00-.646-.473c-.38-.245-.616-.388-.616-.388l.177.042c.118.034.291.067.5.131a6.61 6.61 0 01.76.274 2.84 2.84 0 01.447.215 3.455 3.455 0 01.469.283 3.79 3.79 0 01.477.359 5.63 5.63 0 01.473.422 10.183 10.183 0 01.9 1.051l.422.6c.139.207.266.422.422.633.274.422.515.874.768 1.317s.485.9.709 1.355.451.891.654 1.325c.422.865.789 1.689 1.1 2.377z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 9707"
              d="M292.803 392.638s.743-5.854 6.083-5.854c2.275 0 7.745 1.87 7.745 1.87l1 1.055.5 2.929z"
              fill="#aa3d4b"
            />
            <path
              data-name="Path 9708"
              d="M299.27 388.873c2.621 0 8.383.844 8.383.844l-1-1.055s-5.487-1.87-7.745-1.87c-3.833 0-5.293 3.006-5.812 4.707.863-1.216 2.645-2.626 6.174-2.626z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 9709"
              d="M292.698 392.638l-.257 2.984h16.031l-.35-2.984z"
              fill="#783d4b"
            />
            <path
              data-name="Path 9710"
              d="M221.832 257.481c-2.9-3.93-5.437-3.246-7.408-2.322s.494 7.957-.7 11.616l-1.123-.844a9.088 9.088 0 00.139-5.6c-.844-3.491-1.038-5.2.536-6.133s5.335-1.971 7.218-.219c1.363 1.266 2.4 1.756 2.777 2.9-.093.751-.148 1.9-.207 2.583-.481.13-1.232-1.981-1.232-1.981z"
              fill="#1c1f23"
              opacity={0.3}
            />
            <g data-name="Group 480" opacity={0.2}>
              <path
                data-name="Path 9711"
                d="M221.827 257.481l-.646.215c-.38.122-.76.236-1.144.342s-.768.2-1.157.291c-.19.046-.388.076-.583.118s-.388.072-.587.1-.392.063-.591.072l-.6.038h-.6l-.591-.084c0 .215.025.422.042.65 0 0 .063.726.089.979q.089.81.19 1.621c.131 1.085.279 2.161.422 3.242.3 2.157.633 4.309.984 6.458s.726 4.3 1.14 6.437l.317 1.6.329 1.6c.228 1.064.477 2.111.734 3.183l-.515-3.225-.477-3.233c-.16-1.072-.3-2.153-.447-3.229s-.283-2.157-.422-3.237a317.4 317.4 0 01-.8-6.471c-.131-1.076-.266-2.153-.384-3.229l-.194-1.608c-.025-.2-.046-.422-.063-.616h.253l.646-.059a3.96 3.96 0 00.633-.1c.211-.034.422-.08.612-.131s.422-.093.6-.152c.4-.11.789-.224 1.178-.354s.768-.258 1.144-.422c.228-.089.447-.186.667-.283-.103-.289-.179-.513-.179-.513z"
                fill="#fff"
                opacity={0.3}
              />
            </g>
            <path
              data-name="Path 9712"
              d="M250.192 190.903c.051 9.472 3.018 25.237 3.018 25.237l-3.947 6.331s-19.227.283-23.73-.7a23.531 23.531 0 01-2.748-4.386s1.321-8.353 1.013-25.984c2.579 2.343 20.729 2.132 26.394-.498z"
              fill="#fbb040"
              opacity={0.5}
            />
            <path
              data-name="Path 9713"
              d="M270.041 247.853c-.612-.895-2.532-.747-3.149-.747s-.422-.988-.422-.988h-.755s-.025 2.056-.025 2.651 1.182.659 1.883.722 1.562-.165 1.731.308l1.059.35a2.638 2.638 0 00-.322-2.296z"
              fill="#594a42"
            />
            <path
              data-name="Path 9714"
              d="M269.301 249.799c.422-.844-.19-1.553-1.224-1.688s-2.359-.046-2.359-1.013v-.967h.756s-.19.988.422.988 2.533-.148 3.149.747a2.638 2.638 0 01.329 2.3z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 9715"
              d="M258.642 222.967l-.46-.089-1.646.616-1.642.62-.287.372-.08 1.272 1.043 1.823 2.195-.823 2.2-.827-.418-2.06z"
              fill="#f26522"
            />
            <path
              data-name="Path 9716"
              d="M267.507 246.017l-2.195.823-2.2.823.1 1.22.722.431.422-.013 1.642-.616 1.646-.62.325-.27.257-.8z"
              fill="#f26522"
            />
            <path
              data-name="Path 9717"
              d="M262.618 231.066c-2.039-5.424-2.659-5.137-2.659-5.137l-2.195.844-2.195.823s-.659.194 1.38 5.618 4.58 9.147 5.631 11.937a5.507 5.507 0 01.536 2.533l2.195-.844 2.195-.823a5.6 5.6 0 01-1.268-2.262c-1.041-2.791-1.581-7.265-3.62-12.689z"
              fill="#1c7f98"
            />
            <path
              data-name="Path 9718"
              d="M265.299 244.118c-1.051-2.79-2.11-7.074-4.145-12.5s-2.33-5.259-2.33-5.259l-.578-2-.646-1-.266-.16-.8.3-.794.3-.093.3.173 1.174.878 1.887s-.325.072 1.714 5.487 4.065 9.345 5.112 12.135a10.915 10.915 0 01.726 2.457l.261 1.156.469.528.228.063.794-.3.8-.3.131-.2v-.7l-.566-1.038a10.783 10.783 0 01-1.068-2.33z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Rectangle 1307"
              fill="#516a80"
              d="M265.347 248.927l1.316-.495 8.496 22.604-1.316.495z"
            />
            <path
              data-name="Rectangle 1308"
              opacity={0.15}
              d="M265.347 248.935l1.316-.495.383 1.02-1.316.494z"
            />
            <path
              data-name="Path 9719"
              d="M274.572 268.751l-1.794.675-.08 1.663 2.267 3.432.659-.245.658-.249-.553-4.073z"
              fill="#516a80"
            />
            <path
              data-name="Rectangle 1309"
              fill="#fff"
              opacity={0.2}
              d="M265.837 248.755l.328-.123 7.574 20.15-.328.124z"
            />
            <path
              data-name="Path 9720"
              d="M273.378 269.203l.333 1.507 1.7 3.647-.194.072-1.992-3.533-.051-1.617z"
              opacity={0.15}
            />
            <path
              data-name="Path 9721"
              d="M273.973 268.979l.743 1.355 1.127 3.858.194-.072-.834-3.971-1.03-1.25z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 9722"
              d="M263.218 248.883l.722.422h.422l1.642-.616 1.646-.62.325-.27.257-.8-.726-.979.346.92-.916.545-2.423.912-.844.029s.574-1.629-2.955-7.214a38.759 38.759 0 011.891 3.926 5.508 5.508 0 01.536 2.532z"
              opacity={0.15}
            />
            <path
              data-name="Path 9723"
              d="M269.3 249.799c-.4.844-1.5 1.152-2.832.422s-2.216-1.266-3.4-.469l.148 1.9a2.891 2.891 0 00.844.57c1.1-.747 1.334.485 2.744.823a2.63 2.63 0 002.79-.76 14.466 14.466 0 00.777-2.153z"
              fill="#594a42"
            />
            <path
              data-name="Path 9724"
              d="M263.079 249.766c1.186-.8 2.073-.253 3.4.469s2.431.422 2.832-.422l1.06.35a2.372 2.372 0 01-2.136 1.52c-1.629.042-2.663-1.135-3.4-1.317s-.992.169-.992.169z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 9725"
              d="M263.843 250.521l.219 1.718-.836-.57-.148-1.9z"
              opacity={0.15}
            />
            <path
              data-name="Path 9726"
              d="M190.076 201.076c-5.766-4.5-3.93-6.91-3.93-6.91a2.9 2.9 0 00-.734 2.706c.346 1.777 4.664 4.204 4.664 4.204z"
              opacity={0.15}
            />
            <path
              data-name="Path 9727"
              d="M190.878 205.141c-6.982-5.116-4.934-7.733-4.934-7.733a3.052 3.052 0 00-.709 2.955c.413 1.996 5.643 4.778 5.643 4.778z"
              opacity={0.15}
            />
            <path
              data-name="Path 9728"
              d="M192.377 209.172c-8.919-5.116-6.3-7.733-6.3-7.733a2.685 2.685 0 00-.9 2.955c.547 2.015 7.2 4.778 7.2 4.778z"
              opacity={0.15}
            />
            <path
              data-name="Path 9729"
              d="M289.477 250.099h26.221v1.861a2.955 2.955 0 01-2.955 2.955h-20.337a2.955 2.955 0 01-2.955-2.955v-1.861z"
              fill="#97a6b3"
            />
            <path
              data-name="Path 9730"
              d="M315.698 251.96v-1.861h-1.541l-1.228 4.79a2.955 2.955 0 002.769-2.929z"
              opacity={0.15}
            />
            <path
              data-name="Path 9731"
              d="M292.685 250.099l-1.731 4.428a2.921 2.921 0 001.456.388h3.09l1.883-4.795z"
              opacity={0.15}
            />
            <path
              data-name="Path 9732"
              d="M305.905 254.894l1.883-4.795h4.7l-1.883 4.795z"
              opacity={0.15}
            />
            <path
              data-name="Path 9733"
              d="M298.354 254.894l1.883-4.795h4.7l-1.887 4.795z"
              opacity={0.15}
            />
            <rect
              data-name="Rectangle 1310"
              width={4.698}
              height={1.287}
              rx={0.644}
              transform="translate(292.685 249.453)"
              fill="#97a6b3"
            />
            <rect
              data-name="Rectangle 1311"
              width={4.698}
              height={1.287}
              rx={0.644}
              transform="translate(300.236 249.453)"
              fill="#97a6b3"
            />
            <rect
              data-name="Rectangle 1312"
              width={4.698}
              height={1.287}
              rx={0.644}
              transform="translate(307.788 249.453)"
              fill="#97a6b3"
            />
            <path
              data-name="Path 9734"
              d="M275.556 304.415h26.221v1.861a2.955 2.955 0 01-2.955 2.955H278.49a2.955 2.955 0 01-2.955-2.955v-1.861z"
              fill="#97a6b3"
            />
            <path
              data-name="Path 9735"
              d="M301.777 306.277v-1.862h-1.541l-1.228 4.786a2.929 2.929 0 002.769-2.924z"
              opacity={0.15}
            />
            <path
              data-name="Path 9736"
              d="M278.764 304.415l-1.731 4.41a2.921 2.921 0 001.456.388h3.09l1.883-4.8z"
              opacity={0.15}
            />
            <path
              data-name="Path 9737"
              d="M291.984 309.21l1.887-4.8h4.7l-1.883 4.8z"
              opacity={0.15}
            />
            <path
              data-name="Path 9738"
              d="M284.433 309.21l1.883-4.8h4.7l-1.887 4.8z"
              opacity={0.15}
            />
            <rect
              data-name="Rectangle 1313"
              width={4.698}
              height={1.287}
              rx={0.644}
              transform="translate(278.764 303.769)"
              fill="#97a6b3"
            />
            <rect
              data-name="Rectangle 1314"
              width={4.698}
              height={1.287}
              rx={0.644}
              transform="translate(286.315 303.769)"
              fill="#97a6b3"
            />
            <rect
              data-name="Rectangle 1315"
              width={4.698}
              height={1.287}
              rx={0.644}
              transform="translate(293.867 303.769)"
              fill="#97a6b3"
            />
            <path
              data-name="Path 9739"
              d="M261.635 358.731h26.238v1.862a2.955 2.955 0 01-2.955 2.955h-20.35a2.955 2.955 0 01-2.955-2.955v-1.862z"
              fill="#97a6b3"
            />
            <path
              data-name="Path 9740"
              d="M287.873 360.597v-1.866h-1.541l-1.228 4.791a2.955 2.955 0 002.769-2.925z"
              opacity={0.15}
            />
            <path
              data-name="Path 9741"
              d="M264.843 358.731l-1.731 4.407a2.888 2.888 0 001.456.393h3.09l1.882-4.8z"
              opacity={0.15}
            />
            <path
              data-name="Path 9742"
              d="M278.063 363.53l1.887-4.8h4.7l-1.883 4.8z"
              opacity={0.15}
            />
            <path
              data-name="Path 9743"
              d="M270.512 363.53l1.883-4.8h4.7l-1.887 4.8z"
              opacity={0.15}
            />
            <rect
              data-name="Rectangle 1316"
              width={4.698}
              height={1.287}
              rx={0.644}
              transform="translate(264.843 358.089)"
              fill="#97a6b3"
            />
            <rect
              data-name="Rectangle 1317"
              width={4.698}
              height={1.287}
              rx={0.644}
              transform="translate(272.394 358.089)"
              fill="#97a6b3"
            />
            <rect
              data-name="Rectangle 1318"
              width={4.698}
              height={1.287}
              rx={0.644}
              transform="translate(279.95 358.089)"
              fill="#97a6b3"
            />
            <path
              data-name="Rectangle 1319"
              fill="#97a6b3"
              d="M285.488 314.604h94.719v5.627h-94.719z"
            />
            <path
              data-name="Path 9744"
              d="M373.289 314.604l1.439 5.631h-2.079l-.473-5.631z"
              opacity={0.15}
            />
            <path
              data-name="Path 9745"
              d="M293.402 314.604l-1.439 5.631h2.077l.473-5.631z"
              opacity={0.15}
            />
            <path
              data-name="Path 9746"
              d="M263.775 395.622h8.864l88.126-343.83a4.3 4.3 0 00-4.166-5.361 4.293 4.293 0 00-4.158 3.229z"
              fill="#97a6b3"
            />
            <path
              data-name="Path 9747"
              d="M310.667 212.612c.084 4.031 3.693 20.168 3.693 20.168L310.983 246l-8.674-.739z"
              opacity={0.15}
            />
            <path
              data-name="Path 9748"
              d="M334.519 143.86a1.688 1.688 0 11-1.689-1.688 1.689 1.689 0 011.689 1.688z"
              fill="#535363"
            />
            <circle
              data-name="Ellipse 439"
              cx={1.701}
              cy={1.701}
              r={1.701}
              transform="translate(286.336 315.719)"
              fill="#535363"
            />
            <path
              data-name="Path 9749"
              d="M301.743 225.321c-1.342 1.769-1.406 1.3-1.41 2.22s-1.19 1.629-2.684 1.19-2.634-1.477-1.756-2.431c.95-1.038 1.688-1.482 1.688-2.558s1.085-1.519 2.389-1.156 2.849 1.317 1.773 2.735z"
              fill="#fcbd92"
            />
            <path
              data-name="Path 9750"
              d="M306.931 222.658c.257 1.266-.422 1.241-.984 1.95s-.954 1.971-2.111 2.532-2.925.355-2.908-1.2.7-.73 1.444-2.072.789-1.849 2.2-1.98 2.182-.095 2.359.77z"
              fill="#fcbd92"
            />
            <path
              data-name="Path 9751"
              d="M310.176 220.227c.253 1.266-.422 1.241-.988 1.95s-.954 1.971-2.11 2.533-2.93.354-2.912-1.2.7-.73 1.443-2.072.794-1.849 2.2-1.98 2.19-.101 2.367.769z"
              fill="#fcbd92"
            />
            <path
              data-name="Path 9752"
              d="M298.848 228.842c-2.03.354-2.317.055-3.157-.578s-1.9-.422-2.271-.747.173-1.6.844-2.2a2.884 2.884 0 012.984-.143c.941.5 2.583.57 2.866 1.629s.067 1.806-1.266 2.039z"
              fill="#fcbd92"
            />
            <path
              data-name="Path 9753"
              d="M310.177 220.222a.526.526 0 00-.059-.173c.156 1.081-.545 1.465-1.574 1.874-.9.354-1.465.2-1.731-.22l.051.228c.372 1.591-.722 2.174-1.908 2.111a1.814 1.814 0 01-1.836-1.5 9 9 0 00-.616 1.081c.034 1.688-1.4 2.2-2.837 2.018-1.5-.182-2.33-1.194-1.975-2.284.025-.089.055-.194.08-.3a1.156 1.156 0 00-.2.7 1.9 1.9 0 01-.515 1.338 2.854 2.854 0 00-2.773.236c-.663.557-1.228 1.87-.844 2.195s1.431.11 2.271.747 1.127.933 3.157.578a2.034 2.034 0 00.781-.262 1.241 1.241 0 00.684-1.03c0-.688.038-.6.625-1.266.241 1.228 1.815 1.363 2.875.844a4.892 4.892 0 001.866-2.157 2.88 2.88 0 001.38-.278c1.156-.557 1.566-1.823 2.11-2.532s1.238-.694.988-1.948z"
              opacity={0.05}
            />
            <path
              data-name="Path 9754"
              d="M299.493 197.771c-2.322 0-4.293 4.116-4.5 7.568s-2.055 8.565-2.055 10.092 5.416 2.723 7.665 2.655 7.952-2.06 8.585-3.917-.072-8.231-2.11-11.684a9.635 9.635 0 00-7.585-4.714z"
              fill="#fcbd92"
            />
            <path
              data-name="Path 9755"
              d="M293.01 215.039a22.687 22.687 0 01-.984 6.893c-.469 1.009.325 1.946 1.9 2.11s3.216-.359 3.2-2.064.11-4.107.937-5.513-.874-2.2-2.17-2.457-2.846-.113-2.883 1.031z"
              fill="#fcbd92"
            />
            <path
              data-name="Path 9756"
              d="M296.632 223.329a7.71 7.71 0 00-1.051 4.7c.165.827-.95 1.735-2.6 1.688s-2.634-.962-1.887-2.026a8.358 8.358 0 00.865-4.8c-.215-.963.844-1.612 2.292-1.587s3.254.506 2.381 2.025z"
              fill="#fcbd92"
            />
            <path
              data-name="Path 9757"
              d="M298.004 215.904a27.268 27.268 0 01-.312 7.446c-.35 1.089.477 2.111 1.975 2.284s3-.388 2.828-2.237-.122-5.187.532-6.7-1.41-2-2.406-1.9c-1.266.128-2.68-.125-2.617 1.107z"
              fill="#fcbd92"
            />
            <path
              data-name="Path 9758"
              d="M305.284 213.878a35.092 35.092 0 011.359 6.969c-.076.967.523 1.621 1.9 1.076 1.068-.422 1.794-.815 1.562-1.988-.312-1.6-1.03-4.457-.8-5.825s-1.448-1.591-2.2-1.418c-.951.223-2.095.126-1.821 1.186z"
              fill="#fcbd92"
            />
            <path
              data-name="Path 9759"
              d="M302.411 215.694a26.934 26.934 0 01.718 6.479 1.75 1.75 0 001.832 1.87c1.186.072 2.279-.511 1.908-2.111a17.422 17.422 0 01-.452-5.85c.313-1.351-1.355-1.65-2.11-1.507-.977.186-2.112.043-1.896 1.119z"
              fill="#fcbd92"
            />
            <path
              data-name="Path 9760"
              d="M295.584 228.272c-.169 2.419-.16 3.326-.629 4.01s-1.152 1.456-1.714 1.562-2.533.106-3.128-.452-.2-1.355-.219-2.313a8.254 8.254 0 011.1-3.225c.378-.655 4.666-.655 4.59.418z"
              fill="#fcbd92"
            />
            <path
              data-name="Path 9761"
              d="M294.504 230.729a6.7 6.7 0 01-2.832-.262 5.066 5.066 0 00-.612 2.233 7.208 7.208 0 003.145.3c.156-.975.299-2.271.299-2.271z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 9762"
              d="M295.732 201.853c-3.984 3.571-3.064 5.546-5.036 7.273-.772 1.325-.422 2.617-2.182 4.031s-3.233 1.266-3.727 2.208.143 1.6 2.11 2.659 5.234-1.3 5.572-3.238 5.487-.844 7.724-5.348-1.607-10.139-4.461-7.585z"
              fill="#fcbd92"
            />
            <path
              data-name="Path 9763"
              d="M294.99 205.339a33.242 33.242 0 01-.566 1.954 19.105 19.105 0 00-.536 1.925q-.11.462-.173.933a4.375 4.375 0 00-.034.9 2.853 2.853 0 00.051.422 2.426 2.426 0 00.093.422 3.859 3.859 0 00.143.422l.182.4.084.182-.051.312c-.072.422-.135.878-.19 1.3a8.12 8.12 0 00-.063.608v.258a.175.175 0 000 .047v-.076l.047.042v.3a30.136 30.136 0 01-.148 3.8c-.034.321-.076.642-.122.967s-.1.654-.182 1c-.042.169-.093.346-.148.528-.034.093-.055.182-.1.283l-.1.253a.258.258 0 000-.059v-.127l.063.279a5.441 5.441 0 01.118.941c0 .279 0 .54-.025.8a12.291 12.291 0 01-.207 1.528 7.162 7.162 0 01-.207.755 9.764 9.764 0 01-.287.768 5.409 5.409 0 01-.422.8l-.182.253s-.025.046 0-.042v.029l-.047.072-.08.122a11.362 11.362 0 00-.616 1.085c-.093.186-.173.371-.249.557s-.143.354-.194.515c-.029.08-.038.152-.067.215a.6.6 0 00-.034.194l-.046.215a4.513 4.513 0 01-.291.73c-.093.207-.181.384-.257.57a1.047 1.047 0 00-.03.654 1.061 1.061 0 01-.3-.6 2.862 2.862 0 010-.684c.025-.228.055-.456.067-.684s0-.46.03-.688a6.491 6.491 0 01.359-1.321 12.42 12.42 0 01.561-1.266c.1-.2.219-.4.342-.6a3.75 3.75 0 00.3-.616 7.505 7.505 0 00.363-1.325 10.523 10.523 0 00.173-1.359 5.516 5.516 0 00-.051-1.372 1.207 1.207 0 01.038-.9 4.819 4.819 0 00.3-.87 15.332 15.332 0 00.354-1.807 36.721 36.721 0 00.334-3.664 1.612 1.612 0 010-.667c.034-.224.072-.443.118-.663.089-.443.194-.878.3-1.313l-.169-.477c-.038-.165-.084-.325-.118-.49a4.812 4.812 0 01-.063-.5 4.03 4.03 0 010-.506 5.316 5.316 0 01.126-1c.03-.169.08-.329.123-.49s.1-.321.152-.481c.432-1.236 1.032-2.444 1.534-3.693z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 9764"
              d="M295.732 201.853l-.321.473c-.106.16-.228.3-.325.464l-.3.464c-.1.152-.186.317-.278.473s-.186.317-.266.477-.177.312-.249.473c-.156.321-.291.646-.422.967a10.4 10.4 0 00-.333 1c-.1.346-.211.7-.346 1.081a8.264 8.264 0 01-.224.587 4.834 4.834 0 01-.312.6 4.7 4.7 0 01-.4.578c-.144.186-.312.35-.469.523l.245-.3a3.854 3.854 0 00-.139.376l-.114.443-.139.536a6.475 6.475 0 01-.182.625 3.834 3.834 0 01-.283.675 4.8 4.8 0 01-.422.642 5.146 5.146 0 01-.469.561 4.923 4.923 0 01-.54.456l-.139.105-.034.025h-.034l-.059.038-.245.148a4.806 4.806 0 01-.616.321 8.376 8.376 0 01-1.211.422 5.017 5.017 0 01-.583.135c-.186.03-.384.025-.553.038l-.532-.025a1.816 1.816 0 00-.629.08 1.424 1.424 0 01.372-.422 2.809 2.809 0 01.489-.279c.346-.156.7-.283 1.047-.422a7.49 7.49 0 001.929-1.165c.144-.122.279-.253.422-.388a3.972 3.972 0 00.359-.422 3.575 3.575 0 00.3-.481 4.342 4.342 0 00.228-.515c.131-.355.228-.718.338-1.081.055-.177.118-.359.19-.532a5.51 5.51 0 01.245-.507c.131-.135.274-.253.4-.4a4.215 4.215 0 00.342-.422 6.107 6.107 0 00.536-.979l.422-1.026c.148-.342.312-.675.486-1l.283-.481.308-.469c.1-.152.219-.3.329-.447a4.351 4.351 0 01.354-.422c.123-.131.232-.287.367-.422l.384-.422c.244-.251.529-.5.793-.757z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 9765"
              d="M310.105 219.936a4.706 4.706 0 01-.422-.312c-.135-.106-.274-.207-.388-.317a7.15 7.15 0 01-.667-.671 6.642 6.642 0 01-.54-.718 5.913 5.913 0 01-.422-.764 4.247 4.247 0 01-.177-.422 4.477 4.477 0 01-.152-.422c-.038-.148-.084-.287-.122-.422a1.9 1.9 0 01-.055-.469 1.216 1.216 0 01.055-.5 2.171 2.171 0 01.22-.54 1.737 1.737 0 01.422-.523.927.927 0 00.253 0 1.267 1.267 0 00.321-.055v-.285l-.047-.633a5.449 5.449 0 00-.068-.658c-.03-.236-.059-.447-.084-.671s-.067-.452-.089-.675l-.2-1.359c-.03-.228-.076-.452-.114-.68l-.114-.68c-.076-.452-.177-.9-.262-1.351-.047-.224-.089-.447-.144-.667s-.093-.452-.148-.671-.1-.422-.156-.667l-.173-.658c-.063-.215-.139-.422-.2-.646l-.224-.633.03.046c-.042-.089-.1-.194-.152-.3l-.173-.308c-.118-.2-.245-.422-.376-.6a12.219 12.219 0 00-.844-1.157 11.968 11.968 0 00-.958-1.059 7.162 7.162 0 00-.549-.469c-.1-.072-.186-.161-.287-.224l-.3-.207.329.156a2.939 2.939 0 01.321.173 6.359 6.359 0 01.612.4 11.812 11.812 0 011.114.941 16.369 16.369 0 011.912 2.2l.346.637.3.654c.186.448.359.9.507 1.359.08.228.143.46.215.692s.127.464.19.7a24.034 24.034 0 01.557 2.845c.067.481.118.958.156 1.439s.059.962.055 1.448a9.219 9.219 0 01-.106 1.444 4.456 4.456 0 01-.042.785 6.17 6.17 0 000 .789c.038.523.114 1.047.2 1.566.201 1.063.433 2.089.64 3.119z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 9766"
              d="M312.697 204.296a10.1 10.1 0 00-4.432-9.637c-5.42-3.516-11.608-.633-11.891.912.072 1.621 0 3.026 0 3.026a16.924 16.924 0 01-2.532 3.238c-1.212 1.051-2.056 4.149-3.858 5.838s-.562 3.677-3.107 4.985-4.166 3.246-3.178 4.74a5 5 0 007.737.3c.072 1.9-.764 3.668-.912 4.715s.562 2.583-.7 5.116-1.477 5.749.051 6.8 4.643.844 5.53-1.3a5.772 5.772 0 00.591-3.3s2.482.781 3.748 0a1.985 1.985 0 001.135-1.8 4.174 4.174 0 003.026.051 3.322 3.322 0 001.87-2 3.17 3.17 0 002.849-1.41c1-1.6 2.689-2.018 2.533-3.972s-.844-3.533-.92-6.277-.274-6.83-1.051-8.442a26.489 26.489 0 013.511-1.583z"
              fill="#f15a29"
              opacity={0.5}
            />
            <path
              data-name="Rectangle 1320"
              fill="#516a80"
              d="M226.436 25.537h18.163v7.146h-18.163z"
            />
            <path
              data-name="Rectangle 1321"
              fill="#a9c4cd"
              d="M231.784 32.679h7.467v4.643h-7.467z"
            />
            <path
              data-name="Path 9767"
              d="M245.695 28.576h-20.36l1.1-3.039h18.16z"
              fill="#516a80"
            />
            <path
              data-name="Path 9768"
              d="M243.079 28.576h-15.128l.819-3.039h13.49z"
              fill="#ffe6d2"
              opacity={0.2}
            />
            <path
              data-name="Path 9769"
              d="M243.08 25.538h-15.145l1.688-8.071c.33-1.6 1.312-2.693 2.423-2.693h6.982c1.11 0 2.11 1.093 2.423 2.693z"
              fill="#516a80"
            />
            <path
              data-name="Path 9770"
              d="M240.255 25.538h-9.48l.984-7.67c.232-1.794 1.266-3.094 2.486-3.094h2.533c1.216 0 2.262 1.3 2.49 3.094z"
              fill="#ffe6d2"
              opacity={0.15}
            />
            <path
              data-name="Path 9771"
              d="M235.532 34.697a4.5 4.5 0 013.732 2.185v-4.22h-7.48v4.22a4.5 4.5 0 013.748-2.185z"
              opacity={0.15}
            />
            <path
              data-name="Path 9772"
              d="M235.532 27.301c-23.384 0-42.341 12.9-42.341 36.28l17.859 2.2h48.917l17.889-2.2c0-23.385-18.955-36.28-42.324-36.28z"
              fill="#f26522"
              opacity={0.5}
            />
            <path
              data-name="Path 9773"
              d="M235.532 27.301c-13.507 0-24.448 15.1-24.448 38.483h48.883c.001-23.384-10.928-38.483-24.435-38.483z"
              fill="#ffe6d2"
              opacity={0.3}
            />
            <path
              data-name="Path 9774"
              d="M258.828 37.369c0 5.019-10.439 3.93-23.313 3.93s-23.313 1.089-23.313-3.93 10.44-9.088 23.331-9.088 23.295 4.069 23.295 9.088z"
              fill="#ffe6d2"
              opacity={0.3}
            />
            <path
              data-name="Rectangle 1322"
              fill="#535363"
              d="M234.701 0h1.634v14.774h-1.634z"
            />
            <path
              data-name="Rectangle 1323"
              fill="#ffe6d2"
              opacity={0.15}
              d="M235.115 0h.806v14.774h-.806z"
            />
            <path
              data-name="Path 9775"
              d="M277.857 63.581l-23.617-1.427h-37.444l-23.621 1.427 17.893 2.2h48.9z"
              opacity={0.15}
            />
            <path
              data-name="Path 9776"
              d="M277.856 63.581h-3.651l-4.187-.055c-1.617 0-3.44-.042-5.424-.118l-6.416-.2-3.5-.114h-1.76l-1.845.03c-2.482.025-5.065.089-7.657.093l-7.906.038-7.906-.038c-2.609 0-5.175-.068-7.657-.093l-1.845-.03h-1.756l-3.5.114-6.416.2c-1.984.076-3.8.1-5.424.118l-4.183.055c-1.161.025-2.077 0-2.7 0h-.954l13.237-.8 6.4-.388 3.5-.211c.6-.055 1.2 0 1.811-.03h34.8c.612 0 1.216-.025 1.811.03l3.5.211 6.4.388z"
              opacity={0.15}
            />
            <path
              data-name="Path 9784"
              d="M272.373 230.775c-2.621 0-4.04-3.854-4.884-6.792-1.443-5.015-2.63-13.085-3.52-24.03a253.993 253.993 0 01-.907-30.13c.553-13.254 2.6-13.419 3.465-13.507a.849.849 0 11.177 1.688c-.144.11-1.587 1.494-1.984 12.663a261.5 261.5 0 00.933 29.159c.886 10.865 2.043 18.792 3.457 23.7 1.481 5.145 2.82 5.593 3.351 5.563a.847.847 0 01.135 1.688 1.983 1.983 0 01-.223-.002z"
              fill="#747481"
            />
            <path
              data-name="Path 9785"
              d="M272.112 230.678c-2.836 0-6.1-3.567-6.1-31.409a258.56 258.56 0 011.545-30.1c1.629-13.165 3.677-13.165 4.55-13.165a.844.844 0 01.038 1.688c-.152.1-1.689 1.359-3.005 12.448a262.152 262.152 0 00-1.439 29.125c0 27.58 3.377 29.72 4.407 29.72a.844.844 0 110 1.688z"
              fill="#a6a6ae"
            />
            <path
              data-name="Path 9786"
              d="M268.266 231.079c-2.836 0-6.1-3.571-6.1-31.409a258.422 258.422 0 011.545-30.1c1.629-13.165 3.676-13.165 4.55-13.165a.844.844 0 01.038 1.688c-.152.1-1.689 1.359-3.005 12.448a262.235 262.235 0 00-1.439 29.125c0 27.576 3.377 29.72 4.407 29.72a.844.844 0 010 1.688z"
              fill="#92929c"
            />
            <path
              data-name="Path 9787"
              d="M274.627 230.631c-2.621 0-4.044-3.85-4.888-6.787-1.443-5.015-2.625-13.085-3.52-24.03a255 255 0 01-.907-30.129c.557-13.254 2.6-13.423 3.47-13.507a.849.849 0 11.173 1.688c-.144.11-1.583 1.49-1.984 12.663a262.564 262.564 0 00.933 29.159c.887 10.869 2.047 18.792 3.461 23.7 1.482 5.145 2.82 5.6 3.347 5.563a.847.847 0 11.135 1.688z"
              fill="#747481"
            />
            <path
              data-name="Path 9788"
              d="M276.219 230.374c-2.621 0-4.039-3.854-4.884-6.787-1.443-5.015-2.63-13.085-3.52-24.03a254.061 254.061 0 01-.907-30.13c.553-13.258 2.6-13.423 3.465-13.507a.849.849 0 11.173 1.688c-.143.11-1.583 1.49-1.984 12.663a263.539 263.539 0 00.933 29.154c.882 10.865 2.047 18.792 3.461 23.7 1.481 5.145 2.82 5.6 3.347 5.563a.847.847 0 01.139 1.688z"
              fill="#868691"
            />
            <path
              data-name="Path 9789"
              d="M278.476 230.233c-2.625 0-4.044-3.854-4.888-6.792-1.443-5.015-2.63-13.085-3.52-24.026a258.734 258.734 0 01-.907-30.134c.557-13.254 2.6-13.419 3.465-13.507a.849.849 0 01.177 1.688c-.143.11-1.583 1.49-1.984 12.663a261.592 261.592 0 00.933 29.159c.886 10.865 2.047 18.792 3.457 23.7 1.482 5.145 2.824 5.6 3.351 5.563a.847.847 0 01.135 1.688z"
              fill="#92929c"
            />
            <rect
              data-name="Rectangle 1329"
              width={27.293}
              height={27.293}
              rx={5.05}
              transform="translate(50.454 317.462)"
              fill="#d1d3d4"
              opacity={0.3}
            />
            <rect
              data-name="Rectangle 1330"
              width={20.185}
              height={20.185}
              rx={3.73}
              transform="translate(54.008 321.016)"
              fill="#788b9c"
            />
            <path
              data-name="Path 9790"
              d="M72.602 321.016h-17.02a1.575 1.575 0 00-1.574 1.574v6.982c2.448 1.6 6.057 1.938 10.092 1.938s7.644-.342 10.092-1.937v-6.982a1.579 1.579 0 00-1.591-1.574z"
              fill="#fff"
              opacity={0.15}
            />
            <circle
              data-name="Ellipse 440"
              cx={7.526}
              cy={7.526}
              r={7.526}
              transform="rotate(-45 426.407 101.022)"
              fill="#fff"
              opacity={0.5}
            />
            <path
              data-name="Path 9791"
              d="M64.907 338.339a.148.148 0 01-.11-.042.152.152 0 01-.055-.122v-1.528h-1.266v1.528a.164.164 0 01-.055.122.156.156 0 01-.11.042 7.282 7.282 0 01-5.605-3.8.173.173 0 010-.165.165.165 0 01.143-.08h.274v-1.891h-1.017a.169.169 0 01-.165-.139 7.344 7.344 0 010-2.275.169.169 0 01.165-.139h1.017v-1.895h-.3a.165.165 0 01-.144-.08.173.173 0 010-.165 7.281 7.281 0 015.605-3.82.156.156 0 01.11.042.165.165 0 01.055.122v1.528h1.266v-1.527a.152.152 0 01.055-.122.148.148 0 01.11-.042 7.277 7.277 0 015.605 3.82.165.165 0 01-.144.245h-.274v1.899h1.017a.169.169 0 01.165.139 7.345 7.345 0 010 2.275.169.169 0 01-.165.139h-.979v1.891h.274a.165.165 0 01.143.245 7.277 7.277 0 01-5.605 3.8z"
              fill="#fff"
              opacity={0.15}
            />
            <rect
              data-name="Rectangle 1331"
              width={5.508}
              height={2.22}
              rx={1.11}
              transform="translate(61.344 333.168)"
              opacity={0.3}
            />
            <path
              data-name="Path 9792"
              d="M61.906 331.104a1.132 1.132 0 11-.333-.8 1.135 1.135 0 01.333.8z"
              opacity={0.3}
            />
            <path
              data-name="Path 9793"
              d="M68.562 331.104a1.135 1.135 0 11-1.135-1.131 1.136 1.136 0 011.135 1.131z"
              opacity={0.3}
            />
            <path
              data-name="Path 9794"
              d="M65.029 331.273a.945.945 0 11-.929-1.114 1.034 1.034 0 01.929 1.114z"
              opacity={0.3}
            />
            <path
              data-name="Path 9795"
              d="M61.733 331.102a.962.962 0 11-.962-.962.962.962 0 01.962.962z"
              fill="#1c1f23"
            />
            <path
              data-name="Path 9796"
              d="M68.381 331.102a.962.962 0 11-.962-.962.962.962 0 01.962.962z"
              fill="#1c1f23"
            />
            <path
              data-name="Path 9797"
              d="M65.663 327.753a1.562 1.562 0 11-1.562-1.562 1.562 1.562 0 011.562 1.562z"
              opacity={0.3}
            />
            <path
              data-name="Path 9798"
              d="M64.936 331.104a.844.844 0 11-.844-.844.844.844 0 01.844.844z"
              fill="#535363"
            />
            <path
              data-name="Path 9799"
              d="M64.696 330.965h-.456v-.456h-.279v.456h-.456v.283h.456v.456h.283v-.456h.456z"
              fill="#1c1f23"
              opacity={0.2}
            />
            <path
              data-name="Path 9800"
              d="M63.961 330.965v-.46h.283v.456h.393a.368.368 0 00.063-.2c0-.241-.266-.422-.6-.422s-.6.2-.6.422a.342.342 0 00.068.2z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Rectangle 1332"
              fill="#1c1f23"
              opacity={0.2}
              d="M63.957 331.319h.017v.38h-.017z"
            />
            <path
              data-name="Rectangle 1333"
              fill="#1c1f23"
              opacity={0.2}
              d="M64.227 331.319h.017v.38h-.017z"
            />
            <path
              data-name="Path 9801"
              d="M64.24 330.965v-.456h-.279v.456h-.456v.283h.068v-.177h.405v-.405h.253v.405h.405v.177h.063v-.283z"
              fill="#1c1f23"
              opacity={0.2}
            />
            <path
              data-name="Path 9802"
              d="M142.744 781.784a.148.148 0 01-.11-.042.152.152 0 01-.055-.122v-1.528h-1.266v1.528a.164.164 0 01-.055.122.156.156 0 01-.11.042 7.282 7.282 0 01-5.605-3.8.173.173 0 010-.165.165.165 0 01.143-.08h.274v-1.891h-1.017a.169.169 0 01-.165-.139 7.344 7.344 0 010-2.275.169.169 0 01.165-.139h1.017V771.4h-.3a.165.165 0 01-.144-.08.173.173 0 010-.165 7.281 7.281 0 015.605-3.82.156.156 0 01.11.042.165.165 0 01.055.122v1.528h1.266V767.5a.152.152 0 01.055-.122.148.148 0 01.11-.042 7.277 7.277 0 015.605 3.82.165.165 0 01-.144.245h-.274v1.899h1.017a.169.169 0 01.165.139 7.345 7.345 0 010 2.275.169.169 0 01-.165.139h-.979v1.891h.274a.165.165 0 01.143.245 7.277 7.277 0 01-5.605 3.8z"
              transform="translate(-77.837 -443.445)"
              opacity={0.5}
              fill="url(#prefix__a)"
            />
            <g data-name="Group 481" opacity={0.15}>
              <path
                data-name="Path 9803"
                d="M55.326 321.683h17.547a1.536 1.536 0 011.309.735 1.575 1.575 0 00-1.566-1.4H55.583a1.579 1.579 0 00-1.566 1.4 1.541 1.541 0 011.309-.735z"
                fill="#fff"
              />
              <path
                data-name="Path 9804"
                d="M72.873 340.53H55.33a1.541 1.541 0 01-1.3-.739 1.579 1.579 0 001.566 1.4h17.006a1.574 1.574 0 001.566-1.4 1.536 1.536 0 01-1.295.739z"
                opacity={0.4}
              />
            </g>
            <circle
              data-name="Ellipse 441"
              cx={11.857}
              cy={11.857}
              r={11.857}
              transform="rotate(-80.85 269.881 88.702)"
              fill="#ef4136"
            />
            <path
              data-name="Path 9805"
              d="M159.496 321.219c.152.591.3 1.19.46 1.777a1.688 1.688 0 00.806.928 3.986 3.986 0 011.165 1.321c.152.279.7 1.165.329 1.4-.688.422-.878-.629-1.017-1a3.439 3.439 0 00-1.169-1.655c-.089-.059-.211-.106-.3-.047a.2.2 0 00-.03.266.725.725 0 00.207.2 1.659 1.659 0 01.6 1.186c.025.367-.118 1.076-.629.642-.106-.089-.2-.308-.312-.422s-.333-.317-.481-.494a18.255 18.255 0 01-1.57-2.406 14.129 14.129 0 00-3.187-3.588 11.627 11.627 0 00-1.439-.093 11.865 11.865 0 00-11.654 9.67 6.164 6.164 0 00.992.312 1.791 1.791 0 001.925-.49 1.3 1.3 0 00.1-1.072c-.059-.177-.367-.494-.27-.658a.313.313 0 01.384-.1c.139.059.215.186.334.266 1.047.735 2.245 1.3 3.326 1.992s2.191 1.456 3.25 2.237a62.9 62.9 0 015.99 5.019 5.1 5.1 0 001.228.946 1.578 1.578 0 001.49 0 .979.979 0 00.384-1.2c-.072-.27-.156-.346.139-.456.481-.186 1.081.287 1.566.123s.393-.448.266-.79-.173-.747-.283-1.114a5.672 5.672 0 01-.494-1.819.422.422 0 01.135-.312c.224-.173 1.266.739 1.49.929.422.371.844.756 1.233 1.144a11.848 11.848 0 00-4.964-12.642z"
              fill="#fff"
              opacity={0.2}
            />
            <circle
              data-name="Ellipse 442"
              cx={7.526}
              cy={7.526}
              r={7.526}
              transform="rotate(-80.83 270.246 83.943)"
              fill="#fbe5c4"
            />
            <path
              data-name="Path 9806"
              d="M153.742 338.339a.165.165 0 01-.169-.165v-1.528h-1.266v1.528a.166.166 0 01-.055.123.157.157 0 01-.11.042h-.021a7.281 7.281 0 01-5.605-3.8.172.172 0 010-.164.164.164 0 01.143-.08h.274v-1.891h-1.017a.168.168 0 01-.165-.139 7.349 7.349 0 010-2.275.168.168 0 01.165-.139h1.017v-1.896h-.274a.164.164 0 01-.143-.08.173.173 0 010-.165 7.281 7.281 0 015.605-3.82h.021a.154.154 0 01.11.042.164.164 0 01.055.122v1.528h1.266v-1.527a.165.165 0 01.169-.165 7.277 7.277 0 015.605 3.82.165.165 0 01-.148.245h-.27v1.9h1.044a.164.164 0 01.165.139 7.342 7.342 0 010 2.275.164.164 0 01-.165.139h-1.01v1.891h.27a.165.165 0 01.148.245 7.277 7.277 0 01-5.605 3.8z"
              fill="#fff"
              opacity={0.15}
            />
            <rect
              data-name="Rectangle 1334"
              width={5.508}
              height={2.22}
              rx={1.11}
              transform="translate(150.179 333.168)"
              opacity={0.3}
            />
            <path
              data-name="Path 9807"
              d="M150.736 331.104a1.131 1.131 0 11-1.131-1.131 1.131 1.131 0 011.131 1.131z"
              opacity={0.3}
            />
            <path
              data-name="Path 9808"
              d="M157.394 331.104a1.131 1.131 0 11-1.131-1.131 1.131 1.131 0 011.131 1.131z"
              opacity={0.3}
            />
            <path
              data-name="Path 9809"
              d="M153.861 331.273a.941.941 0 11-.924-1.115 1.03 1.03 0 01.924 1.115z"
              opacity={0.3}
            />
            <path
              data-name="Path 9810"
              d="M150.568 331.102a.962.962 0 11-.962-.962.962.962 0 01.962.962z"
              fill="#1c1f23"
            />
            <path
              data-name="Path 9811"
              d="M157.224 331.102a.962.962 0 11-.962-.962.962.962 0 01.962.962z"
              fill="#1c1f23"
            />
            <circle
              data-name="Ellipse 443"
              cx={1.562}
              cy={1.562}
              r={1.562}
              transform="translate(151.374 326.191)"
              opacity={0.3}
            />
            <path
              data-name="Path 9812"
              d="M153.771 331.104a.844.844 0 11-.844-.844.844.844 0 01.844.844z"
              fill="#535363"
            />
            <path
              data-name="Path 9813"
              d="M153.53 330.965h-.456v-.456h-.283v.456h-.455v.283h.456v.456h.283v-.456h.456z"
              fill="#1c1f23"
              opacity={0.2}
            />
            <path
              data-name="Path 9814"
              d="M152.801 330.965v-.46h.283v.456h.393a.367.367 0 00.063-.2c0-.241-.266-.422-.6-.422s-.6.2-.6.422a.342.342 0 00.068.2z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Rectangle 1335"
              fill="#1c1f23"
              opacity={0.2}
              d="M152.792 331.319h.017v.38h-.017z"
            />
            <path
              data-name="Rectangle 1336"
              fill="#1c1f23"
              opacity={0.2}
              d="M153.058 331.319h.017v.38h-.017z"
            />
            <path
              data-name="Path 9815"
              d="M153.075 330.965v-.456h-.283v.456h-.456v.283h.068v-.177h.405v-.405h.249v.405h.405v.177h.068v-.283z"
              fill="#1c1f23"
              opacity={0.2}
            />
            <path
              data-name="Path 9816"
              d="M353.169 781.784a.165.165 0 01-.169-.165v-1.528h-1.266v1.528a.166.166 0 01-.055.123.157.157 0 01-.11.042h-.021a7.281 7.281 0 01-5.605-3.8.172.172 0 010-.164.164.164 0 01.143-.08h.274v-1.891h-1.017a.168.168 0 01-.165-.139 7.349 7.349 0 010-2.275.168.168 0 01.165-.139h1.017V771.4h-.274a.164.164 0 01-.143-.08.173.173 0 010-.165 7.281 7.281 0 015.605-3.82h.021a.154.154 0 01.11.042.164.164 0 01.055.122v1.528H353V767.5a.165.165 0 01.169-.165 7.277 7.277 0 015.605 3.82.165.165 0 01-.148.245h-.27v1.9h1.044a.164.164 0 01.165.139 7.342 7.342 0 010 2.275.164.164 0 01-.165.139h-1.01v1.891h.27a.165.165 0 01.148.245 7.277 7.277 0 01-5.605 3.8z"
              transform="translate(-199.427 -443.445)"
              opacity={0.5}
              fill="url(#prefix__d)"
            />
            <path
              data-name="Path 9817"
              d="M152.936 319.669a11.856 11.856 0 0111.853 11.648v-.209a11.857 11.857 0 10-23.714 0v.211a11.857 11.857 0 0111.861-11.65z"
              fill="#fff"
              opacity={0.3}
            />
            <path
              data-name="Path 9818"
              d="M152.936 342.543a11.856 11.856 0 01-11.852-11.648v.208a11.857 11.857 0 1023.714 0v-.211a11.861 11.861 0 01-11.862 11.651z"
              opacity={0.2}
            />
            <path
              data-name="Path 9819"
              d="M130.429 317.462H86.303a2.11 2.11 0 00-2.132 2.11v23.047a2.111 2.111 0 002.132 2.111h44.126a2.11 2.11 0 002.132-2.111v-23.025a2.11 2.11 0 00-2.132-2.132z"
              fill="#41c3c4"
              opacity={0.3}
            />
            <rect
              data-name="Rectangle 1337"
              width={41.29}
              height={20.185}
              rx={3.73}
              transform="translate(87.725 321.016)"
              fill="#1c7f98"
            />
            <g data-name="Group 482" opacity={0.15}>
              <path
                data-name="Path 9820"
                d="M89.063 321.683h38.652a1.54 1.54 0 011.309.734 1.579 1.579 0 00-1.566-1.4H89.304a1.575 1.575 0 00-1.566 1.4 1.536 1.536 0 011.325-.734z"
                fill="#fff"
              />
              <path
                data-name="Path 9821"
                d="M127.698 340.529H89.063a1.537 1.537 0 01-1.309-.734 1.574 1.574 0 001.566 1.4h38.135a1.579 1.579 0 001.566-1.4 1.541 1.541 0 01-1.325.734z"
                opacity={0.4}
              />
            </g>
            <circle
              data-name="Ellipse 444"
              cx={7.526}
              cy={7.526}
              r={7.526}
              transform="rotate(-45 443.268 60.326)"
              fill="#fff"
              opacity={0.5}
            />
            <path
              data-name="Path 9822"
              d="M98.624 338.339a.159.159 0 01-.11-.042.165.165 0 01-.055-.123v-1.528h-1.266v1.528a.152.152 0 01-.055.123.149.149 0 01-.11.042 7.278 7.278 0 01-5.606-3.8.165.165 0 01.144-.245h.274v-1.891h-1.017a.168.168 0 01-.165-.139 7.345 7.345 0 010-2.275.168.168 0 01.165-.139h1.017v-1.895h-.274a.165.165 0 01-.143-.245 7.276 7.276 0 015.605-3.82.146.146 0 01.11.042.151.151 0 01.055.122v1.528h1.266v-1.527a.164.164 0 01.055-.122.154.154 0 01.11-.042 7.281 7.281 0 015.635 3.8.173.173 0 010 .165.164.164 0 01-.143.08h-.279v1.891h1.017a.169.169 0 01.165.139 7.345 7.345 0 010 2.275.169.169 0 01-.165.139h-1.017v1.891h.274a.164.164 0 01.144.08.173.173 0 010 .165 7.281 7.281 0 01-5.606 3.8z"
              fill="#fff"
              opacity={0.15}
            />
            <rect
              data-name="Rectangle 1338"
              width={5.508}
              height={2.22}
              rx={1.11}
              transform="translate(95.062 333.168)"
              opacity={0.3}
            />
            <path
              data-name="Path 9823"
              d="M95.623 331.104a1.135 1.135 0 11-1.131-1.131 1.136 1.136 0 011.131 1.131z"
              opacity={0.3}
            />
            <path
              data-name="Path 9824"
              d="M102.279 331.104a1.135 1.135 0 11-1.131-1.131 1.136 1.136 0 011.131 1.131z"
              opacity={0.3}
            />
            <path
              data-name="Path 9825"
              d="M98.747 331.273a.945.945 0 11-.929-1.114 1.03 1.03 0 01.929 1.114z"
              opacity={0.3}
            />
            <path
              data-name="Path 9826"
              d="M95.449 331.102a.962.962 0 11-.962-.962.962.962 0 01.962.962z"
              fill="#1c1f23"
            />
            <path
              data-name="Path 9827"
              d="M102.111 331.102a.962.962 0 11-.962-.962.962.962 0 01.962.962z"
              fill="#1c1f23"
            />
            <path
              data-name="Path 9828"
              d="M99.38 327.753a1.558 1.558 0 11-.456-1.105 1.562 1.562 0 01.456 1.105z"
              opacity={0.3}
            />
            <path
              data-name="Path 9829"
              d="M98.657 331.104a.844.844 0 11-.844-.844.844.844 0 01.844.844z"
              fill="#535363"
            />
            <path
              data-name="Path 9830"
              d="M98.418 330.965h-.456v-.456h-.283v.456h-.456v.283h.456v.456h.283v-.456h.456z"
              fill="#1c1f23"
              opacity={0.2}
            />
            <path
              data-name="Path 9831"
              d="M97.679 330.965v-.46h.283v.456h.388a.342.342 0 00.068-.2c0-.241-.27-.422-.6-.422s-.6.2-.6.422a.367.367 0 00.063.2z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Rectangle 1339"
              fill="#1c1f23"
              opacity={0.2}
              d="M97.679 331.319h.017v.38h-.017z"
            />
            <path
              data-name="Rectangle 1340"
              fill="#1c1f23"
              opacity={0.2}
              d="M97.945 331.319h.017v.38h-.017z"
            />
            <path
              data-name="Path 9832"
              d="M97.962 330.965v-.456h-.283v.456h-.456v.283h.063v-.177h.405v-.405h.253v.405h.405v.177h.068v-.283z"
              fill="#1c1f23"
              opacity={0.2}
            />
            <path
              data-name="Path 9833"
              d="M222.624 781.784a.159.159 0 01-.11-.042.165.165 0 01-.055-.123v-1.528h-1.266v1.528a.152.152 0 01-.055.123.149.149 0 01-.11.042 7.278 7.278 0 01-5.606-3.8.165.165 0 01.144-.245h.274v-1.891h-1.017a.168.168 0 01-.165-.139 7.345 7.345 0 010-2.275.168.168 0 01.165-.139h1.017V771.4h-.274a.165.165 0 01-.143-.245 7.276 7.276 0 015.605-3.82.146.146 0 01.11.042.151.151 0 01.055.122v1.528h1.266V767.5a.164.164 0 01.055-.122.154.154 0 01.11-.042 7.281 7.281 0 015.635 3.8.173.173 0 010 .165.164.164 0 01-.143.08h-.279v1.891h1.017a.169.169 0 01.165.139 7.345 7.345 0 010 2.275.169.169 0 01-.165.139h-1.017v1.891h.274a.164.164 0 01.144.08.173.173 0 010 .165 7.281 7.281 0 01-5.606 3.8z"
              transform="translate(-124 -443.445)"
              opacity={0.5}
              fill="url(#prefix__e)"
            />
            <circle
              data-name="Ellipse 445"
              cx={7.526}
              cy={7.526}
              r={7.526}
              transform="rotate(-45 453.818 34.846)"
              fill="#fff"
              opacity={0.5}
            />
            <path
              data-name="Path 9834"
              d="M119.729 338.339a.158.158 0 01-.11-.042.166.166 0 01-.055-.123v-1.528h-1.266v1.528a.153.153 0 01-.055.123.149.149 0 01-.11.042 7.278 7.278 0 01-5.605-3.8.165.165 0 01.144-.245h.274v-1.891h-1.017a.168.168 0 01-.165-.139 7.345 7.345 0 010-2.275.168.168 0 01.165-.139h1.017v-1.895h-.274a.165.165 0 01-.144-.245 7.277 7.277 0 015.605-3.82.146.146 0 01.11.042.151.151 0 01.055.122v1.528h1.266v-1.527a.164.164 0 01.055-.122.154.154 0 01.11-.042h.021a7.281 7.281 0 015.614 3.8.173.173 0 010 .165.165.165 0 01-.144.08h-.279v1.891h1.017a.169.169 0 01.165.139 7.347 7.347 0 010 2.275.169.169 0 01-.165.139h-1.017v1.891h.274a.164.164 0 01.143.08.173.173 0 010 .165 7.282 7.282 0 01-5.605 3.8z"
              fill="#fff"
              opacity={0.15}
            />
            <rect
              data-name="Rectangle 1341"
              width={5.508}
              height={2.22}
              rx={1.11}
              transform="translate(116.167 333.168)"
              opacity={0.3}
            />
            <path
              data-name="Path 9835"
              d="M116.728 331.104a1.135 1.135 0 11-1.131-1.131 1.136 1.136 0 011.131 1.131z"
              opacity={0.3}
            />
            <path
              data-name="Path 9836"
              d="M123.384 331.104a1.135 1.135 0 11-1.131-1.131 1.136 1.136 0 011.131 1.131z"
              opacity={0.3}
            />
            <path
              data-name="Path 9837"
              d="M119.852 331.273a.946.946 0 11-.929-1.114 1.03 1.03 0 01.929 1.114z"
              opacity={0.3}
            />
            <path
              data-name="Path 9838"
              d="M116.554 331.102a.962.962 0 11-.962-.962.962.962 0 01.962.962z"
              fill="#1c1f23"
            />
            <path
              data-name="Path 9839"
              d="M123.216 331.102a.962.962 0 11-.962-.962.962.962 0 01.962.962z"
              fill="#1c1f23"
            />
            <path
              data-name="Path 9840"
              d="M120.485 327.753a1.558 1.558 0 11-.456-1.105 1.562 1.562 0 01.456 1.105z"
              opacity={0.3}
            />
            <path
              data-name="Path 9841"
              d="M119.762 331.104a.844.844 0 11-.844-.844.844.844 0 01.844.844z"
              fill="#535363"
            />
            <path
              data-name="Path 9842"
              d="M119.523 330.965h-.456v-.456h-.283v.456h-.456v.283h.456v.456h.283v-.456h.456z"
              fill="#1c1f23"
              opacity={0.2}
            />
            <path
              data-name="Path 9843"
              d="M118.784 330.965v-.46h.283v.456h.388a.343.343 0 00.068-.2c0-.241-.27-.422-.6-.422s-.6.2-.6.422a.367.367 0 00.063.2z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Rectangle 1342"
              fill="#1c1f23"
              opacity={0.2}
              d="M118.784 331.319h.017v.38h-.017z"
            />
            <path
              data-name="Rectangle 1343"
              fill="#1c1f23"
              opacity={0.2}
              d="M119.05 331.319h.017v.38h-.017z"
            />
            <path
              data-name="Path 9844"
              d="M119.067 330.965v-.456h-.283v.456h-.456v.283h.063v-.177h.405v-.405h.253v.405h.405v.177h.068v-.283z"
              fill="#1c1f23"
              opacity={0.2}
            />
            <path
              data-name="Path 9845"
              d="M272.624 781.784a.158.158 0 01-.11-.042.166.166 0 01-.055-.123v-1.528h-1.266v1.528a.153.153 0 01-.055.123.149.149 0 01-.11.042 7.278 7.278 0 01-5.605-3.8.165.165 0 01.144-.245h.274v-1.891h-1.017a.168.168 0 01-.165-.139 7.345 7.345 0 010-2.275.168.168 0 01.165-.139h1.017V771.4h-.274a.165.165 0 01-.144-.245 7.277 7.277 0 015.605-3.82.146.146 0 01.11.042.151.151 0 01.055.122v1.528h1.266V767.5a.164.164 0 01.055-.122.154.154 0 01.11-.042h.021a7.281 7.281 0 015.614 3.8.173.173 0 010 .165.165.165 0 01-.144.08h-.279v1.891h1.017a.169.169 0 01.165.139 7.347 7.347 0 010 2.275.169.169 0 01-.165.139h-1.017v1.891h.274a.164.164 0 01.143.08.173.173 0 010 .165 7.282 7.282 0 01-5.605 3.8z"
              transform="translate(-152.895 -443.445)"
              opacity={0.5}
              fill="url(#prefix__f)"
            />
            <path
              data-name="Path 9846"
              d="M111.434 341.014a33.492 33.492 0 01-10.071-3.263 7.5 7.5 0 01-10.831-8.514 33.7 33.7 0 01-2.807-3.8v9.083l.177.068a14.756 14.756 0 015.753 3.55 6.934 6.934 0 011.566 3.031h17.281c-.363-.045-.73-.112-1.068-.155z"
              fill="#fff"
              opacity={0.15}
            />
            <g data-name="Group 483" opacity={0.15} fill="#fff">
              <path
                data-name="Path 9847"
                d="M118.923 338.63a7.6 7.6 0 01-1.845-.236 5.8 5.8 0 01.11 2.8h10.02l-3.858-4.014a7.47 7.47 0 01-4.427 1.45z"
              />
              <path
                data-name="Path 9848"
                d="M127.44 321.016H92.71a49.19 49.19 0 0118.695 10.219v-.131a7.5 7.5 0 012.533-5.631 3.432 3.432 0 01.566-2.216c1.266-1.794 3.98-1.634 6.057-.924a19.505 19.505 0 017.919 5.175c.186.194.359.422.532.6v-5.521a1.575 1.575 0 00-1.572-1.571z"
              />
            </g>
            <path
              data-name="Path 9849"
              d="M34.241 413.182a400.828 400.828 0 017.328 8.919h17.04c-3.579-3.883-8.615-9.142-14.807-15.2-3.276-3.2-6.842-6.631-10.662-10.21s-7.885-7.319-12.081-11.16q-3.166-2.881-6.332-5.846l-.506-.472c.545.211 1.093.422 1.646.612a57.288 57.288 0 009.978 2.613 40 40 0 008.079.515 16.565 16.565 0 001.845 1.891 17.608 17.608 0 003 2.144 20.524 20.524 0 006.8 2.377 22.116 22.116 0 006.678.105 19.5 19.5 0 005.614-1.591 14.855 14.855 0 004.01-2.655 12.19 12.19 0 001.338-1.486 11.438 11.438 0 00.933-1.456 10.713 10.713 0 00.937-2.49c.093-.35.135-.658.186-.928a5.983 5.983 0 00.076-.692 2.971 2.971 0 01.034-.511l-2.533-.051v1.064a4.466 4.466 0 01-.1.777 8.238 8.238 0 01-.642 2.111 10.128 10.128 0 01-.709 1.266 9.946 9.946 0 01-1.068 1.3 12.245 12.245 0 01-3.377 2.414 17.2 17.2 0 01-4.985 1.562 20.347 20.347 0 01-6.1 0 18.644 18.644 0 01-6.3-2.111 16.326 16.326 0 01-4.052-3.157l.844-.093a23.139 23.139 0 005.086-1.165 13.836 13.836 0 004.445-2.532 8.292 8.292 0 001.6-1.883 5.705 5.705 0 00.794-2.25 5.19 5.19 0 000-1.173 5.257 5.257 0 00-.277-1.135 5.191 5.191 0 00-.241-.54l-.055-.114-.03-.055c-.034-.068-.034-.055-.051-.089l-.152-.258a5.634 5.634 0 00-.768-.954 6.248 6.248 0 00-2.153-1.351 8.483 8.483 0 00-2.5-.528 12.108 12.108 0 00-4.782.7 11.679 11.679 0 00-2.077.971 10 10 0 00-1.769 1.308 7.882 7.882 0 00-1.347 1.6 6.608 6.608 0 00-.777 1.84 6.867 6.867 0 00.19 3.757 6.529 6.529 0 00.228.612 37.133 37.133 0 01-4.782-.882 49.732 49.732 0 01-8.611-3.1q-2.073-.954-4.052-2.055c-.329-.182-.658-.363-.983-.553l-1.009-.574c-.713-.422-1.427-.794-2.17-1.182s-1.5-.772-2.355-1.144a14.729 14.729 0 00-1.427-.562 9.412 9.412 0 00-.992-.27 6.914 6.914 0 00-.739-.11 5.363 5.363 0 00-1.233 0 4.944 4.944 0 00-1.021.258 4.16 4.16 0 00-.612.287 4.021 4.021 0 00-.612.422 3.33 3.33 0 00-.844 1.1 2.953 2.953 0 00-.257.928 3.2 3.2 0 00.063 1.1 5.118 5.118 0 00.19.633 6.346 6.346 0 00.393.844c.122.232.249.422.371.633.485.772.967 1.4 1.448 2.026.962 1.233 1.937 2.368 2.9 3.491s1.946 2.216 2.917 3.3c1.937 2.161 3.866 4.267 5.753 6.332 3.8 4.136 7.412 8.125 10.8 11.928s6.556 7.459 9.388 10.828zm-1.625-37.816c.528-2.153 2.6-4 5.2-4.837a9.939 9.939 0 014.073-.481 5.166 5.166 0 013.377 1.52 4.06 4.06 0 01.481.692l.093.19v.025l.021.055.046.118a2.5 2.5 0 01.131.393 4.11 4.11 0 01.11.806 3.955 3.955 0 01-.089.8 4.925 4.925 0 01-2.047 2.76 11.4 11.4 0 01-3.71 1.663 19.52 19.52 0 01-4.343.616 25.846 25.846 0 01-2.744-.051 8.018 8.018 0 01-.422-1.042 5.69 5.69 0 01-.177-3.227z"
              fill="#788b9c"
            />
            <path
              data-name="Path 9850"
              d="M1.039 375.307c.485.772.967 1.4 1.448 2.026.962 1.232 1.937 2.368 2.9 3.491s1.946 2.216 2.917 3.3c1.937 2.161 3.866 4.268 5.753 6.332 3.8 4.137 7.412 8.125 10.8 11.929s6.551 7.416 9.383 10.789a400.828 400.828 0 017.328 8.919h3.322L.275 373.838a6.328 6.328 0 00.393.844c.122.224.249.431.371.625z"
              fill="#1c1f23"
              opacity={0.2}
            />
            <path
              data-name="Path 9851"
              d="M15.856 379.836a61.092 61.092 0 006.479 1.916 36.4 36.4 0 01-11.639-6.209 27.5 27.5 0 003.512 3.681c.565.211 1.093.413 1.648.612z"
              fill="#1c1f23"
              opacity={0.2}
            />
            <path
              data-name="Path 9852"
              d="M37.352 384.563a16.19 16.19 0 01-1.861-1.688l-1.579.105a16.964 16.964 0 001.823 1.874 1.816 1.816 0 011.617-.291z"
              fill="#1c1f23"
              opacity={0.2}
            />
            <path
              data-name="Path 9853"
              d="M33.005 379.181a2.531 2.531 0 01-1.444-.131c.055.152.106.3.169.456.844.11 1.486.131 1.486.131-.076-.148-.144-.304-.211-.456z"
              fill="#1c1f23"
              opacity={0.2}
            />
            <path
              data-name="Path 9854"
              d="M63.643 377.636v.067c0 .161-.025.346-.038.57a5.366 5.366 0 01-.122.785 8.586 8.586 0 01-.726 2.111 9.781 9.781 0 01-.76 1.266 9.922 9.922 0 01-1.127 1.292 11.526 11.526 0 01-1.266 1.06 12.72 12.72 0 01-2.676 1.756 17.21 17.21 0 01-4.985 1.562c-.393.059-.794.11-1.207.147a22.47 22.47 0 001.688-.16 18.964 18.964 0 005.3-1.507 13.848 13.848 0 003.736-2.457 10.9 10.9 0 001.233-1.359 10.417 10.417 0 00.844-1.325 9.357 9.357 0 00.844-2.254c.076-.316.11-.595.148-.844a6.01 6.01 0 00.059-.616v-.072z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 9855"
              d="M62.842 378.131v.553a4.461 4.461 0 01-.1.776 4.911 4.911 0 01-.1.5c.312-.536 2.212-.059 2.077 1.043a10.958 10.958 0 00.363-1.2c.093-.35.135-.658.186-.929a5.966 5.966 0 00.076-.692 2.971 2.971 0 01.034-.511l-2.533-.051s-.007.161-.003.511z"
              fill="#1c1f23"
              opacity={0.2}
            />
            <path
              data-name="Path 9856"
              d="M37.815 409.172c4.643 5 8.484 9.413 11.447 12.929h6.353c-3.347-3.769-8.223-9.033-14.313-15.158-3.073-3.09-6.437-6.412-10.042-9.885s-7.445-7.109-11.421-10.836c-1.988-1.874-4.006-3.773-6.028-5.711s-4.056-3.9-5.909-5.939c-.359-.4-.7-.8-1.017-1.195l.068.025c.688.253 1.38.553 2.073.844s1.38.633 2.064.967l1.055.5c.355.173.713.338 1.072.5q2.157.983 4.407 1.828a54.747 54.747 0 009.358 2.63 38.844 38.844 0 007.277.654h.68c.625 0 1.266-.051 1.866-.11a22.238 22.238 0 004.774-.967 12.894 12.894 0 004.124-2.157 7.291 7.291 0 001.486-1.6 4.827 4.827 0 00.764-1.916 4.493 4.493 0 00.025-1.009 4.428 4.428 0 00-.224-.984c-.063-.16-.127-.333-.2-.473-.038-.076-.063-.131-.118-.228l-.131-.224a4.941 4.941 0 00-.663-.844 5.513 5.513 0 00-1.9-1.19 7.88 7.88 0 00-2.267-.481 11.317 11.317 0 00-4.483.587 10.421 10.421 0 00-3.617 2.06 7.288 7.288 0 00-1.266 1.465 5.652 5.652 0 00-.7 4.584c.139.422.422.979.342.76a5.69 5.69 0 01-.165-3.229 5.508 5.508 0 011.127-2.174 6.881 6.881 0 011.013-1.131 9.708 9.708 0 013.453-1.933 10.664 10.664 0 014.221-.523 5.77 5.77 0 013.681 1.558 3.8 3.8 0 011.03 3.292A5.155 5.155 0 0145 377.493a11.97 11.97 0 01-3.858 1.844 20.981 20.981 0 01-4.491.756c-.886.055-1.777.063-2.672.034h-.564a37.766 37.766 0 01-6.04-.81 52.151 52.151 0 01-8.864-2.807 66.287 66.287 0 01-5.179-2.415l-.983-.532q-1.034-.541-2.111-1.051a35.22 35.22 0 00-2.2-.988 9.606 9.606 0 00-1.22-.422 6.587 6.587 0 00-.73-.182 3.9 3.9 0 00-.46-.067 3.03 3.03 0 00-.642 0 1.947 1.947 0 00-1 .422 1.334 1.334 0 00-.477.87 1.637 1.637 0 00.038.549 2.185 2.185 0 00.122.376 6.009 6.009 0 00.6 1.081 21.9 21.9 0 001.347 1.747c1.87 2.2 3.85 4.221 5.8 6.222s3.9 3.955 5.821 5.88c3.833 3.849 7.522 7.564 10.975 11.118s6.692 6.897 9.603 10.054zm-32.42-36.233z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 9857"
              d="M41.303 406.943c-3.073-3.09-6.437-6.412-10.042-9.885s-7.45-7.108-11.422-10.835a1441.66 1441.66 0 01-3.9-3.685l35.3 39.563h4.377c-3.343-3.77-8.222-9.034-14.313-15.158z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 9858"
              d="M64.1 363.104h-6.576v4.124a11.638 11.638 0 014.706 9.434h-.544a.507.507 0 000 1.013h4.829a.507.507 0 000-1.013h-.549a11.635 11.635 0 014.711-9.434v-4.12z"
              fill="#516a80"
            />
            <path
              data-name="Rectangle 1344"
              fill="#3c3c4e"
              d="M66.616 361.711h1.773v1.393h-1.773z"
            />
            <path
              data-name="Rectangle 1345"
              fill="#535363"
              d="M66.616 361.711h1.773v.321h-1.773z"
            />
            <path
              data-name="Path 9859"
              d="M67.503 355.831a.777.777 0 00-.777.777v2.667h1.553v-2.667a.777.777 0 00-.777-.777z"
              fill="#aac9df"
            />
            <path
              data-name="Path 9860"
              d="M67.448 355.831h.114a.422.422 0 01.422.422v3.01h-.954v-3.01a.422.422 0 01.418-.422z"
              fill="#fff"
              opacity={0.3}
            />
            <path
              data-name="Path 9861"
              d="M67.502 355.831a.215.215 0 00-.215.215v3.2h.422v-3.2a.215.215 0 00-.207-.215z"
              fill="#fff"
              opacity={0.3}
            />
            <path
              data-name="Rectangle 1346"
              fill="#1c1f23"
              opacity={0.2}
              d="M66.726 358.933h1.553v.321h-1.553z"
            />
            <path
              data-name="Rectangle 1347"
              fill="#252d3a"
              d="M66.844 359.254h1.321v2.457h-1.321z"
            />
            <path
              data-name="Rectangle 1348"
              fill="#fff"
              opacity={0.15}
              d="M67.182 359.503h.642v2.203h-.642z"
            />
            <path
              data-name="Path 9862"
              d="M67.933 356.13c0 .16-.194.291-.422.291s-.422-.131-.422-.291.19-.287.422-.287.422.127.422.287z"
              fill="#fff"
              opacity={0.3}
            />
            <path
              data-name="Rectangle 1349"
              fill="#3c3c4e"
              d="M59.812 361.711h1.773v1.393h-1.773z"
            />
            <path
              data-name="Rectangle 1350"
              fill="#535363"
              d="M59.812 361.711h1.773v.321h-1.773z"
            />
            <path
              data-name="Path 9863"
              d="M60.694 355.831a.773.773 0 00-.772.777v2.668h1.549v-2.668a.777.777 0 00-.777-.777z"
              fill="#aac9df"
            />
            <path
              data-name="Path 9864"
              d="M60.639 355.831h.114a.422.422 0 01.422.422v3.01h-.954v-3.01a.422.422 0 01.422-.422z"
              fill="#fff"
              opacity={0.3}
            />
            <path
              data-name="Path 9865"
              d="M60.693 355.831a.211.211 0 00-.211.215v3.2h.422v-3.2a.215.215 0 00-.211-.215z"
              fill="#fff"
              opacity={0.3}
            />
            <path
              data-name="Rectangle 1351"
              fill="#1c1f23"
              opacity={0.2}
              d="M59.922 358.933h1.553v.321h-1.553z"
            />
            <path
              data-name="Rectangle 1352"
              fill="#252d3a"
              d="M60.036 359.254h1.321v2.457h-1.321z"
            />
            <path
              data-name="Rectangle 1353"
              fill="#fff"
              opacity={0.15}
              d="M60.373 359.503h.642v2.203h-.642z"
            />
            <ellipse
              data-name="Ellipse 446"
              cx={0.426}
              cy={0.291}
              rx={0.426}
              ry={0.291}
              transform="translate(60.268 355.839)"
              fill="#fff"
              opacity={0.3}
            />
            <path
              data-name="Rectangle 1354"
              fill="#fff"
              opacity={0.15}
              d="M60.268 363.104h7.661v4.972h-7.661z"
            />
            <path
              data-name="Rectangle 1355"
              fill="#fff"
              opacity={0.15}
              d="M62.454 374.361h3.292v2.296h-3.292z"
            />
            <path
              data-name="Rectangle 1356"
              fill="#fff"
              opacity={0.15}
              d="M63.13 373.635h1.937v.418H63.13z"
            />
            <path
              data-name="Rectangle 1357"
              fill="#fff"
              opacity={0.15}
              d="M62.066 368.401h4.065v.422h-4.065z"
            />
            <path
              data-name="Rectangle 1358"
              fill="#fff"
              opacity={0.15}
              d="M62.252 369.097h3.698v.422h-3.698z"
            />
            <path
              data-name="Path 9866"
              d="M65.747 374.361v2.3h.219a11.647 11.647 0 014.711-9.434v-4.12h-2.744v4.966s-2.186 3.35-2.186 6.288z"
              fill="#1c1f23"
              opacity={0.2}
            />
            <path
              data-name="Path 9867"
              d="M181.246 107.007c-1.076 2.672-24.275 2.79-27.437 2.735s-9.565.722-11.308-2.338 4.428-8.792 6.365-11.7 20.983-4.538 26.259.371 6.754 9.357 6.121 10.932z"
              opacity={0.1}
            />
            <path
              data-name="Path 9868"
              d="M180.111 107.572c-5.838 1.363-14.187 1.942-22.046 1.731s-11.5-1.954-12.874-3.537-1-4.327 1.161-7.492 19.079-1.79 24 .477 11.996 8.293 9.759 8.821z"
              opacity={0.1}
            />
            <g
              data-name="Group 484"
              transform="translate(140.754 66.916)"
              clipPath="url(#prefix__g)"
            >
              <path
                data-name="Path 9869"
                d="M1.917 37.149A132.119 132.119 0 0119.84 8.602a2.989 2.989 0 014.643 0 132.119 132.119 0 0117.922 28.542c.523 1.2-1.266 3.14-3.048 3.508a95.854 95.854 0 01-34.384 0c-1.79-.35-3.571-2.3-3.056-3.503z"
                fill="#fbc400"
              />
              <path
                data-name="Path 9870"
                d="M40.175 37.464c-4.365-9.265-10.641-18.526-16.884-26.888a1.418 1.418 0 00-2.262 0C14.79 18.938 8.514 28.199 4.145 37.464c-.283.625.545 1.591 1.452 1.743a115.774 115.774 0 0033.118 0c.916-.154 1.743-1.121 1.46-1.743zm-.988.764a.392.392 0 01-.245.139 126.163 126.163 0 01-33.557 0 .392.392 0 01-.245-.139.211.211 0 01-.055-.219c4.348-9.358 10.818-18.374 16.85-26.943a.261.261 0 01.228-.118.274.274 0 01.228.118c6.032 8.569 12.5 17.585 16.85 26.943a.211.211 0 01-.055.219z"
                fill="#1c7f98"
              />
              <path
                data-name="Path 9871"
                d="M22.869 15.453c-2.339 4.322-4.8 8.6-7.129 12.925 2.11.021 3.14.03 5.234.034-1.49 3.263-2.912 6.581-4.124 9.932 2.507-3.913 5.259-7.7 8.045-11.464h-5.137c2.043-3.069 2.925-4.546 5.141-7.7-.801-1.503-1.219-2.245-2.03-3.727z"
                fill="#1c7f98"
              />
              <path
                data-name="Path 9872"
                d="M16.85 38.344l3.951-2.533-4.221-2.064c.11 1.836.144 2.752.27 4.597z"
                fill="#1c7f98"
              />
              <path
                data-name="Path 9873"
                d="M19.847 8.606l.076-.08a2.143 2.143 0 01.228-.236 3.023 3.023 0 011.055-.629 3.068 3.068 0 011.9 0 2.983 2.983 0 011.021.587 9.069 9.069 0 01.87.983c.587.7 1.2 1.486 1.849 2.309s1.321 1.688 1.992 2.638 1.363 1.887 2.056 2.87 1.368 2 2.035 3.026 1.33 2.051 1.954 3.081 1.233 2.039 1.815 3.026 1.123 1.954 1.625 2.879.962 1.8 1.4 2.6.806 1.562 1.131 2.233.616 1.266.844 1.735c.452.967.713 1.519.713 1.519l-.81-1.5c-.249-.473-.57-1.034-.933-1.688s-.781-1.376-1.237-2.174-.946-1.65-1.494-2.533-1.123-1.836-1.726-2.8-1.224-1.971-1.883-2.955-1.33-2.013-2.018-3.018l-2.081-2.955-2.051-2.849-1.933-2.663-1.76-2.36-.422-.54c-.072-.1-.126-.16-.181-.224a1.175 1.175 0 00-.169-.186 2.694 2.694 0 00-.789-.528 3 3 0 00-1.617-.19 3.284 3.284 0 00-1.089.38z"
                fill="#fff"
                opacity={0.3}
              />
              <path
                data-name="Path 9874"
                d="M24.482 8.602a2.989 2.989 0 00-4.643 0A126.283 126.283 0 009.113 23.684c9.037 2.056 24.558 8.02 32.362 15.8a2.312 2.312 0 00.92-2.334A132.112 132.112 0 0024.482 8.602z"
                fill="#fff"
                opacity={0.2}
              />
              <path
                data-name="Path 9875"
                d="M39.531 40.201a95.976 95.976 0 01-34.389 0c-1.663-.346-3.343-2.068-3.115-3.271l-.105.22c-.523 1.2 1.266 3.14 3.048 3.508a95.856 95.856 0 0034.384 0 4.342 4.342 0 003.081-2.642 4.588 4.588 0 01-2.904 2.185z"
                opacity={0.1}
              />
            </g>
            <path
              data-name="Path 9877"
              d="M155.569 108.834s-6.99-3.225-8.324-5-1.418-6.146-1.418-6.146z"
              fill="#fbc400"
            />
            <path
              data-name="Path 9878"
              d="M155.122 108.328l-.076-.042c-.726-.38-6.2-3.263-7.345-4.812-1.224-1.663-1.363-2.6-1.87-5.77 0 0 .084 4.39 1.418 6.146s8.324 4.985 8.324 4.985l-.447-.507z"
              opacity={0.1}
            />
            <path
              data-name="Path 9879"
              d="M153.919 106.952a46.12 46.12 0 01-5.285-3.681c-.9-.983-1.266-1.465-1.351-1.866a10.985 10.985 0 01.1-1.921l.751.844s-.4.777-.186 1.11a7 7 0 001.055 1.427c.511.494 4.09 3.128 4.09 3.128z"
              fill="#1c7f98"
            />
            <path
              data-name="Path 9880"
              d="M155.123 108.328s-6.036-3.3-7.26-4.964-1.528-2.486-2.034-5.66z"
              fill="#fff"
              opacity={0.3}
            />
            <rect
              data-name="Rectangle 1359"
              width={21.827}
              height={38.618}
              rx={4.86}
              transform="translate(92.613 253.391)"
              fill="#516a80"
            />
            <path
              data-name="Path 9881"
              d="M97.504 289.983h-1.266a1.216 1.216 0 01-1.216-1.216 1.216 1.216 0 011.216-1.216h1.266a1.216 1.216 0 011.216 1.216 1.216 1.216 0 01-1.216 1.216z"
              opacity={0.2}
            />
            <path
              data-name="Path 9882"
              d="M104.171 289.983h-1.266a1.216 1.216 0 01-1.216-1.216 1.216 1.216 0 011.216-1.216h1.266a1.216 1.216 0 011.216 1.216 1.216 1.216 0 01-1.216 1.216z"
              opacity={0.2}
            />
            <path
              data-name="Path 9883"
              d="M110.854 289.983h-1.287a1.216 1.216 0 01-1.216-1.216 1.216 1.216 0 011.216-1.216h1.287a1.216 1.216 0 011.216 1.216 1.216 1.216 0 01-1.216 1.216z"
              opacity={0.2}
            />
            <path
              data-name="Path 9884"
              d="M97.504 269.3h-1.266a1.216 1.216 0 01-1.216-1.216 1.216 1.216 0 011.216-1.216h1.266a1.216 1.216 0 011.216 1.216 1.216 1.216 0 01-1.216 1.216z"
              opacity={0.2}
            />
            <path
              data-name="Path 9885"
              d="M104.171 269.3h-1.266a1.216 1.216 0 01-1.216-1.216 1.216 1.216 0 011.216-1.216h1.266a1.216 1.216 0 011.216 1.216 1.216 1.216 0 01-1.216 1.216z"
              opacity={0.2}
            />
            <path
              data-name="Path 9886"
              d="M110.854 269.3h-1.287a1.216 1.216 0 01-1.216-1.216 1.216 1.216 0 011.216-1.216h1.287a1.216 1.216 0 011.216 1.216 1.216 1.216 0 01-1.216 1.216z"
              opacity={0.2}
            />
            <path
              data-name="Path 9887"
              d="M111.11 278.536v.333a.347.347 0 11-.692-.051 6.856 6.856 0 00-.072-1.583.346.346 0 01.287-.4.35.35 0 01.4.287 7.858 7.858 0 01.077 1.414z"
              fill="#fff"
            />
            <path
              data-name="Path 9888"
              d="M110.789 280.485a.333.333 0 010 .093 7.6 7.6 0 01-.7 1.6.347.347 0 01-.6-.35 6.6 6.6 0 00.637-1.448.346.346 0 01.68.11z"
              fill="#f15a29"
            />
            <path
              data-name="Path 9889"
              d="M110.565 275.589a.346.346 0 01-.667.127 6.93 6.93 0 00-.768-1.385.346.346 0 01.076-.485.35.35 0 01.485.08 7.6 7.6 0 01.844 1.524.425.425 0 01.03.139z"
              fill="#f15a29"
            />
            <path
              data-name="Path 9890"
              d="M109.118 283.335a.359.359 0 01-.1.232 7.7 7.7 0 01-1.338 1.114.348.348 0 11-.38-.583 6.951 6.951 0 001.216-1.013.35.35 0 01.6.249z"
              fill="#fff"
            />
            <path
              data-name="Path 9891"
              d="M108.641 272.909a.371.371 0 01-.089.219.346.346 0 01-.49.034 6.762 6.762 0 00-1.3-.9.346.346 0 01-.144-.469.342.342 0 01.469-.144 7.421 7.421 0 011.435.988.346.346 0 01.122.27z"
              fill="#fff"
            />
            <path
              data-name="Path 9892"
              d="M106.37 285.141a.354.354 0 01-.228.321 7.6 7.6 0 01-1.688.422.35.35 0 01-.388-.308.346.346 0 01.308-.384 6.633 6.633 0 001.536-.363.354.354 0 01.447.207.419.419 0 01.013.105z"
              fill="#fff"
            />
            <path
              data-name="Path 9893"
              d="M105.719 271.36a.268.268 0 010 .08.346.346 0 01-.422.249 7.005 7.005 0 00-1.57-.224.311.311 0 01-.186-.059.361.361 0 01-.19.063 6.714 6.714 0 00-1.566.224.346.346 0 01-.422-.245.355.355 0 01.249-.422 7.609 7.609 0 011.722-.249.356.356 0 01.211.063.313.313 0 01.207-.063 7.375 7.375 0 011.722.245.342.342 0 01.245.338z"
              fill="#f15a29"
            />
            <path
              data-name="Path 9894"
              d="M103.069 285.53v.029a.346.346 0 01-.384.3 7.521 7.521 0 01-1.688-.393.347.347 0 11.232-.654 6.933 6.933 0 001.541.359.342.342 0 01.299.359z"
              fill="#fff"
            />
            <path
              data-name="Path 9895"
              d="M100.486 271.976a.355.355 0 01-.186.3 6.889 6.889 0 00-1.3.9.35.35 0 01-.46-.523 7.738 7.738 0 011.431-.992.346.346 0 01.473.139.371.371 0 01.042.176z"
              fill="#fff"
            />
            <path
              data-name="Path 9896"
              d="M99.959 284.415a.371.371 0 01-.059.182.346.346 0 01-.477.1 7.715 7.715 0 01-1.346-1.11.35.35 0 010-.494.346.346 0 01.49 0 6.986 6.986 0 001.22 1.009.35.35 0 01.172.313z"
              fill="#fff"
            />
            <path
              data-name="Path 9897"
              d="M98.004 274.159a.423.423 0 01-.063.194 7.044 7.044 0 00-.768 1.385.342.342 0 01-.452.19.346.346 0 01-.19-.452 7.514 7.514 0 01.844-1.528.346.346 0 01.481-.08.342.342 0 01.148.291z"
              fill="#f15a29"
            />
            <path
              data-name="Path 9898"
              d="M97.67 282.035a.342.342 0 01-.169.291.35.35 0 01-.477-.123 7.569 7.569 0 01-.709-1.591.347.347 0 11.663-.207 6.8 6.8 0 00.646 1.443.329.329 0 01.046.187z"
              fill="#f15a29"
            />
            <path
              data-name="Path 9899"
              d="M96.754 277.222v.047a6.837 6.837 0 00-.068 1.583.35.35 0 01-.321.371.346.346 0 01-.371-.325 7.738 7.738 0 01.072-1.739.35.35 0 01.692.063z"
              fill="#fff"
            />
            <rect
              data-name="Rectangle 1360"
              width={17.087}
              height={8.75}
              rx={3.07}
              transform="translate(94.986 255.962)"
              fill="#fff"
              opacity={0.2}
            />
            <rect
              data-name="Rectangle 1361"
              width={7.361}
              height={15.698}
              rx={1.43}
              transform="rotate(90 -72.641 184.017)"
              fill="#97a6b3"
            />
            <path
              data-name="Path 9900"
              d="M97.504 289.443h-1.266a1.216 1.216 0 01-1.216-1.216 1.216 1.216 0 011.216-1.216h1.266a1.216 1.216 0 011.216 1.216 1.216 1.216 0 01-1.216 1.216z"
              fill="#25465b"
            />
            <path
              data-name="Path 9901"
              d="M96.202 288.328a.519.519 0 110-1.038h1.266a.519.519 0 110 1.038z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 9902"
              d="M104.171 289.443h-1.266a1.216 1.216 0 01-1.216-1.216 1.216 1.216 0 011.216-1.216h1.266a1.216 1.216 0 011.216 1.216 1.216 1.216 0 01-1.216 1.216z"
              fill="#25465b"
            />
            <path
              data-name="Path 9903"
              d="M102.883 288.328a.519.519 0 110-1.038h1.271a.519.519 0 110 1.038z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 9904"
              d="M110.854 289.443h-1.287a1.216 1.216 0 01-1.216-1.216 1.216 1.216 0 011.216-1.216h1.287a1.216 1.216 0 011.216 1.216 1.216 1.216 0 01-1.216 1.216z"
              fill="#25465b"
            />
            <path
              data-name="Path 9905"
              d="M109.569 288.328a.519.519 0 110-1.038h1.287a.519.519 0 110 1.038z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 9906"
              d="M97.504 268.73h-1.266a1.216 1.216 0 01-1.216-1.216 1.216 1.216 0 011.216-1.216h1.266a1.216 1.216 0 011.216 1.216 1.216 1.216 0 01-1.216 1.216z"
              fill="#25465b"
            />
            <path
              data-name="Path 9907"
              d="M96.201 267.612a.523.523 0 110-1.043h1.271a.523.523 0 010 1.043z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 9908"
              d="M104.171 268.73h-1.266a1.216 1.216 0 01-1.216-1.216 1.216 1.216 0 011.216-1.216h1.266a1.216 1.216 0 011.216 1.216 1.216 1.216 0 01-1.216 1.216z"
              fill="#25465b"
            />
            <path
              data-name="Path 9909"
              d="M102.883 267.612a.523.523 0 010-1.043h1.266a.523.523 0 010 1.043z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 9910"
              d="M110.854 268.73h-1.287a1.216 1.216 0 01-1.216-1.216 1.216 1.216 0 011.216-1.216h1.287a1.216 1.216 0 011.216 1.216 1.216 1.216 0 01-1.216 1.216z"
              fill="#25465b"
            />
            <path
              data-name="Path 9911"
              d="M109.569 267.612a.523.523 0 010-1.043h1.287a.523.523 0 010 1.043z"
              fill="#fff"
              opacity={0.2}
            />
            <circle
              data-name="Ellipse 447"
              cx={6.112}
              cy={6.112}
              r={6.112}
              transform="rotate(-67.72 257.761 69.643)"
              opacity={0.2}
            />
            <circle
              data-name="Ellipse 448"
              cx={5.521}
              cy={5.521}
              r={5.521}
              transform="rotate(-77.81 223.635 81.246)"
              fill="#ef4136"
            />
            <path
              data-name="Path 9912"
              d="M98.004 278.329v-.194a4 4 0 01.047-.549 2.9 2.9 0 01.059-.388c.021-.139.076-.287.114-.447a5.1 5.1 0 01.177-.5c.063-.177.16-.342.245-.528a3.522 3.522 0 01.333-.54 4.8 4.8 0 01.422-.528 5.191 5.191 0 011.106-.954 5.714 5.714 0 011.414-.663 5.582 5.582 0 013.187 0 5.748 5.748 0 011.418.663 5.809 5.809 0 011.528 1.482c.122.181.228.367.329.54a3.728 3.728 0 01.249.528c.068.173.127.338.173.5s.08.308.114.447.042.27.063.388a4.8 4.8 0 01.046.549v.194l-.025-.194a4.485 4.485 0 00-.084-.54l-.08-.38c-.046-.135-.093-.279-.139-.422s-.131-.308-.2-.477-.169-.329-.258-.5a4.007 4.007 0 00-.342-.515 5.105 5.105 0 00-.422-.494 6.085 6.085 0 00-1.085-.886 5.514 5.514 0 00-1.359-.616 5.817 5.817 0 00-1.536-.207 5.907 5.907 0 00-1.5.207 5.515 5.515 0 00-1.359.616 5.97 5.97 0 00-1.089.886 5.748 5.748 0 00-.422.494c-.122.173-.232.346-.338.515a4.376 4.376 0 00-.262.5 4.806 4.806 0 00-.2.477l-.139.422-.084.376c-.055.228-.063.422-.084.545z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 9913"
              d="M102.465 283.264a5.167 5.167 0 001.064.114 5.227 5.227 0 001.064-.114v-9.869a4.939 4.939 0 00-1.064-.114 4.877 4.877 0 00-1.064.114z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 9914"
              d="M102.465 278.27a9.647 9.647 0 001.064.059 9.767 9.767 0 001.064-.059v-4.934c-.346-.034-.7-.055-1.064-.055s-.722.021-1.064.055z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 9915"
              d="M102.828 274.642l.7-1.212.7 1.212z"
              fill="#fff"
            />
            <path
              data-name="Path 9916"
              d="M108.62 258.553l-.718-.718h2.617l-.718.718z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9917"
              d="M110.659 257.975v1.9l-.359.359-.359-.359v-1.182z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9918"
              d="M110.161 260.373l-.359.359h-1.182l-.359-.359.359-.359h1.182z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9919"
              d="M107.763 257.975v1.9l.359.359.359-.359v-1.182z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9920"
              d="M109.801 262.192l.718.718h-2.617l.718-.718z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9921"
              d="M107.763 262.77v-1.9l.359-.359.359.359v1.182z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9922"
              d="M110.659 262.77v-1.9l-.359-.359-.359.359v1.182z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9923"
              d="M104.736 258.553l-.722-.718h2.617l-.718.718z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9924"
              d="M106.771 257.975v1.9l-.359.359-.359-.359v-1.182z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9925"
              d="M106.276 260.373l-.363.359h-1.178l-.359-.359.359-.359h1.178z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9926"
              d="M103.875 257.975v1.9l.359.359.363-.359v-1.182z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9927"
              d="M105.914 262.192l.718.718h-2.613l.718-.718z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9928"
              d="M103.875 262.77v-1.9l.359-.359.363.359v1.182z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9929"
              d="M106.771 262.77v-1.9l-.359-.359-.359.359v1.182z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9930"
              d="M100.849 258.553l-.718-.718h2.617l-.718.718z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9931"
              d="M102.888 257.975v1.9l-.359.359-.363-.359v-1.182z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9932"
              d="M102.389 260.373l-.359.359h-1.182l-.359-.359.359-.359h1.182z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9933"
              d="M99.992 257.975v1.9l.359.359.359-.359v-1.182z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9934"
              d="M102.03 262.192l.718.718h-2.617l.718-.718z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9935"
              d="M99.992 262.77v-1.9l.359-.359.359.359v1.182z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9936"
              d="M102.888 262.77v-1.9l-.359-.359-.363.359v1.182z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9937"
              d="M98.501 260.373l-.359.359H96.96l-.359-.359.359-.359h1.182z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9938"
              d="M102.465 273.395a25.23 25.23 0 00-1.346 6.2 5.39 5.39 0 001.346 3.664z"
              opacity={0.2}
            />
            <path
              data-name="Path 9939"
              d="M94.39 253.685h17.547a2.671 2.671 0 01.608.047 2.148 2.148 0 01.574.22 2.073 2.073 0 01.844.895 2.5 2.5 0 01.2 1.233v34.19s-.03-.865-.089-2.385-.1-3.681-.177-6.281c-.034-1.3-.046-2.706-.076-4.2s-.051-3.06-.08-4.685-.063-3.305-.063-5.01-.021-3.44-.03-5.171-.021-3.465-.03-5.175v-1.578a1.959 1.959 0 000-.236 1.3 1.3 0 00-.135-.422 1.558 1.558 0 00-.608-.65 1.629 1.629 0 00-.422-.165h-.49c-1.625 0-3.2 0-4.685-.047-.743 0-1.469 0-2.17-.042l-2.026-.063-3.55-.114-2.735-.139a60.101 60.101 0 01-1.76-.106z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 9940"
              d="M100.797 256.658l6.965 7.361h-5.4l-4.487-7.361z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 9941"
              d="M81.267 269.743h6.53a.659.659 0 01.659.658v.215a.984.984 0 01-.984.984h-5.876a.984.984 0 01-.984-.984v-.215a.658.658 0 01.655-.658z"
              fill="#ef4136"
            />
            <path
              data-name="Path 9942"
              d="M87.084 270.963h-5.091a.637.637 0 01-.642-.637.422.422 0 01.422-.422h5.513a.422.422 0 01.422.422.637.637 0 01-.625.637z"
              fill="#fff"
              opacity={0.3}
            />
            <path
              data-name="Path 9943"
              d="M86.24 282.009h-3.4l-.836-10.413h5.069z"
              fill="#ef4136"
            />
            <path
              data-name="Path 9944"
              d="M85.243 282.009h-1.414l-.346-10.413h2.106z"
              fill="#fff"
              opacity={0.3}
            />
            <path
              data-name="Path 9945"
              d="M83.829 253.02h1.414l.346 16.724h-2.106z"
              fill="#aac9df"
            />
            <path
              data-name="Path 9946"
              d="M84.235 253.02h.608l.148 16.724h-.9z"
              fill="#fff"
              opacity={0.5}
            />
            <path
              data-name="Path 9947"
              d="M84.539 272.702a2.84 2.84 0 012.334 1.389l.2-2.495h-5.067l.2 2.495a2.845 2.845 0 012.333-1.389z"
              opacity={0.2}
            />
            <path
              data-name="Path 9948"
              d="M118.868 269.744h6.538a.658.658 0 01.659.658v.215a.983.983 0 01-.984.983h-5.884a.983.983 0 01-.984-.983v-.215a.654.654 0 01.654-.654z"
              fill="#fbb040"
            />
            <path
              data-name="Path 9949"
              d="M124.685 270.963h-5.091a.633.633 0 01-.637-.637.422.422 0 01.422-.422h5.513a.422.422 0 01.422.422.637.637 0 01-.629.637z"
              fill="#fff"
              opacity={0.3}
            />
            <path
              data-name="Path 9950"
              d="M123.84 282.009h-3.4l-.836-10.413h5.069z"
              fill="#fbb040"
            />
            <path
              data-name="Path 9951"
              d="M122.844 282.009h-1.414l-.346-10.413h2.106z"
              fill="#fff"
              opacity={0.3}
            />
            <path
              data-name="Path 9952"
              d="M121.43 253.02h1.414l.346 16.724h-2.106z"
              fill="#aac9df"
            />
            <path
              data-name="Path 9953"
              d="M121.836 253.02h.6l.152 16.724h-.9z"
              fill="#fff"
              opacity={0.5}
            />
            <path
              data-name="Path 9954"
              d="M122.14 272.702a2.84 2.84 0 012.334 1.389l.2-2.495h-5.067l.2 2.495a2.845 2.845 0 012.333-1.389z"
              opacity={0.2}
            />
            <path
              data-name="Path 9955"
              d="M122.903 282.014a1.2 1.2 0 01-.034.232c-.034.152-.042.38-.072.68-.063.595-.152 1.469-.266 2.579-.059.553-.122 1.165-.2 1.828s-.186 1.38-.3 2.144a85.88 85.88 0 01-.941 5.095c-.194.924-.422 1.882-.642 2.87s-.473 2-.7 3.031a25.622 25.622 0 00-.515 3.141 4.628 4.628 0 00.485 2.891 2.884 2.884 0 001.11.958c.089.051.266.131.376.181s.249.1.38.144a4.708 4.708 0 00.8.2 3.376 3.376 0 003.043-1.026 3.959 3.959 0 001.043-3.187 3.584 3.584 0 00-.6-1.574 3.741 3.741 0 00-1.233-1.123 5.919 5.919 0 00-1.6-.612 8.238 8.238 0 00-1.735-.215 11.4 11.4 0 00-3.491.557 44.1 44.1 0 00-6.526 2.9 24.963 24.963 0 01-6.475 2.533 7.122 7.122 0 01-6.26-1.727 7.381 7.381 0 01-1.625-2.49 12.481 12.481 0 01-.7-2.486 26.107 26.107 0 01-.363-4.06c-.025-1.114 0-1.98 0-2.567v-.895h1.528v3.436a25.376 25.376 0 00.321 3.824 11.142 11.142 0 00.6 2.195 5.989 5.989 0 001.266 2.018 4.9 4.9 0 002.2 1.266l.325.084.186.038h.16a5.2 5.2 0 00.684.072 7.412 7.412 0 001.448-.1 14.859 14.859 0 003.026-.916c1.026-.422 2.06-.9 3.115-1.41a44.641 44.641 0 016.754-2.866 12.558 12.558 0 013.85-.544 8.311 8.311 0 011.98.287c.165.051.338.1.481.148l.236.084.236.093a5.9 5.9 0 01.9.5 4.559 4.559 0 011.414 1.507 4.5 4.5 0 01.578 1.954 5.066 5.066 0 01-1.266 3.672 4.449 4.449 0 01-3.579 1.469 5.74 5.74 0 01-.975-.127q-.241-.051-.481-.126c-.169-.055-.274-.08-.456-.156a4.07 4.07 0 01-1.688-1.177 4.379 4.379 0 01-.87-1.849 7.8 7.8 0 01-.169-1.878 13.917 13.917 0 01.156-1.756c.076-.57.186-1.119.3-1.659.456-2.144 1.043-4.094 1.541-5.909s.92-3.461 1.207-4.947c.148-.743.262-1.439.355-2.11s.16-1.241.2-1.781a18.411 18.411 0 00.034-2.507 5.213 5.213 0 00-.055-.663l-.025-.232z"
              fill="#3c3c4e"
            />
            <path
              data-name="Path 9956"
              d="M100.283 291.983v.975c0 .118.025.262.038.422a10.306 10.306 0 00.181 1.03 21.587 21.587 0 00.844 2.777c.194.536.422 1.106.658 1.714s.507 1.245.747 1.942a12.441 12.441 0 01.587 2.284 6.942 6.942 0 01.068 1.3 6.481 6.481 0 01-.059.688 3.78 3.78 0 01-.152.7 5.762 5.762 0 01-1.49 2.533c-.186.165-.363.338-.557.49l-.291.219-.148.11-.038.025-.046.034-.072.042-.274.173a3.15 3.15 0 01-.3.173c-.22.118-.452.249-.671.346a12.767 12.767 0 01-5.715 1.051 14.661 14.661 0 01-5.757-1.376 13.244 13.244 0 01-4.706-3.617 12.364 12.364 0 01-2.448-5.234v-.2l-.025-.165-.051-.325-.1-.646c-.051-.448-.072-.937-.1-1.393v-.68a5.9 5.9 0 01.038-.671 11.753 11.753 0 01.2-1.3 29.022 29.022 0 011.482-4.449 24.135 24.135 0 001.076-3.579c.055-.27.118-.532.165-.785s.072-.506.11-.743.076-.464.093-.684.038-.422.055-.625c.084-.794.08-1.427.093-1.857s0-.659 0-.659h1.659s0 .241-.021.7a18.07 18.07 0 01-.114 1.967c0 .211-.038.422-.063.667s-.068.477-.106.734-.08.515-.122.789-.118.557-.177.844c-.114.582-.3 1.19-.481 1.832-.106.312-.211.637-.321.966l-.363 1a28.06 28.06 0 00-1.4 4.221 9.875 9.875 0 00-.173 1.131 5.256 5.256 0 00-.03.578v.587c.034.393.038.768.089 1.182.03.215.063.422.1.646l.051.325.025.165v.114a10.67 10.67 0 002.111 4.542 11.627 11.627 0 004.128 3.178 13.118 13.118 0 005.137 1.211 10.132 10.132 0 004.875-1.043c.181-.084.329-.186.494-.274a2.136 2.136 0 00.262-.165l.27-.181.068-.047h.03l.11-.089.219-.173c.139-.118.262-.253.393-.376a4.11 4.11 0 00.992-1.718 5.865 5.865 0 00.165-1.988 13.208 13.208 0 00-.291-2.034 27.921 27.921 0 00-1.093-3.643c-.384-1.089-.734-2.052-.967-2.883a19.588 19.588 0 01-.287-1.123l-.1-.464-.063-.422-.025-.173v-.139a.538.538 0 00-.025-.211v-.18z"
              fill="#d40032"
            />
            <path
              data-name="Path 9957"
              d="M142.058 282.001s-.059 1.266-.131 3.482c0 .553-.03 1.165-.047 1.836s-.034 1.376 0 2.11a13.331 13.331 0 001.106 4.808 8.2 8.2 0 001.591 2.258 7.532 7.532 0 002.469 1.608 13.3 13.3 0 006.488.633c.578-.063 1.157-.16 1.739-.261l1.769-.372a46.253 46.253 0 003.52-.979 62.041 62.041 0 006.952-2.807 55.983 55.983 0 017.032-2.908 14.573 14.573 0 013.748-.646 8.926 8.926 0 011.891.08 6.538 6.538 0 011.836.532 3.849 3.849 0 011.524 1.224 2.558 2.558 0 01.422 1.937 3.061 3.061 0 01-.933 1.646 5.066 5.066 0 01-1.486.967 8.936 8.936 0 01-3.2.675h-1.532c-.494 0-1-.063-1.477-.089a17.4 17.4 0 01-2.735-.5 11.654 11.654 0 01-2.376-.891 7.929 7.929 0 01-3.153-2.811 8.268 8.268 0 01-1.009-2.634c-.089-.65-.139-.992-.139-.992h1.688s0 .283-.038.844a5.974 5.974 0 00.511 2.246 6.255 6.255 0 002.533 2.647 12.549 12.549 0 004.791 1.431c.464.03.924.1 1.422.105l.747.025h.734a8.315 8.315 0 002.955-.654 4.279 4.279 0 001.266-.844 2.33 2.33 0 00.688-1.266 1.554 1.554 0 00-.034-.7 1.768 1.768 0 00-.308-.641 3.022 3.022 0 00-1.216-.937 5.618 5.618 0 00-1.608-.422 8.438 8.438 0 00-1.735-.051 13.675 13.675 0 00-3.525.625 54.363 54.363 0 00-6.91 2.879 62.949 62.949 0 01-7.032 2.807c-1.19.392-2.406.739-3.6 1.03l-1.79.393c-.6.11-1.2.215-1.807.287a14.331 14.331 0 01-6.994-.65 8.6 8.6 0 01-2.82-1.807 9.46 9.46 0 01-1.832-2.532 14.615 14.615 0 01-1.355-5.2c-.076-.8-.1-1.545-.11-2.2s-.03-1.266-.046-1.836a243.852 243.852 0 00-.127-3.482z"
              fill="#d40032"
            />
            <path
              data-name="Path 9958"
              d="M163.885 289.92l-.025.232a5.8 5.8 0 01-.08.688 16.826 16.826 0 01-.528 2.625 19.639 19.639 0 01-1.469 3.8 16.883 16.883 0 01-3.048 4.3 11.233 11.233 0 01-2.393 1.866 8.277 8.277 0 01-3.086 1.064 6.194 6.194 0 01-1.722 0 4.151 4.151 0 01-1.688-.62 4.39 4.39 0 01-1.832-3.136 6.242 6.242 0 01.633-3.668 4.592 4.592 0 012.955-2.431 6.371 6.371 0 013.833.469 21.966 21.966 0 013.377 1.824c2.136 1.355 4.183 2.811 6.365 3.925a15.906 15.906 0 006.792 1.942 7.8 7.8 0 003.254-.477 4.149 4.149 0 001.3-.844 5.327 5.327 0 00.519-.553 6.331 6.331 0 00.422-.642 8.83 8.83 0 00.9-2.853 23.64 23.64 0 00.257-2.879c.059-1.866-.021-3.592-.1-5.12s-.173-2.866-.245-3.968c-.156-2.212-.241-3.478-.241-3.478h1.693l-.059.9c-.038.588-.063 1.448-.093 2.532s-.03 2.431-.03 3.972v2.45c0 .865 0 1.773-.067 2.727a24.419 24.419 0 01-.3 2.98 9.625 9.625 0 01-1.026 3.111 7.71 7.71 0 01-.477.73 5.914 5.914 0 01-.616.646 4.857 4.857 0 01-1.536.95 6.978 6.978 0 01-.865.287c-.3.051-.587.131-.895.156a8.6 8.6 0 01-.9.068h-.907a16.567 16.567 0 01-7.062-2.111c-2.224-1.165-4.28-2.655-6.378-4.014a20.736 20.736 0 00-3.263-1.769 7.648 7.648 0 00-1.731-.49 4.459 4.459 0 00-1.739.047 4.015 4.015 0 00-2.533 2.111 5.577 5.577 0 00-.549 3.305 3.77 3.77 0 001.574 2.68 3.486 3.486 0 001.427.511 5.493 5.493 0 001.557 0 7.5 7.5 0 002.815-1.009 10.326 10.326 0 002.22-1.764 14.136 14.136 0 002.748-4.166 15.523 15.523 0 001.1-3.685 13.963 13.963 0 00.186-2.431c0-.266-.021-.507-.03-.654v-.232z"
              fill="#f26522"
            />
            <rect
              data-name="Rectangle 1362"
              width={21.827}
              height={36.507}
              rx={2.88}
              transform="translate(149.289 253.391)"
              fill="#1c7f98"
            />
            <path
              data-name="Path 9959"
              d="M169.478 253.813h-19.472l19.049.422a1.216 1.216 0 011.216 1.216l.422 33.7v-34.122a1.216 1.216 0 00-1.215-1.216z"
              fill="#fff"
              opacity={0.2}
            />
            <g
              data-name="Group 485"
              transform="translate(165.371 275.324)"
              opacity={0.2}
            >
              <rect
                data-name="Rectangle 1363"
                width={2.554}
                height={1.802}
                rx={0.901}
              />
              <rect
                data-name="Rectangle 1364"
                width={2.554}
                height={1.802}
                rx={0.901}
                transform="translate(0 2.604)"
              />
              <rect
                data-name="Rectangle 1365"
                width={2.554}
                height={1.802}
                rx={0.901}
                transform="translate(0 5.209)"
              />
              <rect
                data-name="Rectangle 1366"
                width={2.554}
                height={1.802}
                rx={0.901}
                transform="translate(0 7.817)"
              />
              <rect
                data-name="Rectangle 1367"
                width={2.554}
                height={1.802}
                rx={0.901}
                transform="translate(0 10.422)"
              />
            </g>
            <rect
              data-name="Rectangle 1368"
              width={17.087}
              height={16.348}
              rx={3.07}
              transform="translate(151.661 255.962)"
              fill="#fff"
              opacity={0.2}
            />
            <rect
              data-name="Rectangle 1369"
              width={14.959}
              height={15.698}
              rx={1.43}
              transform="rotate(90 -44.302 212.352)"
              fill="#97a6b3"
            />
            <path
              data-name="Path 9960"
              d="M162.083 258.798l-.409-.409h1.494l-.41.409z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9961"
              d="M163.248 258.469v1.081l-.207.207-.207-.207v-.671z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9962"
              d="M162.961 259.84l-.2.2h-.675l-.2-.2.2-.207h.675z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9963"
              d="M161.593 258.469v1.081l.207.207.2-.207v-.671z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9964"
              d="M162.753 260.871l.41.409h-1.49l.409-.409z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9965"
              d="M161.593 261.205v-1.085l.207-.207.2.207v.675z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9966"
              d="M163.248 261.205v-1.085l-.207-.207-.207.207v.675z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9967"
              d="M159.867 258.798l-.409-.409h1.49l-.409.409z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9968"
              d="M161.027 258.469v1.081l-.2.207-.207-.207v-.671z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9969"
              d="M160.745 259.84l-.207.2h-.671l-.207-.2.207-.207h.671z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9970"
              d="M159.377 258.469v1.081l.2.207.207-.207v-.671z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9971"
              d="M160.538 260.871l.409.409h-1.49l.409-.409z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9972"
              d="M159.377 261.205v-1.085l.2-.207.207.207v.675z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9973"
              d="M161.027 261.205v-1.085l-.2-.207-.207.207v.675z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9974"
              d="M157.651 258.798l-.414-.409h1.49l-.41.409z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9975"
              d="M158.811 258.469v1.081l-.207.207-.2-.207v-.671z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9976"
              d="M158.529 259.84l-.207.2h-.671l-.207-.2.207-.207h.671z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9977"
              d="M157.161 258.469v1.081l.2.207.207-.207v-.671z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9978"
              d="M158.322 260.871l.41.409h-1.495l.414-.409z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9979"
              d="M157.161 261.205v-1.085l.2-.207.207.207v.675z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9980"
              d="M158.811 261.205v-1.085l-.207-.207-.2.207v.675z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9981"
              d="M162.083 263.108l-.409-.409h1.494l-.41.409z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9982"
              d="M163.248 262.779v1.081l-.207.207-.207-.207v-.671z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9983"
              d="M162.961 264.14l-.2.207h-.675l-.2-.207.2-.2h.675z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9984"
              d="M161.593 262.779v1.081l.207.207.2-.207v-.671z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9985"
              d="M162.753 265.18l.41.409h-1.49l.409-.409z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9986"
              d="M161.593 265.51v-1.081l.207-.207.2.207v.671z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9987"
              d="M163.248 265.51v-1.081l-.207-.207-.207.207v.671z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9988"
              d="M159.867 263.108l-.409-.409h1.49l-.409.409z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9989"
              d="M161.027 262.779v1.081l-.2.207-.207-.207v-.671z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9990"
              d="M160.745 264.14l-.207.207h-.671l-.207-.207.207-.2h.671z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9991"
              d="M159.377 262.779v1.081l.2.207.207-.207v-.671z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9992"
              d="M160.538 265.18l.409.409h-1.49l.409-.409z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9993"
              d="M159.377 265.51v-1.081l.2-.207.207.207v.671z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9994"
              d="M161.027 265.51v-1.081l-.2-.207-.207.207v.671z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9995"
              d="M157.651 263.108l-.414-.409h1.49l-.41.409z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9996"
              d="M158.811 262.779v1.081l-.207.207-.2-.207v-.671z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9997"
              d="M158.529 264.14l-.207.207h-.671l-.207-.207.207-.2h.671z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9998"
              d="M157.161 262.779v1.081l.2.207.207-.207v-.671z"
              fill="#252d3a"
            />
            <path
              data-name="Path 9999"
              d="M158.322 265.18l.41.409h-1.495l.414-.409z"
              fill="#252d3a"
            />
            <path
              data-name="Path 10000"
              d="M157.161 265.51v-1.081l.2-.207.207.207v.671z"
              fill="#252d3a"
            />
            <path
              data-name="Path 10001"
              d="M158.811 265.51v-1.081l-.207-.207-.2.207v.671z"
              fill="#252d3a"
            />
            <path
              data-name="Path 10002"
              d="M162.083 267.417l-.409-.409h1.494l-.41.409z"
              fill="#252d3a"
            />
            <path
              data-name="Path 10003"
              d="M163.248 267.084v1.085l-.207.207-.207-.207v-.671z"
              fill="#252d3a"
            />
            <path
              data-name="Path 10004"
              d="M162.961 268.452l-.2.207h-.675l-.2-.207.2-.2h.675z"
              fill="#252d3a"
            />
            <path
              data-name="Path 10005"
              d="M161.593 267.084v1.085l.207.207.2-.207v-.671z"
              fill="#252d3a"
            />
            <path
              data-name="Path 10006"
              d="M162.753 269.49l.41.409h-1.49l.409-.409z"
              fill="#252d3a"
            />
            <path
              data-name="Path 10007"
              d="M161.593 269.819v-1.081l.207-.207.2.207v.671z"
              fill="#252d3a"
            />
            <path
              data-name="Path 10008"
              d="M163.248 269.819v-1.081l-.207-.207-.207.207v.671z"
              fill="#252d3a"
            />
            <path
              data-name="Path 10009"
              d="M159.867 267.417l-.409-.409h1.49l-.409.409z"
              fill="#252d3a"
            />
            <path
              data-name="Path 10010"
              d="M161.027 267.084v1.085l-.2.207-.207-.207v-.671z"
              fill="#252d3a"
            />
            <path
              data-name="Path 10011"
              d="M160.745 268.452l-.207.207h-.671l-.207-.207.207-.2h.671z"
              fill="#252d3a"
            />
            <path
              data-name="Path 10012"
              d="M159.377 267.084v1.085l.2.207.207-.207v-.671z"
              fill="#252d3a"
            />
            <path
              data-name="Path 10013"
              d="M160.538 269.49l.409.409h-1.49l.409-.409z"
              fill="#252d3a"
            />
            <path
              data-name="Path 10014"
              d="M159.377 269.819v-1.081l.2-.207.207.207v.671z"
              fill="#252d3a"
            />
            <path
              data-name="Path 10015"
              d="M161.027 269.819v-1.081l-.2-.207-.207.207v.671z"
              fill="#252d3a"
            />
            <path
              data-name="Path 10016"
              d="M157.651 267.417l-.414-.409h1.49l-.41.409z"
              fill="#252d3a"
            />
            <path
              data-name="Path 10017"
              d="M158.811 267.084v1.085l-.207.207-.2-.207v-.671z"
              fill="#252d3a"
            />
            <path
              data-name="Path 10018"
              d="M158.529 268.452l-.207.207h-.671l-.207-.207.207-.2h.671z"
              fill="#252d3a"
            />
            <path
              data-name="Path 10019"
              d="M157.161 267.084v1.085l.2.207.207-.207v-.671z"
              fill="#252d3a"
            />
            <path
              data-name="Path 10020"
              d="M158.322 269.49l.41.409h-1.495l.414-.409z"
              fill="#252d3a"
            />
            <path
              data-name="Path 10021"
              d="M157.161 269.819v-1.081l.2-.207.207.207v.671z"
              fill="#252d3a"
            />
            <path
              data-name="Path 10022"
              d="M158.811 269.819v-1.081l-.207-.207-.2.207v.671z"
              fill="#252d3a"
            />
            <path
              data-name="Path 10023"
              d="M155.975 259.84l-.207.2h-.671l-.207-.2.207-.207h.671z"
              fill="#252d3a"
            />
            <path
              data-name="Path 10024"
              d="M155.975 264.14l-.207.207h-.671l-.207-.207.207-.2h.671z"
              fill="#252d3a"
            />
            <path
              data-name="Path 10025"
              d="M155.975 268.452l-.207.207h-.671l-.207-.207.207-.2h.671z"
              fill="#252d3a"
            />
            <path
              data-name="Path 10026"
              d="M165.515 259.84l-.207.2h-.671l-.207-.2.207-.207h.671z"
              fill="#252d3a"
            />
            <path
              data-name="Path 10027"
              d="M165.515 264.14l-.207.207h-.671l-.207-.207.207-.2h.671z"
              fill="#252d3a"
            />
            <path
              data-name="Path 10028"
              d="M165.515 268.452l-.207.207h-.671l-.207-.207.207-.2h.671z"
              fill="#252d3a"
            />
            <path
              data-name="Path 10029"
              d="M155.878 256.658l8.56 14.938h-5.4l-6.081-14.938z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 10030"
              d="M167.448 256.658h-6.83l7.433 9.214v-8.615a.6.6 0 00-.603-.599z"
              fill="#fff"
              opacity={0.2}
            />
            <circle
              data-name="Ellipse 449"
              cx={4.981}
              cy={4.981}
              r={4.981}
              transform="rotate(-80.75 243.635 53.318)"
              opacity={0.2}
            />
            <circle
              data-name="Ellipse 450"
              cx={4.5}
              cy={4.5}
              r={4.5}
              transform="rotate(-80.75 243.692 52.798)"
              fill="#97a6b3"
            />
            <path
              data-name="Path 10031"
              d="M153.071 281.12v-.156a3.476 3.476 0 01.034-.448q.025-.143.051-.317l.093-.363c.038-.131.093-.262.143-.422a2.779 2.779 0 01.2-.422 2.645 2.645 0 01.27-.422 4.059 4.059 0 01.342-.422 4.526 4.526 0 01.9-.777 4.723 4.723 0 011.152-.536 4.449 4.449 0 012.6 0 4.878 4.878 0 011.152.536 4.5 4.5 0 01.9.777 4.131 4.131 0 01.346.422c.1.148.186.3.27.422a2.245 2.245 0 01.2.422 3.111 3.111 0 01.144.422l.093.363.051.317a2.961 2.961 0 01.038.448 4.145 4.145 0 00-.068-.443l-.068-.308-.114-.354c-.042-.122-.105-.249-.16-.384s-.139-.27-.215-.422a3.261 3.261 0 00-.274-.422 5.067 5.067 0 00-.35-.422 4.889 4.889 0 00-.886-.722 4.386 4.386 0 00-1.106-.5 4.646 4.646 0 00-2.478 0 4.516 4.516 0 00-1.106.5 5.194 5.194 0 00-.886.722 4.309 4.309 0 00-.346.422c-.1.139-.19.283-.279.422a2.629 2.629 0 00-.211.422c-.059.144-.118.262-.165.384l-.11.354-.068.308c-.046.186-.051.342-.072.443a.856.856 0 00-.017.156z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 10032"
              d="M156.701 285.13a4.107 4.107 0 001.735 0v-8.02a4.091 4.091 0 00-1.735 0z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 10033"
              d="M156.701 281.059a8.112 8.112 0 001.735 0v-4.018a8.112 8.112 0 00-1.735 0z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 10034"
              d="M157.001 278.11l.57-.988.57.988z"
              fill="#fff"
            />
            <path
              data-name="Path 10035"
              d="M156.701 277.092a20.649 20.649 0 00-1.093 5.065 4.39 4.39 0 001.093 2.984z"
              opacity={0.2}
            />
            <path
              data-name="Path 10036"
              d="M157.866 275.442a.3.3 0 11-.3-.3.3.3 0 01.3.3z"
              fill="#fff"
            />
            <path
              data-name="Path 10037"
              d="M161.791 277.317a.3.3 0 01-.422 0 .3.3 0 010-.422.3.3 0 01.422 0 .3.3 0 010 .422z"
              fill="#fff"
            />
            <path
              data-name="Path 10038"
              d="M163.239 281.414a.3.3 0 11.3-.3.3.3 0 01-.3.3z"
              fill="#fff"
            />
            <path
              data-name="Path 10039"
              d="M161.365 285.337a.3.3 0 010-.422.3.3 0 01.422 0 .3.3 0 010 .422.3.3 0 01-.422 0z"
              fill="#fff"
            />
            <path
              data-name="Path 10040"
              d="M157.267 286.785a.3.3 0 11.3.3.3.3 0 01-.3-.3z"
              fill="#fff"
            />
            <path
              data-name="Path 10041"
              d="M153.345 284.918a.3.3 0 110 .422.3.3 0 010-.422z"
              fill="#fff"
            />
            <path
              data-name="Path 10042"
              d="M151.902 280.806a.3.3 0 11-.3.3.3.3 0 01.3-.3z"
              fill="#fff"
            />
            <path
              data-name="Path 10043"
              d="M153.771 276.898a.3.3 0 11-.422 0 .3.3 0 01.422 0z"
              fill="#fff"
            />
            <rect
              data-name="Rectangle 1370"
              width={2.554}
              height={1.802}
              rx={0.901}
              transform="translate(165.514 274.999)"
              fill="#97a6b3"
            />
            <rect
              data-name="Rectangle 1371"
              width={2.554}
              height={1.802}
              rx={0.901}
              transform="translate(165.514 277.603)"
              fill="#97a6b3"
            />
            <rect
              data-name="Rectangle 1372"
              width={2.554}
              height={1.802}
              rx={0.901}
              transform="translate(165.514 280.211)"
              fill="#97a6b3"
            />
            <rect
              data-name="Rectangle 1373"
              width={2.554}
              height={1.802}
              rx={0.901}
              transform="translate(165.514 282.816)"
              fill="#97a6b3"
            />
            <rect
              data-name="Rectangle 1374"
              width={2.554}
              height={1.802}
              rx={0.901}
              transform="translate(165.514 285.42)"
              fill="#97a6b3"
            />
            <path
              data-name="Path 10044"
              d="M137.938 269.743h6.534a.654.654 0 01.654.654v.215a.984.984 0 01-.983.984h-5.876a.984.984 0 01-.984-.984v-.219a.659.659 0 01.655-.65z"
              fill="#d40032"
            />
            <path
              data-name="Path 10045"
              d="M143.759 270.963h-5.09a.637.637 0 01-.642-.637.422.422 0 01.422-.422h5.517a.422.422 0 01.422.422.637.637 0 01-.629.637z"
              fill="#fff"
              opacity={0.3}
            />
            <path
              data-name="Path 10046"
              d="M142.915 282.009h-3.406l-.831-10.413h5.069z"
              fill="#d40032"
            />
            <path
              data-name="Path 10047"
              d="M141.919 282.009h-1.41l-.346-10.413h2.106z"
              fill="#fff"
              opacity={0.3}
            />
            <path
              data-name="Path 10048"
              d="M140.746 253.02h.933l.228 16.724h-1.389z"
              fill="#aac9df"
            />
            <path
              data-name="Path 10049"
              d="M141.011 253.02h.4l.1 16.724h-.6z"
              fill="#fff"
              opacity={0.5}
            />
            <path
              data-name="Path 10050"
              d="M141.214 272.702a2.84 2.84 0 012.334 1.389l.2-2.495h-5.067l.2 2.495a2.845 2.845 0 012.333-1.389z"
              opacity={0.2}
            />
            <path
              data-name="Path 10051"
              d="M175.543 269.743h6.534a.659.659 0 01.658.658v.215a.984.984 0 01-.984.984h-5.88a.984.984 0 01-.984-.984v-.215a.658.658 0 01.656-.658z"
              fill="#f26522"
            />
            <path
              data-name="Path 10052"
              d="M181.36 270.963h-5.091a.637.637 0 01-.642-.637.422.422 0 01.422-.422h5.513a.422.422 0 01.422.422.637.637 0 01-.625.637z"
              fill="#fff"
              opacity={0.3}
            />
            <path
              data-name="Path 10053"
              d="M180.516 282.009h-3.4l-.836-10.413h5.069z"
              fill="#f26522"
            />
            <path
              data-name="Path 10054"
              d="M179.519 282.009h-1.414l-.346-10.413h2.106z"
              fill="#fff"
              opacity={0.3}
            />
            <path
              data-name="Path 10055"
              d="M178.346 253.02h.933l.228 16.724h-1.389z"
              fill="#aac9df"
            />
            <path
              data-name="Path 10056"
              d="M178.612 253.02h.4l.1 16.724h-.6z"
              fill="#fff"
              opacity={0.5}
            />
            <path
              data-name="Path 10057"
              d="M178.815 272.702a2.84 2.84 0 012.334 1.389l.2-2.495h-5.067l.2 2.495a2.845 2.845 0 012.333-1.389z"
              opacity={0.2}
            />
            <path
              data-name="Path 10058"
              d="M16.014 186.977l-.439-.274h-3.879l-.439.274-.578 1.279.371 2.292h5.175l.367-2.292z"
              fill="#f26522"
            />
            <path
              data-name="Path 10059"
              d="M16.225 214.22H11.05l-.371 1.3.578.726.439.152h3.883l.439-.152.578-.726z"
              fill="#f26522"
            />
            <path
              data-name="Path 10060"
              d="M16.981 196.884c0-6.391-.756-6.332-.756-6.332h-5.174s-.756-.055-.756 6.332 1.182 11.229 1.182 14.516a6.166 6.166 0 01-.422 2.82h5.171a6.1 6.1 0 01-.422-2.82c-.005-3.305 1.177-8.121 1.177-14.516z"
              fill="#1c7f98"
            />
            <path
              data-name="Path 10061"
              d="M14.681 211.401c0-3.288.57-8.121.57-14.516s-.363-6.332-.363-6.332l.177-2.292-.291-1.271-.211-.274h-1.861l-.211.274-.283 1.266.182 2.292s-.367-.055-.367 6.332.57 11.228.57 14.516a12.033 12.033 0 01-.2 2.82l-.182 1.3.283.726.211.152h1.874l.211-.152.279-.726-.177-1.3a11.727 11.727 0 01-.211-2.815z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Rectangle 1375"
              fill="#788b9c"
              d="M12.862 216.394h1.553v26.643h-1.553z"
            />
            <path
              data-name="Rectangle 1376"
              opacity={0.15}
              d="M12.862 216.394h1.553v1.203h-1.553z"
            />
            <path
              data-name="Path 10062"
              d="M14.694 240.449h-2.115l-.726 1.688 1.009 4.424h1.553l1.009-4.424z"
              fill="#788b9c"
            />
            <path
              data-name="Rectangle 1377"
              fill="#fff"
              opacity={0.2}
              d="M13.444 216.394h.388v23.752h-.388z"
            />
            <path
              data-name="Path 10063"
              d="M13.288 240.449l-.241 1.688.333 4.424h-.228l-.684-4.424.578-1.688z"
              opacity={0.15}
            />
            <path
              data-name="Path 10064"
              d="M13.989 240.449l.241 1.688-.333 4.424h.228l.684-4.424-.578-1.688z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 10065"
              d="M10.679 215.516l.578.726.422.152h3.9l.422-.152.578-.726-.367-1.3v1.089l-1.161.207h-2.844l-.9-.3s1.228-1.46-.262-8.6a41.265 41.265 0 01.422 4.787 6.165 6.165 0 01-.422 2.82z"
              opacity={0.15}
            />
            <g data-name="Group 486" opacity={0.2} fill="#fff">
              <path
                data-name="Path 10066"
                d="M15.905 206.779a12.566 12.566 0 00-3.7-4.842 5.343 5.343 0 00-1.752-.971c.144 2.018.371 3.841.574 5.487a1.828 1.828 0 01.886-.929 1.883 1.883 0 011.726.245 5.486 5.486 0 011.266 1.3 3.622 3.622 0 01.87 1.621 1.262 1.262 0 01-.844 1.465 7.267 7.267 0 01-.844 0 1.237 1.237 0 00-.219 2.419 5.008 5.008 0 001.975-.249c0-.275-.03-.578-.03-.924a35.25 35.25 0 01.338-4.078 4.421 4.421 0 01-.246-.544z"
              />
              <path
                data-name="Path 10067"
                d="M12.456 192.964a3.76 3.76 0 00-1.9-.908 30.031 30.031 0 00-.236 3.714 3.325 3.325 0 011.726-.068 5.015 5.015 0 012.8 2.013 15.405 15.405 0 011.9 4.065l.025.08a56.46 56.46 0 00.228-4.968v-.844a5.951 5.951 0 01-2.642-1.308c-.681-.552-1.238-1.224-1.901-1.776z"
              />
            </g>
            <path
              data-name="Path 10068"
              d="M30.792 186.91l-.439-.207h-3.879l-.439.207-.578.979.371 1.752h5.175l.367-1.752z"
              fill="#f26522"
            />
            <path
              data-name="Path 10069"
              d="M31.003 207.728h-5.175l-.371.988.578.557.439.114h3.879l.439-.114.578-.557z"
              fill="#f26522"
            />
            <path
              data-name="Path 10070"
              d="M31.759 194.483c0-4.884-.756-4.842-.756-4.842h-5.174s-.756-.042-.756 4.842 1.182 8.577 1.182 11.089a3.738 3.738 0 01-.422 2.157h5.171a3.738 3.738 0 01-.422-2.157c-.009-2.511 1.177-6.206 1.177-11.089z"
              fill="#fbb040"
            />
            <path
              data-name="Path 10071"
              d="M30.577 205.563a12.484 12.484 0 01.084-1.321 2.41 2.41 0 01-2.046-.963 2.132 2.132 0 01-.084-2.334c.422-.663 1.266-1.081 1.431-1.849.144-.608-.122-1.389.367-1.777a1.017 1.017 0 011.182.093c.038.025.072.059.106.084.038-.422.072-.844.1-1.266l-.131-.042a1.4 1.4 0 01-.684-.473.667.667 0 010-.785 1.122 1.122 0 01.878-.262v-.186c0-.667 0-1.237-.042-1.735-.886.152-1.549-.933-2.182-1.418a3.55 3.55 0 00-3.744-.35 3.2 3.2 0 00-.566.388 19.22 19.22 0 00-.114 1.448 1.332 1.332 0 011.157-.734.983.983 0 01.768 1.043 2 2 0 01-.642 1.241c-.333.342-.722.625-1.034.984a2.406 2.406 0 00-.258.359c.03.747.08 1.465.148 2.148a.844.844 0 011.034-.4.958.958 0 01.342 1.106c-.106.422-.342.764-.422 1.174a3.461 3.461 0 00.967 2.638 31.006 31.006 0 002.326 2.925 7.7 7.7 0 001.123 1 3.877 3.877 0 01-.064-.736z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 10072"
              d="M29.458 205.563c0-2.512.57-6.2.57-11.089s-.363-4.841-.363-4.841l.177-1.752-.3-.967-.211-.211h-1.852l-.211.211-.283.975.181 1.752s-.367-.042-.367 4.842.57 8.577.57 11.089a7.117 7.117 0 01-.2 2.157l-.181.988.283.557.211.114h1.874l.211-.114.279-.557-.177-.988a6.982 6.982 0 01-.211-2.166z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Rectangle 1378"
              fill="#788b9c"
              d="M27.825 209.387h1.178v34.916h-1.178z"
            />
            <path
              data-name="Rectangle 1379"
              opacity={0.15}
              d="M27.825 209.387h1.178v1.203h-1.178z"
            />
            <path
              data-name="Path 10073"
              d="M27.615 246.566h1.6l.426-4.846h-2.457z"
              fill="#788b9c"
            />
            <path
              data-name="Path 10074"
              d="M27.808 246.566h1.216l.321-4.846h-1.862z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Rectangle 1380"
              fill="#fff"
              opacity={0.2}
              d="M28.268 209.387h.295v32.025h-.295z"
            />
            <path
              data-name="Path 10075"
              d="M25.457 208.716l.578.557.422.114h3.879l.422-.114.578-.557-.367-.988v.844l-1.161.156h-2.823l-.9-.232s1.228-1.114-.262-6.568a24.314 24.314 0 01.422 3.655 3.738 3.738 0 01-.422 2.157z"
              opacity={0.15}
            />
            <path
              data-name="Path 10076"
              d="M28.416 199.966a1.013 1.013 0 01-1.013-1.017V194.2a1.013 1.013 0 011.013-1.013 1.013 1.013 0 011.013 1.013v4.749a1.013 1.013 0 01-1.013 1.017z"
              opacity={0.5}
            />
            <path
              data-name="Path 10077"
              d="M28.416 198.535a.473.473 0 01-.477-.477v-2.955a.477.477 0 01.477-.481.481.481 0 01.477.481v2.955a.477.477 0 01-.477.477z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 10078"
              d="M28.416 195.513a.422.422 0 01-.4-.4.422.422 0 01.4-.4.422.422 0 01.4.4.422.422 0 01-.4.4z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 10079"
              d="M28.471 195.103h-.11a.173.173 0 01-.173-.173.169.169 0 01.173-.169h.11a.173.173 0 01.173.169.173.173 0 01-.173.173z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 10080"
              d="M28.417 193.187a.969.969 0 00-.11 0v.772c0 .422-.03.464-.245.684a.545.545 0 00-.211.422v2.984a.54.54 0 00.211.422c.215.215.245.262.245.684v.773a.483.483 0 00.219 0v-.773c0-.422.025-.469.245-.684a.553.553 0 00.211-.422v-2.984a.549.549 0 00-.215-.422c-.219-.219-.245-.262-.245-.684v-.772a.951.951 0 00-.105 0z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 10081"
              d="M28.416 193.208v2.849c0 .084 0 .093-.051.135a.11.11 0 00-.042.084v.591a.11.11 0 00.042.084c.042.042.051.051.051.135v2.858h.042v-2.858c0-.084 0-.093.046-.135a.11.11 0 00.042-.084v-.589a.11.11 0 00-.042-.084c-.042-.042-.046-.051-.046-.135v-2.851z"
              opacity={0.5}
            />
            <path
              data-name="Path 10082"
              d="M28.416 196.906a.063.063 0 01-.063-.059v-.532a.063.063 0 01.063-.059.059.059 0 01.059.059v.532a.059.059 0 01-.059.059z"
              fill="#ed1c24"
            />
            <path
              data-name="Path 10083"
              d="M123.212 196.652l-1.6 6.281a4.766 4.766 0 01-3.8.629l-.739 2.891-3.406-.886 1.119-4.386 1.6-6.281a4.766 4.766 0 013.8-.629l1.836-7.176c1.946.946 2.9 2.887 2.558 4.221-.174.647-.558 2.15-1.368 5.336z"
              fill="#788b9c"
            />
            <path
              data-name="Path 10084"
              d="M122.017 187.083l.106.059a3.013 3.013 0 01.3.165 4.112 4.112 0 01.443.3 2.649 2.649 0 01.253.2 3.644 3.644 0 01.27.249 4.99 4.99 0 01.528.62 3.893 3.893 0 01.443.794 3.17 3.17 0 01.258.941 2.567 2.567 0 01-.072 1l-1.334 5.238s0-.173.021-.473c0-.152.03-.333.046-.54s.034-.443.063-.7c.055-.511.131-1.1.219-1.731.051-.312.106-.637.156-.967s.122-.663.182-1a.243.243 0 01.021-.122v-.084a.813.813 0 000-.177 1.3 1.3 0 000-.181 1.421 1.421 0 00-.025-.182 3.271 3.271 0 00-.224-.735 5.392 5.392 0 00-.321-.688c-.059-.11-.127-.207-.19-.308s-.131-.2-.2-.291c-.131-.181-.274-.333-.4-.477a3.236 3.236 0 01-.3-.422 3.852 3.852 0 01-.2-.346.244.244 0 00-.046-.106z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 10085"
              d="M123.212 196.648c.072-.3.148-.6.224-.895a5.394 5.394 0 00-3.09-2.11l-.165.646a4.77 4.77 0 013.031 2.359z"
              opacity={0.15}
            />
            <path
              data-name="Path 10086"
              d="M114.786 201.186l-.228.895a5.412 5.412 0 003.09 2.111l.165-.646a4.748 4.748 0 01-3.027-2.36z"
              opacity={0.15}
            />
            <path
              data-name="Path 10087"
              d="M117.442 205.018l-4.073-1.038c-.532-.135-.228.422-.992.4s-2.047-.557-1.688.528a7.108 7.108 0 01-.262 5.947c-1.359 2.794-5.314 12.072-4.8 16.1s-1.178 5.846.916 6.483 3.474.629 3.655-.093-.422-7.433 1.971-14.351 3.769-8.125 4.276-10.13.997-3.846.997-3.846z"
              fill="#1c7f98"
            />
            <path
              data-name="Path 10088"
              d="M114.588 212.975a26.532 26.532 0 001.87-4.107l.983-3.85-4.073-1.038c-.532-.135-.228.422-.992.4s-2.047-.557-1.688.528a7.332 7.332 0 01.422 3.8c1.592.937 3.702 2.52 3.478 4.267z"
              fill="#f26522"
            />
            <path
              data-name="Path 10089"
              d="M106.555 233.422c2.11.637 3.474.629 3.655-.093.076-.287.025-1.52.084-3.33a13.013 13.013 0 00-4.643.207c-.197 1.832-.505 2.794.904 3.216z"
              fill="#f26522"
            />
            <path
              data-name="Path 10090"
              d="M107.348 233.169a14.41 14.41 0 01-.65-.186c-.806-.245-.844-.54-.65-2.11a15.2 15.2 0 00.063-3.989c-.464-3.63 3.005-12.241 4.757-15.829a7.618 7.618 0 00.291-6.277s0-.072-.03-.089a5.183 5.183 0 01.566.072 4.68 4.68 0 00.671.08 1.29 1.29 0 00.6-.105 1.621 1.621 0 011.11-.093l1.127.287a1.714 1.714 0 011.237 2.085l-.422 1.731a11.168 11.168 0 01-1 2.326 53.606 53.606 0 00-3.271 7.754 41.5 41.5 0 00-1.946 13.254 9.03 9.03 0 01-.034 1.144c-.034.118-.274.173-.494.19a6.185 6.185 0 01-1.916-.249z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 10091"
              d="M115.005 211.076l-.422.844c-.266.532-.641 1.3-1.047 2.246s-.844 2.051-1.3 3.254c-.215.6-.447 1.224-.65 1.87-.1.317-.207.641-.3.971s-.19.654-.27.988c-.169.659-.321 1.33-.447 1.988s-.241 1.313-.329 1.95a44.097 44.097 0 00-.35 3.486c-.063 1.021-.08 1.878-.093 2.478s0 .937 0 .937a5.029 5.029 0 01-.3-.946 7.9 7.9 0 01-.181-1.1c-.034-.422-.038-.9-.038-1.418s0-1.085.038-1.688.08-1.228.177-1.874.2-1.313.346-1.984.312-1.347.515-2.014c.093-.338.207-.671.317-1s.224-.654.342-.971c.232-.654.485-1.266.73-1.862a57.88 57.88 0 011.5-3.2c.232-.46.473-.87.68-1.237s.4-.675.553-.933l.529-.785z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 10092"
              d="M115.479 195.677v6.479a4.749 4.749 0 003.52 1.549v2.984h3.52v-11.012a4.765 4.765 0 00-3.52-1.549v-7.425c-2.11.422-3.52 2.081-3.52 3.457z"
              fill="#788b9c"
            />
            <path
              data-name="Path 10093"
              d="M121.566 198.915a2.575 2.575 0 11-2.571-2.571 2.575 2.575 0 012.571 2.571z"
              opacity={0.15}
            />
            <circle
              data-name="Ellipse 451"
              cx={2.22}
              cy={2.22}
              r={2.22}
              transform="translate(116.779 196.695)"
              fill="#788b9c"
            />
            <path
              data-name="Path 10094"
              d="M118.999 205.217h4.2c.549 0 .118.46.865.629s2.11-.034 1.49.924a7.108 7.108 0 00-1.216 5.825c.629 3.047 2.165 13.013.671 16.787s-.308 5.956-2.49 6.057-3.52-.249-3.52-.992 2.241-7.1 1.642-14.4-1.642-8.8-1.642-10.856z"
              fill="#1c7f98"
            />
            <path
              data-name="Path 10095"
              d="M119.797 213.629a26.92 26.92 0 01-.8-4.44v-3.972h4.2c.549 0 .118.46.865.629s2.11-.034 1.49.924a7.336 7.336 0 00-1.363 3.592c-1.741.507-4.169 1.533-4.392 3.267z"
              fill="#f26522"
            />
            <path
              data-name="Path 10096"
              d="M122.519 235.439c-2.186.1-3.52-.249-3.52-.992 0-.3.35-1.477.739-3.25a13.086 13.086 0 014.453 1.347c-.262 1.81-.199 2.823-1.672 2.895z"
              fill="#f26522"
            />
            <path
              data-name="Path 10097"
              d="M121.818 234.984h.675c.844-.038.945-.317 1.148-1.878a15.082 15.082 0 01.929-3.879c1.346-3.406.114-12.6-.7-16.517a7.636 7.636 0 011.266-6.154l.051-.076a4.769 4.769 0 00-.561-.072 5.589 5.589 0 01-.671-.089 1.265 1.265 0 01-.557-.253 1.613 1.613 0 00-1.055-.363h-1.161a1.718 1.718 0 00-1.718 1.714v1.79a11.121 11.121 0 00.393 2.495 53.716 53.716 0 011.266 8.324 41.959 41.959 0 01-1.389 13.326c-.122.49-.249 1-.253 1.114s.224.232.422.308a6.294 6.294 0 001.916.228z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 10098"
              d="M124.571 229.201v-.072a2.05 2.05 0 010-.207 7.381 7.381 0 000-.755c-.025-.312 0-.68 0-1.106v-1.439a103.82 103.82 0 00-.08-1.714c0-.3-.038-.62-.063-.941s-.034-.646-.059-.979c-.051-.667-.1-1.359-.148-2.06s-.118-1.418-.177-2.111a76.084 76.084 0 00-.485-4.187c-.046-.338-.089-.667-.135-1 0-.16-.038-.317-.051-.481s0-.342-.03-.506a8.276 8.276 0 01.165-1.823 6.965 6.965 0 01.485-1.452 8.061 8.061 0 01.566-1.013c.177-.27.338-.464.422-.6l.16-.207-.139.219c-.089.143-.224.35-.376.629a7.341 7.341 0 00-.844 2.465 7.651 7.651 0 00-.055 1.748 17.555 17.555 0 00.317 1.925c.245 1.334.464 2.765.646 4.2.089.718.169 1.435.237 2.144s.122 1.406.16 2.081c.025.338.038.671.051 1s.03.642.03.954v1.752c0 .27-.034.528-.046.777s-.038.477-.068.7-.051.422-.084.612l-.1.511a4.816 4.816 0 01-.2.709z"
              fill="#fff"
              opacity={0.2}
            />
            <g data-name="Group 487" opacity={0.2} fill="#fff">
              <path
                data-name="Path 10099"
                d="M106.462 224.473a2.8 2.8 0 002.376-.553c.912-.941.274-2.659-.878-3.28a3.69 3.69 0 00-1.216-.388 30.361 30.361 0 00-1 4.124z"
              />
              <path
                data-name="Path 10100"
                d="M109.4 229.375a2.949 2.949 0 01.929-.135c.046-.916.122-1.942.253-3.048a3.647 3.647 0 00-1.393.4 21.3 21.3 0 00-2.292 1.608 5.481 5.481 0 01-1.161.62c-.051 2.74-.916 4.09.819 4.618.485.148.933.257 1.334.338v-.975c-.055-1.341.249-2.979 1.511-3.426z"
              />
              <path
                data-name="Path 10101"
                d="M111.734 214.541a17.837 17.837 0 00-2.292-1.5c-.422 1.009-.929 2.2-1.41 3.474a4.829 4.829 0 013.976 1.266c.148.148.291.3.422.46.346-.967.667-1.815.967-2.566-.739-.534-1.439-.96-1.663-1.134z"
              />
            </g>
            <g data-name="Group 488" opacity={0.2} fill="#fff">
              <path
                data-name="Path 10102"
                d="M120.722 223.152c0 1-.076 1.967-.165 2.883a22.453 22.453 0 012.664 2.6c.5.582.967 1.194 1.41 1.823a11.2 11.2 0 01.367-1.076 10.136 10.136 0 00.553-2.765 10.566 10.566 0 01-4.829-3.465z"
              />
              <path
                data-name="Path 10103"
                d="M120.409 217.682c1.422.127 2.858.084 4.284.177l.485.042c-.279-2.25-.616-4.221-.844-5.306a7.4 7.4 0 01-.135-.916 8.7 8.7 0 00-4.559 1.224c.237 1.145.524 2.648.769 4.779z"
              />
            </g>
            <path
              data-name="Path 10104"
              d="M24.415 336.916v.342a9.32 9.32 0 01-.055 1.068 14.378 14.378 0 01-.253 1.823 14.063 14.063 0 01-.663 2.3 11.917 11.917 0 01-3.246 4.791 8.793 8.793 0 01-5.846 2.292 9.1 9.1 0 01-6.7-3.275 10.539 10.539 0 01-.718-.882l-.342-.473-.025-.03-.042-.063-.034-.059-.076-.114-.144-.236a13.132 13.132 0 01-1.1-2.368 22.062 22.062 0 01-1.106-5.289 34.356 34.356 0 01-.051-5.555 41.1 41.1 0 01.751-5.525 46.745 46.745 0 011.418-5.335 44.283 44.283 0 011.984-5.015 40.42 40.42 0 015.373-8.594 37.73 37.73 0 016.538-6.293 50.697 50.697 0 013.427-2.313 33.072 33.072 0 013.406-1.819 41.454 41.454 0 016.433-2.423 51.3 51.3 0 015.572-1.266c.844-.156 1.617-.241 2.343-.346l1.992-.215 1.608-.122c.469-.038.865-.047 1.19-.068l.992-.047v2.735h-3.703l-1.95.11c-.709.067-1.477.11-2.292.224a39.821 39.821 0 00-5.462 1 39.132 39.132 0 00-6.332 2.153 35.076 35.076 0 00-13.085 9.81 38.832 38.832 0 00-8.307 18.23 34.911 34.911 0 00-.274 10.354 19.838 19.838 0 001.119 4.521 10.8 10.8 0 00.882 1.811l.152.224.076.114.038.059v.025l.3.38a9.305 9.305 0 00.612.717 7.352 7.352 0 005.525 2.566 7.427 7.427 0 004.744-1.921 9.572 9.572 0 002.533-3.748 10.739 10.739 0 00.515-1.752 11.712 11.712 0 00.2-1.338 9.111 9.111 0 00.059-.924v-.342z"
              fill="#516a80"
            />
            <path
              data-name="Path 10105"
              d="M23.512 336.916v.342a8.253 8.253 0 01-.055 1.047 14.351 14.351 0 01-.844 3.8 10.734 10.734 0 01-3.06 4.441 7.872 7.872 0 01-5.551 1.908 8.974 8.974 0 01-6.234-3.427c-.232-.27-.452-.557-.667-.844l-.169-.241-.148-.228a5.519 5.519 0 01-.291-.494 13.01 13.01 0 01-.984-2.242 22.615 22.615 0 01-1.026-5.065 38.019 38.019 0 01.671-10.814 46.521 46.521 0 011.389-5.247 43.5 43.5 0 011.971-4.922 39.678 39.678 0 015.34-8.442 37.739 37.739 0 013.153-3.377 39.791 39.791 0 013.335-2.777 38.864 38.864 0 016.754-4 41.076 41.076 0 016.386-2.322 47.315 47.315 0 015.517-1.182c.844-.143 1.6-.215 2.317-.312l1.971-.186c1.195-.072 2.132-.127 2.769-.131l.983-.025v1.182h-.971c-.633 0-1.562.021-2.744.068l-1.954.135c-.709.08-1.482.131-2.3.257a41.585 41.585 0 00-5.487 1.059 40.338 40.338 0 00-6.332 2.208 36.2 36.2 0 00-6.673 3.871 37.819 37.819 0 00-3.275 2.735 37.1 37.1 0 00-3.119 3.3 38.92 38.92 0 00-5.276 8.265 41.343 41.343 0 00-3.254 10.012 36.415 36.415 0 00-.485 10.51 21.753 21.753 0 001.03 4.77 11.526 11.526 0 00.908 2.005 4.874 4.874 0 00.279.452l.148.228.144.19c.2.279.422.536.625.789a8.233 8.233 0 005.753 3.12 7.227 7.227 0 005.065-1.777 9.8 9.8 0 002.744-4 12.663 12.663 0 00.756-3.377c.038-.422.046-.7.051-.937s0-.342 0-.342z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10106"
              d="M61.627 293.296v-6.576h-4.12a11.647 11.647 0 01-9.434 4.706v-.545a.507.507 0 00-1.013 0v4.829a.507.507 0 101.013 0v-.549a11.645 11.645 0 019.434 4.711h4.12z"
              fill="#42b7ba"
            />
            <path
              data-name="Rectangle 1381"
              fill="#3c3c4e"
              d="M63.02 295.812v1.773h-1.393v-1.773z"
            />
            <path
              data-name="Rectangle 1382"
              fill="#535363"
              d="M63.02 295.812v1.773h-.321v-1.773z"
            />
            <path
              data-name="Path 10107"
              d="M68.917 296.699a.777.777 0 00-.772-.777h-2.668v1.553h2.668a.772.772 0 00.772-.777z"
              fill="#aac9df"
            />
            <path
              data-name="Path 10108"
              d="M68.904 296.623v.114a.422.422 0 01-.422.422h-3.018v-.954h3.009a.422.422 0 01.431.418z"
              fill="#fff"
              opacity={0.3}
            />
            <path
              data-name="Path 10109"
              d="M68.888 296.698a.215.215 0 00-.215-.215h-3.2v.422h3.2a.215.215 0 00.215-.207z"
              fill="#fff"
              opacity={0.3}
            />
            <path
              data-name="Rectangle 1383"
              fill="#1c1f23"
              opacity={0.2}
              d="M65.797 295.926v1.553h-.321v-1.553z"
            />
            <path
              data-name="Rectangle 1384"
              fill="#252d3a"
              d="M65.477 296.04v1.321H63.02v-1.321z"
            />
            <path
              data-name="Rectangle 1385"
              fill="#fff"
              opacity={0.15}
              d="M65.223 296.378v.642H63.02v-.642z"
            />
            <path
              data-name="Path 10110"
              d="M68.596 297.129c-.16 0-.291-.194-.291-.422s.131-.422.291-.422.291.19.291.422-.13.422-.291.422z"
              fill="#fff"
              opacity={0.3}
            />
            <path
              data-name="Rectangle 1386"
              fill="#3c3c4e"
              d="M63.02 289.008v1.773h-1.393v-1.773z"
            />
            <path
              data-name="Rectangle 1387"
              fill="#535363"
              d="M63.02 289.004v1.773h-.321v-1.773z"
            />
            <path
              data-name="Path 10111"
              d="M68.917 289.891a.772.772 0 00-.772-.772h-2.668v1.549h2.668a.772.772 0 00.772-.777z"
              fill="#aac9df"
            />
            <path
              data-name="Path 10112"
              d="M68.908 289.814v.114a.422.422 0 01-.422.422h-3.01v-.954h3.01a.422.422 0 01.422.418z"
              fill="#fff"
              opacity={0.3}
            />
            <path
              data-name="Path 10113"
              d="M68.888 289.89a.211.211 0 00-.215-.211h-3.2v.422h3.2a.215.215 0 00.215-.211z"
              fill="#fff"
              opacity={0.3}
            />
            <path
              data-name="Rectangle 1388"
              fill="#1c1f23"
              opacity={0.2}
              d="M65.793 289.118v1.553h-.321v-1.553z"
            />
            <path
              data-name="Rectangle 1389"
              fill="#252d3a"
              d="M65.472 289.236v1.321h-2.457v-1.321z"
            />
            <path
              data-name="Rectangle 1390"
              fill="#fff"
              opacity={0.15}
              d="M65.228 289.569v.642h-2.203v-.642z"
            />
            <path
              data-name="Path 10114"
              d="M68.596 290.321c-.16 0-.291-.194-.291-.422s.131-.422.291-.422.291.19.291.422-.13.422-.291.422z"
              fill="#fff"
              opacity={0.3}
            />
            <path
              data-name="Rectangle 1391"
              fill="#fff"
              opacity={0.15}
              d="M61.623 289.468v7.661h-4.972v-7.661z"
            />
            <path
              data-name="Rectangle 1392"
              fill="#fff"
              opacity={0.15}
              d="M50.37 291.65v3.292h-2.296v-3.292z"
            />
            <path
              data-name="Rectangle 1393"
              fill="#fff"
              opacity={0.15}
              d="M51.096 292.33v1.937h-.418v-1.937z"
            />
            <path
              data-name="Rectangle 1394"
              fill="#fff"
              opacity={0.15}
              d="M56.325 291.262v4.065h-.422v-4.065z"
            />
            <path
              data-name="Rectangle 1395"
              fill="#fff"
              opacity={0.15}
              d="M55.629 291.444v3.698h-.422v-3.698z"
            />
            <path
              data-name="Path 10115"
              d="M50.369 294.943h-2.3v.219a11.657 11.657 0 019.434 4.711h4.12v-2.744h-4.977s-3.339-2.186-6.277-2.186z"
              fill="#1c1f23"
              opacity={0.2}
            />
            <path
              data-name="Path 10116"
              d="M14.9 270.917h17.032a1.579 1.579 0 011.579 1.579v58.591a1.579 1.579 0 01-1.579 1.579H14.9a1.574 1.574 0 01-1.574-1.579v-58.591a1.574 1.574 0 011.574-1.579z"
              fill="#42b7ba"
            />
            <path
              data-name="Rectangle 1396"
              fill="#fff"
              opacity={0.5}
              d="M19.932 326.263h6.973v3.774h-6.973z"
            />
            <path
              data-name="Rectangle 1397"
              fill="#ed1c24"
              d="M20.43 326.74h5.977v2.811H20.43z"
            />
            <path
              data-name="Rectangle 1398"
              fill="#fff"
              opacity={0.3}
              d="M21.992 326.74h4.179v2.811h-4.179z"
            />
            <path
              data-name="Rectangle 1399"
              fill="#fff"
              opacity={0.3}
              d="M21.992 326.74h.165v2.811h-.165z"
            />
            <path
              data-name="Path 10117"
              d="M26.407 329.555l-.236.207s-2.98.123-4.094.819l-1.647-1.026z"
              opacity={0.2}
            />
            <path
              data-name="Path 10118"
              d="M28.362 328.766a.62.62 0 11.62-.62.62.62 0 01-.62.62zm0-.95a.333.333 0 10.333.329.329.329 0 00-.333-.329z"
              fill="#fff"
              opacity={0.5}
            />
            <path
              data-name="Path 10119"
              d="M19.016 328.289h-.95a.144.144 0 110-.283h.95a.144.144 0 110 .283z"
              fill="#fff"
              opacity={0.5}
            />
            <path
              data-name="Path 10120"
              d="M33.511 305.369v-32.873a1.583 1.583 0 00-1.579-1.579H14.9a1.579 1.579 0 00-1.574 1.579v13.266c4.43 7.273 14.53 15.382 20.185 19.607z"
              fill="#fff"
              opacity={0.15}
            />
            <g data-name="Group 489" opacity={0.15}>
              <path
                data-name="Path 10121"
                d="M14.644 271.587h17.545a1.545 1.545 0 011.309.73 1.579 1.579 0 00-1.566-1.4H14.9a1.579 1.579 0 00-1.566 1.4 1.549 1.549 0 011.31-.73z"
                fill="#fff"
              />
              <path
                data-name="Path 10122"
                d="M32.189 331.991H14.644a1.541 1.541 0 01-1.309-.73 1.579 1.579 0 001.566 1.4h17.031a1.579 1.579 0 001.566-1.4 1.532 1.532 0 01-1.309.73z"
                opacity={0.4}
              />
            </g>
            <circle
              data-name="Ellipse 452"
              cx={7.526}
              cy={7.526}
              r={7.526}
              transform="rotate(-67.5 246.957 150.308)"
              fill="#fff"
              opacity={0.5}
            />
            <path
              data-name="Path 10123"
              d="M24.224 324.11a.151.151 0 01-.11-.046.156.156 0 01-.059-.122v-1.529h-1.261v1.528a.165.165 0 01-.055.122.161.161 0 01-.11.046 7.273 7.273 0 01-5.606-3.82.165.165 0 010-.16.17.17 0 01.144-.084h.274v-1.887H16.39a.173.173 0 01-.165-.144 7.345 7.345 0 010-2.275.169.169 0 01.165-.139h1.017v-1.9h-.274a.165.165 0 01-.144-.08.173.173 0 010-.165 7.282 7.282 0 015.605-3.8.165.165 0 01.165.169v1.528h1.266v-1.536a.165.165 0 01.059-.127.17.17 0 01.11-.042 7.278 7.278 0 015.605 3.8.165.165 0 01-.148.245h-.27v1.891h1.013a.165.165 0 01.165.139 7.014 7.014 0 010 2.275.169.169 0 01-.165.144h-1.011v1.887h.27a.169.169 0 01.144.084.156.156 0 010 .16 7.264 7.264 0 01-5.605 3.82z"
              fill="#fff"
              opacity={0.15}
            />
            <rect
              data-name="Rectangle 1400"
              width={5.508}
              height={2.22}
              rx={1.11}
              transform="translate(20.662 318.935)"
              opacity={0.3}
            />
            <path
              data-name="Path 10124"
              d="M21.224 316.875a1.136 1.136 0 11-.33-.808 1.136 1.136 0 01.33.808z"
              opacity={0.3}
            />
            <path
              data-name="Path 10125"
              d="M27.856 316.875a1.131 1.131 0 11-1.112-1.144 1.131 1.131 0 011.112 1.144z"
              opacity={0.3}
            />
            <path
              data-name="Path 10126"
              d="M24.347 317.04a.946.946 0 11-.929-1.11 1.034 1.034 0 01.929 1.11z"
              opacity={0.3}
            />
            <path
              data-name="Path 10127"
              d="M21.051 316.875a.962.962 0 11-.962-.962.962.962 0 01.962.962z"
              fill="#1c1f23"
            />
            <path
              data-name="Path 10128"
              d="M27.702 316.876a.962.962 0 11-.962-.963.962.962 0 01.962.963z"
              fill="#1c1f23"
            />
            <path
              data-name="Path 10129"
              d="M24.977 313.524a1.562 1.562 0 11-1.562-1.562 1.562 1.562 0 011.562 1.562z"
              opacity={0.3}
            />
            <path
              data-name="Path 10130"
              d="M24.254 316.875a.844.844 0 11-.844-.844.844.844 0 01.844.844z"
              fill="#535363"
            />
            <path
              data-name="Path 10131"
              d="M24.014 316.732h-.455v-.456h-.283v.456h-.457v.283h.456v.456h.284v-.456h.456z"
              fill="#1c1f23"
              opacity={0.2}
            />
            <path
              data-name="Path 10132"
              d="M23.275 316.731v-.456h.284v.456h.393a.356.356 0 00.063-.194c0-.245-.266-.422-.6-.422s-.6.2-.6.422a.33.33 0 00.068.194z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Rectangle 1401"
              fill="#1c1f23"
              opacity={0.2}
              d="M23.275 317.09h.017v.38h-.017z"
            />
            <path
              data-name="Rectangle 1402"
              fill="#1c1f23"
              opacity={0.2}
              d="M23.541 317.09h.017v.38h-.017z"
            />
            <path
              data-name="Path 10133"
              d="M23.559 316.732v-.456h-.283v.456h-.457v.283h.068v-.177h.405v-.405h.249v.405h.405v.177h.068v-.283z"
              fill="#1c1f23"
              opacity={0.2}
            />
            <path
              data-name="Path 10134"
              d="M46.317 748.057a.151.151 0 01-.11-.046.156.156 0 01-.059-.122v-1.529h-1.261v1.528a.165.165 0 01-.055.122.161.161 0 01-.11.046 7.273 7.273 0 01-5.606-3.82.165.165 0 010-.16.17.17 0 01.144-.084h.274v-1.887h-1.051a.173.173 0 01-.165-.144 7.345 7.345 0 010-2.275.169.169 0 01.165-.139H39.5v-1.9h-.274a.165.165 0 01-.144-.08.173.173 0 010-.165 7.282 7.282 0 015.605-3.8.165.165 0 01.165.169v1.528h1.266v-1.536a.165.165 0 01.059-.127.17.17 0 01.11-.042 7.278 7.278 0 015.605 3.8.165.165 0 01-.148.245h-.27v1.891h1.013a.165.165 0 01.165.139 7.014 7.014 0 010 2.275.169.169 0 01-.165.144h-1.011v1.887h.27a.169.169 0 01.144.084.156.156 0 010 .16 7.264 7.264 0 01-5.605 3.82z"
              transform="translate(-22.093 -423.947)"
              opacity={0.5}
              fill="url(#prefix__h)"
            />
            <circle
              data-name="Ellipse 453"
              cx={7.526}
              cy={7.526}
              r={7.526}
              transform="rotate(-80.78 187.22 144.307)"
              fill="#fff"
              opacity={0.5}
            />
            <path
              data-name="Path 10135"
              d="M24.224 306.982a.148.148 0 01-.11-.042.156.156 0 01-.059-.122v-1.528h-1.261v1.528a.165.165 0 01-.055.122.156.156 0 01-.11.042 7.281 7.281 0 01-5.605-3.8.173.173 0 010-.165.164.164 0 01.144-.08h.274v-1.891H16.39a.169.169 0 01-.165-.139 7.346 7.346 0 010-2.275.169.169 0 01.165-.139h1.017v-1.891h-.274a.164.164 0 01-.144-.08.173.173 0 010-.165 7.282 7.282 0 015.605-3.8.156.156 0 01.11.042.164.164 0 01.055.122v1.482h1.266v-1.528a.157.157 0 01.059-.122.147.147 0 01.11-.042 7.276 7.276 0 015.605 3.8.165.165 0 01-.148.245h-.27v1.891h1.013a.165.165 0 01.165.139 7.015 7.015 0 010 2.275.165.165 0 01-.165.139h-1.011v1.891h.27a.165.165 0 01.148.245 7.277 7.277 0 01-5.605 3.8z"
              fill="#fff"
              opacity={0.15}
            />
            <rect
              data-name="Rectangle 1403"
              width={5.508}
              height={2.22}
              rx={1.11}
              transform="translate(20.662 301.81)"
              opacity={0.3}
            />
            <path
              data-name="Path 10136"
              d="M21.224 299.75a1.135 1.135 0 11-1.135-1.135 1.135 1.135 0 011.135 1.135z"
              opacity={0.3}
            />
            <path
              data-name="Path 10137"
              d="M27.856 299.75a1.131 1.131 0 11-.33-.8 1.131 1.131 0 01.33.8z"
              opacity={0.3}
            />
            <path
              data-name="Path 10138"
              d="M24.347 299.915a.945.945 0 11-.929-1.11 1.03 1.03 0 01.929 1.11z"
              opacity={0.3}
            />
            <path
              data-name="Path 10139"
              d="M21.051 299.751a.962.962 0 11-.962-.967.962.962 0 01.962.967z"
              fill="#1c1f23"
            />
            <path
              data-name="Path 10140"
              d="M27.702 299.751a.962.962 0 11-.962-.967.962.962 0 01.962.967z"
              fill="#1c1f23"
            />
            <path
              data-name="Path 10141"
              d="M24.977 296.395a1.562 1.562 0 11-1.562-1.562 1.562 1.562 0 011.562 1.562z"
              opacity={0.3}
            />
            <path
              data-name="Path 10142"
              d="M24.254 299.75a.844.844 0 11-.844-.844.844.844 0 01.844.844z"
              fill="#535363"
            />
            <path
              data-name="Path 10143"
              d="M24.014 299.607h-.455v-.456h-.283v.456h-.457v.283h.456v.456h.284v-.456h.456z"
              fill="#1c1f23"
              opacity={0.2}
            />
            <path
              data-name="Path 10144"
              d="M23.275 299.607v-.456h.284v.456h.393a.367.367 0 00.063-.2c0-.241-.266-.422-.6-.422s-.6.2-.6.422a.341.341 0 00.068.2z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Rectangle 1404"
              fill="#1c1f23"
              opacity={0.2}
              d="M23.275 299.966h.017v.38h-.017z"
            />
            <path
              data-name="Rectangle 1405"
              fill="#1c1f23"
              opacity={0.2}
              d="M23.541 299.966h.017v.38h-.017z"
            />
            <path
              data-name="Path 10145"
              d="M23.559 299.607v-.456h-.283v.456h-.457v.283h.068v-.177h.405v-.405h.249v.405h.405v.177h.068v-.283z"
              fill="#1c1f23"
              opacity={0.2}
            />
            <path
              data-name="Path 10146"
              d="M46.317 707.46a.148.148 0 01-.11-.042.156.156 0 01-.059-.122v-1.528h-1.261v1.528a.165.165 0 01-.055.122.156.156 0 01-.11.042 7.281 7.281 0 01-5.605-3.8.173.173 0 010-.165.164.164 0 01.144-.08h.274v-1.891h-1.052a.169.169 0 01-.165-.139 7.346 7.346 0 010-2.275.169.169 0 01.165-.139H39.5v-1.891h-.274a.164.164 0 01-.144-.08.173.173 0 010-.165 7.282 7.282 0 015.605-3.8.156.156 0 01.11.042.164.164 0 01.055.122v1.482h1.266v-1.528a.157.157 0 01.059-.122.147.147 0 01.11-.042 7.276 7.276 0 015.605 3.8.165.165 0 01-.148.245h-.27v1.891h1.013a.165.165 0 01.165.139 7.015 7.015 0 010 2.275.165.165 0 01-.165.139h-1.011v1.891h.27a.165.165 0 01.148.245 7.277 7.277 0 01-5.605 3.8z"
              transform="translate(-22.093 -400.478)"
              opacity={0.5}
              fill="url(#prefix__i)"
            />
            <circle
              data-name="Ellipse 454"
              cx={7.526}
              cy={7.526}
              r={7.526}
              transform="translate(15.892 275.096)"
              fill="#fff"
              opacity={0.5}
            />
            <path
              data-name="Path 10147"
              d="M24.224 289.861a.169.169 0 01-.11-.042.16.16 0 01-.059-.122v-1.536h-1.261v1.528a.173.173 0 01-.055.122.176.176 0 01-.11.042 7.281 7.281 0 01-5.605-3.82.173.173 0 010-.165.165.165 0 01.144-.08h.274v-1.891H16.39a.169.169 0 01-.165-.139 7.344 7.344 0 010-2.275.173.173 0 01.165-.144h1.017v-1.887h-.274a.169.169 0 01-.144-.084.165.165 0 010-.161 7.281 7.281 0 015.605-3.82.156.156 0 01.11.042.164.164 0 01.055.122v1.528h1.266v-1.528a.156.156 0 01.059-.122.147.147 0 01.11-.042 7.277 7.277 0 015.605 3.82.156.156 0 010 .161.169.169 0 01-.144.084h-.27v1.887h1.013a.169.169 0 01.165.144 7.015 7.015 0 010 2.275.164.164 0 01-.165.139h-1.011v1.891h.27a.165.165 0 01.148.245 7.277 7.277 0 01-5.605 3.82z"
              fill="#fff"
              opacity={0.15}
            />
            <rect
              data-name="Rectangle 1406"
              width={5.508}
              height={2.22}
              rx={1.11}
              transform="translate(20.662 284.682)"
              opacity={0.3}
            />
            <circle
              data-name="Ellipse 455"
              cx={1.131}
              cy={1.131}
              r={1.131}
              transform="translate(18.957 281.49)"
              opacity={0.3}
            />
            <path
              data-name="Path 10148"
              d="M27.856 282.621a1.131 1.131 0 11-1.131-1.131 1.131 1.131 0 011.131 1.131z"
              opacity={0.3}
            />
            <path
              data-name="Path 10149"
              d="M24.347 282.807a.946.946 0 11-.929-1.114 1.034 1.034 0 01.929 1.114z"
              opacity={0.3}
            />
            <path
              data-name="Path 10150"
              d="M21.051 282.621a.962.962 0 11-.962-.962.962.962 0 01.962.962z"
              fill="#1c1f23"
            />
            <circle
              data-name="Ellipse 456"
              cx={0.962}
              cy={0.962}
              r={0.962}
              transform="translate(25.782 281.659)"
              fill="#1c1f23"
            />
            <path
              data-name="Path 10151"
              d="M24.977 279.27a1.562 1.562 0 11-1.562-1.562 1.562 1.562 0 011.562 1.562z"
              opacity={0.3}
            />
            <path
              data-name="Path 10152"
              d="M24.254 282.617a.844.844 0 11-.844-.844.844.844 0 01.844.844z"
              fill="#535363"
            />
            <path
              data-name="Path 10153"
              d="M24.014 282.482h-.455v-.456h-.283v.456h-.457v.283h.456v.456h.284v-.456h.456z"
              fill="#1c1f23"
              opacity={0.2}
            />
            <path
              data-name="Path 10154"
              d="M23.275 282.483v-.456h.284v.456h.393a.368.368 0 00.063-.2c0-.245-.266-.422-.6-.422s-.6.194-.6.422a.342.342 0 00.068.2z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Rectangle 1407"
              fill="#1c1f23"
              opacity={0.2}
              d="M23.275 282.837h.017v.384h-.017z"
            />
            <path
              data-name="Rectangle 1408"
              fill="#1c1f23"
              opacity={0.2}
              d="M23.541 282.837h.017v.384h-.017z"
            />
            <path
              data-name="Path 10155"
              d="M23.559 282.482v-.456h-.283v.456h-.457v.283h.068v-.177h.405v-.405h.249v.405h.405v.177h.068v-.283z"
              fill="#1c1f23"
              opacity={0.2}
            />
            <path
              data-name="Path 10156"
              d="M46.317 666.9a.169.169 0 01-.11-.042.16.16 0 01-.059-.122V665.2h-1.261v1.528a.173.173 0 01-.055.122.176.176 0 01-.11.042 7.281 7.281 0 01-5.605-3.82.173.173 0 010-.165.165.165 0 01.144-.08h.274v-1.891h-1.052a.169.169 0 01-.165-.139 7.344 7.344 0 010-2.275.173.173 0 01.165-.144H39.5v-1.887h-.274a.169.169 0 01-.144-.084.165.165 0 010-.161 7.281 7.281 0 015.605-3.82.156.156 0 01.11.042.164.164 0 01.055.122v1.528h1.266v-1.528a.156.156 0 01.059-.122.147.147 0 01.11-.042 7.277 7.277 0 015.605 3.82.156.156 0 010 .161.169.169 0 01-.144.084h-.27v1.887h1.013a.169.169 0 01.165.144 7.015 7.015 0 010 2.275.164.164 0 01-.165.139H51.48v1.891h.27a.165.165 0 01.148.245 7.277 7.277 0 01-5.605 3.82z"
              transform="translate(-22.093 -377.039)"
              opacity={0.5}
              fill="url(#prefix__j)"
            />
            <path
              data-name="Path 10157"
              d="M26.044 333.459h-5.256a.739.739 0 01-.739-.743.494.494 0 01.494-.524h5.745a.494.494 0 01.5.494.743.743 0 01-.743.772z"
              fill="#42b7ba"
            />
            <path
              data-name="Path 10158"
              d="M25.723 333.037h-4.618a.422.422 0 01-.422-.422.291.291 0 01.287-.287h4.9a.287.287 0 01.283.287.422.422 0 01-.426.422z"
              fill="#fff"
              opacity={0.3}
            />
            <path
              data-name="Path 10159"
              d="M24.879 336.916h-2.921l-.718-3.478h4.352z"
              fill="#42b7ba"
            />
            <path
              data-name="Path 10160"
              d="M24.022 336.916H22.81l-.3-3.478h1.807z"
              fill="#fff"
              opacity={0.3}
            />
            <path
              data-name="Path 10161"
              d="M23.42 333.806a4.09 4.09 0 012 .464l.169-.844H21.24l.173.844a4.076 4.076 0 012.007-.464z"
              opacity={0.2}
            />
            <path
              data-name="Path 10162"
              d="M127.209 362.242l3.356-.962h-1.807l4.972-2.989-5.943 2.149 2.68-2.393-2.891 1.549 4.183-7.564-4.749 6.72 1.266-5.031-2.495 5.242v-11.292l-.95 10.164-.671-4.36v4.183l-2.828-8.759 1.811 9.463-2.575-4.715 1.9 4.609-4.538-5.665 4.115 6.825-4.326-3.094 3.166 3.233-6.859-1.794 6.12 2.571-4.044-.388 3.554 1.089-1.509-.032 3.554 1.241z"
              fill="#fbb040"
            />
            <path
              data-name="Path 10163"
              d="M126.605 360.613l1.2-2.089-1.515 1.562.583-2.056-1.338 1.671-.122-4.17-.473 3.238-.393-1.216-.118 1.832-1.532-4.327.755 4.2-.755-.882.371 1.038-1.709-1.777 1.376 2.41-1.672-.861 1.528 1.423z"
              fill="#ef4136"
            />
            <path
              data-name="Rectangle 1409"
              fill="#ef4136"
              d="M82.994 366.046h51.408v29.577H82.994z"
            />
            <path
              data-name="Rectangle 1410"
              fill="#fff"
              opacity={0.15}
              d="M99.034 372.803h19.328v16.069H99.034z"
            />
            <path
              data-name="Path 10164"
              d="M84.421 363.099h48.542a1.427 1.427 0 011.427 1.427v1.524h-51.4v-1.524a1.427 1.427 0 011.431-1.427z"
              fill="#4a3c40"
            />
            <path
              data-name="Rectangle 1411"
              fill="#fff"
              opacity={0.15}
              d="M82.994 366.046h51.408v3.259H82.994z"
            />
            <path
              data-name="Rectangle 1412"
              fill="#fff"
              opacity={0.15}
              d="M82.994 392.803h51.408v1.773H82.994z"
            />
            <path
              data-name="Rectangle 1413"
              opacity={0.15}
              d="M82.994 369.308h51.408v1.629H82.994z"
            />
            <circle
              data-name="Ellipse 457"
              cx={1.072}
              cy={1.072}
              r={1.072}
              transform="translate(84.973 391.73)"
              opacity={0.15}
            />
            <circle
              data-name="Ellipse 458"
              cx={1.072}
              cy={1.072}
              r={1.072}
              transform="translate(89.507 391.73)"
              opacity={0.15}
            />
            <path
              data-name="Path 10165"
              d="M96.18 392.802a1.076 1.076 0 11-1.072-1.072 1.077 1.077 0 011.072 1.072z"
              opacity={0.15}
            />
            <path
              data-name="Path 10166"
              d="M100.714 392.802a1.076 1.076 0 11-1.076-1.072 1.077 1.077 0 011.076 1.072z"
              opacity={0.15}
            />
            <circle
              data-name="Ellipse 459"
              cx={1.072}
              cy={1.072}
              r={1.072}
              transform="translate(103.094 391.73)"
              opacity={0.15}
            />
            <path
              data-name="Path 10167"
              d="M109.772 392.802a1.076 1.076 0 11-1.072-1.072 1.077 1.077 0 011.072 1.072z"
              opacity={0.15}
            />
            <path
              data-name="Path 10168"
              d="M114.301 392.802a1.072 1.072 0 11-1.072-1.072 1.072 1.072 0 011.072 1.072z"
              opacity={0.15}
            />
            <circle
              data-name="Ellipse 460"
              cx={1.072}
              cy={1.072}
              r={1.072}
              transform="translate(116.686 391.73)"
              opacity={0.15}
            />
            <circle
              data-name="Ellipse 461"
              cx={1.072}
              cy={1.072}
              r={1.072}
              transform="translate(121.219 391.73)"
              opacity={0.15}
            />
            <path
              data-name="Path 10169"
              d="M127.897 392.802a1.076 1.076 0 11-1.072-1.072 1.077 1.077 0 011.072 1.072z"
              opacity={0.15}
            />
            <path
              data-name="Path 10170"
              d="M132.426 392.802a1.076 1.076 0 11-1.076-1.072 1.077 1.077 0 011.076 1.072z"
              opacity={0.15}
            />
            <rect
              data-name="Rectangle 1414"
              width={7.298}
              height={3.259}
              rx={1.629}
              transform="translate(120.894 360.613)"
              fill="#788b9c"
            />
            <path
              data-name="Path 10171"
              d="M122.017 360.778h5.065a.464.464 0 01.464.464v.076a.46.46 0 01-.46.46h-5.065a.464.464 0 01-.456-.46v-.076a.464.464 0 01.452-.464z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10172"
              d="M120.059 362.243h8.974a.713.713 0 01.713.713v3.09h-10.4v-3.093a.713.713 0 01.718-.713z"
              fill="#fbb040"
            />
            <path
              data-name="Path 10173"
              d="M129.028 362.242h-8.97a.718.718 0 00-.718.718v1.452a.54.54 0 01.54-.536h9.324a.54.54 0 01.54.536v-1.452a.718.718 0 00-.716-.718z"
              fill="#fff"
              opacity={0.15}
            />
            <rect
              data-name="Rectangle 1415"
              width={7.298}
              height={3.259}
              rx={1.629}
              transform="translate(89.207 360.613)"
              fill="#788b9c"
            />
            <path
              data-name="Path 10174"
              d="M90.33 360.778h5.065a.464.464 0 01.464.464v.076a.46.46 0 01-.46.46H90.33a.464.464 0 01-.464-.464v-.076a.464.464 0 01.464-.46z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10175"
              d="M88.367 362.243h8.974a.713.713 0 01.713.713v3.09h-10.4v-3.093a.713.713 0 01.713-.71z"
              fill="#fbb040"
            />
            <path
              data-name="Path 10176"
              d="M97.341 362.243h-8.974a.718.718 0 00-.713.718v1.452a.536.536 0 01.54-.536h9.312a.536.536 0 01.54.536v-1.452a.718.718 0 00-.705-.718z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Rectangle 1416"
              fill="#fbb040"
              d="M89.866 375.518h5.977v1.71h-5.977z"
            />
            <path
              data-name="Rectangle 1417"
              fill="#fbb040"
              d="M121.553 375.518h5.977v1.71h-5.977z"
            />
            <path
              data-name="Rectangle 1418"
              fill="#fbb040"
              d="M125.398 373.382v5.977h-1.71v-5.977z"
            />
            <path
              data-name="Path 10177"
              d="M82.994 366.045h51.408v29.572c-.135-.612-.249-1.228-.342-1.845s-.173-1.232-.253-1.849-.139-1.232-.182-1.849-.11-1.232-.135-1.849l-.089-1.849-.059-1.844-.122-3.7c-.046-1.233-.072-2.465-.1-3.7l-.076-3.7v-7.387l1.384 1.385-6.424-.063-6.441-.122-12.849-.249-12.853-.4c-2.14-.063-4.284-.173-6.424-.258l-3.216-.135z"
              fill="#fff"
              opacity={0.3}
            />
            <ellipse
              data-name="Ellipse 462"
              cx={22.114}
              cy={1.406}
              rx={22.114}
              ry={1.406}
              transform="translate(148.445 394.761)"
              fill="#1c1f23"
              opacity={0.1}
            />
            <path
              data-name="Path 10178"
              d="M188.629 396.166c0 .422-8.759.768-19.564.768s-19.56-.342-19.56-.768 8.759-.768 19.56-.768 19.564.346 19.564.768z"
              fill="#1c1f23"
              opacity={0.1}
            />
            <path
              data-name="Path 10179"
              d="M155.995 374.825h25.613a1.507 1.507 0 011.507 1.507v19.51a.313.313 0 01-.312.313h-28.008a.313.313 0 01-.312-.312v-19.5a1.507 1.507 0 011.512-1.518z"
              fill="#25465b"
            />
            <path
              data-name="Path 10180"
              d="M176.363 374.825h-11.162c.422.422.844.8 1.11 1.064l7.176 6.69c.7.654 1.473 1.536 1.19 2.457s-1.5 1.229-2.49 1.19c-3.28-.118-6.293-1.912-8.72-4.12s-4.419-4.854-6.72-7.176l-.089-.089h-.657a1.507 1.507 0 00-1.507 1.5v5.784a15.416 15.416 0 011.621.591 15.976 15.976 0 017.627 6.977 5.183 5.183 0 01.789 2.676 2.279 2.279 0 01-1.541 2.144c-1.127.279-2.187-.6-3.018-1.4l-5.487-5.3v4.926a9.285 9.285 0 011.98 2.064c.308.422.608.9.907 1.363h23.308a14.761 14.761 0 01-1.942-2.457 5.3 5.3 0 01-.886-2.191 2.317 2.317 0 01.823-2.111 2.8 2.8 0 013.01.211c.5.313.962.692 1.431 1.051v-9.818a27.353 27.353 0 01-3.014-2.288 51.05 51.05 0 01-3.739-3.738z"
              fill="#fff"
              opacity={0.05}
            />
            <path
              data-name="Path 10181"
              d="M155.996 374.825h25.613a1.507 1.507 0 011.507 1.507v.844h-28.627v-.844a1.507 1.507 0 011.507-1.507z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Rectangle 1419"
              opacity={0.15}
              d="M154.485 377.189h28.631v1.178h-28.631z"
            />
            <rect
              data-name="Rectangle 1420"
              width={14.267}
              height={10.553}
              rx={2.84}
              transform="translate(158.381 380.836)"
              fill="#fbb040"
            />
            <rect
              data-name="Rectangle 1421"
              width={6.488}
              height={10.553}
              rx={2.84}
              transform="translate(173.264 380.836)"
              fill="#fff"
              opacity={0.1}
            />
            <path
              data-name="Rectangle 1422"
              fill="#fff"
              opacity={0.15}
              d="M160.344 383.85h10.341v.633h-10.341z"
            />
            <path
              data-name="Rectangle 1423"
              fill="#fff"
              opacity={0.15}
              d="M160.344 385.044h3.799v.633h-3.799z"
            />
            <path
              data-name="Rectangle 1424"
              fill="#fff"
              opacity={0.15}
              d="M164.776 385.044h5.909v.633h-5.909z"
            />
            <path
              data-name="Rectangle 1425"
              fill="#fff"
              opacity={0.15}
              d="M160.344 386.239h7.121v.633h-7.121z"
            />
            <path
              data-name="Rectangle 1426"
              fill="#fff"
              opacity={0.15}
              d="M160.344 387.438h5.259v.633h-5.259z"
            />
            <path
              data-name="Rectangle 1427"
              fill="#fff"
              opacity={0.15}
              d="M166.253 387.438h.789v.633h-.789z"
            />
            <path
              data-name="Rectangle 1428"
              fill="#d40032"
              d="M176.113 374.087h4.381v.751h-4.381z"
            />
            <path
              data-name="Path 10182"
              d="M178.591 372.765h-1.845v.743h1.845v.578h.739v-.841a.46.46 0 00-.46-.464z"
              fill="#788b9c"
            />
            <path
              data-name="Path 10183"
              d="M14.918 169.342c0 .528-.709.954-1.583.954s-1.579-.422-1.579-.954.7-.958 1.579-.958 1.583.431 1.583.958z"
              fill="#3c3c4e"
            />
            <path
              data-name="Path 10184"
              d="M17.472 161.103H8.81s.393.46.393.709v5.842a1.688 1.688 0 001.688 1.688h4.892a1.688 1.688 0 001.688-1.688v-5.842c0-.249.393-.709.393-.709z"
              fill="#516a80"
            />
            <path
              data-name="Path 10185"
              d="M14.613 169.055h-2.532a1.313 1.313 0 01-1.313-1.313v-6.644h5.158v6.649a1.313 1.313 0 01-1.313 1.308z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10186"
              d="M13.486 169.055h-.321a.794.794 0 01-.794-.794v-7.175h1.909v7.175a.794.794 0 01-.794.794z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10187"
              d="M17.661 162.563l-8.484 1.211a.6.6 0 01-.675-.511.6.6 0 01.507-.675l8.488-1.195a.6.6 0 01.675.506.6.6 0 01-.511.664z"
              fill="#516a80"
            />
            <path
              data-name="Path 10188"
              d="M9.091 162.977a.177.177 0 01-.139-.283.182.182 0 01.114-.068l8.493-1.195a.182.182 0 01.194.148.173.173 0 01-.034.131.182.182 0 01-.118.068l-8.484 1.2z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10189"
              d="M17.661 164.552l-8.484 1.195a.6.6 0 01-.675-.507.6.6 0 01.507-.675l8.488-1.212a.6.6 0 01.675.511.6.6 0 01-.511.688z"
              fill="#516a80"
            />
            <path
              data-name="Path 10190"
              d="M9.092 164.967a.177.177 0 01-.025-.35l8.493-1.2a.182.182 0 01.194.152.173.173 0 01-.034.131.181.181 0 01-.118.068l-8.484 1.195z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10191"
              d="M17.661 166.54l-8.484 1.195a.6.6 0 01-.675-.506.6.6 0 01.507-.675l8.488-1.2a.6.6 0 01.675.511.6.6 0 01-.511.675z"
              fill="#516a80"
            />
            <path
              data-name="Path 10192"
              d="M9.092 166.953a.181.181 0 01-.173-.152.173.173 0 01.034-.131.181.181 0 01.114-.068l8.493-1.2a.181.181 0 01.194.152.173.173 0 01-.152.2l-8.484 1.191z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10193"
              d="M17.661 168.528l-1.785.249a.6.6 0 01-.675-.507.6.6 0 01.507-.675l1.79-.253a.6.6 0 01.675.511.6.6 0 01-.512.675z"
              fill="#516a80"
            />
            <path
              data-name="Path 10194"
              d="M15.791 167.996a.177.177 0 01-.173-.152.173.173 0 01.034-.131.169.169 0 01.114-.068l1.794-.253a.176.176 0 01.042.35l-1.785.249z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10195"
              d="M18.151 161.872a.536.536 0 00-.051-.165v-.025a.613.613 0 00-.089-.118v-.025a.535.535 0 00-.114-.076l-.042-.03a.71.71 0 00-.135-.038h-.038a2.856 2.856 0 01.207-.279h-1.507v.068a.806.806 0 00.422.608.52.52 0 00.241.1.918.918 0 00.283-.034 1.592 1.592 0 01.342-.047.152.152 0 01.106.034.11.11 0 010 .122.211.211 0 01-.144.093.933.933 0 00-.241.021h-.051a.5.5 0 00-.422.515l.038.781v.039a.241.241 0 000 .055.481.481 0 00.553.393h.072a.1.1 0 01.059 0 .118.118 0 01.051.042V163.961a.19.19 0 01-.038.161c0 .025-.063.051-.063.059h-.1l-.131.03h-.046a.325.325 0 00-.253.333l.055.781v.072a.279.279 0 00.329.219h.148a.279.279 0 01.135.051.316.316 0 01.106.106.337.337 0 01.034.068V165.917a.422.422 0 01-.262.422h-.118l-.127.025h-.021a.131.131 0 00-.106.139l.063.781v.03a.076.076 0 00.093.051.553.553 0 01.422.055.6.6 0 01.266.371.966.966 0 00-.03-.118.558.558 0 00-.122-.2.317.317 0 00-.068-.063.558.558 0 00-.211-.093.614.614 0 00-.232 0v-.781l.152-.021h.118l.08-.03.046-.021.072-.046h.025a.642.642 0 00.076-.076.568.568 0 00.063-.11.563.563 0 00.038-.11.08.08 0 000-.034v-.131a.575.575 0 000-.084v-.046a.27.27 0 00-.025-.076v-.038a.369.369 0 00-.042-.068l-.025-.038-.063-.063-.025-.021-.08-.055h-.025a.6.6 0 00-.241-.063h-.135v-.823h.27a.313.313 0 00.08-.03l.046-.021.072-.047.025-.021a.422.422 0 00.076-.076.571.571 0 00.063-.11.569.569 0 00.038-.11.071.071 0 000-.029v-.135a.467.467 0 000-.08v-.051a.207.207 0 00-.025-.072v-.042a.362.362 0 00-.042-.068l-.025-.038-.063-.063-.025-.021-.08-.055h-.025a.6.6 0 00-.241-.063h-.135v-.781l.152-.021h.118l.08-.03.046-.025.072-.046.025-.021a.427.427 0 00.076-.076.569.569 0 00.063-.11.48.48 0 00.038-.11.072.072 0 000-.03v-.135a.422.422 0 00.049-.193z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10196"
              d="M23.11 151.242l-1.292-4.132H4.85l-1.292 4.132a27.53 27.53 0 00.355 4.96 2.79 2.79 0 002.461 2.284l.422 1.477 2.013 1.14h9.054l2.013-1.14.422-1.477a2.79 2.79 0 002.461-2.284 27.34 27.34 0 00.35-4.96z"
              fill="#aac9df"
            />
            <path
              data-name="Path 10197"
              d="M19.666 151.243H7.003a42.926 42.926 0 00.228 4.96c.274 2.144 1.6 2.284 1.6 2.284l.274 1.477 1.3 1.14h5.863l1.3-1.14.27-1.477s1.321-.139 1.6-2.284a41.893 41.893 0 00.228-4.96z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10198"
              d="M15.195 151.243h-3.714s0 2.811.068 4.96.469 2.284.469 2.284l.08 1.477.384 1.14H14.2l.384-1.14.08-1.477s.384-.139.464-2.284.067-4.96.067-4.96z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10199"
              d="M6.374 158.486h13.925l-.422 1.477H6.796z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10200"
              d="M19.877 159.964l-2.013 1.14H8.809l-2.013-1.14z"
              opacity={0.15}
            />
            <path
              data-name="Path 10201"
              d="M19.974 147.111h-4.221v-27.859c0-1.925-1.106-3.55-2.419-3.55s-2.414 1.625-2.414 3.55v27.859H6.699v-27.859c0-4.284 2.976-7.771 6.635-7.771s6.64 3.487 6.64 7.771z"
              fill="#d5eeff"
            />
            <path
              data-name="Path 10202"
              d="M23.115 151.242l-1.3-4.132H4.851l-1.292 4.132z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10203"
              d="M19.67 151.242l-.84-4.132H7.839l-.836 4.132z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10204"
              d="M15.187 151.242l-.245-4.132h-3.22l-.245 4.132z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Rectangle 1429"
              opacity={0.15}
              d="M4.749 152.247h4.327v.705H4.749z"
            />
            <path
              data-name="Rectangle 1430"
              opacity={0.15}
              d="M4.749 153.754h4.327v.705H4.749z"
            />
            <path
              data-name="Rectangle 1431"
              opacity={0.15}
              d="M4.935 155.13h4.141v.705H4.935z"
            />
            <ellipse
              data-name="Ellipse 463"
              cx={1.583}
              cy={0.954}
              rx={1.583}
              ry={0.954}
              transform="translate(130.56 159.947)"
              fill="#3c3c4e"
            />
            <path
              data-name="Path 10205"
              d="M136.276 152.661h-8.662s.393.46.393.709v5.842a1.688 1.688 0 001.688 1.688h4.889a1.688 1.688 0 001.688-1.688v-5.842c0-.249.393-.709.393-.709z"
              fill="#516a80"
            />
            <path
              data-name="Path 10206"
              d="M133.431 160.613h-2.533a1.313 1.313 0 01-1.312-1.313v-6.644h5.145v6.649a1.313 1.313 0 01-1.3 1.308z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10207"
              d="M132.29 160.613h-.3a.794.794 0 01-.794-.794v-7.175h1.888v7.175a.794.794 0 01-.794.794z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10208"
              d="M136.466 154.121l-8.484 1.211a.6.6 0 01-.675-.511.6.6 0 01.511-.675l8.484-1.194a.6.6 0 01.675.506.6.6 0 01-.511.663z"
              fill="#516a80"
            />
            <path
              data-name="Path 10209"
              d="M127.896 154.535a.177.177 0 01-.173-.152.173.173 0 01.034-.131.181.181 0 01.118-.068l8.488-1.195a.181.181 0 01.194.148.173.173 0 01-.034.131.182.182 0 01-.118.068l-8.484 1.2z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10210"
              d="M136.465 156.109l-8.484 1.195a.6.6 0 01-.675-.507.595.595 0 01.511-.675l8.484-1.2a.6.6 0 01.675.511.6.6 0 01-.511.675z"
              fill="#516a80"
            />
            <path
              data-name="Path 10211"
              d="M127.897 156.519a.182.182 0 01-.173-.152.177.177 0 01.173-.194l8.488-1.2a.181.181 0 01.194.152.173.173 0 01-.034.131.181.181 0 01-.118.068l-8.484 1.195z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10212"
              d="M136.465 158.097l-8.484 1.195a.6.6 0 01-.675-.507.595.595 0 01.511-.675l8.484-1.2a.6.6 0 01.675.511.6.6 0 01-.511.675z"
              fill="#516a80"
            />
            <path
              data-name="Path 10213"
              d="M127.896 158.511a.182.182 0 01-.173-.152.172.172 0 01.034-.131.181.181 0 01.118-.068l8.488-1.2a.182.182 0 01.194.152.177.177 0 01-.148.2l-8.489 1.194z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10214"
              d="M136.465 160.085l-1.785.249a.6.6 0 01-.675-.506.6.6 0 01.511-.675l1.786-.253a.6.6 0 01.675.511.6.6 0 01-.511.675z"
              fill="#516a80"
            />
            <path
              data-name="Path 10215"
              d="M134.595 159.554a.182.182 0 01-.173-.152.173.173 0 01.034-.131.182.182 0 01.118-.068l1.79-.253a.176.176 0 01.042.35l-1.786.249z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10216"
              d="M136.972 153.43a.687.687 0 00-.055-.165v-.025a.617.617 0 00-.089-.118l-.025-.025a.631.631 0 00-.11-.076l-.042-.03-.139-.038h-.038a2.883 2.883 0 01.207-.279h-1.482v.068a.81.81 0 00.422.608.506.506 0 00.236.1.956.956 0 00.287-.034 1.518 1.518 0 01.338-.047.135.135 0 01.106.034.11.11 0 010 .122.215.215 0 01-.139.093.928.928 0 00-.241.021h-.055a.5.5 0 00-.422.515l.042.781v.039a.25.25 0 000 .055.481.481 0 00.553.393h.068a.1.1 0 01.059 0 .131.131 0 01.055.042v.034a.039.039 0 010 .021.178.178 0 01-.038.16c0 .025-.063.051-.063.059h-.1l-.127.029h-.046a.317.317 0 00-.253.333l.055.781v.072a.279.279 0 00.329.22h.148a.279.279 0 01.135.051.37.37 0 01.11.106.318.318 0 01.03.068v.034a.125.125 0 010 .042.393.393 0 01-.114.317.422.422 0 01-.148.1h-.114l-.131.025h-.021a.139.139 0 00-.105.144l.068.781v.03a.072.072 0 00.089.051.549.549 0 01.422.055.566.566 0 01.266.371.544.544 0 00-.03-.118.555.555 0 00-.122-.2.485.485 0 00-.072-.063.557.557 0 00-.211-.093.612.612 0 00-.232 0v-.781l.152-.021h.118l.08-.03.046-.021.072-.046h.025a.426.426 0 00.076-.076.971.971 0 00.067-.11 1.065 1.065 0 00.034-.11v-.034a.614.614 0 000-.089v-.042a.574.574 0 000-.084.218.218 0 000-.046l-.025-.076-.021-.038a.363.363 0 00-.042-.068l-.025-.038a.883.883 0 00-.063-.063l-.025-.021a.5.5 0 00-.076-.055h-.03a.578.578 0 00-.236-.063h-.139v-.819h.27a.262.262 0 00.08-.03l.046-.021.072-.046.025-.021a.323.323 0 00.076-.076.947.947 0 00.068-.11 1.106 1.106 0 00.034-.11v-.03a.785.785 0 000-.093v-.042a.451.451 0 000-.08.213.213 0 000-.051l-.025-.072-.021-.042a.357.357 0 00-.042-.068l-.025-.038-.063-.063-.025-.021a.384.384 0 00-.08-.055h-.025a.578.578 0 00-.236-.063h-.151v-.781l.152-.021h.118l.08-.03.047-.025.072-.046.025-.021a.324.324 0 00.076-.076.96.96 0 00.068-.11.851.851 0 00.034-.11v-.03a.694.694 0 000-.093v-.042c.105-.152.105-.171.101-.196z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10217"
              d="M141.919 146.6l1.925-2.022h-23.406l1.925 2.022s-.068-.566.355 1.583a2.2 2.2 0 002.461 1.862l.422.608 2.013 2.009h9.054l2.013-2.009.422-.608a2.2 2.2 0 002.461-1.862c.422-2.136.355-1.583.355-1.583z"
              fill="#aac9df"
            />
            <path
              data-name="Path 10218"
              d="M120.438 144.578l1.925 2.022h19.556l1.925-2.022z"
              opacity={0.15}
            />
            <path
              data-name="Path 10219"
              d="M124.558 144.578l1 2.022h13.157l1-2.022z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10220"
              d="M129.919 144.578l.291 2.022h3.862l.291-2.022z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10221"
              d="M138.47 146.6h-12.663s-.046-.566.228 1.583 1.591 1.862 1.591 1.862l.274.608 1.3 2.009h5.867l1.3-2.009.274-.608s1.321.283 1.6-1.862.229-1.583.229-1.583z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10222"
              d="M134.001 146.6h-3.715s0-.566.068 1.583.464 1.862.464 1.862l.08.608.384 2.009H133l.384-2.009.08-.608s.388.283.469-1.862.068-1.583.068-1.583z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10223"
              d="M125.178 150.044h13.925l-.422.608H125.6z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10224"
              d="M138.682 150.652l-2.013 2.009h-9.054l-2.013-2.009z"
              opacity={0.15}
            />
            <path
              data-name="Path 10225"
              d="M144.751 139.331a12.529 12.529 0 01-1.144 5.247h-22.932a12.612 12.612 0 1124.081-5.247z"
              fill="#d5eeff"
            />
            <path
              data-name="Path 10226"
              d="M140.818 133.62c0 3.305-3.883 2.191-8.674 2.191s-8.678 1.114-8.678-2.191 3.883-5.994 8.678-5.994 8.674 2.685 8.674 5.994z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10227"
              d="M132.54 127.305c0 .11-.186.194-.422.194s-.422-.084-.422-.194.186-.194.422-.194.422.089.422.194z"
              fill="#fff"
            />
            <circle
              data-name="Ellipse 464"
              cx={0.941}
              cy={0.941}
              r={0.941}
              transform="translate(131.202 128.547)"
              fill="#fff"
            />
            <path
              data-name="Path 10228"
              d="M132.143 144.08c-5.091 0-9.62-1.389-12.553-3.554a12.464 12.464 0 001.085 4.052h22.937a12.537 12.537 0 001.081-4.052c-2.934 2.165-7.463 3.554-12.55 3.554z"
              opacity={0.05}
            />
            <path
              data-name="Path 10229"
              d="M172.897 152.661h-.422c0-3.005 1-7.859 2.448-10.025.156-.224.38-.5.6-.523a.3.3 0 01.228.067.57.57 0 01.152.473c0 .2-.844.57-.844.57a23.068 23.068 0 00-2.162 9.438zm2.579-10.037a2.142 2.142 0 00-.2.249c-.059.089-.118.186-.177.283a.814.814 0 00.371-.485.215.215 0 00.006-.047z"
              fill="#535363"
            />
            <path
              data-name="Path 10230"
              d="M171.01 152.661h-.422a23.083 23.083 0 00-2.161-9.438l-.118.19s-.258.021-.325-.038a1.076 1.076 0 01-.409-.7.557.557 0 01.152-.473.27.27 0 01.228-.067c.211.025.422.3.591.523 1.46 2.144 2.464 6.998 2.464 10.003zm-3.014-10.046v.051a.816.816 0 00.372.485 6.365 6.365 0 00-.177-.283 2.212 2.212 0 00-.194-.253z"
              fill="#535363"
            />
            <path
              data-name="Path 10231"
              d="M165.13 146.327c2.748 2.748 2.891 4.576 2.891 6.332h7.442c0-1.76.143-3.588 2.9-6.332a9.354 9.354 0 10-13.229 0z"
              fill="#f15a29"
              opacity={0.5}
            />
            <path
              data-name="Path 10232"
              d="M178.359 133.097a9.349 9.349 0 00-9.193-2.377 6.978 6.978 0 013.077 2.377 11.514 11.514 0 010 13.229 9.02 9.02 0 00-2.2 6.331h5.424c0-1.76.143-3.588 2.9-6.331a9.358 9.358 0 00-.008-13.229z"
              fill="#fff"
              opacity={0.3}
            />
            <path
              data-name="Path 10233"
              d="M168.895 149.124a10.662 10.662 0 00-2.752-4.158 8.229 8.229 0 01-.1-11.574 8.087 8.087 0 017.243-2.208 7.659 7.659 0 012.82 1.127 8.1 8.1 0 011.359 12.536 10.785 10.785 0 00-2.883 4.31 2.334 2.334 0 01-2.212 1.655h-1.2a2.4 2.4 0 01-2.275-1.688z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10234"
              d="M176.071 134.861c0 1.541-1.925 1.688-4.3 1.688s-4.3-.152-4.3-1.688 1.929-2.79 4.3-2.79 4.3 1.249 4.3 2.79z"
              fill="#fff"
              opacity={0.5}
            />
            <path
              data-name="Path 10235"
              d="M173.324 160.9c0 .528-.709.954-1.579.954s-1.583-.422-1.583-.954.709-.958 1.583-.958 1.579.431 1.579.958z"
              fill="#3c3c4e"
            />
            <path
              data-name="Path 10236"
              d="M175.876 152.661h-8.661s.392.46.392.709v5.842a1.688 1.688 0 001.688 1.688h4.892a1.688 1.688 0 001.688-1.688v-5.842c0-.249.393-.709.393-.709z"
              fill="#516a80"
            />
            <path
              data-name="Path 10237"
              d="M173.019 160.613h-2.532a1.313 1.313 0 01-1.313-1.313v-6.644h5.158v6.649a1.313 1.313 0 01-1.313 1.308z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10238"
              d="M171.892 160.613h-.3a.794.794 0 01-.794-.794v-7.175h1.888v7.175a.794.794 0 01-.794.794z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10239"
              d="M176.067 154.121l-8.493 1.211a.6.6 0 01-.675-.511.6.6 0 01.511-.675l8.484-1.194a.6.6 0 01.675.506.6.6 0 01-.502.663z"
              fill="#516a80"
            />
            <path
              data-name="Path 10240"
              d="M167.499 154.535a.177.177 0 01-.173-.152.173.173 0 01.034-.131.181.181 0 01.118-.068l8.489-1.195a.181.181 0 01.194.148.173.173 0 01-.034.131.181.181 0 01-.118.068l-8.484 1.2z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10241"
              d="M176.067 156.109l-8.493 1.195a.6.6 0 01-.675-.507.595.595 0 01.511-.675l8.484-1.2a.6.6 0 01.675.511.6.6 0 01-.502.676z"
              fill="#516a80"
            />
            <path
              data-name="Path 10242"
              d="M167.498 156.525a.181.181 0 01-.173-.152.177.177 0 01.152-.2l8.488-1.2a.181.181 0 01.194.152.173.173 0 01-.034.131.182.182 0 01-.118.068l-8.484 1.194z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10243"
              d="M176.067 158.097l-8.493 1.194a.6.6 0 01-.675-.506.595.595 0 01.511-.675l8.484-1.2a.6.6 0 01.675.511.6.6 0 01-.502.676z"
              fill="#516a80"
            />
            <path
              data-name="Path 10244"
              d="M167.498 158.511a.182.182 0 01-.173-.152.173.173 0 01.034-.131.181.181 0 01.118-.068l8.489-1.2a.181.181 0 01.194.152.177.177 0 01-.148.2l-8.489 1.194z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10245"
              d="M176.067 160.086l-1.785.249a.6.6 0 01-.675-.507.595.595 0 01.511-.675l1.786-.253a.6.6 0 01.675.511.6.6 0 01-.512.675z"
              fill="#516a80"
            />
            <path
              data-name="Path 10246"
              d="M174.197 159.554a.181.181 0 01-.173-.152.173.173 0 01.034-.131.181.181 0 01.118-.068l1.79-.253a.176.176 0 01.042.35l-1.786.249z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10247"
              d="M176.574 153.43a.687.687 0 00-.055-.165v-.025a.611.611 0 00-.089-.118l-.025-.025a1.031 1.031 0 00-.11-.08.259.259 0 01-.046-.025.712.712 0 00-.135-.038h-.038a2.875 2.875 0 01.207-.279h-1.482v.068a.807.807 0 00.422.608.536.536 0 00.241.1.955.955 0 00.287-.034 1.52 1.52 0 01.338-.047.135.135 0 01.105.034.11.11 0 010 .122.215.215 0 01-.139.093.928.928 0 00-.241.021h-.055a.5.5 0 00-.422.515l.042.781v.038a.258.258 0 000 .055.477.477 0 00.549.393.119.119 0 00.046 0h.042a.1.1 0 01.059 0 .132.132 0 01.055.042v.034a.039.039 0 010 .021.178.178 0 01-.038.16c0 .025-.063.051-.063.059h-.1l-.127.029h-.046a.317.317 0 00-.253.333l.055.781v.072a.279.279 0 00.329.22h.148a.279.279 0 01.135.051.371.371 0 01.11.106.315.315 0 01.03.068v.034a.128.128 0 010 .042.393.393 0 01-.114.317.423.423 0 01-.148.1h-.114l-.131.025h-.022a.139.139 0 00-.105.144l.068.781v.03a.071.071 0 00.034.044.072.072 0 00.055.007.549.549 0 01.422.055.565.565 0 01.266.371.534.534 0 00-.03-.118.555.555 0 00-.122-.2.478.478 0 00-.072-.063.556.556 0 00-.211-.093.611.611 0 00-.232 0v-.781l.152-.021h.118l.08-.03.046-.021.072-.046h.025a.421.421 0 00.093-.1.967.967 0 00.068-.11.763.763 0 00.034-.106.077.077 0 000-.034.317.317 0 000-.089.129.129 0 000-.042.28.28 0 000-.084.21.21 0 000-.046l-.025-.076-.021-.038a.36.36 0 00-.042-.068l-.025-.038c0-.021-.038-.042-.063-.063l-.025-.021a.383.383 0 00-.08-.055h-.025a.578.578 0 00-.236-.063h-.139v-.8h.27a.262.262 0 00.08-.03l.046-.021.072-.046.025-.021a.32.32 0 00.076-.076.946.946 0 00.068-.11 1.075 1.075 0 00.034-.11.075.075 0 000-.03.369.369 0 000-.093.144.144 0 000-.042.288.288 0 000-.084.21.21 0 000-.046l-.025-.072-.021-.042a.359.359 0 00-.042-.068l-.025-.038-.063-.063-.025-.021a.385.385 0 00-.08-.055h-.025a.58.58 0 00-.2-.156h-.145v-.781l.152-.021h.118l.08-.03.046-.025.072-.046.025-.021a.321.321 0 00.076-.076.93.93 0 00.068-.11.835.835 0 00.034-.11.075.075 0 000-.03.348.348 0 000-.093.144.144 0 000-.042.424.424 0 00.022-.103z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10248"
              d="M174.83 143.092h-.025v-.211a.114.114 0 00.1-.059.237.237 0 000-.224.672.672 0 00-.422-.245.848.848 0 00-.148-.03.631.631 0 01-.03.321v.025a.241.241 0 01-.257.089.283.283 0 01-.224-.224.376.376 0 01.228-.384.254.254 0 00-.029-.042.473.473 0 00-.422-.2.422.422 0 00-.291.173.624.624 0 01-.063.73h-.16a.68.68 0 01-.042-.68.422.422 0 00-.494 0l-.038.034a.793.793 0 010 .6h-.181a.612.612 0 01-.034-.633.549.549 0 00-.895-.16l-.059.059a.655.655 0 01.114.1.557.557 0 01.16.4.367.367 0 01-.135.249.278.278 0 01-.219.059.376.376 0 01-.279-.372.7.7 0 01.068-.367.908.908 0 00-.422-.068.844.844 0 00-.494.19.681.681 0 01.228.3.422.422 0 01-.025.312.316.316 0 01-.186.16.3.3 0 01-.245-.03.388.388 0 01-.19-.241.575.575 0 01.106-.464.988.988 0 00-.515-.169.549.549 0 00-.422.2.559.559 0 01.245.177.536.536 0 01.114.447v.068h-.068a.422.422 0 01-.4-.135.566.566 0 01-.156-.367.157.157 0 00-.076.046.259.259 0 000 .2l-.2.055a.379.379 0 01.342-.532.735.735 0 01.646-.384 1.224 1.224 0 01.65.215 1.071 1.071 0 01.654-.274 1.1 1.1 0 01.553.1l.1-.1a.756.756 0 011.178.139 1.266 1.266 0 001.152-.245.693.693 0 01.62.279.838.838 0 01.08.131 1.133 1.133 0 01.274.038.843.843 0 01.566.346.422.422 0 010 .443.312.312 0 01-.332.155zm-4.854-.722a.423.423 0 00-.076.291.2.2 0 00.089.11.1.1 0 00.08 0 .085.085 0 00.059-.055.181.181 0 000-.148.421.421 0 00-.152-.198zm-1.19.106a.358.358 0 00.1.224.3.3 0 00.131.076.35.35 0 00-.232-.3zm2.431-.274a.512.512 0 00-.042.236c0 .08.047.173.106.182a.063.063 0 00.055-.021.144.144 0 00.055-.1.337.337 0 00-.11-.236.447.447 0 00-.064-.062zm2.921.143a.169.169 0 00-.106.156.08.08 0 00.063.051h.03a.423.423 0 00.013-.207z"
              fill="#fff"
            />
            <circle
              data-name="Ellipse 465"
              cx={6.91}
              cy={6.91}
              r={6.91}
              transform="rotate(-45 250.571 -125.314)"
              fill="url(#prefix__k)"
            />
            <path
              data-name="Path 10249"
              d="M173.239 152.659c0-1.988.371-3.153.3-3.588a2.764 2.764 0 01-.051-1.081c.076-.291-.422-.54-.528-.211s-.789.169-1.195.169-1.021.224-1.169-.143-.7-.236-.713-.068a.925.925 0 01-.274.726c-.291.291.5 2.018.528 2.837s.08 1.359.08 1.359z"
              fill="#fff"
              opacity={0.5}
            />
            <path
              data-name="Path 10250"
              d="M93.707 155.194h-.422c0-3.005 1-7.859 2.448-10.025.156-.224.38-.5.6-.523a.279.279 0 01.224.068.574.574 0 01.156.473c0 .2-.844.57-.844.57-1.297 2.24-2.162 6.647-2.162 9.437zm2.578-10.038a2.134 2.134 0 00-.2.249c-.059.089-.118.186-.177.283a.815.815 0 00.371-.485.133.133 0 010-.046z"
              fill="#535363"
            />
            <path
              data-name="Path 10251"
              d="M91.808 155.194h-.422a23.084 23.084 0 00-2.161-9.438l-.118.19s-.258.021-.325-.038a1.106 1.106 0 01-.4-.722.57.57 0 01.152-.473.279.279 0 01.228-.068c.215.025.422.3.591.523 1.449 2.166 2.455 7.021 2.455 10.026zm-3-10.042a.206.206 0 000 .051.814.814 0 00.371.485 3.717 3.717 0 00-.182-.283 1.819 1.819 0 00-.195-.253z"
              fill="#535363"
            />
            <path
              data-name="Path 10252"
              d="M85.965 148.056a9.211 9.211 0 012.853 7.133h7.442a9.136 9.136 0 012.853-7.133c4.466-3.972 1.266-11.186-.258-15.542-3.026-8.615-9.582-8.7-12.633 0-1.528 4.361-4.723 11.574-.257 15.542z"
              fill="#8eddeb"
              opacity={0.5}
            />
            <path
              data-name="Path 10253"
              d="M100.684 145.984c1.937-4.082-.536-9.793-1.828-13.465-1.887-5.373-5.145-7.425-8.071-6.1a6.148 6.148 0 012.284 2.288c3.212 5.247 2.7 13.283-.021 18.391a15.66 15.66 0 00-2.212 8.1h5.424a13.816 13.816 0 01.105-1.65 2.851 2.851 0 01.063-.447c.051-.3.114-.608.194-.92a8.138 8.138 0 012.49-4.115 6.564 6.564 0 001.572-2.082z"
              fill="#fff"
              opacity={0.3}
            />
            <path
              data-name="Path 10254"
              d="M89.667 150.904a10.624 10.624 0 00-2.727-4.9c-3.976-3.66-1.233-10.278 0-14.351 1.38-4.538 4.369-6.1 7.222-5.2a5.218 5.218 0 012.782 2.913c1.845 4.259 5.745 12.481 1.3 16.559a10.941 10.941 0 00-2.849 5.036 2.445 2.445 0 01-2.233 2.047h-1.207a2.546 2.546 0 01-2.288-2.104z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10255"
              d="M96.952 131.965c0 1.975-1.9 1.33-4.386 1.325s-4.381.612-4.39-1.368a4.731 4.731 0 014.39-4.5c2.511.001 4.395 2.585 4.386 4.543z"
              fill="#fff"
              opacity={0.5}
            />
            <path
              data-name="Path 10256"
              d="M95.627 145.624h-.026v-.211a.118.118 0 00.1-.059.236.236 0 000-.224.671.671 0 00-.422-.245 1.032 1.032 0 00-.148-.03.633.633 0 01-.03.321v.025a.245.245 0 01-.257.089.283.283 0 01-.224-.224.376.376 0 01.228-.384.262.262 0 00-.03-.042.473.473 0 00-.422-.2.422.422 0 00-.291.173.625.625 0 01-.063.73h-.165a.692.692 0 01-.038-.68.422.422 0 00-.49 0l-.038.034a.794.794 0 010 .6h-.182a.612.612 0 01-.034-.633.553.553 0 00-.9-.16l-.055.059a.63.63 0 01.11.1.545.545 0 01.165.4.368.368 0 01-.135.249.279.279 0 01-.219.059.376.376 0 01-.283-.372.8.8 0 01.068-.367.892.892 0 00-.422-.068.844.844 0 00-.49.19.67.67 0 01.224.3.422.422 0 010 .312.317.317 0 01-.186.16.3.3 0 01-.245-.03.389.389 0 01-.19-.241.574.574 0 01.106-.464 1 1 0 00-.519-.169.549.549 0 00-.422.2.557.557 0 01.245.177.536.536 0 01.114.447v.068h-.068a.422.422 0 01-.422-.135.545.545 0 01-.156-.367.156.156 0 00-.076.046.257.257 0 000 .2l-.2.055a.379.379 0 01.342-.532.734.734 0 01.646-.384 1.224 1.224 0 01.654.215 1.072 1.072 0 01.654-.274 1.106 1.106 0 01.553.1l.1-.1a.789.789 0 01.675-.207.8.8 0 01.5.346.629.629 0 01.739 0 .658.658 0 01.422-.228.692.692 0 01.62.279.836.836 0 01.08.131 1.136 1.136 0 01.274.038.844.844 0 01.566.346.422.422 0 010 .443.312.312 0 01-.337.138zm-4.854-.722a.422.422 0 00-.076.291.2.2 0 00.089.11.1.1 0 00.08 0 .1.1 0 00.059-.055.181.181 0 000-.148.422.422 0 00-.152-.198zm-1.19.106a.358.358 0 00.1.224.278.278 0 00.131.076.35.35 0 00-.076-.19.38.38 0 00-.152-.11zm2.427-.274a.57.57 0 00-.038.236c0 .08.046.173.106.182a.064.064 0 00.055-.021.143.143 0 00.055-.1.354.354 0 00-.11-.236.314.314 0 00-.059-.063zm2.925.143a.169.169 0 00-.106.156.081.081 0 00.063.051h.03a.423.423 0 00.013-.207z"
              fill="#fff"
            />
            <path
              data-name="Path 10257"
              d="M94.036 155.192c0-1.988.371-3.153.3-3.588a2.866 2.866 0 01-.055-1.081c.08-.291-.422-.54-.528-.211s-.785.169-1.19.169-1.026.224-1.169-.144-.7-.236-.713-.068a.941.941 0 01-.274.726c-.291.291.5 2.018.528 2.837s.076 1.359.076 1.359z"
              fill="#fff"
              opacity={0.5}
            />
            <path
              data-name="Path 10258"
              d="M94.129 163.433c0 .528-.709.954-1.583.954s-1.579-.422-1.579-.954.709-.958 1.579-.958 1.583.431 1.583.958z"
              fill="#3c3c4e"
            />
            <path
              data-name="Path 10259"
              d="M96.661 155.194h-8.649s.393.46.393.709v5.842a1.688 1.688 0 001.688 1.688h4.88a1.688 1.688 0 001.688-1.688v-5.842c0-.249.393-.709.393-.709z"
              fill="#516a80"
            />
            <path
              data-name="Path 10260"
              d="M93.816 163.146h-2.532a1.313 1.313 0 01-1.313-1.313v-6.644h5.158v6.649a1.313 1.313 0 01-1.313 1.308z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10261"
              d="M92.689 163.146h-.3a.794.794 0 01-.794-.794v-7.175h1.888v7.175a.794.794 0 01-.794.794z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10262"
              d="M96.864 156.654l-8.484 1.211a.6.6 0 01-.675-.511.6.6 0 01.511-.675l8.484-1.194a.6.6 0 01.675.506.6.6 0 01-.511.663z"
              fill="#516a80"
            />
            <path
              data-name="Path 10263"
              d="M88.295 157.068a.177.177 0 01-.173-.152.173.173 0 01.034-.131.182.182 0 01.118-.068l8.488-1.194a.181.181 0 01.194.148.173.173 0 01-.034.131.181.181 0 01-.118.068l-8.484 1.2z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10264"
              d="M96.864 158.642l-8.484 1.195a.6.6 0 01-.675-.507.6.6 0 01.511-.675l8.484-1.2a.6.6 0 01.675.511.6.6 0 01-.511.676z"
              fill="#516a80"
            />
            <path
              data-name="Path 10265"
              d="M88.295 159.058a.182.182 0 01-.173-.152.177.177 0 01.152-.2l8.488-1.2a.181.181 0 01.194.152.173.173 0 01-.034.131.181.181 0 01-.118.068l-8.484 1.195z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10266"
              d="M96.864 160.63l-8.484 1.195a.6.6 0 01-.675-.507.6.6 0 01.511-.675l8.484-1.2a.6.6 0 01.675.511.6.6 0 01-.511.676z"
              fill="#516a80"
            />
            <path
              data-name="Path 10267"
              d="M88.295 161.044a.181.181 0 01-.173-.152.173.173 0 01.034-.131.181.181 0 01.118-.068l8.488-1.2a.181.181 0 01.194.152.173.173 0 01-.152.2l-8.484 1.195z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10268"
              d="M96.862 162.618l-1.786.249a.6.6 0 01-.675-.507.6.6 0 01.511-.675l1.785-.253a.6.6 0 01.675.511.6.6 0 01-.51.675z"
              fill="#516a80"
            />
            <path
              data-name="Path 10269"
              d="M94.994 162.087a.181.181 0 01-.173-.152.173.173 0 01.034-.131.182.182 0 01.114-.068l1.794-.253a.176.176 0 01.042.35l-1.785.249z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10270"
              d="M97.366 155.962a.537.537 0 00-.051-.165.088.088 0 000-.025.4.4 0 00-.089-.118l-.021-.025a.788.788 0 00-.114-.08l-.042-.025a.72.72 0 00-.135-.038h-.038a2.861 2.861 0 01.207-.279h-1.481v.068a.806.806 0 00.422.608.517.517 0 00.241.1.911.911 0 00.283-.034 1.576 1.576 0 01.342-.046.135.135 0 01.106.034.11.11 0 010 .122.211.211 0 01-.143.093.945.945 0 00-.241.021h-.051a.5.5 0 00-.422.515l.038.781v.1a.486.486 0 00.553.393h.072a.1.1 0 01.059 0 .129.129 0 01.055.042V158.059a.178.178 0 01-.038.16c0 .025-.063.051-.063.059h-.1l-.127.03h-.051a.317.317 0 00-.249.333l.051.781v.072a.279.279 0 00.329.22h.148a.277.277 0 01.135.051.372.372 0 01.11.106.329.329 0 01.03.068v.034a.128.128 0 010 .042.392.392 0 01-.114.317.42.42 0 01-.148.1h-.117l-.131.025a.139.139 0 00-.105.144l.068.781v.03a.076.076 0 00.093.051.549.549 0 01.422.055.6.6 0 01.266.371.972.972 0 00-.03-.118.557.557 0 00-.122-.2.041.041 0 00-.021 0 .314.314 0 00-.068-.063.57.57 0 00-.207-.093.609.609 0 00-.232 0v-.781l.152-.021h.118l.08-.03.046-.021.072-.046h.025a.42.42 0 00.076-.076.954.954 0 00.068-.11.449.449 0 00.038-.105.079.079 0 000-.034.323.323 0 000-.089v-.042a.574.574 0 000-.084.218.218 0 000-.046.57.57 0 00-.03-.076.152.152 0 000-.038.356.356 0 00-.042-.067l-.025-.038-.063-.063-.025-.021-.08-.055h-.025a.585.585 0 00-.241-.063h-.127v-.823h.27a.309.309 0 00.08-.03l.046-.021.072-.046.025-.021a.327.327 0 00.076-.076.956.956 0 00.068-.11.561.561 0 00.038-.11.073.073 0 000-.03.374.374 0 000-.093.144.144 0 000-.042.476.476 0 000-.08.213.213 0 000-.051.372.372 0 00-.03-.072.129.129 0 000-.042.368.368 0 00-.042-.068l-.025-.038-.063-.063-.025-.021-.08-.055h-.025a.582.582 0 00-.241-.063h-.144v-.781l.152-.021h.118l.08-.03.072-.106.072-.046.025-.021a.323.323 0 00.076-.076.954.954 0 00.068-.11.482.482 0 00.038-.11.073.073 0 000-.03.353.353 0 000-.093.144.144 0 000-.042.424.424 0 00.003-.126z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10271"
              d="M55.718 149.221a2.11 2.11 0 01-2.111-2.11v-3.141c0-2.14 1.709-3.136 2.841-3.8 1.266-.73 1.422-.945 1.422-1.372a2.111 2.111 0 114.221 0c0 2.955-2.2 4.25-3.516 5.019-.232.135-.553.321-.747.46v2.828a2.11 2.11 0 01-2.111 2.115z"
              fill="#d0ddec"
            />
            <path
              data-name="Path 10272"
              d="M59.968 140.914a2.111 2.111 0 01-2.111-1.967c-.756-.819-4.715-1.541-6.64-1.9-4.365-.8-8.134-1.49-8.134-4.592a2.111 2.111 0 014.1-.7 26.87 26.87 0 004.791 1.14c4.732.87 10.1 1.849 10.1 5.909a2.111 2.111 0 01-2.106 2.11z"
              fill="#d0ddec"
            />
            <path
              data-name="Path 10273"
              d="M59.969 134.228a2.111 2.111 0 01-2.111-2.047c-.561-.806-4.153-1.625-5.909-2.022-3.8-.87-7.4-1.688-7.4-4.719a2.111 2.111 0 014.132-.6 22.716 22.716 0 004.221 1.2c4.3.979 9.172 2.111 9.172 6.074a2.11 2.11 0 01-2.1 2.11z"
              fill="#d0ddec"
            />
            <path
              data-name="Path 10274"
              d="M59.968 127.896a2.11 2.11 0 01-2.081-1.743c-.844-.663-4.1-1.334-5.88-1.688-4.162-.865-7.446-1.545-7.446-4.339a2.111 2.111 0 014.031-.882 28.707 28.707 0 004.272 1.089c4.529.941 9.214 1.916 9.214 5.487a2.111 2.111 0 01-2.11 2.076z"
              fill="#d0ddec"
            />
            <path
              data-name="Path 10275"
              d="M49.466 149.221a2.111 2.111 0 01-2.111-2.111v-2.828c-.2-.139-.519-.325-.751-.46-1.313-.768-3.516-2.056-3.516-5.019a2.111 2.111 0 014.221 0c0 .422.177.642 1.422 1.372 1.131.659 2.845 1.655 2.845 3.8v3.14a2.11 2.11 0 01-2.11 2.106z"
              fill="#d5eeff"
            />
            <path
              data-name="Path 10276"
              d="M45.199 140.914a2.111 2.111 0 01-2.111-2.111c0-4.018 5.34-5.116 10.054-6.087a26.364 26.364 0 004.825-1.266 2.111 2.111 0 014.111.667c0 3.069-3.748 3.837-8.087 4.732-1.95.4-5.964 1.228-6.686 2.077a2.111 2.111 0 01-2.106 1.988z"
              fill="#d5eeff"
            />
            <path
              data-name="Path 10277"
              d="M45.199 134.57a2.111 2.111 0 01-2.111-2.111c0-4.018 5.34-5.12 10.054-6.087a27.072 27.072 0 004.825-1.266 2.11 2.11 0 014.111.667c0 3.069-3.748 3.841-8.087 4.732-1.95.4-5.964 1.228-6.686 2.081a2.111 2.111 0 01-2.106 1.984z"
              fill="#d5eeff"
            />
            <path
              data-name="Path 10278"
              d="M46.671 127.554a2.11 2.11 0 01-2.111-2.11c0-3.558 4.453-4.474 8.383-5.285a25.2 25.2 0 003.617-.912 2.111 2.111 0 014.044.844c0 2.794-3.157 3.444-6.809 4.2-1.52.312-4.28.882-5.036 1.465a2.11 2.11 0 01-2.088 1.798z"
              fill="#d5eeff"
            />
            <path
              data-name="Path 10279"
              d="M58.495 122.206a2.111 2.111 0 01-2.085-1.8 8.7 8.7 0 00-4.221-.954 6.177 6.177 0 00-3.423.886 2.114 2.114 0 11-4.221-.245c0-3.157 3.934-4.863 7.632-4.863 2.912 0 8.412 1.017 8.412 4.863a2.111 2.111 0 01-2.094 2.111z"
              fill="#d5eeff"
            />
            <ellipse
              data-name="Ellipse 466"
              cx={1.583}
              cy={0.954}
              rx={1.583}
              ry={0.954}
              transform="translate(51.421 168.389)"
              fill="#3c3c4e"
            />
            <path
              data-name="Path 10280"
              d="M57.141 161.103h-8.662s.393.46.393.709v5.842a1.688 1.688 0 001.688 1.688h4.892a1.688 1.688 0 001.688-1.688v-5.842c0-.249.393-.709.393-.709z"
              fill="#516a80"
            />
            <path
              data-name="Path 10281"
              d="M54.282 169.055H51.75a1.313 1.313 0 01-1.313-1.313v-6.644h5.158v6.649a1.313 1.313 0 01-1.313 1.308z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10282"
              d="M53.155 169.055h-.3a.794.794 0 01-.794-.794v-7.175h1.888v7.175a.794.794 0 01-.794.794z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10283"
              d="M57.33 162.563l-8.484 1.211a.6.6 0 01-.675-.511.6.6 0 01.511-.675l8.484-1.195a.6.6 0 01.675.506.6.6 0 01-.511.664z"
              fill="#516a80"
            />
            <path
              data-name="Path 10284"
              d="M48.761 162.977a.177.177 0 01-.173-.152.173.173 0 01.034-.131.182.182 0 01.118-.068l8.488-1.195a.181.181 0 01.194.148.173.173 0 01-.034.131.181.181 0 01-.118.068l-8.484 1.2z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10285"
              d="M57.33 164.551l-8.484 1.195a.6.6 0 01-.675-.507.6.6 0 01.511-.675l8.484-1.2a.6.6 0 01.675.511.6.6 0 01-.511.676z"
              fill="#516a80"
            />
            <path
              data-name="Path 10286"
              d="M48.761 164.967a.182.182 0 01-.173-.152.177.177 0 01.152-.2l8.488-1.2a.182.182 0 01.194.152.173.173 0 01-.034.131.181.181 0 01-.118.068l-8.484 1.195z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10287"
              d="M57.33 166.54l-8.484 1.194a.6.6 0 01-.675-.506.6.6 0 01.511-.675l8.484-1.2a.6.6 0 01.663.532.6.6 0 01-.499.655z"
              fill="#516a80"
            />
            <path
              data-name="Path 10288"
              d="M48.761 166.953a.181.181 0 01-.173-.152.173.173 0 01.034-.131.181.181 0 01.118-.068l8.488-1.2a.181.181 0 01.194.152.173.173 0 01-.152.2l-8.484 1.194z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10289"
              d="M57.33 168.528l-1.785.249a.6.6 0 01-.675-.507.6.6 0 01.511-.675l1.785-.253a.6.6 0 01.675.511.6.6 0 01-.511.675z"
              fill="#516a80"
            />
            <path
              data-name="Path 10290"
              d="M55.46 167.996a.181.181 0 01-.173-.152.173.173 0 01.034-.131.182.182 0 01.114-.068l1.794-.253a.176.176 0 01.042.35l-1.785.249z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10291"
              d="M57.828 161.872a.535.535 0 00-.051-.164.091.091 0 000-.025.4.4 0 00-.089-.118v-.025a.535.535 0 00-.114-.076l-.042-.03a.7.7 0 00-.135-.038h-.038a2.866 2.866 0 01.207-.279h-1.481v.068a.806.806 0 00.422.608.519.519 0 00.241.1.907.907 0 00.283-.034 1.591 1.591 0 01.342-.046.135.135 0 01.106.034.11.11 0 010 .122.211.211 0 01-.144.093.944.944 0 00-.241.021h-.051a.5.5 0 00-.422.515l.038.781v.1a.485.485 0 00.553.393h.072a.1.1 0 01.059 0 .131.131 0 01.055.042V163.969a.177.177 0 01-.038.16c0 .025-.063.051-.063.059h-.1l-.127.03h-.055a.317.317 0 00-.249.333l.051.781v.072a.279.279 0 00.329.219h.148a.279.279 0 01.135.051.374.374 0 01.11.105.327.327 0 01.03.068v.034a.127.127 0 010 .042.393.393 0 01-.114.317.423.423 0 01-.148.1h-.114l-.131.025a.135.135 0 00-.106.139l.068.781v.029a.076.076 0 00.093.051.549.549 0 01.422.055.6.6 0 01.266.371.972.972 0 00-.03-.118.557.557 0 00-.122-.2.317.317 0 00-.068-.063.569.569 0 00-.207-.093.613.613 0 00-.232 0v-.781l.152-.021h.118l.08-.03.046-.021.072-.047h.025a.422.422 0 00.076-.076.953.953 0 00.068-.11.561.561 0 00.038-.11.08.08 0 000-.034.323.323 0 000-.089v-.042a.574.574 0 000-.084.222.222 0 000-.046.575.575 0 00-.03-.076.149.149 0 000-.038.364.364 0 00-.042-.068l-.025-.038-.063-.063-.025-.021-.08-.055h-.025a.582.582 0 00-.241-.063h-.135v-.815h.27a.3.3 0 00.08-.03l.046-.021.072-.046.025-.021a.326.326 0 00.076-.076.954.954 0 00.068-.11.566.566 0 00.038-.11.072.072 0 000-.03.375.375 0 000-.093.142.142 0 000-.042.469.469 0 000-.08.209.209 0 000-.051.363.363 0 00-.03-.072.126.126 0 000-.042.365.365 0 00-.042-.068l-.025-.038-.063-.063-.025-.021-.08-.055h-.025a.586.586 0 00-.241-.063h-.135v-.781l.152-.021h.118l.08-.03.046-.025.072-.046.025-.021a.323.323 0 00.076-.076.952.952 0 00.068-.11.481.481 0 00.038-.11.071.071 0 000-.029.348.348 0 000-.093.142.142 0 000-.042.423.423 0 00-.011-.201z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10292"
              d="M62.783 151.242l-1.3-4.132H44.524l-1.3 4.132a27.53 27.53 0 00.355 4.96 2.79 2.79 0 002.461 2.284l.422 1.477 2.013 1.14h9.054l2.013-1.14.422-1.477a2.79 2.79 0 002.461-2.284 27.527 27.527 0 00.355-4.96z"
              fill="#aac9df"
            />
            <path
              data-name="Path 10293"
              d="M59.335 151.243H46.672a41.891 41.891 0 00.228 4.96c.27 2.144 1.591 2.284 1.591 2.284l.274 1.477 1.3 1.14h5.863l1.3-1.14.274-1.477s1.321-.139 1.591-2.284a41.894 41.894 0 00.232-4.96z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10294"
              d="M54.873 151.243h-3.71s0 2.811.063 4.96.469 2.284.469 2.284l.08 1.477.384 1.14h1.718l.384-1.14.08-1.477s.388-.139.469-2.284.063-4.96.063-4.96z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10295"
              d="M46.043 158.486h13.925l-.422 1.477H46.463z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10296"
              d="M59.546 159.964l-2.013 1.14h-9.054l-2.013-1.14z"
              opacity={0.15}
            />
            <path
              data-name="Path 10297"
              d="M62.784 151.242l-1.3-4.132h-16.96l-1.3 4.132z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10298"
              d="M59.339 151.242l-.836-4.132h-11l-.836 4.132z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10299"
              d="M54.865 151.242l-.249-4.132h-3.221l-.249 4.132z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10300"
              d="M53.818 153.143a.811.811 0 11-.237-.577.815.815 0 01.237.577z"
              opacity={0.15}
            />
            <path
              data-name="Path 10301"
              d="M58.006 153.142a.73.73 0 11-.73-.73.73.73 0 01.73.73z"
              opacity={0.15}
            />
            <path
              data-name="Path 10302"
              d="M61.956 153.143a.473.473 0 11-.469-.549.511.511 0 01.469.549z"
              opacity={0.15}
            />
            <path
              data-name="Path 10303"
              d="M48.006 153.142a.73.73 0 10.73-.73.73.73 0 00-.73.73z"
              opacity={0.15}
            />
            <path
              data-name="Path 10304"
              d="M44.055 153.143a.473.473 0 10.469-.549.511.511 0 00-.469.549z"
              opacity={0.15}
            />
            <path
              data-name="Path 10305"
              d="M37.977 16.601L5.416 10.595l-.663.608 7.653 42.142.836-.118 31.881-9.451z"
              fill="#c2d8e8"
            />
            <path
              data-name="Path 10306"
              d="M5.416 10.595l-.663.608 7.653 42.142.836-.118z"
              opacity={0.15}
            />
            <g data-name="Group 490" opacity={0.15}>
              <path
                data-name="Path 10307"
                d="M37.766 17.116l2.106 8.028-4.044-.19-2.161-8.56z"
              />
              <path
                data-name="Path 10308"
                d="M39.99 25.6l2.2 8.383-3.976.431-2.264-8.966z"
              />
              <path
                data-name="Path 10309"
                d="M42.309 34.46l2.3 8.754-3.9 1.106-2.37-9.4z"
              />
              <path
                data-name="Path 10310"
                d="M33.286 16.331l2.165 8.611-4.694-.211-2.215-9.232z"
              />
              <path
                data-name="Path 10311"
                d="M35.575 25.435l2.271 9.016-4.635.5-2.326-9.7z"
              />
              <path
                data-name="Path 10312"
                d="M37.972 34.967l2.374 9.46-4.559 1.292-2.441-10.212z"
              />
              <path
                data-name="Path 10313"
                d="M30.45 25.241L32.78 35l-5.47.6-2.377-10.57z"
              />
              <path
                data-name="Path 10314"
                d="M32.911 35.558l2.457 10.274-5.407 1.532L27.449 36.2z"
              />
              <path
                data-name="Path 10315"
                d="M24.414 25.009l2.385 10.641-6.551.709-2.41-11.6z"
              />
              <path
                data-name="Path 10316"
                d="M26.934 36.258l2.52 11.249-6.5 1.84-2.567-12.321z"
              />
              <path
                data-name="Path 10317"
                d="M14.816 13.092l2.271 11.017-7.978-.366-2.25-12.051z"
              />
              <path
                data-name="Path 10318"
                d="M19.771 37.098l2.562 12.427-7.986 2.262-2.571-13.756z"
              />
              <path
                data-name="Path 10319"
                d="M28.103 15.424l2.22 9.29-5.521-.253-2.254-10.017z"
              />
              <path
                data-name="Path 10320"
                d="M22.029 14.356l2.258 10.08-6.581-.3-2.27-10.937z"
              />
              <path
                data-name="Path 10321"
                d="M17.218 24.739l2.414 11.688-7.99.865L9.24 24.435z"
              />
            </g>
            <path
              data-name="Path 10322"
              d="M38.1 16.965l2.106 8.033-4.044-.186-2.161-8.565z"
              fill="#6dd3e5"
            />
            <path
              data-name="Path 10323"
              d="M40.324 25.453l2.2 8.383-3.976.431-2.264-8.966z"
              fill="#6dd3e5"
            />
            <path
              data-name="Path 10324"
              d="M42.645 34.308l2.3 8.759-3.9 1.1-2.372-9.39z"
              fill="#6dd3e5"
            />
            <path
              data-name="Path 10325"
              d="M33.624 16.18l2.161 8.615-4.693-.207-2.212-9.24z"
              fill="#6dd3e5"
            />
            <path
              data-name="Path 10326"
              d="M35.913 25.289l2.267 9.016-4.635.5-2.326-9.7z"
              fill="#6dd3e5"
            />
            <path
              data-name="Path 10327"
              d="M38.306 34.819l2.376 9.455-4.559 1.287-2.443-10.202z"
              fill="#6dd3e5"
            />
            <path
              data-name="Path 10328"
              d="M30.784 25.09l2.33 9.763-5.466.591-2.381-10.561z"
              fill="#6dd3e5"
            />
            <path
              data-name="Path 10329"
              d="M33.249 35.41l2.452 10.274-5.4 1.532-2.518-11.164z"
              fill="#6dd3e5"
            />
            <path
              data-name="Path 10330"
              d="M24.753 24.862l2.38 10.641-6.547.709-2.414-11.599z"
              fill="#6dd3e5"
            />
            <path
              data-name="Path 10331"
              d="M27.272 36.111l2.516 11.25-6.5 1.84-2.567-12.326z"
              fill="#6dd3e5"
            />
            <path
              data-name="Path 10332"
              d="M15.153 12.941l2.275 11.017-7.985-.364-2.25-12.05z"
              fill="#6dd3e5"
            />
            <path
              data-name="Path 10333"
              d="M20.105 36.946l2.562 12.431-7.986 2.258-2.566-13.752z"
              fill="#6dd3e5"
            />
            <path
              data-name="Path 10334"
              d="M16.782 45.48a1.76 1.76 0 00.616.376 1.224 1.224 0 001.245-.253 1.688 1.688 0 00.422-.57 2.423 2.423 0 00.194-.76 3.069 3.069 0 00-.051-.87 3.2 3.2 0 00-.3-.844 2.553 2.553 0 00-.473-.642 1.861 1.861 0 00-.6-.393 1.266 1.266 0 00-.658-.08 1.2 1.2 0 00-.6.27 1.608 1.608 0 00-.422.561 2.343 2.343 0 00-.211.772 3 3 0 00.046.9 3.065 3.065 0 00.308.844 2.614 2.614 0 00.484.689z"
              fill="#ffd732"
            />
            <path
              data-name="Path 10335"
              d="M14.296 39.677h.093a2.11 2.11 0 01.523.485 3.436 3.436 0 01.393.637 6.048 6.048 0 01.312.76c.089.258.165.519.241.785.03-.076.059-.152.093-.22a2.289 2.289 0 01.11-.2c.042-.068.084-.127.127-.186l.144-.16c-.122-.219-.249-.422-.38-.646a4.582 4.582 0 00-.422-.574 2.293 2.293 0 00-.494-.422 1.625 1.625 0 00-.626-.259h-.122z"
              fill="#ffd732"
            />
            <path
              data-name="Path 10336"
              d="M15.302 42.886a3.806 3.806 0 00-.422-.135 2.731 2.731 0 00-.4-.076 1.493 1.493 0 00-.388 0 1.447 1.447 0 00-.194.046 1.033 1.033 0 00-.186.08 1.267 1.267 0 00-.186.118 1.55 1.55 0 00-.182.156.2.2 0 01-.03.03l-.021.025-.025.025-.03.034.03-.034.025-.025.021-.025a.1.1 0 00.03-.03h.2a1.435 1.435 0 01.582.038 2.478 2.478 0 01.566.253 5.019 5.019 0 01.549.388c.182.148.359.3.536.456v-.186a2.451 2.451 0 00-.038-.245 2.393 2.393 0 01-.021-.245 2.213 2.213 0 010-.236v-.228a3.817 3.817 0 00-.416-.184z"
              fill="#ffd732"
            />
            <path
              data-name="Path 10337"
              d="M18.914 40.644a2.485 2.485 0 01-.384.422c-.139.122-.291.236-.422.346a2.084 2.084 0 01.177.114l.169.135.16.156c.051.055.1.114.148.173.11-.173.215-.346.312-.523a3.64 3.64 0 00.241-.557 2.339 2.339 0 00.114-.633 2.823 2.823 0 00-.068-.751v-.114a.122.122 0 000 .038v.084a2.111 2.111 0 01-.131.646 1.874 1.874 0 01-.316.464z"
              fill="#ffd732"
            />
            <path
              data-name="Path 10338"
              d="M16.53 38.357l.034.034.025.03.025.03.03.034a2.659 2.659 0 01.241.709 3.664 3.664 0 01.063.709 5.734 5.734 0 01-.059.713c-.034.241-.08.477-.127.718l.089-.042.093-.03a.365.365 0 01.1-.025h.449a7.16 7.16 0 00-.055-.739 4.873 4.873 0 00-.135-.764 3.182 3.182 0 00-.241-.671 2.533 2.533 0 00-.422-.616l-.046-.034-.025-.025-.025-.03-.034-.034z"
              fill="#ffd732"
            />
            <path
              data-name="Path 10339"
              d="M19.839 48.74h-.127a2.436 2.436 0 01-.422-.646 3.643 3.643 0 01-.169-.819 6.447 6.447 0 01-.11-.844 19.505 19.505 0 01-.051-.844c-.046.055-.1.11-.148.16a1.643 1.643 0 01-.16.139 1.266 1.266 0 01-.177.114 1.558 1.558 0 01-.19.089c.076.262.152.528.232.785a6.387 6.387 0 00.283.739 2.761 2.761 0 00.384.616 1.789 1.789 0 00.549.422h.127z"
              fill="#ffd732"
            />
            <path
              data-name="Path 10340"
              d="M21.392 46.009h-.11a1.131 1.131 0 01-.536-.173 2.231 2.231 0 01-.481-.422 5.017 5.017 0 01-.422-.557c-.144-.2-.283-.422-.422-.637a.756.756 0 01-.03.258 2.2 2.2 0 01-.046.241.736.736 0 01-.068.232 4.482 4.482 0 01-.084.219c.152.135.3.27.452.393a3.9 3.9 0 00.456.333 1.63 1.63 0 00.46.2 1.051 1.051 0 00.473 0h.127l.068-.025.063-.03h.072z"
              fill="#ffd732"
            />
            <path
              data-name="Path 10341"
              d="M21.173 42.366a.13.13 0 000 .034v.072a1.222 1.222 0 01-.148.148.956.956 0 01-.156.11 1.212 1.212 0 01-.169.076 1.348 1.348 0 01-.177.042 1.308 1.308 0 01-.317 0 2.322 2.322 0 01-.333-.042 3.437 3.437 0 01-.346-.084c-.118-.034-.236-.076-.355-.114l.076.177.063.182c.021.063.038.127.055.19s.034.131.046.2v.055a.329.329 0 010 .059.287.287 0 010 .059.249.249 0 010 .055h.367l.118-.021a2.382 2.382 0 00.388-.1 1.431 1.431 0 00.346-.182 1.409 1.409 0 00.291-.3 1.993 1.993 0 00.219-.456.2.2 0 010-.038.13.13 0 000-.034v-.076z"
              fill="#ffd732"
            />
            <path
              data-name="Path 10342"
              d="M17.2 47.529a5.1 5.1 0 01.329-.684c.122-.219.253-.422.38-.642a1.908 1.908 0 01-.219 0 1.432 1.432 0 01-.219-.042 1.265 1.265 0 01-.211-.072 1.408 1.408 0 01-.211-.106c-.068.253-.135.507-.194.76a6.7 6.7 0 00-.127.772 3.352 3.352 0 00.025.794 2.925 2.925 0 00.262.819v.08l.021.038a.4.4 0 000 .042v-.021.021a.224.224 0 01-.025-.042l-.021-.038v-.08a2.858 2.858 0 01-.021-.844 3.419 3.419 0 01.231-.755z"
              fill="#ffd732"
            />
            <path
              data-name="Path 10343"
              d="M14.428 47.065v.055a.261.261 0 000-.055.144.144 0 010-.042v-.093a1.9 1.9 0 01.287-.473 1.725 1.725 0 01.367-.321 1.987 1.987 0 01.422-.207 3.291 3.291 0 01.456-.122l.173-.03.173-.03h.173l.173-.025a2.643 2.643 0 01-.186-.19 3.083 3.083 0 01-.169-.215 2.693 2.693 0 01-.291-.5c-.182.114-.363.22-.536.342a2.832 2.832 0 00-.49.422 1.979 1.979 0 00-.376.561 2.6 2.6 0 00-.194.8.19.19 0 010 .051.144.144 0 010 .042v.063z"
              fill="#ffd732"
            />
            <path
              data-name="Path 10344"
              d="M28.437 15.272l2.22 9.29-5.521-.253-2.254-10.012z"
              fill="#6dd3e5"
            />
            <path
              data-name="Path 10345"
              d="M22.363 14.208l2.258 10.08-6.576-.3-2.275-10.937z"
              fill="#6dd3e5"
            />
            <path
              data-name="Path 10346"
              d="M17.556 24.592l2.41 11.688-7.99.865-2.402-12.857z"
              fill="#6dd3e5"
            />
            <path
              data-name="Path 10347"
              d="M37.977 16.601l-23.76-4.381 27.576 32.544 3.33-.988z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10348"
              d="M37.977 16.601L5.416 10.595l.511 2.8 35.735 17.22z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10349"
              d="M308.978 50.943a1.207 1.207 0 01-1.2-1.2 3.284 3.284 0 012-2.862 4.935 4.935 0 00.422-.262v-1.612a1.203 1.203 0 012.406 0v1.794a2.565 2.565 0 01-1.617 2.161c-.713.422-.815.54-.815.781a1.2 1.2 0 01-1.2 1.2z"
              fill="#d1d3d4"
            />
            <path
              data-name="Path 10350"
              d="M317.42 54.561a1.2 1.2 0 01-1.135-.806 15.831 15.831 0 00-2.731-.65c-2.7-.494-5.757-1.051-5.757-3.377a1.204 1.204 0 012.406-.08c.422.464 2.684.878 3.8 1.081 2.486.456 4.643.844 4.643 2.617a1.207 1.207 0 01-1.224 1.216z"
              fill="#d1d3d4"
            />
            <path
              data-name="Path 10351"
              d="M316.576 58.558a1.2 1.2 0 01-1.152-.844 13.594 13.594 0 00-2.4-.684c-2.448-.561-5.23-1.195-5.23-3.465a1.203 1.203 0 112.406-.034c.321.46 2.368.924 3.377 1.152 2.17.494 4.221.962 4.221 2.689a1.2 1.2 0 01-1.222 1.186z"
              fill="#d1d3d4"
            />
            <path
              data-name="Path 10352"
              d="M316.576 61.626a1.2 1.2 0 01-1.093-.7 16.735 16.735 0 00-2.435-.616c-2.583-.54-5.255-1.093-5.255-3.119a1.2 1.2 0 012.389-.211 13.153 13.153 0 003.356.971c2.368.494 4.242.882 4.242 2.478a1.207 1.207 0 01-1.204 1.197z"
              fill="#d1d3d4"
            />
            <path
              data-name="Path 10353"
              d="M317.42 50.943a1.2 1.2 0 01-1.2-1.2c0-.241-.1-.367-.81-.781a2.51 2.51 0 01-1.621-2.161v-1.794a1.203 1.203 0 112.406 0v1.612c.11.08.3.186.422.262a3.242 3.242 0 012.005 2.862 1.207 1.207 0 01-1.202 1.2z"
              fill="#fff"
            />
            <path
              data-name="Path 10354"
              d="M308.978 54.75a1.2 1.2 0 01-1.2-1.2c0-1.747 2.136-2.186 4.609-2.693 1.115-.232 3.4-.7 3.8-1.186a1.204 1.204 0 012.406.072c0 2.292-3.043 2.917-5.732 3.47a15.331 15.331 0 00-2.748.722 1.207 1.207 0 01-1.135.815z"
              fill="#fff"
            />
            <path
              data-name="Path 10355"
              d="M308.978 58.373a1.207 1.207 0 01-1.2-1.2c0-1.752 2.136-2.191 4.609-2.7 1.115-.228 3.4-.7 3.8-1.186a1.204 1.204 0 012.406.072c0 2.292-3.043 2.917-5.732 3.47a15.326 15.326 0 00-2.748.722 1.207 1.207 0 01-1.135.822z"
              fill="#fff"
            />
            <path
              data-name="Path 10356"
              d="M309.822 61.627a1.207 1.207 0 01-1.2-1.2c0-1.6 1.8-1.967 3.883-2.393a10.993 10.993 0 002.87-.844 1.2 1.2 0 012.393.177c0 2.03-2.532 2.554-4.778 3.014a14.781 14.781 0 00-2.064.519 1.2 1.2 0 01-1.104.727z"
              fill="#fff"
            />
            <path
              data-name="Path 10357"
              d="M313.414 63.176c-1.659 0-4.8-.578-4.8-2.769a1.2 1.2 0 012.393-.181 5 5 0 002.4.544 3.575 3.575 0 001.954-.5 1.202 1.202 0 012.4.139c.008 1.796-2.236 2.767-4.347 2.767z"
              fill="#fff"
            />
            <ellipse
              data-name="Ellipse 467"
              cx={0.903}
              cy={0.545}
              rx={0.903}
              ry={0.545}
              transform="translate(312.051 31.788)"
              fill="#3c3c4e"
            />
            <path
              data-name="Path 10358"
              d="M310.595 37.033h4.938s-.223-.266-.223-.422v-3.316a.962.962 0 00-.963-.962h-2.79a.962.962 0 00-.963.962v3.33c0 .139-.224.422-.224.422z"
              fill="#516a80"
            />
            <path
              data-name="Path 10359"
              d="M312.223 32.502h1.456a.747.747 0 01.747.747v3.8h-2.954v-3.8a.747.747 0 01.751-.747z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10360"
              d="M312.866 32.502h.173a.452.452 0 01.452.452v4.082h-1.077v-4.09a.451.451 0 01.452-.443z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10361"
              d="M310.485 36.196l4.828-.684a.346.346 0 01.388.291.342.342 0 01-.291.384l-4.825.684a.342.342 0 01-.384-.291.338.338 0 01.287-.384z"
              fill="#516a80"
            />
            <path
              data-name="Path 10362"
              d="M315.37 35.959a.1.1 0 01.1.089.11.11 0 010 .072.145.145 0 01-.068.042l-4.842.68a.105.105 0 01-.11-.084.107.107 0 010-.076.092.092 0 01.063-.038l4.837-.684z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10363"
              d="M310.485 35.064l4.828-.684a.346.346 0 01.388.291.342.342 0 01-.291.384l-4.825.684a.342.342 0 01-.384-.291.338.338 0 01.287-.384z"
              fill="#516a80"
            />
            <path
              data-name="Path 10364"
              d="M315.374 34.828a.1.1 0 010 .2l-4.829.684a.105.105 0 01-.11-.084.107.107 0 010-.076.093.093 0 01.063-.038l4.837-.684z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10365"
              d="M310.484 33.928l4.825-.68a.342.342 0 01.388.287.346.346 0 01-.291.388l-4.825.688a.338.338 0 01-.384-.287.342.342 0 01.287-.4z"
              fill="#516a80"
            />
            <path
              data-name="Path 10366"
              d="M315.371 33.692a.1.1 0 01.1.089.1.1 0 010 .072.119.119 0 01-.067.042l-4.842.68a.1.1 0 01-.11-.084.1.1 0 010-.072.093.093 0 01.063-.042l4.837-.68z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10367"
              d="M310.485 32.799l1.021-.144a.337.337 0 01.384.291.342.342 0 01-.291.384l-1.017.144a.342.342 0 01-.384-.291.338.338 0 01.287-.384z"
              fill="#516a80"
            />
            <path
              data-name="Path 10368"
              d="M311.553 33.101a.1.1 0 01.1.084.111.111 0 01-.021.076.093.093 0 01-.068.038l-1.021.144a.105.105 0 01-.11-.084.107.107 0 010-.076.093.093 0 01.063-.038l1.021-.143z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10369"
              d="M310.205 36.592a.244.244 0 00.03.093.2.2 0 00.051.068.332.332 0 00.063.042h.122a1.353 1.353 0 01-.118.16h.844v-.042a.464.464 0 00-.241-.346.286.286 0 00-.135-.055.553.553 0 00-.165 0 .978.978 0 01-.194.025.08.08 0 01-.059-.021.055.055 0 010-.068.123.123 0 01.08-.055h.169a.283.283 0 00.228-.3v-.477a.274.274 0 00-.317-.224h-.058l-.034-.021a.107.107 0 010-.093.273.273 0 00.038-.034h.156a.177.177 0 00.143-.19l-.03-.422v-.042a.16.16 0 00-.186-.127h-.047a.059.059 0 01-.038 0 .144.144 0 01-.08-.03.2.2 0 01-.059-.059v-.063a.055.055 0 010-.025.215.215 0 01.063-.181.36.36 0 01.084-.055h.139a.076.076 0 00.059-.08l-.038-.447a.046.046 0 00-.051-.03.317.317 0 01-.241-.03.329.329 0 01-.152-.211.352.352 0 00.084.181l.038.034a.322.322 0 00.118.051.341.341 0 00.131 0v.449h-.207l-.042.025-.042.042a.25.25 0 00-.038.063.383.383 0 00-.021.063.2.2 0 000 .051v.1a.244.244 0 000 .042l.025.038.038.038a.174.174 0 00.047.03.419.419 0 00.139.038h.076v.422h-.207l-.042.03-.042.046a.178.178 0 00-.038.059.253.253 0 00-.021.059.294.294 0 000 .055v.1a.174.174 0 000 .042.063.063 0 000 .025l.025.038.038.034.046.034a.321.321 0 00.139.034h.076v.422h-.207a.141.141 0 00-.042.025l-.042.042a.2.2 0 00-.038.063.337.337 0 00-.021.059.22.22 0 000 .051v.03s-.003.408.004.425z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10370"
              d="M307.378 42.632l.739 2.355h9.67l.739-2.355a15.538 15.538 0 00-.2-2.828 1.591 1.591 0 00-1.406-1.3l-.24-.844-1.148-.646h-5.16l-1.148.646-.241.844a1.591 1.591 0 00-1.4 1.3 15.728 15.728 0 00-.205 2.828z"
              fill="#aac9df"
            />
            <path
              data-name="Path 10371"
              d="M309.345 42.632h7.231a24.1 24.1 0 00-.131-2.828c-.156-1.22-.907-1.3-.907-1.3l-.156-.844-.743-.646h-3.343l-.743.646-.156.844s-.755.08-.912 1.3a24.617 24.617 0 00-.14 2.828z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10372"
              d="M311.895 42.632h2.11s0-1.6-.038-2.828-.266-1.3-.266-1.3l-.047-.844-.215-.646h-.979l-.219.646-.047.844s-.219.08-.266 1.3-.033 2.828-.033 2.828z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10373"
              d="M316.922 38.517h-7.94l.241-.844h7.458z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10374"
              d="M309.223 37.677l1.148-.646h5.162l1.148.646z"
              opacity={0.15}
            />
            <path
              data-name="Path 10375"
              d="M307.378 42.649l.739 2.355h9.674l.734-2.355z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10376"
              d="M309.341 42.649l.477 2.355h6.268l.477-2.355z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10377"
              d="M311.895 42.649l.139 2.355h1.836l.144-2.355z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10378"
              d="M312.49 41.569a.464.464 0 11.464.46.464.464 0 01-.464-.46z"
              opacity={0.15}
            />
            <path
              data-name="Path 10379"
              d="M310.101 41.566a.422.422 0 11.422.422.422.422 0 01-.422-.422z"
              opacity={0.15}
            />
            <path
              data-name="Path 10380"
              d="M307.851 41.569a.27.27 0 11.266.312.291.291 0 01-.266-.312z"
              opacity={0.15}
            />
            <path
              data-name="Path 10381"
              d="M315.803 41.566a.422.422 0 10-.422.422.422.422 0 00.422-.422z"
              opacity={0.15}
            />
            <path
              data-name="Path 10382"
              d="M318.053 41.569a.27.27 0 10-.266.312.291.291 0 00.266-.312z"
              opacity={0.15}
            />
            <path
              data-name="Rectangle 1432"
              fill="#aac9df"
              d="M303.871 25.537h18.163v7.146h-18.163z"
            />
            <path
              data-name="Rectangle 1433"
              fill="#ffe6d2"
              opacity={0.15}
              d="M306.205 25.537H319.7v7.146h-13.495z"
            />
            <path
              data-name="Rectangle 1434"
              fill="#a9c4cd"
              d="M309.219 32.679h7.467v4.643h-7.467z"
            />
            <path
              data-name="Path 10383"
              d="M323.135 30.321h-20.366l1.1-3.018h18.163z"
              fill="#aac9df"
            />
            <path
              data-name="Path 10384"
              d="M320.518 30.321h-15.132l.819-3.018h13.491z"
              fill="#ffe6d2"
              opacity={0.3}
            />
            <path
              data-name="Path 10385"
              d="M318.336 25.538h-10.768l1.178-8.071c.232-1.6.933-2.693 1.722-2.693h4.968c.794 0 1.49 1.093 1.726 2.693z"
              fill="#aac9df"
            />
            <path
              data-name="Path 10386"
              d="M316.327 25.538h-6.754l.7-7.67c.165-1.794.908-3.094 1.773-3.094h1.8c.865 0 1.608 1.3 1.773 3.094z"
              fill="#ffe6d2"
              opacity={0.3}
            />
            <path
              data-name="Path 10387"
              d="M312.954 34.697a4.517 4.517 0 013.732 2.186v-4.221h-7.468v4.22a4.516 4.516 0 013.736-2.185z"
              opacity={0.15}
            />
            <path
              data-name="Rectangle 1435"
              fill="#aac9df"
              d="M312.135 0h1.634v14.774h-1.634z"
            />
            <path
              data-name="Rectangle 1436"
              fill="#ffe6d2"
              opacity={0.15}
              d="M312.549 0h.806v14.774h-.806z"
            />
            <path
              data-name="Path 10388"
              d="M331.615 66.312a23.806 23.806 0 10-37.326 0z"
              fill="#41c3c4"
              opacity={0.5}
            />
            <path
              data-name="Path 10389"
              d="M336.757 51.546a23.683 23.683 0 01-5.141 14.774h-9.4a41.075 41.075 0 002.533-14.774c0-13.148-5.289-23.807-11.819-23.807a23.806 23.806 0 0123.832 23.807z"
              fill="#fff"
              opacity={0.5}
            />
            <path
              data-name="Path 10390"
              d="M327.191 37.199c0 4.643-6.374 4.588-14.238 4.588s-14.242.042-14.242-4.588 6.378-8.391 14.242-8.391 14.238 3.757 14.238 8.391z"
              fill="#fff"
              opacity={0.5}
            />
            <path
              data-name="Path 10391"
              d="M89.688 84.145a10.342 10.342 0 013.318-4.183c-3.736-4.5-6.1-9.708-13.212-11.084 6.64 3.02 7.395 9.468 9.894 15.267z"
              fill="#fbc400"
            />
            <path
              data-name="Path 10392"
              d="M95.357 78.654a10.227 10.227 0 013.8-.726 10.4 10.4 0 011.5.11c.54-5.821 2.533-11.169-1.5-17.18 2.57 6.83-1.47 11.929-3.8 17.796z"
              fill="#fbc400"
            />
            <path
              data-name="Path 10393"
              d="M107.433 82.09c4.5-3.736 9.708-6.1 11.08-13.212-3.014 6.644-9.468 7.4-15.263 9.9a10.358 10.358 0 014.183 3.312z"
              fill="#fbc400"
            />
            <path
              data-name="Path 10394"
              d="M109.464 88.24a10.348 10.348 0 01-.109 1.5c5.825.542 11.173 2.534 17.179-1.5-6.83 2.566-11.924-1.469-17.792-3.8a10.323 10.323 0 01.722 3.8z"
              fill="#fbc400"
            />
            <path
              data-name="Path 10395"
              d="M102.955 97.826a10.312 10.312 0 01-5.3.616c-.54 5.821-2.533 11.169 1.5 17.175-2.566-6.829 1.465-11.924 3.8-17.791z"
              fill="#fbc400"
            />
            <path
              data-name="Path 10396"
              d="M88.844 88.24a10.355 10.355 0 01.11-1.5c-5.825-.542-11.173-2.534-17.179 1.5 6.83-2.566 11.924 1.465 17.8 3.8a10.245 10.245 0 01-.731-3.8z"
              fill="#fbc400"
            />
            <path
              data-name="Path 10397"
              d="M108.62 92.335a10.342 10.342 0 01-3.318 4.183c3.736 4.5 6.1 9.708 13.212 11.084-6.657-3.017-7.396-9.467-9.894-15.267z"
              fill="#fbc400"
            />
            <path
              data-name="Path 10398"
              d="M90.874 94.39c-4.5 3.736-9.708 6.1-11.08 13.212 3.014-6.644 9.468-7.4 15.263-9.9a10.387 10.387 0 01-4.183-3.312z"
              fill="#fbc400"
            />
            <circle
              data-name="Ellipse 468"
              cx={8.839}
              cy={8.839}
              r={8.839}
              transform="rotate(-45 149.84 -60.483)"
              fill="#fbc400"
            />
            <circle
              data-name="Ellipse 469"
              cx={8.839}
              cy={8.839}
              r={8.839}
              transform="rotate(-45 149.84 -60.483)"
              fill="#fbc400"
            />
            <g data-name="Group 491" opacity={0.2} fill="#fff">
              <path
                data-name="Path 10399"
                d="M99.156 77.928a10.4 10.4 0 011.5.11c.54-5.821 2.533-11.169-1.5-17.18 2.562 6.83-1.469 11.929-3.8 17.8a10.227 10.227 0 013.8-.73z"
              />
              <path
                data-name="Path 10400"
                d="M107.434 82.09c4.5-3.736 9.708-6.1 11.08-13.212-3.014 6.644-9.468 7.4-15.263 9.9a10.358 10.358 0 014.183 3.312z"
              />
              <path
                data-name="Path 10401"
                d="M108.742 84.441a10.353 10.353 0 01.612 5.3c5.825.54 11.173 2.533 17.18-1.5-6.83 2.565-11.925-1.47-17.792-3.8z"
              />
              <path
                data-name="Path 10402"
                d="M108.62 92.334a10.342 10.342 0 01-3.318 4.183c.211.253.422.511.625.772q1.266.57 2.533 1.034c.895.325 1.828.642 2.786.945-.921-2.244-1.639-4.638-2.626-6.934z"
              />
              <path
                data-name="Path 10403"
                d="M107.991 88.239a8.822 8.822 0 00-11.781-8.328c.612.262 1.237.507 1.845.768a9.051 9.051 0 013.592 2.435 3.944 3.944 0 01.675 4.094 2.561 2.561 0 01-3.681 1.026 10.4 10.4 0 01-1.14-1.389 1.53 1.53 0 00-1.579-.612c-1.009.371-.684 1.891-.1 2.79a22.051 22.051 0 007.6 6.96 8.826 8.826 0 004.569-7.744z"
              />
            </g>
            <path
              data-name="Path 10404"
              d="M68.186 264.331v.067c.076-1.4-.81-2.807-2.659-3.875l-.046-.029a33.95 33.95 0 00-6.754-2.71 23.327 23.327 0 01-4.377-1.688 3.452 3.452 0 01-1.6-1.642l-.283.038v5.839c.042.1.089.19.139.283a4.376 4.376 0 00-2.452 3.584v5.846c0 1.351.886 2.7 2.668 3.731a10.336 10.336 0 001.3.625c.355.139.722.262 1.1.371a14.66 14.66 0 002.719.484c.296.024.591.042.891.051s.616 0 .924 0 .671-.034 1-.067.772-.093 1.152-.16a13.124 13.124 0 001.71-.422 10.3 10.3 0 001.984-.87.942.942 0 01.11-.067 6.89 6.89 0 001.144-.844 5.317 5.317 0 00.561-.6 4.268 4.268 0 00.363-.536 3.515 3.515 0 00.241-.515 3.185 3.185 0 00.148-.511 3.621 3.621 0 00.059-.519v-5.926z"
              fill="#1c7f98"
            />
            <path
              data-name="Path 10405"
              d="M52.733 260.521a14.208 14.208 0 0110.24-1.034l-.633-.257-.388-.152-.118-.042-.523-.194-.135-.046-.388-.135-.19-.068-.333-.114-.194-.063-.333-.11-.181-.059-.363-.118-.144-.047-.481-.152-.355-.114-.089-.025-.262-.084-.122-.042-.232-.072-.127-.042-.241-.08-.1-.034-.333-.114h-.042l-.283-.1-.1-.038-.215-.076-.114-.042-.2-.08-.072-.025h-.03l-.367-.148-.063-.03a5.141 5.141 0 01-.317-.144h-.055l-.329-.16-.072-.038-.317-.173a4.615 4.615 0 01-1.245-.992 2.33 2.33 0 01-.173-.228 2.6 2.6 0 01-.27-.5v5.849c.042.1.089.19.139.283z"
              opacity={0.2}
            />
            <path
              data-name="Path 10406"
              d="M52.763 273.775a10.334 10.334 0 001.3.625c.355.139.722.262 1.1.372a14.021 14.021 0 001.841.384c.3.042.582.076.878.1s.591.042.891.051.616 0 .924 0 .671-.034 1-.068.772-.093 1.152-.16a13.164 13.164 0 001.709-.422 10.3 10.3 0 001.984-.869.949.949 0 01.11-.068 6.882 6.882 0 001.144-.844 5.308 5.308 0 00.561-.6 4.291 4.291 0 00.363-.536 3.522 3.522 0 00.241-.515 3.2 3.2 0 00.148-.511 3.625 3.625 0 00.059-.519v-5.846a3.621 3.621 0 01-.059.519 3.814 3.814 0 01-.148.506 3.321 3.321 0 01-.241.515 4.635 4.635 0 01-.363.54 5.32 5.32 0 01-.561.6 7.122 7.122 0 01-1.144.844l-.11.063a10.042 10.042 0 01-1.984.87 12.506 12.506 0 01-1.709.422c-.38.072-.764.122-1.152.16s-.667.059-1 .068-.616 0-.924 0-.6-.021-.891-.047-.591-.059-.878-.1-.6-.1-.9-.156-.633-.144-.941-.232a11.576 11.576 0 01-1.1-.371 9.786 9.786 0 01-1.3-.625c-1.781-1.03-2.672-2.381-2.668-3.727v5.846c-.009 1.367.882 2.701 2.668 3.731z"
              opacity={0.2}
            />
            <g data-name="Group 492">
              <path
                data-name="Path 10407"
                d="M61.8 265.923c1.461-.844 1.452-2.22 0-3.064a5.82 5.82 0 00-5.293 0c-1.456.844-1.448 2.22 0 3.064a5.821 5.821 0 005.293 0z"
                opacity={0.2}
              />
            </g>
            <path
              data-name="Path 10408"
              d="M61.8 265.755c1.461-.844 1.452-2.22 0-3.064a5.821 5.821 0 00-5.293 0c-1.456.844-1.448 2.22 0 3.064a5.821 5.821 0 005.293 0z"
              fill="#788b9c"
            />
            <path
              data-name="Path 10409"
              d="M56.984 262.969a4.765 4.765 0 014.327 0 1.323 1.323 0 010 2.507 4.756 4.756 0 01-4.322 0 1.324 1.324 0 01-.005-2.507z"
              opacity={0.2}
            />
            <path
              data-name="Path 10410"
              d="M56.984 263.1a4.955 4.955 0 014.327 0 1.494 1.494 0 01.9 1.169 1.507 1.507 0 00-.9-1.3 4.766 4.766 0 00-4.327 0 1.486 1.486 0 00-.882 1.266 1.469 1.469 0 01.882-1.135z"
              opacity={0.2}
            />
            <path
              data-name="Path 10411"
              d="M52.763 267.924l.232.106a7.157 7.157 0 00.667.287l.481.177c.173.063.371.11.578.169a6.727 6.727 0 00.667.165c.236.051.485.1.747.139s.528.093.815.118.574.063.874.068l.46.021h.469a8.338 8.338 0 00.967-.038 15.007 15.007 0 002-.253 12.508 12.508 0 001.984-.566 7.849 7.849 0 00.945-.422l.447-.24.22-.118.2-.131c.144-.1.3-.194.422-.291l.363-.3a4.029 4.029 0 00.342-.321l.169-.16.139-.177a3.575 3.575 0 00.764-1.507 2.755 2.755 0 00-.131-1.49 4.335 4.335 0 00-.667-1.161c-.262-.317-.5-.6-.722-.811l-.152-.156-.139-.131-.224-.215a1.973 1.973 0 01-.186-.186l.215.135a5.787 5.787 0 01.6.422c.122.1.266.2.422.325a3.637 3.637 0 01.422.422 4.352 4.352 0 01.777 1.224 3.254 3.254 0 01.2 1.688 3.681 3.681 0 01-.819 1.718 5.954 5.954 0 01-1.558 1.334l-.224.143-.232.123c-.16.08-.312.169-.473.245-.329.135-.65.291-.992.4a13.027 13.027 0 01-2.056.536 15.777 15.777 0 01-2.051.211h-1.462l-.464-.038a6.053 6.053 0 01-.886-.105c-.287-.042-.557-.093-.819-.144s-.511-.114-.747-.177-.46-.122-.663-.2-.422-.131-.574-.2l-.477-.2c-.287-.114-.494-.249-.646-.321z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10412"
              d="M59.229 265.991a4.335 4.335 0 002.085-.515 1.327 1.327 0 000-2.507 4.357 4.357 0 00-2.073-.515z"
              opacity={0.2}
            />
            <path
              data-name="Path 10413"
              d="M56.836 265.374l.156.1a4.758 4.758 0 004.322 0 1.327 1.327 0 000-2.507 4.357 4.357 0 00-2.073-.515 6.069 6.069 0 00-2.405 2.922z"
              opacity={0.2}
            />
            <path
              data-name="Path 10414"
              d="M66.907 266.924l-.093.089a7.116 7.116 0 01-1.144.844l-.11.063a10.042 10.042 0 01-1.984.87 12.521 12.521 0 01-1.71.422c-.38.072-.764.122-1.152.16s-.667.059-1 .068h-.566v5.85h.549a9.9 9.9 0 001-.068c.333-.034.772-.093 1.152-.16a13.126 13.126 0 001.71-.422 10.3 10.3 0 001.984-.87.945.945 0 01.11-.068 6.881 6.881 0 001.144-.844l.11-.1z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10415"
              d="M62.015 275.037a12.722 12.722 0 001.545-.393 10.411 10.411 0 001.912-.844v-5.829a10.348 10.348 0 01-1.9.823 12.4 12.4 0 01-1.562.4z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10416"
              d="M52.763 260.495a9.9 9.9 0 011.756-.781v-3.284l-.072-.038-.317-.173a4.61 4.61 0 01-1.245-.992 1.725 1.725 0 01-.105-.139z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10417"
              d="M89.279 199.746l.722-.895.912-5.015-2.157-6.754-.747-.139-.4 2.195a.388.388 0 11-.139.76l-.6 3.326a1.04 1.04 0 01.422.177.194.194 0 01.186-.063.207.207 0 01.169.241.211.211 0 01-.093.135 1.321 1.321 0 01.076.173.272.272 0 01.084 0 .207.207 0 01.165.241.2.2 0 01-.177.165v.207h.03a.207.207 0 01.169.241.2.2 0 01-.219.165l-.025.219a.214.214 0 01-.076.422l-.051.215a.2.2 0 01.143.232.2.2 0 01-.241.165H87.4c-.025.063-.055.122-.084.186a.2.2 0 01-.127.38.2.2 0 01-.08-.03l-.127.135a.232.232 0 01.034.16.211.211 0 01-.241.169.2.2 0 01-.152-.127 1.052 1.052 0 01-.46 0l-.422 2.229a3.714 3.714 0 00-4.221 4.749l-2.271 3.8 2.988.545 1.119-2.14a3.7 3.7 0 001.06.363 3.827 3.827 0 001.119.034 3.736 3.736 0 002.5-1.427 3.7 3.7 0 00.7-1.6 3.651 3.651 0 00-.182-1.984l.578-1.186z"
              fill="#788b9c"
            />
            <path
              data-name="Path 10418"
              d="M88.76 203.592a3.651 3.651 0 00-.181-1.984l.367-.755a4.36 4.36 0 00-3.06-2.229l-.118.646a3.715 3.715 0 00-4.221 4.749l-.422.718a4.395 4.395 0 001.959 2.081l.3-.583a3.7 3.7 0 001.059.363 3.831 3.831 0 001.119.034 3.736 3.736 0 002.5-1.427 3.7 3.7 0 00.698-1.613z"
              opacity={0.15}
            />
            <path
              data-name="Path 10419"
              d="M83.488 207.8a.464.464 0 00-.27-.608l-3.482-1.334c-.515-.2-.274.388-1.03.279s-1.971-.789-1.726.329a7.125 7.125 0 01-.95 5.876c-1.688 2.621-6.678 11.376-6.631 15.432s-1.849 5.677.156 6.551 3.377 1.026 3.643.333.447-7.437 3.622-14.035 4.685-7.636 5.42-9.552z"
              fill="#1c7f98"
            />
            <path
              data-name="Path 10420"
              d="M79.903 214.929a26.658 26.658 0 002.334-3.858l1.266-3.271a.464.464 0 00-.27-.608l-3.482-1.334c-.515-.2-.274.388-1.03.279s-1.971-.789-1.726.329a7.327 7.327 0 010 3.841c1.414 1.098 3.322 2.917 2.908 4.622z"
              fill="#f26522"
            />
            <path
              data-name="Path 10421"
              d="M69.554 234.325c2 .874 3.377 1.026 3.643.333.106-.279.2-1.507.473-3.3a12.992 12.992 0 00-4.643-.333c-.402 1.783-.824 2.709.527 3.3z"
              fill="#f26522"
            />
            <path
              data-name="Path 10422"
              d="M70.373 234.152c-.2-.08-.422-.165-.629-.262-.768-.333-.764-.633-.4-2.165a15.336 15.336 0 00.523-3.955c-.042-3.66 4.4-11.819 6.555-15.17a7.6 7.6 0 001.021-6.192v-.093a5.589 5.589 0 01.553.139 5.645 5.645 0 00.654.156 1.292 1.292 0 00.616-.038 1.621 1.621 0 011.11.038l1.089.422a1.718 1.718 0 01.988 2.216l-.642 1.667a11.017 11.017 0 01-1.266 2.191 53.48 53.48 0 00-4.149 7.311 41.22 41.22 0 00-3.47 12.942c-.059.5-.127 1.017-.165 1.131s-.291.139-.515.131a6.331 6.331 0 01-1.87-.469z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 10423"
              d="M82.436 209.235l-.422 1.1a11.359 11.359 0 01-.523 1.241c-.245.46-.574.95-.929 1.482-.718 1.064-1.52 2.326-2.3 3.727s-1.558 2.925-2.263 4.479c-.342.785-.658 1.578-.937 2.372s-.523 1.583-.743 2.355c-.422 1.545-.73 3.009-.954 4.272s-.35 2.326-.422 3.069c-.046.367-.084.659-.11.844a2.745 2.745 0 01-.059.3.416.416 0 000-.084 1.852 1.852 0 00-.046-.236 9.993 9.993 0 01-.131-.886 10.435 10.435 0 01-.046-1.372c0-.532.08-1.123.148-1.769s.156-1.351.3-2.085c.059-.371.144-.747.215-1.135s.186-.772.3-1.169a24.065 24.065 0 01.772-2.406c.144-.422.312-.806.477-1.211s.367-.815.557-1.2l.291-.57.148-.3.152-.283.612-1.131c.422-.743.844-1.469 1.266-2.161a51.613 51.613 0 012.533-3.626c.384-.515.756-.962 1.026-1.393a10.786 10.786 0 00.616-1.178z"
              fill="#fff"
              opacity={0.2}
            />
            <g data-name="Group 493" opacity={0.2} fill="#fff">
              <path
                data-name="Path 10424"
                d="M72.116 225.739a14.5 14.5 0 01-.844-1.929 1.878 1.878 0 00-.743-.709 14.115 14.115 0 00-1.114 4.672 9.972 9.972 0 01-.051 1.266 5.407 5.407 0 011.743-.92 3.233 3.233 0 013.039.641c.148-.709.321-1.46.532-2.241a2.406 2.406 0 01-2.562-.78z"
              />
              <path
                data-name="Path 10425"
                d="M76.156 217.893c-.515-.819-.844-1.748-1.448-2.533a2.7 2.7 0 00-.291-.329c-.8 1.4-1.688 3.1-2.533 4.837a4.322 4.322 0 014.221 1.819 2.008 2.008 0 01.114.211c.186-.422.38-.844.587-1.3s.464-.954.684-1.389a3.832 3.832 0 01-1.334-1.316z"
              />
              <path
                data-name="Path 10426"
                d="M77.08 213.38a5.534 5.534 0 012.7 1.469 1.552 1.552 0 01.105.127 26.929 26.929 0 002.364-3.9l.063-.169a3.074 3.074 0 01-2.3-1.844 16.775 16.775 0 00-1.211-2.195 2.955 2.955 0 00-1.38-1.03c-.215 0-.38.038-.422.224a7.623 7.623 0 012.014 4.131 2.858 2.858 0 01-.072 1.389 1.266 1.266 0 01-1.009.865 1.654 1.654 0 01-1.368-.81l-.063-.093a7.758 7.758 0 01-.452.8c-.139.224-.308.49-.494.794a8.66 8.66 0 011.525.242z"
              />
            </g>
            <path
              data-name="Path 10427"
              d="M88.413 204.63a3.71 3.71 0 00-3.3-5.428v-2.262a1.018 1.018 0 01-.448-.1.207.207 0 01-.38-.11.216.216 0 01.063-.152 1.685 1.685 0 01-.1-.156.252.252 0 01-.084 0 .207.207 0 01-.059-.4 1.169 1.169 0 00-.046-.194h-.03a.207.207 0 01-.207-.207.2.2 0 01.177-.186v-.219a.211.211 0 010-.422v-.219a.2.2 0 01-.186-.2.207.207 0 01.207-.207h.03a.757.757 0 01.046-.2.2.2 0 01-.143-.194.2.2 0 01.2-.207.251.251 0 01.084 0 1.124 1.124 0 01.106-.156.194.194 0 01-.068-.148.207.207 0 01.38-.114 1.017 1.017 0 01.447-.1v-3.377a.388.388 0 110-.772v-2.23h-.76l-3.33 6.239v5.095l.549 1.013v.684l.359 1.266a3.724 3.724 0 004.289 5.475l.718 2.3h3.039z"
              fill="#788b9c"
            />
            <path
              data-name="Path 10428"
              d="M82.918 202.925a2.186 2.186 0 102.182-2.182 2.187 2.187 0 00-2.182 2.182z"
              opacity={0.15}
            />
            <circle
              data-name="Ellipse 470"
              cx={1.891}
              cy={1.891}
              r={1.891}
              transform="translate(83.209 201.034)"
              fill="#788b9c"
            />
            <path
              data-name="Path 10429"
              d="M85.839 208.011a.473.473 0 01.38-.549l3.664-.692c.54-.1.2.422.967.46s2.077-.422 1.638.633a7.108 7.108 0 00-.122 5.952c1.182 2.879 4.533 12.384 3.765 16.369s.8 5.909-1.33 6.416-3.5.422-3.643-.325.891-7.4-1.047-14.457-3.242-8.349-3.622-10.346z"
              fill="#1c7f98"
            />
            <path
              data-name="Path 10430"
              d="M88.089 215.668a26 26 0 01-1.6-4.221l-.65-3.44a.473.473 0 01.38-.549l3.664-.692c.54-.1.2.422.967.46s2.077-.422 1.638.633a7.353 7.353 0 00-.68 3.8c-1.619.81-3.819 2.253-3.719 4.009z"
              fill="#f26522"
            />
            <path
              data-name="Path 10431"
              d="M94.8 236.6c-2.11.5-3.5.422-3.643-.325-.055-.291.076-1.52.127-3.33a12.961 12.961 0 014.643.5c.063 1.829.312 2.817-1.127 3.155z"
              fill="#f26522"
            />
            <path
              data-name="Path 10432"
              d="M94.027 236.284c.211-.042.422-.089.663-.144.819-.19.87-.485.781-2.06a15.146 15.146 0 01.194-3.985c.7-3.592-2.216-12.4-3.736-16.1a7.6 7.6 0 01.11-6.277s.025-.072.034-.089a5.228 5.228 0 00-.57.034 4.536 4.536 0 01-.671.038 1.229 1.229 0 01-.6-.148 1.646 1.646 0 00-1.106-.161l-1.144.215a1.722 1.722 0 00-1.368 2l.329 1.752a11.177 11.177 0 00.844 2.385 53.38 53.38 0 012.765 7.948 41.427 41.427 0 011.1 13.351 10.778 10.778 0 00-.038 1.144c.021.11.262.186.481.22a6.257 6.257 0 001.925-.127z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 10433"
              d="M95.665 230.096v-.068c0-.046-.034-.114-.051-.2-.046-.173-.059-.422-.143-.743s-.127-.663-.211-1.081c-.03-.211-.072-.422-.118-.675s-.084-.485-.139-.743q-.177-.777-.393-1.688c-.068-.3-.152-.6-.236-.912s-.152-.629-.241-.95c-.173-.65-.346-1.317-.528-2l-.566-2.064a63.884 63.884 0 00-1.266-4.023c-.11-.325-.215-.642-.317-.954-.046-.161-.1-.308-.144-.469s-.08-.329-.118-.494a8.21 8.21 0 01-.177-1.819 6.63 6.63 0 01.211-1.515 7.774 7.774 0 01.367-1.1c.122-.3.245-.519.321-.671l.122-.228-.1.236c-.059.16-.156.388-.253.692a7.352 7.352 0 00-.376 2.579 7.92 7.92 0 00.266 1.726 17.365 17.365 0 00.671 1.832c.485 1.266.967 2.63 1.41 4.006.219.688.422 1.38.629 2.064s.38 1.359.544 2.017c.084.329.16.654.232.971s.148.629.2.933c.131.608.224 1.19.308 1.727.042.266.068.523.1.768s.051.481.063.7.03.422.034.616 0 .367 0 .523a5.181 5.181 0 01-.063.73z"
              fill="#fff"
              opacity={0.2}
            />
            <g data-name="Group 494" opacity={0.2} fill="#fff">
              <path
                data-name="Path 10434"
                d="M94.238 225.921a5.3 5.3 0 00-1.266-.2c-.422.03-.891.367-.844.8s.688.68 1.161.561.878-.422 1.355-.523a1.811 1.811 0 011.482.422 22.62 22.62 0 00-.2-1.317 2.765 2.765 0 01-1.688.257z"
              />
              <path
                data-name="Path 10435"
                d="M86.843 212.679a6.76 6.76 0 01.363-1.22c.68-1.688 3.377-4.5 5.251-3.529l.03-.068c.422-1.059-.874-.608-1.638-.633s-.422-.561-.967-.46l-3.664.688a.477.477 0 00-.38.553l.65 3.461a6.978 6.978 0 00.355 1.208z"
              />
              <path
                data-name="Path 10436"
                d="M92.369 218.15a6.391 6.391 0 01-2.571 2.562c.051.186.106.376.16.57l.553-.03h.27a20.025 20.025 0 013.558 0 5.437 5.437 0 01.574.1 79.982 79.982 0 00-1.764-5.487 8.629 8.629 0 01-.78 2.285z"
              />
              <path
                data-name="Path 10437"
                d="M95.302 233.709a3.894 3.894 0 01.625.076 15.793 15.793 0 01.034-2.419 3.377 3.377 0 01-1.646.958 3.541 3.541 0 01-3.005-.739c0 1.321-.063 2.431-.11 3.25a6.33 6.33 0 014.102-1.126z"
              />
            </g>
            <path
              data-name="Path 10438"
              d="M56.448 204.469l.093-.679.266-.984-.76-15.816-.756-.1-1.916 13.929c.211.025.11.794-.106.764l-.257 1.887a3.715 3.715 0 00-4.014 4.926l-2.111 3.9 3.014.422 1.021-2.187a3.646 3.646 0 001.076.317 3.544 3.544 0 001.119 0 3.714 3.714 0 002.8-5.137z"
              fill="#788b9c"
            />
            <path
              data-name="Path 10439"
              d="M56.19 207.673a3.714 3.714 0 00-.27-1.98l.338-.768a4.369 4.369 0 00-3.157-2.111l-.089.65a3.715 3.715 0 00-4.014 4.926l-.393.73a4.343 4.343 0 002.047 1.992l.274-.591a3.653 3.653 0 001.076.317 3.544 3.544 0 001.119 0 3.7 3.7 0 003.073-3.157z"
              opacity={0.15}
            />
            <path
              data-name="Path 10440"
              d="M51.104 212.088a.473.473 0 00-.3-.6l-3.537-1.176c-.519-.173-.257.4-1.017.321s-2-.7-1.688.422a7.1 7.1 0 01-.692 5.91c-1.562 2.689-6.18 11.65-5.96 15.706s-1.6 5.745.422 6.534 3.419.882 3.655.173.122-7.446 3.01-14.178 4.352-7.83 5-9.776z"
              fill="#1c7f98"
            />
            <path
              data-name="Path 10441"
              d="M47.828 219.366a26.267 26.267 0 002.165-3.959l1.11-3.318a.473.473 0 00-.3-.6l-3.537-1.182c-.519-.173-.257.4-1.017.321s-2-.7-1.688.422a7.358 7.358 0 01.156 3.837c1.469 1.025 3.453 2.756 3.111 4.479z"
              fill="#f26522"
            />
            <path
              data-name="Path 10442"
              d="M38.327 239.187c2.043.785 3.419.882 3.655.173.093-.279.135-1.511.325-3.314a13.006 13.006 0 00-4.644-.133c-.332 1.8-.707 2.743.664 3.274z"
              fill="#f26522"
            />
            <path
              data-name="Path 10443"
              d="M39.137 238.976c-.2-.068-.422-.143-.637-.228-.785-.3-.794-.6-.494-2.148a15.074 15.074 0 00.355-3.972c-.2-3.655 3.883-11.984 5.909-15.445a7.6 7.6 0 00.751-6.234l-.021-.093a5.411 5.411 0 01.557.114 5.487 5.487 0 00.658.127 1.22 1.22 0 00.612-.063 1.608 1.608 0 011.114 0l1.106.367a1.718 1.718 0 011.081 2.174l-.566 1.688a11.184 11.184 0 01-1.165 2.246 53.249 53.249 0 00-3.824 7.5 41.415 41.415 0 00-2.9 13.085c-.042.5-.084 1.021-.118 1.135s-.287.152-.507.156a6.3 6.3 0 01-1.891-.393z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 10444"
              d="M50.112 213.583l-.371 1.114a10.76 10.76 0 01-.473 1.266c-.224.469-.528.971-.844 1.52-.671 1.093-1.418 2.389-2.132 3.824s-1.431 2.989-2.068 4.576a33.328 33.328 0 00-1.486 4.791 42.966 42.966 0 00-.768 4.309c-.165 1.266-.249 2.339-.312 3.082-.03.376-.055.667-.072.844a2.444 2.444 0 01-.046.3v-.08l-.055-.236c-.051-.2-.11-.5-.173-.878a10.98 10.98 0 01-.1-1.372c0-.528.03-1.123.072-1.773s.1-1.355.207-2.111c.046-.371.11-.751.169-1.14s.152-.781.241-1.182a23.888 23.888 0 01.671-2.435c.127-.422.279-.844.422-1.233s.329-.844.5-1.224l.262-.587.139-.3.139-.291.561-1.152c.38-.76.764-1.5 1.152-2.216a50.888 50.888 0 012.376-3.731c.363-.532.713-.992.967-1.435a10.434 10.434 0 00.561-1.2z"
              fill="#fff"
              opacity={0.2}
            />
            <g data-name="Group 495" opacity={0.2} fill="#fff">
              <path
                data-name="Path 10445"
                d="M40.522 230.497c-.422-.553-.574-1.287-.945-1.887a1.87 1.87 0 00-.772-.675 14.1 14.1 0 00-.912 4.719c.025.456 0 .878 0 1.266a5.4 5.4 0 011.688-.992 3.23 3.23 0 013.064.506c.118-.713.262-1.473.422-2.258a2.393 2.393 0 01-2.545-.679z"
              />
              <path
                data-name="Path 10446"
                d="M44.216 222.481c-.553-.794-.929-1.709-1.558-2.448a3.6 3.6 0 00-.308-.317 77.606 77.606 0 00-2.309 4.943 4.331 4.331 0 014.3 1.634c.046.067.08.139.122.211.165-.422.338-.882.528-1.325s.422-.971.625-1.414a3.8 3.8 0 01-1.4-1.284z"
              />
              <path
                data-name="Path 10447"
                d="M44.942 217.94a5.488 5.488 0 012.748 1.351 1.553 1.553 0 01.114.122 26.749 26.749 0 002.191-4.006l.055-.169a3.091 3.091 0 01-2.381-1.743 16.178 16.178 0 00-1.3-2.14 2.9 2.9 0 00-1.422-.967c-.22 0-.38.051-.422.236a7.6 7.6 0 012.2 4.044 2.811 2.811 0 010 1.389 1.266 1.266 0 01-.971.908 1.621 1.621 0 01-1.4-.747l-.068-.089a8.858 8.858 0 01-.422.819c-.131.228-.287.5-.46.815a8.35 8.35 0 011.541.177z"
              />
            </g>
            <path
              data-name="Path 10448"
              d="M55.815 208.847a3.681 3.681 0 00.422-1.71 3.719 3.719 0 00-3.723-3.719v-1.9c-.215 0-.215-.772 0-.772v-14.043h-.76l-2.908 15.554.127 1.013v.684l.359 1.266a3.724 3.724 0 004.289 5.475l.718 2.3h3.039z"
              fill="#788b9c"
            />
            <circle
              data-name="Ellipse 471"
              cx={2.182}
              cy={2.182}
              r={2.182}
              transform="translate(50.323 204.964)"
              opacity={0.15}
            />
            <circle
              data-name="Ellipse 472"
              cx={1.891}
              cy={1.891}
              r={1.891}
              transform="translate(50.614 205.255)"
              fill="#788b9c"
            />
            <path
              data-name="Path 10449"
              d="M53.244 212.232a.464.464 0 01.376-.549l3.664-.692c.54-.1.2.422.967.46s2.077-.422 1.638.633a7.113 7.113 0 00-.118 5.952c1.178 2.879 4.533 12.384 3.761 16.369s.8 5.909-1.33 6.416-3.5.422-3.643-.325.895-7.4-1.047-14.457-3.242-8.349-3.622-10.367z"
              fill="#1c7f98"
            />
            <path
              data-name="Path 10450"
              d="M55.493 219.889a26.411 26.411 0 01-1.6-4.221l-.646-3.44a.464.464 0 01.376-.549l3.664-.692c.54-.1.2.422.967.46s2.077-.422 1.638.633a7.315 7.315 0 00-.675 3.8c-1.626.81-3.825 2.253-3.724 4.009z"
              fill="#f26522"
            />
            <path
              data-name="Path 10451"
              d="M62.201 240.821c-2.111.5-3.5.422-3.643-.325-.055-.291.076-1.52.131-3.33a12.983 12.983 0 014.643.5c.059 1.829.304 2.817-1.131 3.155z"
              fill="#f26522"
            />
            <path
              data-name="Path 10452"
              d="M61.428 240.505c.211-.042.422-.089.667-.143.819-.19.844-.485.777-2.06a15.329 15.329 0 01.194-3.984c.7-3.592-2.216-12.4-3.736-16.1a7.6 7.6 0 01.11-6.277s.03-.072.034-.089a5.213 5.213 0 00-.566.034 4.644 4.644 0 01-.675.038 1.229 1.229 0 01-.6-.148 1.634 1.634 0 00-1.1-.16l-1.144.215a1.714 1.714 0 00-1.368 2l.329 1.752a11.145 11.145 0 00.844 2.385 53.728 53.728 0 012.769 7.948 41.4 41.4 0 011.093 13.351c-.025.5-.055 1.026-.038 1.144s.262.186.481.219a6.242 6.242 0 001.925-.127z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 10453"
              d="M63.066 234.317v-.068a2 2 0 00-.046-.2c-.051-.173-.059-.422-.148-.743s-.127-.663-.207-1.081c-.034-.211-.076-.422-.118-.671s-.089-.49-.143-.747q-.173-.777-.393-1.688c-.068-.3-.152-.6-.236-.912s-.152-.629-.241-.95c-.169-.65-.346-1.317-.523-2s-.376-1.372-.566-2.064a63.884 63.884 0 00-1.266-4.023 82.17 82.17 0 00-.317-.954c-.046-.16-.1-.308-.139-.469s-.08-.329-.122-.494a8.474 8.474 0 01-.177-1.819 6.63 6.63 0 01.211-1.515 9.044 9.044 0 01.367-1.1c.122-.3.245-.519.321-.671l.122-.228-.1.241c-.063.156-.16.384-.257.688a7.267 7.267 0 00-.371 2.579 7.658 7.658 0 00.262 1.726 18.368 18.368 0 00.671 1.832c.49 1.266.967 2.63 1.41 4.006.22.688.422 1.38.629 2.064s.38 1.359.544 2.018c.089.329.16.654.232.971s.148.629.2.933c.131.608.224 1.19.312 1.726.038.266.063.524.093.768a6.073 6.073 0 01.063.7c0 .219.03.422.034.616s0 .367 0 .523a5.311 5.311 0 01-.059.73l-.042.276z"
              fill="#fff"
              opacity={0.2}
            />
            <g data-name="Group 496" opacity={0.2} fill="#fff">
              <path
                data-name="Path 10454"
                d="M61.626 230.142a5.311 5.311 0 00-1.266-.2c-.422.03-.895.367-.844.8s.684.68 1.157.561.882-.422 1.359-.523a1.815 1.815 0 011.482.422q-.08-.637-.2-1.317a2.765 2.765 0 01-1.688.257z"
              />
              <path
                data-name="Path 10455"
                d="M54.244 216.9a7.123 7.123 0 01.363-1.22c.68-1.688 3.377-4.5 5.251-3.529l.03-.068c.422-1.059-.874-.608-1.638-.633s-.422-.561-.967-.46l-3.676.692a.464.464 0 00-.376.549l.646 3.44a7.358 7.358 0 00.367 1.229z"
              />
              <path
                data-name="Path 10456"
                d="M59.77 222.371a6.39 6.39 0 01-2.571 2.562l.165.57.549-.03h.27a20.025 20.025 0 013.558 0 5.434 5.434 0 01.574.1 77.835 77.835 0 00-1.764-5.487 8.478 8.478 0 01-.781 2.285z"
              />
              <path
                data-name="Path 10457"
                d="M62.703 237.93a3.893 3.893 0 01.625.076 15.777 15.777 0 01.034-2.419 3.376 3.376 0 01-1.646.958 3.541 3.541 0 01-3.005-.739c0 1.321-.063 2.431-.11 3.25a6.331 6.331 0 014.102-1.126z"
              />
            </g>
            <rect
              data-name="Rectangle 1437"
              width={18.906}
              height={29.116}
              rx={1.94}
              transform="translate(177.713 315.951)"
              fill="#d1d3d4"
            />
            <path
              data-name="Rectangle 1438"
              opacity={0.2}
              d="M177.713 323.582h18.906v16.977h-18.906z"
            />
            <path
              data-name="Rectangle 1439"
              fill="#fff"
              opacity={0.2}
              d="M177.713 319.083h18.906v18.636h-18.906z"
            />
            <path
              data-name="Rectangle 1440"
              fill="#fff"
              opacity={0.2}
              d="M177.713 321.446h18.906v.228h-18.906z"
            />
            <path
              data-name="Rectangle 1441"
              opacity={0.2}
              d="M177.713 339.344h18.906v.228h-18.906z"
            />
            <path
              data-name="Rectangle 1442"
              fill="#d1d3d4"
              d="M177.713 321.674h18.906v17.665h-18.906z"
            />
            <rect
              data-name="Rectangle 1443"
              width={15.179}
              height={8.645}
              rx={2.61}
              transform="translate(179.579 326.187)"
              fill="#fff"
            />
            <rect
              data-name="Rectangle 1444"
              width={14.335}
              height={7.872}
              rx={2.42}
              transform="translate(180.001 326.575)"
              fill="#252d3a"
            />
            <path
              data-name="Path 10458"
              d="M190.461 328.689l-.718-.717h2.617l-.718.717z"
              fill="#ed1c24"
            />
            <path
              data-name="Path 10459"
              d="M192.5 328.111v1.9l-.359.359-.359-.359v-1.182z"
              fill="#ed1c24"
            />
            <path
              data-name="Path 10460"
              d="M192.001 330.509l-.359.359h-1.182l-.359-.359.359-.359h1.182z"
              fill="#ed1c24"
            />
            <path
              data-name="Path 10461"
              d="M189.604 328.111v1.9l.359.359.359-.359v-1.182z"
              fill="#ed1c24"
            />
            <path
              data-name="Path 10462"
              d="M191.642 332.328l.718.718h-2.617l.718-.718z"
              fill="#ed1c24"
            />
            <path
              data-name="Path 10463"
              d="M189.604 332.908v-1.9l.359-.359.359.359v1.182z"
              fill="#ed1c24"
            />
            <path
              data-name="Path 10464"
              d="M192.5 332.908v-1.9l-.359-.359-.359.359v1.182z"
              fill="#ed1c24"
            />
            <path
              data-name="Path 10465"
              d="M186.578 328.689l-.718-.717h2.613l-.718.717z"
              fill="#ed1c24"
            />
            <path
              data-name="Path 10466"
              d="M188.616 328.111v1.9l-.359.359-.363-.359v-1.182z"
              fill="#ed1c24"
            />
            <path
              data-name="Path 10467"
              d="M188.117 330.509l-.363.359h-1.178l-.359-.359.359-.359h1.178z"
              fill="#ed1c24"
            />
            <path
              data-name="Path 10468"
              d="M185.72 328.111v1.9l.359.359.359-.359v-1.182z"
              fill="#ed1c24"
            />
            <path
              data-name="Path 10469"
              d="M187.759 332.328l.718.718h-2.617l.718-.718z"
              fill="#ed1c24"
            />
            <path
              data-name="Path 10470"
              d="M185.72 332.908v-1.9l.359-.359.359.359v1.182z"
              fill="#ed1c24"
            />
            <path
              data-name="Path 10471"
              d="M188.616 332.908v-1.9l-.359-.359-.363.359v1.182z"
              fill="#ed1c24"
            />
            <path
              data-name="Path 10472"
              d="M182.69 328.689l-.718-.717h2.617l-.718.717z"
              fill="#ed1c24"
            />
            <path
              data-name="Path 10473"
              d="M184.729 328.111v1.9l-.359.359-.359-.359v-1.182z"
              fill="#ed1c24"
            />
            <path
              data-name="Path 10474"
              d="M184.231 330.509l-.359.359h-1.182l-.359-.359.359-.359h1.181z"
              fill="#ed1c24"
            />
            <path
              data-name="Path 10475"
              d="M181.833 328.111v1.9l.359.359.359-.359v-1.182z"
              fill="#ed1c24"
            />
            <path
              data-name="Path 10476"
              d="M183.872 332.328l.718.718h-2.618l.718-.718z"
              fill="#ed1c24"
            />
            <path
              data-name="Path 10477"
              d="M181.833 332.908v-1.9l.359-.359.359.359v1.182z"
              fill="#ed1c24"
            />
            <path
              data-name="Path 10478"
              d="M184.729 332.908v-1.9l-.359-.359-.359.359v1.182z"
              fill="#ed1c24"
            />
            <path
              data-name="Path 10479"
              d="M183.28 335.57a1.477 1.477 0 101.477 1.478 1.478 1.478 0 00-1.477-1.478zm0 2.659a1.175 1.175 0 11.837-.343 1.182 1.182 0 01-.837.343z"
              fill="#252d3a"
            />
            <path
              data-name="Path 10480"
              d="M187.171 335.57a1.477 1.477 0 101.477 1.478 1.477 1.477 0 00-1.477-1.478zm0 2.659a1.174 1.174 0 11.837-.343 1.182 1.182 0 01-.837.343z"
              fill="#252d3a"
            />
            <path
              data-name="Path 10481"
              d="M191.054 335.57a1.477 1.477 0 101.477 1.478 1.477 1.477 0 00-1.477-1.478zm0 2.659a1.174 1.174 0 11.837-.343 1.182 1.182 0 01-.837.343z"
              fill="#252d3a"
            />
            <path
              data-name="Path 10482"
              d="M180.454 341.302a1.477 1.477 0 101.047.431 1.477 1.477 0 00-1.047-.431zm0 2.659a1.182 1.182 0 11.839-.344 1.182 1.182 0 01-.839.344z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 10483"
              d="M187.171 341.302a1.477 1.477 0 101.477 1.477 1.477 1.477 0 00-1.477-1.477zm0 2.659a1.182 1.182 0 111.182-1.182 1.182 1.182 0 01-1.182 1.182z"
              fill="#fff"
              opacity={0.2}
            />
            <g data-name="Group 497" opacity={0.5} fill="#fff">
              <path
                data-name="Path 10484"
                d="M193.959 316.753a.726.726 0 10.518.212.73.73 0 00-.518-.212zm0 1.313a.583.583 0 11.415-.169.587.587 0 01-.415.169z"
                opacity={0.2}
              />
              <path
                data-name="Path 10485"
                d="M192.018 316.753a.725.725 0 10.518.212.73.73 0 00-.518-.212zm0 1.313a.583.583 0 11.415-.169.587.587 0 01-.415.169z"
                opacity={0.2}
              />
              <path
                data-name="Path 10486"
                d="M190.08 316.753a.726.726 0 10.515.214.73.73 0 00-.515-.214zm0 1.313a.587.587 0 11.583-.583.587.587 0 01-.583.583z"
                opacity={0.2}
              />
              <path
                data-name="Path 10487"
                d="M188.139 316.753a.726.726 0 10.518.212.73.73 0 00-.518-.212zm0 1.313a.587.587 0 11.583-.583.587.587 0 01-.583.583z"
                opacity={0.2}
              />
              <path
                data-name="Path 10488"
                d="M186.197 316.753a.726.726 0 10.518.212.73.73 0 00-.518-.212zm0 1.313a.587.587 0 11.582-.583.587.587 0 01-.582.583z"
                opacity={0.2}
              />
              <path
                data-name="Path 10489"
                d="M184.255 316.753a.73.73 0 10.73.73.73.73 0 00-.73-.73zm0 1.313a.587.587 0 11.583-.583.587.587 0 01-.583.583z"
                opacity={0.2}
              />
              <path
                data-name="Path 10490"
                d="M182.314 316.753a.73.73 0 10.73.73.73.73 0 00-.73-.73zm0 1.313a.587.587 0 11.583-.583.587.587 0 01-.583.583z"
                opacity={0.2}
              />
              <path
                data-name="Path 10491"
                d="M180.372 316.753a.73.73 0 10.73.73.73.73 0 00-.73-.73zm0 1.313a.587.587 0 11.583-.583.587.587 0 01-.583.583z"
                opacity={0.2}
              />
            </g>
            <path
              data-name="Path 10492"
              d="M193.875 341.302a1.477 1.477 0 101.477 1.477 1.477 1.477 0 00-1.477-1.477zm0 2.659a1.182 1.182 0 111.182-1.182 1.182 1.182 0 01-1.182 1.182z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 10493"
              d="M182.331 337.483l.95-1.254.95 1.254z"
              fill="#252d3a"
            />
            <path
              data-name="Path 10494"
              d="M192.001 336.718l-.95 1.254-.95-1.254z"
              fill="#252d3a"
            />
            <path
              data-name="Rectangle 1445"
              fill="#252d3a"
              d="M186.949 337.005h.435v.861h-.435z"
            />
            <path
              data-name="Rectangle 1446"
              fill="#252d3a"
              d="M186.949 336.368h.435v.431h-.435z"
            />
            <path
              data-name="Rectangle 1447"
              opacity={0.2}
              d="M178.363 322.379h6.365v.844h-6.365z"
            />
            <path
              data-name="Rectangle 1448"
              opacity={0.2}
              d="M185.539 322.379h1.845v.844h-1.845z"
            />
            <path
              data-name="Rectangle 1449"
              opacity={0.2}
              d="M188.253 322.379h3.634v.844h-3.634z"
            />
            <path
              data-name="Rectangle 1450"
              opacity={0.2}
              d="M178.363 323.857h2.739v.844h-2.739z"
            />
            <path
              data-name="Rectangle 1451"
              opacity={0.2}
              d="M181.976 323.857h1.845v.844h-1.845z"
            />
            <path
              data-name="Rectangle 1452"
              opacity={0.2}
              d="M184.644 323.857h2.279v.844h-2.279z"
            />
            <path
              data-name="Path 10495"
              d="M180.457 343.961a1.182 1.182 0 11.838-.344 1.182 1.182 0 01-.838.344z"
              opacity={0.2}
            />
            <path
              data-name="Path 10496"
              d="M187.166 343.961a1.182 1.182 0 111.182-1.182 1.182 1.182 0 01-1.182 1.182z"
              opacity={0.2}
            />
            <path
              data-name="Path 10497"
              d="M193.875 343.961a1.182 1.182 0 111.182-1.182 1.182 1.182 0 01-1.182 1.182z"
              opacity={0.2}
            />
            <path
              data-name="Path 10498"
              d="M195.8 315.951h-11.789l2.208 3.132 6.53 2.592 3.871 10.709v-15.618a.819.819 0 00-.819-.815z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 10499"
              d="M177.705 316.769v9.936l4.386 12.638h7.505l-6.078-17.669-3.525-2.592-1.443-3.132a.819.819 0 00-.844.819z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 10500"
              d="M168.984 234.89h-7.176c0-5.487-2.8-6.918-8.163-9.151-4.994-2.081-11.819-4.926-11.819-14.322h7.176c0 4.415 2.406 5.614 7.408 7.695 5.301 2.212 12.574 5.235 12.574 15.778z"
              fill="#1c7f98"
            />
            <path
              data-name="Path 10501"
              d="M148.579 211.417h-1.688c0-4.01 2.5-7.4 5.462-7.4v1.688c-2.001.005-3.774 2.673-3.774 5.712z"
              fill="#fbb040"
            />
            <path
              data-name="Path 10502"
              d="M146.857 211.417h-1.688a24.528 24.528 0 013.461-12.663l1.452.844a22.857 22.857 0 00-3.225 11.819z"
              fill="#d1d3d4"
            />
            <path
              data-name="Path 10503"
              d="M146.857 211.418a22.825 22.825 0 01.131-2.473c-.068.574-.321 1.266-.566 1.266s-.177-3.871-.177-4.415-.19-.971-.452.038a24.816 24.816 0 00-.62 5.563z"
              opacity={0.1}
            />
            <path
              data-name="Path 10504"
              d="M145.659 211.418h-1.688v-.937c0-6.407.03-14.381-5.909-20.307l1.19-1.195c6.42 6.42 6.4 14.774 6.391 21.527z"
              fill="#1c7f98"
            />
            <path
              data-name="Path 10505"
              d="M143.937 211.418h-1.688c0-4.111-1.4-6.952-4.149-8.442l.806-1.486c3.342 1.807 5.031 5.15 5.031 9.928z"
              fill="#d40032"
            />
            <path
              data-name="Path 10506"
              d="M156.402 219.113c-5-2.081-7.408-3.28-7.408-7.695h-4.711c.156.654 1.022.844 1.688 1.034a5.369 5.369 0 013.309 2.592c-.979-.545-2.229-1.081-3.153-.447a2.017 2.017 0 00-.346 2.676 4.276 4.276 0 002.444 1.6 22.017 22.017 0 012.849.878 3.111 3.111 0 011.887 2.157 2.8 2.8 0 01-1.714 2.8c.819.376 1.625.709 2.389 1.03.891.371 1.688.718 2.452 1.068a4.031 4.031 0 017.687-1.747c.456.92.553 2 1.076 2.883a5.933 5.933 0 002.875 2.178l.768.329c-1.764-7.031-7.618-9.47-12.092-11.336z"
              fill="#fff"
              opacity={0.1}
            />
            <path
              data-name="Path 10507"
              d="M167.507 234.89h-2.11c0-10.13-6.2-13.689-11.346-15.829s-7.8-2.832-7.8-7.644h2.111c0 4.018 1.309 5.065 6.175 7.112 5.474 2.28 12.97 5.399 12.97 16.361z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 10508"
              d="M153.079 223.392c-5.728-2.009-9.527-6.332-9.527-11.975h-1.726c0 9.4 6.834 12.241 11.819 14.322 5.361 2.233 8.163 3.651 8.163 9.151 0-6.808-3.001-9.489-8.729-11.498z"
              opacity={0.25}
            />
            <path
              data-name="Path 10509"
              d="M148.301 208.454c-.764 1.511-1.173 1.1-1.093.591a9.435 9.435 0 00-.308 2.372h1.688c0-3.039 1.764-5.707 3.774-5.707-1.482-.172-3.238 1.119-4.061 2.744z"
              opacity={0.1}
            />
            <path
              data-name="Path 10510"
              d="M142.248 211.417h1.688a16.62 16.62 0 00-.245-2.913c.025.768-.114 1.195-.65-.173-.878-2.233-3.081-4.715-4.943-5.361 2.736 1.495 4.15 4.336 4.15 8.447z"
              opacity={0.1}
            />
            <path
              data-name="Path 10511"
              d="M143.974 210.481v.937h1.688v-2.237c0 .984-.515 1.583-.819 1.583s-.844-.515-.874-2.11c.005.611.005 1.227.005 1.827z"
              opacity={0.1}
            />
            <path
              data-name="Path 10512"
              d="M138.534 202.139c2.326 1.093 4.546 5.166 4.846 5.842.076.173.135 0 .093-.422a9.138 9.138 0 00-4.6-6.074z"
              fill="#fff"
              opacity={0.2}
            />
            <path
              data-name="Path 10513"
              d="M148.736 198.809c-2.76 4.685-2.575 10.232-2.2 7.974a23.213 23.213 0 012.955-7.522z"
              fill="#fff"
              opacity={0.3}
            />
            <path
              data-name="Path 10514"
              d="M147.854 207.306c-.485 1.19-.422 1.874-.228 1.266.308-.924 1.946-3.651 4.736-3.651v-.882c-1.845-.017-3.512 1.304-4.508 3.267z"
              fill="#fff"
              opacity={0.3}
            />
            <path
              data-name="Path 10515"
              d="M139.091 189.164l-.557.557c5.909 5.859 6.281 16.589 6.285 18.61 0 1.875 2.225-11.35-5.728-19.167z"
              fill="#fff"
              opacity={0.3}
            />
            <path
              data-name="Rectangle 1453"
              fill="#c2d8e8"
              d="M56.325 62.868v38.981H6.154V62.868z"
            />
            <g data-name="Group 498" opacity={0.2}>
              <path
                data-name="Rectangle 1454"
                d="M55.047 89.316v11.76h-8.982v-11.76z"
              />
              <path
                data-name="Rectangle 1455"
                d="M55.047 76.902v11.76h-8.982v-11.76z"
              />
              <path
                data-name="Rectangle 1456"
                d="M55.051 64.484v11.76h-8.982v-11.76z"
              />
              <path
                data-name="Rectangle 1457"
                d="M45.292 89.316v11.76H36.31v-11.76z"
              />
              <path
                data-name="Rectangle 1458"
                d="M45.292 76.902v11.76H36.31v-11.76z"
              />
              <path
                data-name="Rectangle 1459"
                d="M45.292 64.488v11.76H36.31v-11.76z"
              />
              <path
                data-name="Rectangle 1460"
                d="M35.533 89.316v11.76h-8.982v-11.76z"
              />
              <path
                data-name="Rectangle 1461"
                d="M35.533 76.898v11.76h-8.982v-11.76z"
              />
              <path
                data-name="Rectangle 1462"
                d="M35.537 64.484v11.76h-8.982v-11.76z"
              />
              <path
                data-name="Rectangle 1463"
                d="M25.778 89.316v11.76h-8.982v-11.76z"
              />
              <path
                data-name="Rectangle 1464"
                d="M25.778 76.902v11.76h-8.982v-11.76z"
              />
              <path
                data-name="Rectangle 1465"
                d="M25.778 64.488v11.76h-8.982v-11.76z"
              />
              <path
                data-name="Rectangle 1466"
                d="M16.024 89.312v11.76H7.042v-11.76z"
              />
              <path
                data-name="Rectangle 1467"
                d="M16.019 76.898v11.76H7.037v-11.76z"
              />
              <path
                data-name="Rectangle 1468"
                d="M16.024 64.484v11.76H7.042v-11.76z"
              />
            </g>
            <path
              data-name="Rectangle 1469"
              fill="#6dd3e5"
              d="M55.469 88.894v11.76h-8.982v-11.76z"
            />
            <path
              data-name="Rectangle 1470"
              fill="#6dd3e5"
              d="M55.469 76.48v11.76h-8.982V76.48z"
            />
            <path
              data-name="Rectangle 1471"
              fill="#6dd3e5"
              d="M55.473 64.062v11.76h-8.982v-11.76z"
            />
            <path
              data-name="Rectangle 1472"
              fill="#6dd3e5"
              d="M45.714 88.894v11.76h-8.982v-11.76z"
            />
            <path
              data-name="Rectangle 1473"
              fill="#6dd3e5"
              d="M45.714 76.48v11.76h-8.982V76.48z"
            />
            <path
              data-name="Rectangle 1474"
              fill="#6dd3e5"
              d="M45.714 64.066v11.76h-8.982v-11.76z"
            />
            <path
              data-name="Rectangle 1475"
              fill="#6dd3e5"
              d="M35.955 88.894v11.76h-8.982v-11.76z"
            />
            <path
              data-name="Rectangle 1476"
              fill="#6dd3e5"
              d="M35.955 76.476v11.76h-8.982v-11.76z"
            />
            <path
              data-name="Rectangle 1477"
              fill="#6dd3e5"
              d="M35.959 64.062v11.76h-8.982v-11.76z"
            />
            <path
              data-name="Rectangle 1478"
              fill="#6dd3e5"
              d="M26.2 88.894v11.76h-8.982v-11.76z"
            />
            <path
              data-name="Rectangle 1479"
              fill="#6dd3e5"
              d="M26.2 76.48v11.76h-8.982V76.48z"
            />
            <path
              data-name="Rectangle 1480"
              fill="#6dd3e5"
              d="M26.2 64.066v11.76h-8.982v-11.76z"
            />
            <path
              data-name="Rectangle 1481"
              fill="#6dd3e5"
              d="M16.445 88.89v11.76H7.463V88.89z"
            />
            <path
              data-name="Path 10516"
              d="M10.523 94.158a1.54 1.54 0 01.5-.633c-.566-.68-.92-1.465-1.992-1.688 1.002.472 1.102 1.447 1.492 2.321z"
              fill="#ffd732"
            />
            <path
              data-name="Path 10517"
              d="M11.397 93.325a1.615 1.615 0 01.574-.11 1.927 1.927 0 01.224 0c.084-.878.384-1.688-.224-2.592.367 1.049-.241 1.817-.574 2.702z"
              fill="#ffd732"
            />
            <path
              data-name="Path 10518"
              d="M13.199 93.843c.68-.561 1.465-.92 1.688-1.992-.456 1-1.431 1.114-2.3 1.494a1.553 1.553 0 01.612.498z"
              fill="#ffd732"
            />
            <path
              data-name="Path 10519"
              d="M13.508 94.774a1.38 1.38 0 010 .228c.878.08 1.688.384 2.592-.228-1.03.388-1.8-.219-2.685-.574a1.528 1.528 0 01.093.574z"
              fill="#ffd732"
            />
            <path
              data-name="Path 10520"
              d="M12.524 96.239a1.591 1.591 0 01-.57.11 1.919 1.919 0 01-.228 0c-.08.878-.384 1.688.228 2.592-.388-1.064.22-1.837.57-2.702z"
              fill="#ffd732"
            />
            <path
              data-name="Path 10521"
              d="M10.397 94.775a1.379 1.379 0 010-.228c-.878-.08-1.688-.384-2.592.228 1.03-.388 1.8.219 2.685.574a1.528 1.528 0 01-.093-.574z"
              fill="#ffd732"
            />
            <path
              data-name="Path 10522"
              d="M13.381 95.395a1.541 1.541 0 01-.5.633c.566.68.92 1.465 2 1.688-1.012-.476-1.124-1.447-1.5-2.321z"
              fill="#ffd732"
            />
            <path
              data-name="Path 10523"
              d="M10.704 95.703c-.68.561-1.465.92-1.688 1.992.452-1 1.427-1.114 2.3-1.494a1.553 1.553 0 01-.612-.498z"
              fill="#ffd732"
            />
            <path
              data-name="Path 10524"
              d="M13.284 94.77a1.33 1.33 0 11-.388-.943 1.334 1.334 0 01.388.943z"
              fill="#ffd732"
            />
            <path
              data-name="Rectangle 1482"
              fill="#6dd3e5"
              d="M16.441 76.476v11.76H7.459v-11.76z"
            />
            <path
              data-name="Rectangle 1483"
              fill="#6dd3e5"
              d="M16.445 64.062v11.76H7.463v-11.76z"
            />
            <path
              data-name="Path 10525"
              d="M56.325 62.868H18.657l31.126 38.981h6.543z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10526"
              d="M6.155 69.917l50.171 14.6V62.868H6.155z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10527"
              d="M120.455 35.6a11.114 11.114 0 01-9.831 8.974 23.57 23.57 0 00-6.787-4.778l2.11-2.11v-.8c0-.4.059-.515.9-1.135a8.861 8.861 0 001.089-.895l.557-.557v-.789c0-3.634-5.8-6.277-7.9-7.391V0h-2.744v26.115c-2.111 1.114-7.9 3.757-7.9 7.391v.794l.557.557a8.868 8.868 0 001.089.895c.844.62.9.734.9 1.135v.789l2.111 2.111a23.57 23.57 0 00-6.779 4.778 11.093 11.093 0 01-9.831-8.974h-3.8c0 3.086 3.525 12.241 14.318 12.845l.958.051.612-.743c2.98-3.626 8.408-5.487 8.463-5.508l.659-.219.659.219c.055.021 5.487 1.883 8.463 5.508l.608.743.962-.051c10.793-.6 14.318-9.759 14.318-12.845z"
              fill="#516a80"
            />
            <path
              data-name="Path 10528"
              d="M91.621 35.751c.844.62.9.734.9 1.135v.789l2.11 2.11h9.207l2.111-2.11v-.789c0-.4.059-.515.9-1.135a8.861 8.861 0 001.089-.9l.312-.317c-.616.367-2.815 1.021-10.641 1.021 0 0-6.256.135-7.653-1.266l.557.557a8.863 8.863 0 001.108.905z"
              opacity={0.15}
            />
            <path
              data-name="Path 10529"
              d="M99.244 26.943c-3.482 0-8.294 3.681-8.294 7.117 0 .844 6.64.9 8.294.9 1.655 0 8.294-.068 8.294-.9.001-3.436-4.811-7.117-8.294-7.117z"
              fill="#ffe6d2"
              opacity={0.3}
            />
            <path
              data-name="Path 10530"
              d="M69.267 28.451a6.939 6.939 0 119.624 6.395 2.423 2.423 0 00-.844.747h-3.8a.519.519 0 00-.367-.612 6.935 6.935 0 01-4.613-6.53z"
              fill="#fbe5c4"
              opacity={0.5}
            />
            <path
              data-name="Path 10531"
              d="M78.68 25.292a2.617 2.617 0 11-2.617-2.617 2.617 2.617 0 012.617 2.617z"
              fill="#fff"
              opacity={0.5}
            />
            <path
              data-name="Path 10532"
              d="M76.206 21.527c5.643 0 7.176 10.038 2.33 13.465a6.935 6.935 0 00-2.33-13.465z"
              fill="#fff"
              opacity={0.5}
            />
            <path
              data-name="Rectangle 1484"
              fill="#516a80"
              d="M97.396 33.983h3.698v14.508h-3.698z"
            />
            <path
              data-name="Path 10533"
              d="M97.273 33.983a.515.515 0 00-.363-.608 6.939 6.939 0 114.643 0 .515.515 0 00-.363.608z"
              fill="#fbe5c4"
              opacity={0.5}
            />
            <path
              data-name="Path 10534"
              d="M101.726 23.68a2.617 2.617 0 11-2.617-2.617 2.617 2.617 0 012.617 2.617z"
              fill="#fff"
              opacity={0.5}
            />
            <path
              data-name="Path 10535"
              d="M99.245 19.906c5.643 0 7.176 10.033 2.33 13.461a6.931 6.931 0 00-2.33-13.461z"
              fill="#fff"
              opacity={0.5}
            />
            <path
              data-name="Path 10536"
              d="M129.222 28.451a6.939 6.939 0 10-9.624 6.395 2.423 2.423 0 01.844.747h3.8a.519.519 0 01.367-.612 6.935 6.935 0 004.613-6.53z"
              fill="#fbe5c4"
              opacity={0.5}
            />
            <path
              data-name="Path 10537"
              d="M124.9 25.292a2.617 2.617 0 11-2.617-2.617 2.617 2.617 0 012.617 2.617z"
              fill="#fff"
              opacity={0.5}
            />
            <path
              data-name="Path 10538"
              d="M122.283 21.527c5.648 0 7.176 10.038 2.334 13.465a6.935 6.935 0 00-2.334-13.465z"
              fill="#fff"
              opacity={0.5}
            />
            <path
              data-name="Path 10539"
              d="M162.18 27.306c0-.3.393-.536.882-.536s.886.241.886.536-.4.536-.886.536-.882-.24-.882-.536z"
              fill="#3c3c4e"
            />
            <path
              data-name="Path 10540"
              d="M160.748 31.924h4.85s-.219-.262-.219-.4v-3.272a.946.946 0 00-.946-.946h-2.74a.946.946 0 00-.945.946v3.271c0 .139-.219.4-.219.4z"
              fill="#516a80"
            />
            <path
              data-name="Path 10541"
              d="M162.349 27.466h1.427a.734.734 0 01.734.734v3.723h-2.9v-3.727a.734.734 0 01.739-.734z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10542"
              d="M162.974 27.466h.169a.443.443 0 01.443.443v4.014h-1.052v-4.014a.443.443 0 01.44-.443z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10543"
              d="M160.639 31.101l4.753-.667a.333.333 0 01.38.283.333.333 0 01-.287.38l-4.753.671a.333.333 0 01-.376-.287.338.338 0 01.283-.38z"
              fill="#516a80"
            />
            <path
              data-name="Path 10544"
              d="M165.439 30.873a.093.093 0 01.1.084.089.089 0 010 .072.093.093 0 01-.063.038l-4.757.671a.1.1 0 01-.089-.156.093.093 0 01.063-.038l4.753-.671z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10545"
              d="M160.639 29.99l4.753-.671a.334.334 0 01.38.283.334.334 0 01-.287.38l-4.753.671a.333.333 0 01-.376-.287.333.333 0 01.283-.376z"
              fill="#516a80"
            />
            <path
              data-name="Path 10546"
              d="M165.438 29.758a.093.093 0 01.1.084.1.1 0 01-.072.127l-4.757.671a.1.1 0 01-.11-.084.105.105 0 01.021-.072.093.093 0 01.063-.038l4.753-.671z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10547"
              d="M160.639 28.876l4.753-.671a.334.334 0 01.38.287.334.334 0 01-.287.376l-4.753.68a.333.333 0 01-.376-.283.333.333 0 01.283-.388z"
              fill="#516a80"
            />
            <path
              data-name="Path 10548"
              d="M165.438 28.644a.1.1 0 01.1.084.076.076 0 010 .072.11.11 0 01-.063.042l-4.757.667a.1.1 0 01-.11-.08.11.11 0 01.021-.076.093.093 0 01.063-.038l4.753-.671z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10549"
              d="M160.639 27.761l1-.139a.333.333 0 01.38.283.333.333 0 01-.287.38l-1 .139a.334.334 0 01-.376-.283.333.333 0 01.283-.38z"
              fill="#516a80"
            />
            <path
              data-name="Path 10550"
              d="M161.686 28.061a.1.1 0 01.1.084.106.106 0 01-.021.072.093.093 0 01-.063.038l-1 .143a.106.106 0 01-.11-.084.11.11 0 01.021-.076.135.135 0 01.063-.038l1-.139z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10551"
              d="M160.356 31.489a.591.591 0 00.03.093.776.776 0 00.051.063l.063.042h.025a.233.233 0 00.076.025h.021a1.613 1.613 0 01-.114.16h.844v-.041a.455.455 0 00-.236-.338.27.27 0 00-.135-.055.693.693 0 00-.16 0 .574.574 0 01-.19.025.076.076 0 01-.059 0 .055.055 0 010-.068.122.122 0 01.08-.055h.169a.283.283 0 00.224-.291v-.422a.086.086 0 010-.03.27.27 0 00-.312-.219h-.077a.033.033 0 01-.03-.025v-.021a.1.1 0 01.021-.089.255.255 0 00.034-.034h.135a.186.186 0 00.144-.19l-.03-.422v-.042a.161.161 0 00-.186-.122h-.084a.191.191 0 01-.076-.03.2.2 0 01-.059-.059.152.152 0 010-.038v-.025a.245.245 0 01.063-.177.362.362 0 01.084-.055h.135a.076.076 0 00.059-.08l-.038-.422a.042.042 0 00-.051-.03.308.308 0 01-.236-.03.312.312 0 01-.148-.207.178.178 0 000 .063.284.284 0 00.068.114l.042.034a.334.334 0 00.118.055.338.338 0 00.131 0v.422h-.207l-.042.03a.221.221 0 00-.042.046.459.459 0 00-.034.063.341.341 0 000 .059.207.207 0 000 .051v.072a.122.122 0 000 .042.059.059 0 000 .025l.025.038.034.034.042.03a.337.337 0 00.131.038h.08v.422h-.207l-.042.025a.38.38 0 00-.042.042.423.423 0 00-.034.059.239.239 0 000 .059.217.217 0 000 .055v.093a.129.129 0 000 .042.059.059 0 000 .025l.025.038.034.038.042.03a.274.274 0 00.131.034h.08v.423h-.207l-.042.025a.2.2 0 00-.042.042.27.27 0 00-.034.059.252.252 0 000 .059.22.22 0 000 .051v.025a.175.175 0 11-.051.346z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10552"
              d="M157.588 35.317l-1.081 1.131h13.115l-1.081-1.131s.038.317-.2-.886a1.237 1.237 0 00-1.38-1.047l-.234-.338-1.127-1.123h-5.065l-1.131 1.123-.236.338a1.232 1.232 0 00-1.376 1.047c-.242 1.202-.204.886-.204.886z"
              fill="#aac9df"
            />
            <path
              data-name="Path 10553"
              d="M169.622 36.447l-1.081-1.131h-10.953l-1.081 1.131z"
              opacity={0.15}
            />
            <path
              data-name="Path 10554"
              d="M167.313 36.447l-.561-1.131h-7.374l-.562 1.131z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10555"
              d="M164.308 36.447l-.165-1.131h-2.161l-.165 1.131z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10556"
              d="M159.516 35.317h7.093s.025.317-.131-.886-.891-1.047-.891-1.047l-.156-.338-.73-1.123h-3.284l-.73 1.123-.152.338s-.739-.156-.895 1.047-.124.886-.124.886z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10557"
              d="M162.024 35.317h2.081s0 .317-.038-.886-.262-1.047-.262-1.047l-.047-.338-.215-1.123h-.962l-.215 1.123-.042.338s-.22-.156-.262 1.047-.038.886-.038.886z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10558"
              d="M166.962 33.384h-7.8l.236-.338h7.328z"
              fill="#fff"
              opacity={0.15}
            />
            <path
              data-name="Path 10559"
              d="M159.398 33.046l1.131-1.123h5.069l1.127 1.123z"
              opacity={0.15}
            />
            <path
              data-name="Path 10560"
              d="M156 39.386a7.044 7.044 0 01.637-2.955h12.849a6.986 6.986 0 01.642 2.955 7.066 7.066 0 11-14.128 0z"
              fill="#fff"
            />
            <path
              data-name="Path 10561"
              d="M163.062 36.723a12.1 12.1 0 017.032 1.992 6.985 6.985 0 00-.608-2.271h-12.848a7.1 7.1 0 00-.608 2.271 12.153 12.153 0 017.032-1.992z"
              opacity={0.05}
            />
            <path
              data-name="Rectangle 1485"
              fill="#1c7f98"
              d="M153.983 20.894h18.163v7.146h-18.163z"
            />
            <path
              data-name="Rectangle 1486"
              fill="#ffe6d2"
              opacity={0.15}
              d="M156.317 20.894h13.495v7.146h-13.495z"
            />
            <path
              data-name="Rectangle 1487"
              fill="#a9c4cd"
              d="M159.331 28.036h7.467v4.643h-7.467z"
            />
            <path
              data-name="Path 10562"
              d="M173.247 25.678h-20.366l1.1-3.018h18.163z"
              fill="#1c7f98"
            />
            <path
              data-name="Path 10563"
              d="M170.63 25.678h-15.132l.819-3.018h13.491z"
              fill="#ffe6d2"
              opacity={0.3}
            />
            <path
              data-name="Path 10564"
              d="M168.448 20.894H157.68l1.173-3.427c.236-1.6.933-2.693 1.726-2.693h4.968c.789 0 1.49 1.093 1.722 2.693z"
              fill="#1c7f98"
            />
            <path
              data-name="Path 10565"
              d="M166.439 20.894h-6.754l.714-3.026c.164-1.794.907-3.094 1.776-3.094h1.8c.865 0 1.608 1.3 1.773 3.094z"
              fill="#ffe6d2"
              opacity={0.3}
            />
            <path
              data-name="Path 10566"
              d="M163.061 30.054a4.517 4.517 0 013.736 2.186v-4.221h-7.466v4.22a4.517 4.517 0 013.73-2.185z"
              opacity={0.15}
            />
            <path
              data-name="Rectangle 1488"
              fill="#1c7f98"
              d="M162.247 0h1.634v14.774h-1.634z"
            />
            <path
              data-name="Rectangle 1489"
              fill="#ffe6d2"
              opacity={0.15}
              d="M162.661 0h.806v14.774h-.806z"
            />
            <path
              data-name="Path 10567"
              d="M151.422 25.676h23.275a4.483 4.483 0 014.483 4.483v26.714a4.483 4.483 0 01-4.483 4.483h-23.275a4.487 4.487 0 01-4.483-4.483v-26.71a4.487 4.487 0 014.483-4.487z"
              fill="#f15a29"
              opacity={0.5}
            />
            <rect
              data-name="Rectangle 1490"
              width={20.366}
              height={35.684}
              rx={8.44}
              transform="translate(152.881 25.676)"
              fill="#f15a29"
              opacity={0.5}
            />
            <path
              data-name="Path 10568"
              d="M174.699 25.676h-23.277a4.483 4.483 0 00-4.483 4.487v26.715a4.483 4.483 0 004.483 4.487 3.946 3.946 0 01-.878-2.486V31.092a3.951 3.951 0 013.951-3.947h6a1.661 1.661 0 00-.034.325v32.076a1.794 1.794 0 001.794 1.8h1.574a1.8 1.8 0 001.794-1.8V27.47a1.661 1.661 0 00-.034-.325h6a3.951 3.951 0 013.951 3.947v27.786a3.946 3.946 0 01-.882 2.486 4.487 4.487 0 004.487-4.487V30.163a4.487 4.487 0 00-4.453-4.487z"
              fill="#f15a29"
              opacity={0.5}
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
